import { GameQuestion, QuizSubject, DifficultyLevel } from '../interfaces/question.interface';

export const QUESTION_BANK: GameQuestion[] = [
  {
    id: 'general-001',
    subject: QuizSubject.GENERAL,
    difficulty: DifficultyLevel.EASY,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'This mountain is the tallest in the world.', ar: 'هذا الجبل هو الأطول في العالم.' },
    options: [
      { id: 'A', text: { en: 'Mount Kilimanjaro', ar: 'جبل كليمنجارو' } },
      { id: 'B', text: { en: 'K2', ar: 'كي تو' } },
      { id: 'C', text: { en: 'Kangchenjunga', ar: 'كانغشينجونغا' } },
      { id: 'D', text: { en: 'Mount Everest', ar: 'جبل إيفرست' } }
    ],
    correctOptionId: 'D',
    timeLimit: 30,
    xpReward: 10
  },
  {
    id: 'general-002',
    subject: QuizSubject.GENERAL,
    difficulty: DifficultyLevel.EASY,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'This is Saudi Arabia\'s national day celebrated every year.', ar: 'هذا هو اليوم الوطني للمملكة العربية السعودية.' },
    options: [
      { id: 'A', text: { en: '1 January', ar: '١ يناير' } },
      { id: 'B', text: { en: 'Unification Day', ar: 'يوم التوحيد' } },
      { id: 'C', text: { en: 'National Day', ar: 'اليوم الوطني' } },
      { id: 'D', text: { en: '23 September', ar: '٢٣ سبتمبر' } }
    ],
    correctOptionId: 'D',
    timeLimit: 30,
    xpReward: 10
  },
  {
    id: 'english-003',
    subject: QuizSubject.ENGLISH,
    difficulty: DifficultyLevel.EASY,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'Complete the phrase: \'An apple a day keeps the doctor _____.\'', ar: 'Complete the phrase: \'An apple a day keeps the doctor _____.\'' },
    options: [
      { id: 'A', text: { en: 'Healthy', ar: 'Healthy' } },
      { id: 'B', text: { en: 'Rich', ar: 'Rich' } },
      { id: 'C', text: { en: 'Happy', ar: 'Happy' } },
      { id: 'D', text: { en: 'Away', ar: 'Away' } }
    ],
    correctOptionId: 'D',
    timeLimit: 30,
    xpReward: 10
  },
  {
    id: 'general-004',
    subject: QuizSubject.GENERAL,
    difficulty: DifficultyLevel.EASY,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'I am full of holes but still hold water. What am I?', ar: 'أنا مليء بالثقوب لكنني أحتفظ بالماء. من أنا؟' },
    options: [
      { id: 'A', text: { en: 'A sponge', ar: 'إسفنجة' } },
      { id: 'B', text: { en: 'A sieve', ar: 'مصفاة' } },
      { id: 'C', text: { en: 'A net', ar: 'شبكة' } },
      { id: 'D', text: { en: 'A bucket', ar: 'دلو' } }
    ],
    correctOptionId: 'A',
    timeLimit: 30,
    xpReward: 10
  },
  {
    id: 'math-005',
    subject: QuizSubject.MATH,
    difficulty: DifficultyLevel.EASY,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'If yesterday is Friday, then tomorrow is _____ .', ar: 'إذا كان أمس الجمعة، فإن الغد هو _____.' },
    options: [
      { id: 'A', text: { en: 'Friday', ar: 'الجمعة' } },
      { id: 'B', text: { en: 'Wednesday', ar: 'الأربعاء' } },
      { id: 'C', text: { en: 'Tomorrow', ar: 'الغد' } },
      { id: 'D', text: { en: 'Sunday', ar: 'الأحد' } }
    ],
    correctOptionId: 'D',
    timeLimit: 30,
    xpReward: 10
  },
  {
    id: 'general-006',
    subject: QuizSubject.GENERAL,
    difficulty: DifficultyLevel.EASY,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'What has 13 hearts but no other organs?', ar: 'ما الذي لديه ١٣ قلباً ولا أعضاء أخرى؟' },
    options: [
      { id: 'A', text: { en: 'A calendar', ar: 'تقويم' } },
      { id: 'B', text: { en: 'A monster', ar: 'وحش' } },
      { id: 'C', text: { en: 'A deck of cards', ar: 'مجموعة ورق لعب' } },
      { id: 'D', text: { en: 'A body', ar: 'جسم' } }
    ],
    correctOptionId: 'C',
    timeLimit: 30,
    xpReward: 10
  },
  {
    id: 'general-007',
    subject: QuizSubject.GENERAL,
    difficulty: DifficultyLevel.MEDIUM,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'Which ancient civilization is known for inventing cheese?', ar: 'أي حضارة قديمة اشتهرت باختراع الجبن؟' },
    options: [
      { id: 'A', text: { en: 'Greeks', ar: 'اليونانيون' } },
      { id: 'B', text: { en: 'Mesopotamians', ar: 'بلاد الرافدين' } },
      { id: 'C', text: { en: 'Egyptians', ar: 'المصريون' } },
      { id: 'D', text: { en: 'Romans', ar: 'الرومان' } }
    ],
    correctOptionId: 'B',
    timeLimit: 30,
    xpReward: 20
  },
  {
    id: 'english-008',
    subject: QuizSubject.ENGLISH,
    difficulty: DifficultyLevel.EASY,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'What starts with E, ends with E, but usually contains only one letter?', ar: 'What starts with E, ends with E, but usually contains only one letter?' },
    options: [
      { id: 'A', text: { en: 'An envelope', ar: 'An envelope' } },
      { id: 'B', text: { en: 'Example', ar: 'Example' } },
      { id: 'C', text: { en: 'Eye', ar: 'Eye' } },
      { id: 'D', text: { en: 'Europe', ar: 'Europe' } }
    ],
    correctOptionId: 'A',
    timeLimit: 30,
    xpReward: 10
  },
  {
    id: 'general-009',
    subject: QuizSubject.GENERAL,
    difficulty: DifficultyLevel.EASY,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'In which country is the Premier League played?', ar: 'في أي بلد يُقام الدوري الإنجليزي الممتاز؟' },
    options: [
      { id: 'A', text: { en: 'Germany', ar: 'ألمانيا' } },
      { id: 'B', text: { en: 'England', ar: 'إنجلترا' } },
      { id: 'C', text: { en: 'Italy', ar: 'إيطاليا' } },
      { id: 'D', text: { en: 'Spain', ar: 'إسبانيا' } }
    ],
    correctOptionId: 'B',
    timeLimit: 30,
    xpReward: 10
  },
  {
    id: 'science-010',
    subject: QuizSubject.SCIENCE,
    difficulty: DifficultyLevel.EASY,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'Which planet is known as the Red Planet?', ar: 'أي كوكب يُعرف بالكوكب الأحمر؟' },
    options: [
      { id: 'A', text: { en: 'Mars', ar: 'المريخ' } },
      { id: 'B', text: { en: 'Saturn', ar: 'زحل' } },
      { id: 'C', text: { en: 'Venus', ar: 'الزهرة' } },
      { id: 'D', text: { en: 'Jupiter', ar: 'المشتري' } }
    ],
    correctOptionId: 'A',
    timeLimit: 30,
    xpReward: 10
  },
  {
    id: 'science-011',
    subject: QuizSubject.SCIENCE,
    difficulty: DifficultyLevel.HARD,
    gradeRange: { min: 6, max: 8 },
    text: { en: 'If a plane takes off from Riyadh flying west at 800 km/h and the wind is blowing east at 100 km/h, what is the plane\'s speed relative to the ground?', ar: 'إذا أقلعت طائرة من الرياض متجهة غرباً بسرعة ٨٠٠ كم/س والرياح تهب شرقاً بسرعة ١٠٠ كم/س، ما سرعة الطائرة بالنسبة للأرض؟' },
    options: [
      { id: 'A', text: { en: '800 km/h', ar: '٨٠٠ كم/س' } },
      { id: 'B', text: { en: '900 km/h', ar: '٩٠٠ كم/س' } },
      { id: 'C', text: { en: '700 km/h', ar: '٧٠٠ كم/س' } },
      { id: 'D', text: { en: 'It depends on altitude', ar: 'يعتمد على الارتفاع' } }
    ],
    correctOptionId: 'B',
    timeLimit: 30,
    xpReward: 35
  },
  {
    id: 'general-012',
    subject: QuizSubject.GENERAL,
    difficulty: DifficultyLevel.MEDIUM,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'Which country is the largest producer of olives in the world?', ar: 'أي بلد هو أكبر منتج للزيتون في العالم؟' },
    options: [
      { id: 'A', text: { en: 'Greece', ar: 'اليونان' } },
      { id: 'B', text: { en: 'Turkey', ar: 'تركيا' } },
      { id: 'C', text: { en: 'Spain', ar: 'إسبانيا' } },
      { id: 'D', text: { en: 'Italy', ar: 'إيطاليا' } }
    ],
    correctOptionId: 'C',
    timeLimit: 30,
    xpReward: 20
  },
  {
    id: 'science-013',
    subject: QuizSubject.SCIENCE,
    difficulty: DifficultyLevel.EASY,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'This is the fastest land animal.', ar: 'هذا هو أسرع حيوان بري.' },
    options: [
      { id: 'A', text: { en: 'Lion', ar: 'أسد' } },
      { id: 'B', text: { en: 'Cheetah', ar: 'فهد' } },
      { id: 'C', text: { en: 'Kangaroo', ar: 'كنغر' } },
      { id: 'D', text: { en: 'Horse', ar: 'حصان' } }
    ],
    correctOptionId: 'B',
    timeLimit: 30,
    xpReward: 10
  },
  {
    id: 'general-014',
    subject: QuizSubject.GENERAL,
    difficulty: DifficultyLevel.EASY,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'Which famous footballer is nicknamed \'CR7\'?', ar: 'أي لاعب كرة قدم شهير لقبه CR7؟' },
    options: [
      { id: 'A', text: { en: 'Kylian Mbappé', ar: 'كيليان مبابي' } },
      { id: 'B', text: { en: 'Lionel Messi', ar: 'ليونيل ميسي' } },
      { id: 'C', text: { en: 'Cristiano Ronaldo', ar: 'كريستيانو رونالدو' } },
      { id: 'D', text: { en: 'Neymar Jr.', ar: 'نيمار جونيور' } }
    ],
    correctOptionId: 'C',
    timeLimit: 30,
    xpReward: 10
  },
  {
    id: 'general-015',
    subject: QuizSubject.GENERAL,
    difficulty: DifficultyLevel.MEDIUM,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'I fly without wings, I cry without eyes. Wherever I go, darkness follows me. What am I?', ar: 'أطير بلا أجنحة، وأبكي بلا عيون. أينما ذهبت يتبعني الظلام. من أنا؟' },
    options: [
      { id: 'A', text: { en: 'A bat', ar: 'خفاش' } },
      { id: 'B', text: { en: 'Wind', ar: 'رياح' } },
      { id: 'C', text: { en: 'A cloud', ar: 'سحابة' } },
      { id: 'D', text: { en: 'Night', ar: 'ليل' } }
    ],
    correctOptionId: 'C',
    timeLimit: 30,
    xpReward: 20
  },
  {
    id: 'general-016',
    subject: QuizSubject.GENERAL,
    difficulty: DifficultyLevel.EASY,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'Which large desert covers much of southern Saudi Arabia and is called the \'Empty Quarter\'?', ar: 'أي صحراء كبيرة تغطي جنوب السعودية وتُسمى "الربع الخالي"؟' },
    options: [
      { id: 'A', text: { en: 'Rub\' al-Khali', ar: 'الربع الخالي' } },
      { id: 'B', text: { en: 'An Nafud', ar: 'النفود' } },
      { id: 'C', text: { en: 'Ad Dahna', ar: 'الدهناء' } },
      { id: 'D', text: { en: 'Sahara', ar: 'الصحراء الكبرى' } }
    ],
    correctOptionId: 'A',
    timeLimit: 30,
    xpReward: 10
  },
  {
    id: 'science-017',
    subject: QuizSubject.SCIENCE,
    difficulty: DifficultyLevel.EASY,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'What type of energy does a moving car have?', ar: 'ما نوع الطاقة التي تمتلكها السيارة المتحركة؟' },
    options: [
      { id: 'A', text: { en: 'Chemical', ar: 'كيميائية' } },
      { id: 'B', text: { en: 'Kinetic', ar: 'حركية' } },
      { id: 'C', text: { en: 'Thermal', ar: 'حرارية' } },
      { id: 'D', text: { en: 'Potential', ar: 'كامنة' } }
    ],
    correctOptionId: 'B',
    timeLimit: 30,
    xpReward: 10
  },
  {
    id: 'science-018',
    subject: QuizSubject.SCIENCE,
    difficulty: DifficultyLevel.MEDIUM,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'What is the main gas in Earth\'s atmosphere?', ar: 'ما الغاز الرئيسي في الغلاف الجوي للأرض؟' },
    options: [
      { id: 'A', text: { en: 'Argon', ar: 'أرغون' } },
      { id: 'B', text: { en: 'Carbon dioxide', ar: 'ثاني أكسيد الكربون' } },
      { id: 'C', text: { en: 'Nitrogen', ar: 'نيتروجين' } },
      { id: 'D', text: { en: 'Oxygen', ar: 'أكسجين' } }
    ],
    correctOptionId: 'C',
    timeLimit: 30,
    xpReward: 20
  },
  {
    id: 'general-019',
    subject: QuizSubject.GENERAL,
    difficulty: DifficultyLevel.EASY,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'Which country won the 2022 FIFA World Cup?', ar: 'أي بلد فاز بكأس العالم ٢٠٢٢؟' },
    options: [
      { id: 'A', text: { en: 'Brazil', ar: 'البرازيل' } },
      { id: 'B', text: { en: 'Croatia', ar: 'كرواتيا' } },
      { id: 'C', text: { en: 'Argentina', ar: 'الأرجنتين' } },
      { id: 'D', text: { en: 'France', ar: 'فرنسا' } }
    ],
    correctOptionId: 'C',
    timeLimit: 30,
    xpReward: 10
  },
  {
    id: 'general-020',
    subject: QuizSubject.GENERAL,
    difficulty: DifficultyLevel.HARD,
    gradeRange: { min: 6, max: 8 },
    text: { en: 'Who is the all-time top scorer in Saudi Pro League history?', ar: 'من هو الهداف التاريخي لدوري المحترفين السعودي؟' },
    options: [
      { id: 'A', text: { en: 'Bafetimbi Gomis', ar: 'بافيتيمبي غوميز' } },
      { id: 'B', text: { en: 'Cristiano Ronaldo', ar: 'كريستيانو رونالدو' } },
      { id: 'C', text: { en: 'Omar Al Somah', ar: 'عمر السومة' } },
      { id: 'D', text: { en: 'Abderrazak Hamdallah', ar: 'عبد الرزاق حمد الله' } }
    ],
    correctOptionId: 'D',
    timeLimit: 30,
    xpReward: 35
  },
  {
    id: 'math-021',
    subject: QuizSubject.MATH,
    difficulty: DifficultyLevel.EASY,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'How many sides does a hexagon have?', ar: 'كم عدد أضلاع الشكل السداسي؟' },
    options: [
      { id: 'A', text: { en: '6', ar: '٦' } },
      { id: 'B', text: { en: '8', ar: '٨' } },
      { id: 'C', text: { en: '5', ar: '٥' } },
      { id: 'D', text: { en: '7', ar: '٧' } }
    ],
    correctOptionId: 'A',
    timeLimit: 30,
    xpReward: 10
  },
  {
    id: 'science-022',
    subject: QuizSubject.SCIENCE,
    difficulty: DifficultyLevel.EASY,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'What is the chemical symbol for gold?', ar: 'ما الرمز الكيميائي للذهب؟' },
    options: [
      { id: 'A', text: { en: 'Fe', ar: 'Fe' } },
      { id: 'B', text: { en: 'Au', ar: 'Au' } },
      { id: 'C', text: { en: 'Cu', ar: 'Cu' } },
      { id: 'D', text: { en: 'Ag', ar: 'Ag' } }
    ],
    correctOptionId: 'B',
    timeLimit: 30,
    xpReward: 10
  },
  {
    id: 'general-023',
    subject: QuizSubject.GENERAL,
    difficulty: DifficultyLevel.MEDIUM,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'Before Mount Everest was discovered, what was the highest mountain in the world?', ar: 'قبل اكتشاف جبل إيفرست، ما كان أعلى جبل في العالم؟' },
    options: [
      { id: 'A', text: { en: 'Mount Everest', ar: 'جبل إيفرست' } },
      { id: 'B', text: { en: 'K2', ar: 'كي تو' } },
      { id: 'C', text: { en: 'Kilimanjaro', ar: 'كليمنجارو' } },
      { id: 'D', text: { en: 'None', ar: 'لا شيء' } }
    ],
    correctOptionId: 'A',
    timeLimit: 30,
    xpReward: 20
  },
  {
    id: 'science-024',
    subject: QuizSubject.SCIENCE,
    difficulty: DifficultyLevel.EASY,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'Which direction does the Sun rise in?', ar: 'من أي اتجاه تشرق الشمس؟' },
    options: [
      { id: 'A', text: { en: 'South', ar: 'الجنوب' } },
      { id: 'B', text: { en: 'East', ar: 'الشرق' } },
      { id: 'C', text: { en: 'North', ar: 'الشمال' } },
      { id: 'D', text: { en: 'West', ar: 'الغرب' } }
    ],
    correctOptionId: 'B',
    timeLimit: 30,
    xpReward: 10
  },
  {
    id: 'english-025',
    subject: QuizSubject.ENGLISH,
    difficulty: DifficultyLevel.MEDIUM,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'What does \'ambiguous\' mean?', ar: 'What does \'ambiguous\' mean?' },
    options: [
      { id: 'A', text: { en: 'Bright', ar: 'Bright' } },
      { id: 'B', text: { en: 'Very clear', ar: 'Very clear' } },
      { id: 'C', text: { en: 'Loud', ar: 'Loud' } },
      { id: 'D', text: { en: 'Having more than one possible meaning', ar: 'Having more than one possible meaning' } }
    ],
    correctOptionId: 'D',
    timeLimit: 30,
    xpReward: 20
  },
  {
    id: 'math-026',
    subject: QuizSubject.MATH,
    difficulty: DifficultyLevel.MEDIUM,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'Omar is 10 years old. His father is 4 times older than him. In how many years will Omar be equal to his father\'s current age?', ar: 'عمر عمره ١٠ سنوات. أبوه أكبر منه بـ ٤ مرات. بعد كم سنة سيصبح عمر عمر مساوياً لعمر أبيه الحالي؟' },
    options: [
      { id: 'A', text: { en: '32', ar: '٣٢' } },
      { id: 'B', text: { en: '16', ar: '١٦' } },
      { id: 'C', text: { en: '19', ar: '١٩' } },
      { id: 'D', text: { en: '30', ar: '٣٠' } }
    ],
    correctOptionId: 'B',
    timeLimit: 30,
    xpReward: 20
  },
  {
    id: 'general-027',
    subject: QuizSubject.GENERAL,
    difficulty: DifficultyLevel.MEDIUM,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'What can you make that no one—not even you—can see?', ar: 'ما الذي تصنعه ولا يستطيع أحد — ولا حتى أنت — أن يراه؟' },
    options: [
      { id: 'A', text: { en: 'Darkness', ar: 'ظلام' } },
      { id: 'B', text: { en: 'A shadow', ar: 'ظل' } },
      { id: 'C', text: { en: 'Noise', ar: 'ضجيج' } },
      { id: 'D', text: { en: 'A promise', ar: 'وعد' } }
    ],
    correctOptionId: 'C',
    timeLimit: 30,
    xpReward: 20
  },
  {
    id: 'general-028',
    subject: QuizSubject.GENERAL,
    difficulty: DifficultyLevel.EASY,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'Which month comes after February in a non-leap year?', ar: 'أي شهر يأتي بعد فبراير في السنة غير الكبيسة؟' },
    options: [
      { id: 'A', text: { en: 'March', ar: 'مارس' } },
      { id: 'B', text: { en: 'December', ar: 'ديسمبر' } },
      { id: 'C', text: { en: 'April', ar: 'أبريل' } },
      { id: 'D', text: { en: 'January', ar: 'يناير' } }
    ],
    correctOptionId: 'A',
    timeLimit: 30,
    xpReward: 10
  },
  {
    id: 'general-029',
    subject: QuizSubject.GENERAL,
    difficulty: DifficultyLevel.EASY,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'What can you keep after giving it to someone?', ar: 'ما الذي يمكنك الاحتفاظ به بعد إعطائه لشخص آخر؟' },
    options: [
      { id: 'A', text: { en: 'A gift', ar: 'هدية' } },
      { id: 'B', text: { en: 'A photo', ar: 'صورة' } },
      { id: 'C', text: { en: 'A game', ar: 'لعبة' } },
      { id: 'D', text: { en: 'A promise', ar: 'وعد' } }
    ],
    correctOptionId: 'D',
    timeLimit: 30,
    xpReward: 10
  },
  {
    id: 'english-030',
    subject: QuizSubject.ENGLISH,
    difficulty: DifficultyLevel.EASY,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'Which word means \'very old or ancient\'?', ar: 'Which word means \'very old or ancient\'?' },
    options: [
      { id: 'A', text: { en: 'Fresh', ar: 'Fresh' } },
      { id: 'B', text: { en: 'New', ar: 'New' } },
      { id: 'C', text: { en: 'Modern', ar: 'Modern' } },
      { id: 'D', text: { en: 'Antique', ar: 'Antique' } }
    ],
    correctOptionId: 'D',
    timeLimit: 30,
    xpReward: 10
  },
  {
    id: 'general-031',
    subject: QuizSubject.GENERAL,
    difficulty: DifficultyLevel.EASY,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'In Saudi Arabia, what is a popular summer resort city in the mountains?', ar: 'ما المدينة السعودية الشهيرة كمصيف في الجبال؟' },
    options: [
      { id: 'A', text: { en: 'Yanbu', ar: 'ينبع' } },
      { id: 'B', text: { en: 'Taif', ar: 'الطائف' } },
      { id: 'C', text: { en: 'Dammam', ar: 'الدمام' } },
      { id: 'D', text: { en: 'Jeddah', ar: 'جدة' } }
    ],
    correctOptionId: 'B',
    timeLimit: 30,
    xpReward: 10
  },
  {
    id: 'general-032',
    subject: QuizSubject.GENERAL,
    difficulty: DifficultyLevel.EASY,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'What is the main ingredient in gahwa (Arabic coffee)?', ar: 'ما المكون الرئيسي في القهوة العربية؟' },
    options: [
      { id: 'A', text: { en: 'Coffee beans', ar: 'حبوب البن' } },
      { id: 'B', text: { en: 'Cardamom only', ar: 'الهيل فقط' } },
      { id: 'C', text: { en: 'Milk', ar: 'حليب' } },
      { id: 'D', text: { en: 'Tea leaves', ar: 'أوراق الشاي' } }
    ],
    correctOptionId: 'A',
    timeLimit: 30,
    xpReward: 10
  },
  {
    id: 'general-033',
    subject: QuizSubject.GENERAL,
    difficulty: DifficultyLevel.MEDIUM,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'What is awarded to the best player of the FIFA World Cup?', ar: 'ما الجائزة التي تُمنح لأفضل لاعب في كأس العالم؟' },
    options: [
      { id: 'A', text: { en: 'Golden Ball', ar: 'الكرة الذهبية' } },
      { id: 'B', text: { en: 'Golden Glove', ar: 'القفاز الذهبي' } },
      { id: 'C', text: { en: 'Silver Star', ar: 'النجمة الفضية' } },
      { id: 'D', text: { en: 'Golden Boot', ar: 'الحذاء الذهبي' } }
    ],
    correctOptionId: 'A',
    timeLimit: 30,
    xpReward: 20
  },
  {
    id: 'science-034',
    subject: QuizSubject.SCIENCE,
    difficulty: DifficultyLevel.EASY,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'What weighs more: a kilogram of feathers or a kilogram of steel?', ar: 'أيهما أثقل: كيلوغرام ريش أم كيلوغرام حديد؟' },
    options: [
      { id: 'A', text: { en: 'Steel', ar: 'الحديد' } },
      { id: 'B', text: { en: 'Feathers', ar: 'الريش' } },
      { id: 'C', text: { en: 'They weigh the same', ar: 'يزنان نفس الوزن' } },
      { id: 'D', text: { en: 'Depends on the shape', ar: 'يعتمد على الشكل' } }
    ],
    correctOptionId: 'C',
    timeLimit: 30,
    xpReward: 10
  },
  {
    id: 'general-035',
    subject: QuizSubject.GENERAL,
    difficulty: DifficultyLevel.EASY,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'What is Saudi Arabia\'s most famous natural resource?', ar: 'ما أشهر مورد طبيعي في السعودية؟' },
    options: [
      { id: 'A', text: { en: 'Oil', ar: 'النفط' } },
      { id: 'B', text: { en: 'Diamonds', ar: 'الألماس' } },
      { id: 'C', text: { en: 'Water', ar: 'الماء' } },
      { id: 'D', text: { en: 'Gold', ar: 'الذهب' } }
    ],
    correctOptionId: 'A',
    timeLimit: 30,
    xpReward: 10
  },
  {
    id: 'general-036',
    subject: QuizSubject.GENERAL,
    difficulty: DifficultyLevel.EASY,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'What has keys but can\'t open locks?', ar: 'ما الذي لديه مفاتيح لكنه لا يفتح أقفالاً؟' },
    options: [
      { id: 'A', text: { en: 'A diary', ar: 'مذكرة' } },
      { id: 'B', text: { en: 'A piano', ar: 'بيانو' } },
      { id: 'C', text: { en: 'A saddle', ar: 'سرج' } },
      { id: 'D', text: { en: 'A map', ar: 'خريطة' } }
    ],
    correctOptionId: 'B',
    timeLimit: 30,
    xpReward: 10
  },
  {
    id: 'general-037',
    subject: QuizSubject.GENERAL,
    difficulty: DifficultyLevel.EASY,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'What belongs to you, but other people use it more than you do?', ar: 'ما الذي يخصك لكن الآخرين يستخدمونه أكثر منك؟' },
    options: [
      { id: 'A', text: { en: 'Your shadow', ar: 'ظلك' } },
      { id: 'B', text: { en: 'Your camel', ar: 'جملك' } },
      { id: 'C', text: { en: 'Your phone', ar: 'هاتفك' } },
      { id: 'D', text: { en: 'Your name', ar: 'اسمك' } }
    ],
    correctOptionId: 'D',
    timeLimit: 30,
    xpReward: 10
  },
  {
    id: 'general-038',
    subject: QuizSubject.GENERAL,
    difficulty: DifficultyLevel.EASY,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'I have cities but no people, forests but no trees, rivers but no water. What am I?', ar: 'لدي مدن بلا سكان، وغابات بلا أشجار، وأنهار بلا ماء. من أنا؟' },
    options: [
      { id: 'A', text: { en: 'A picture', ar: 'صورة' } },
      { id: 'B', text: { en: 'A map', ar: 'خريطة' } },
      { id: 'C', text: { en: 'A dream', ar: 'حلم' } },
      { id: 'D', text: { en: 'A story', ar: 'قصة' } }
    ],
    correctOptionId: 'B',
    timeLimit: 30,
    xpReward: 10
  },
  {
    id: 'english-039',
    subject: QuizSubject.ENGLISH,
    difficulty: DifficultyLevel.EASY,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'Complete the phrase: \'A bird in the hand is worth two in the _____.\'', ar: 'Complete the phrase: \'A bird in the hand is worth two in the _____.\'' },
    options: [
      { id: 'A', text: { en: 'Tree', ar: 'Tree' } },
      { id: 'B', text: { en: 'Sky', ar: 'Sky' } },
      { id: 'C', text: { en: 'Bush', ar: 'Bush' } },
      { id: 'D', text: { en: 'Nest', ar: 'Nest' } }
    ],
    correctOptionId: 'C',
    timeLimit: 30,
    xpReward: 10
  },
  {
    id: 'science-040',
    subject: QuizSubject.SCIENCE,
    difficulty: DifficultyLevel.EASY,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'This is the process by which a caterpillar becomes a butterfly.', ar: 'ما العملية التي تتحول بها اليرقة إلى فراشة؟' },
    options: [
      { id: 'A', text: { en: 'Metamorphosis', ar: 'التحول' } },
      { id: 'B', text: { en: 'Photosynthesis', ar: 'البناء الضوئي' } },
      { id: 'C', text: { en: 'Migration', ar: 'الهجرة' } },
      { id: 'D', text: { en: 'Hibernation', ar: 'السبات' } }
    ],
    correctOptionId: 'A',
    timeLimit: 30,
    xpReward: 10
  },
  {
    id: 'general-041',
    subject: QuizSubject.GENERAL,
    difficulty: DifficultyLevel.MEDIUM,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'In what year did the first iPhone launch? (bonus knowledge)', ar: 'في أي سنة أُطلق أول آيفون؟' },
    options: [
      { id: 'A', text: { en: '2005', ar: '٢٠٠٥' } },
      { id: 'B', text: { en: '2009', ar: '٢٠٠٩' } },
      { id: 'C', text: { en: '2010', ar: '٢٠١٠' } },
      { id: 'D', text: { en: '2007', ar: '٢٠٠٧' } }
    ],
    correctOptionId: 'D',
    timeLimit: 30,
    xpReward: 20
  },
  {
    id: 'science-042',
    subject: QuizSubject.SCIENCE,
    difficulty: DifficultyLevel.EASY,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'This force keeps us on the ground.', ar: 'هذه القوة تُبقينا على الأرض.' },
    options: [
      { id: 'A', text: { en: 'Friction', ar: 'الاحتكاك' } },
      { id: 'B', text: { en: 'Magnetism', ar: 'المغناطيسية' } },
      { id: 'C', text: { en: 'Electricity', ar: 'الكهرباء' } },
      { id: 'D', text: { en: 'Gravity', ar: 'الجاذبية' } }
    ],
    correctOptionId: 'D',
    timeLimit: 30,
    xpReward: 10
  },
  {
    id: 'science-043',
    subject: QuizSubject.SCIENCE,
    difficulty: DifficultyLevel.EASY,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'What is the boiling point of water in Celsius?', ar: 'ما درجة غليان الماء بالدرجة المئوية؟' },
    options: [
      { id: 'A', text: { en: '212', ar: '٢١٢' } },
      { id: 'B', text: { en: '100', ar: '١٠٠' } },
      { id: 'C', text: { en: '50', ar: '٥٠' } },
      { id: 'D', text: { en: '0', ar: '٠' } }
    ],
    correctOptionId: 'B',
    timeLimit: 30,
    xpReward: 10
  },
  {
    id: 'science-044',
    subject: QuizSubject.SCIENCE,
    difficulty: DifficultyLevel.EASY,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'What is the freezing point of water in Celsius?', ar: 'ما درجة تجمد الماء بالدرجة المئوية؟' },
    options: [
      { id: 'A', text: { en: '32', ar: '٣٢' } },
      { id: 'B', text: { en: '100', ar: '١٠٠' } },
      { id: 'C', text: { en: '0', ar: '٠' } },
      { id: 'D', text: { en: '-10', ar: '-١٠' } }
    ],
    correctOptionId: 'C',
    timeLimit: 30,
    xpReward: 10
  },
  {
    id: 'general-045',
    subject: QuizSubject.GENERAL,
    difficulty: DifficultyLevel.MEDIUM,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'Which spice is made from the dried stigma of a flower and is very expensive?', ar: 'أي بهار يُصنع من ميسم زهرة مجففة وهو غالي الثمن؟' },
    options: [
      { id: 'A', text: { en: 'Cumin', ar: 'كمون' } },
      { id: 'B', text: { en: 'Saffron', ar: 'زعفران' } },
      { id: 'C', text: { en: 'Turmeric', ar: 'كركم' } },
      { id: 'D', text: { en: 'Paprika', ar: 'بابريكا' } }
    ],
    correctOptionId: 'B',
    timeLimit: 30,
    xpReward: 20
  },
  {
    id: 'general-046',
    subject: QuizSubject.GENERAL,
    difficulty: DifficultyLevel.MEDIUM,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'What is the largest desert in the world?', ar: 'ما أكبر صحراء في العالم؟' },
    options: [
      { id: 'A', text: { en: 'Arabian', ar: 'العربية' } },
      { id: 'B', text: { en: 'Gobi', ar: 'غوبي' } },
      { id: 'C', text: { en: 'Antarctic Desert', ar: 'الصحراء القطبية' } },
      { id: 'D', text: { en: 'Sahara', ar: 'الصحراء الكبرى' } }
    ],
    correctOptionId: 'C',
    timeLimit: 30,
    xpReward: 20
  },
  {
    id: 'science-047',
    subject: QuizSubject.SCIENCE,
    difficulty: DifficultyLevel.EASY,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'This is the main source of energy for Earth.', ar: 'ما المصدر الرئيسي للطاقة على الأرض؟' },
    options: [
      { id: 'A', text: { en: 'The Sun', ar: 'الشمس' } },
      { id: 'B', text: { en: 'Wind', ar: 'الرياح' } },
      { id: 'C', text: { en: 'The Moon', ar: 'القمر' } },
      { id: 'D', text: { en: 'Volcanoes', ar: 'البراكين' } }
    ],
    correctOptionId: 'A',
    timeLimit: 30,
    xpReward: 10
  },
  {
    id: 'general-048',
    subject: QuizSubject.GENERAL,
    difficulty: DifficultyLevel.MEDIUM,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'Which region in Saudi is known for cooler weather and rose farms?', ar: 'أي منطقة في السعودية تشتهر بالطقس البارد ومزارع الورد؟' },
    options: [
      { id: 'A', text: { en: 'Hejaz', ar: 'الحجاز' } },
      { id: 'B', text: { en: 'Asir', ar: 'عسير' } },
      { id: 'C', text: { en: 'Najd', ar: 'نجد' } },
      { id: 'D', text: { en: 'Taif', ar: 'الطائف' } }
    ],
    correctOptionId: 'D',
    timeLimit: 30,
    xpReward: 20
  },
  {
    id: 'science-049',
    subject: QuizSubject.SCIENCE,
    difficulty: DifficultyLevel.EASY,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'Which color absorbs the most heat from sunlight?', ar: 'أي لون يمتص أكبر قدر من الحرارة من أشعة الشمس؟' },
    options: [
      { id: 'A', text: { en: 'Black', ar: 'أسود' } },
      { id: 'B', text: { en: 'Silver', ar: 'فضي' } },
      { id: 'C', text: { en: 'Yellow', ar: 'أصفر' } },
      { id: 'D', text: { en: 'White', ar: 'أبيض' } }
    ],
    correctOptionId: 'A',
    timeLimit: 30,
    xpReward: 10
  },
  {
    id: 'general-050',
    subject: QuizSubject.GENERAL,
    difficulty: DifficultyLevel.MEDIUM,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'Who won the Ballon d\'Or in 2023?', ar: 'من فاز بالكرة الذهبية عام ٢٠٢٣؟' },
    options: [
      { id: 'A', text: { en: 'Lionel Messi', ar: 'ليونيل ميسي' } },
      { id: 'B', text: { en: 'Karim Benzema', ar: 'كريم بنزيمة' } },
      { id: 'C', text: { en: 'Erling Haaland', ar: 'إيرلينغ هالاند' } },
      { id: 'D', text: { en: 'Kylian Mbappé', ar: 'كيليان مبابي' } }
    ],
    correctOptionId: 'A',
    timeLimit: 30,
    xpReward: 20
  },
  {
    id: 'general-051',
    subject: QuizSubject.GENERAL,
    difficulty: DifficultyLevel.MEDIUM,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'Which Saudi national team player scored the winning goal against Argentina in the 2022 World Cup?', ar: 'أي لاعب سعودي سجل هدف الفوز ضد الأرجنتين في كأس العالم ٢٠٢٢؟' },
    options: [
      { id: 'A', text: { en: 'Mohammed Kanno', ar: 'محمد كنو' } },
      { id: 'B', text: { en: 'Saleh Al-Shehri', ar: 'صالح الشهري' } },
      { id: 'C', text: { en: 'Salem Al-Dawsari', ar: 'سالم الدوسري' } },
      { id: 'D', text: { en: 'Saud Abdulhamid', ar: 'سعود عبد الحميد' } }
    ],
    correctOptionId: 'C',
    timeLimit: 30,
    xpReward: 20
  },
  {
    id: 'english-052',
    subject: QuizSubject.ENGLISH,
    difficulty: DifficultyLevel.EASY,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'Which word is a synonym for \'abundant\'?', ar: 'Which word is a synonym for \'abundant\'?' },
    options: [
      { id: 'A', text: { en: 'Rare', ar: 'Rare' } },
      { id: 'B', text: { en: 'Plentiful', ar: 'Plentiful' } },
      { id: 'C', text: { en: 'Few', ar: 'Few' } },
      { id: 'D', text: { en: 'Scarce', ar: 'Scarce' } }
    ],
    correctOptionId: 'B',
    timeLimit: 30,
    xpReward: 10
  },
  {
    id: 'general-053',
    subject: QuizSubject.GENERAL,
    difficulty: DifficultyLevel.MEDIUM,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'This tall modern building in Riyadh looks like it has a giant hole near the top.', ar: 'هذا المبنى الحديث في الرياض يبدو وكأن فيه فتحة كبيرة قرب القمة.' },
    options: [
      { id: 'A', text: { en: 'Faisaliah Tower', ar: 'برج الفيصلية' } },
      { id: 'B', text: { en: 'Jeddah Tower', ar: 'برج جدة' } },
      { id: 'C', text: { en: 'Kingdom Centre', ar: 'برج المملكة' } },
      { id: 'D', text: { en: 'Abraj Al Bait', ar: 'أبراج البيت' } }
    ],
    correctOptionId: 'C',
    timeLimit: 30,
    xpReward: 20
  },
  {
    id: 'general-054',
    subject: QuizSubject.GENERAL,
    difficulty: DifficultyLevel.EASY,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'If you drop me, I\'m sure to crack. Give me a smile, and I\'ll always smile back. What am I?', ar: 'إذا أسقطتني سأنكسر حتماً. ابتسم لي وسأبتسم لك دائماً. من أنا؟' },
    options: [
      { id: 'A', text: { en: 'A phone screen', ar: 'شاشة هاتف' } },
      { id: 'B', text: { en: 'A joke', ar: 'نكتة' } },
      { id: 'C', text: { en: 'A mirror', ar: 'مرآة' } },
      { id: 'D', text: { en: 'An egg', ar: 'بيضة' } }
    ],
    correctOptionId: 'C',
    timeLimit: 30,
    xpReward: 10
  },
  {
    id: 'general-055',
    subject: QuizSubject.GENERAL,
    difficulty: DifficultyLevel.EASY,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'This is the smallest country in the world.', ar: 'ما أصغر دولة في العالم؟' },
    options: [
      { id: 'A', text: { en: 'Vatican City', ar: 'الفاتيكان' } },
      { id: 'B', text: { en: 'Liechtenstein', ar: 'ليختنشتاين' } },
      { id: 'C', text: { en: 'San Marino', ar: 'سان مارينو' } },
      { id: 'D', text: { en: 'Monaco', ar: 'موناكو' } }
    ],
    correctOptionId: 'A',
    timeLimit: 30,
    xpReward: 10
  },
  {
    id: 'science-056',
    subject: QuizSubject.SCIENCE,
    difficulty: DifficultyLevel.EASY,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'What causes a shadow to form?', ar: 'ما الذي يُسبب تكوّن الظل؟' },
    options: [
      { id: 'A', text: { en: 'Sound waves', ar: 'الموجات الصوتية' } },
      { id: 'B', text: { en: 'Light being blocked', ar: 'حجب الضوء' } },
      { id: 'C', text: { en: 'Heat', ar: 'الحرارة' } },
      { id: 'D', text: { en: 'Light bending', ar: 'انحناء الضوء' } }
    ],
    correctOptionId: 'B',
    timeLimit: 30,
    xpReward: 10
  },
  {
    id: 'arabic-057',
    subject: QuizSubject.ARABIC,
    difficulty: DifficultyLevel.EASY,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'أكمل:(الصبر مفتاح _____).', ar: 'أكمل:(الصبر مفتاح _____).' },
    options: [
      { id: 'A', text: { en: 'النجاح', ar: 'النجاح' } },
      { id: 'B', text: { en: 'الفرج', ar: 'الفرج' } },
      { id: 'C', text: { en: 'السعادة', ar: 'السعادة' } },
      { id: 'D', text: { en: 'الكنز', ar: 'الكنز' } }
    ],
    correctOptionId: 'B',
    timeLimit: 30,
    xpReward: 10
  },
  {
    id: 'science-058',
    subject: QuizSubject.SCIENCE,
    difficulty: DifficultyLevel.MEDIUM,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'What pigment gives plants their green color?', ar: 'أي صبغة تعطي النباتات لونها الأخضر؟' },
    options: [
      { id: 'A', text: { en: 'Hemoglobin', ar: 'هيموغلوبين' } },
      { id: 'B', text: { en: 'Melanin', ar: 'ميلانين' } },
      { id: 'C', text: { en: 'Carotene', ar: 'كاروتين' } },
      { id: 'D', text: { en: 'Chlorophyll', ar: 'كلوروفيل' } }
    ],
    correctOptionId: 'D',
    timeLimit: 30,
    xpReward: 20
  },
  {
    id: 'general-059',
    subject: QuizSubject.GENERAL,
    difficulty: DifficultyLevel.MEDIUM,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'What is the only food that never expires?', ar: 'ما الطعام الوحيد الذي لا تنتهي صلاحيته أبداً؟' },
    options: [
      { id: 'A', text: { en: 'Honey', ar: 'العسل' } },
      { id: 'B', text: { en: 'Vinegar', ar: 'الخل' } },
      { id: 'C', text: { en: 'Sugar', ar: 'السكر' } },
      { id: 'D', text: { en: 'Salt', ar: 'الملح' } }
    ],
    correctOptionId: 'A',
    timeLimit: 30,
    xpReward: 20
  },
  {
    id: 'general-060',
    subject: QuizSubject.GENERAL,
    difficulty: DifficultyLevel.EASY,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'Why did the smartphone need glasses?', ar: 'لماذا احتاج الهاتف الذكي إلى نظارات؟' },
    options: [
      { id: 'A', text: { en: 'Old phone', ar: 'هاتف قديم' } },
      { id: 'B', text: { en: 'It lost all its contacts', ar: 'فقد جميع جهات اتصاله' } },
      { id: 'C', text: { en: 'Too bright', ar: 'ساطع جداً' } },
      { id: 'D', text: { en: 'Bad screen', ar: 'شاشة سيئة' } }
    ],
    correctOptionId: 'B',
    timeLimit: 30,
    xpReward: 10
  },
  {
    id: 'science-061',
    subject: QuizSubject.SCIENCE,
    difficulty: DifficultyLevel.EASY,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'What do we call the push or pull that can make things move?', ar: 'ماذا نسمي الدفع أو السحب الذي يجعل الأشياء تتحرك؟' },
    options: [
      { id: 'A', text: { en: 'Mass', ar: 'كتلة' } },
      { id: 'B', text: { en: 'Force', ar: 'قوة' } },
      { id: 'C', text: { en: 'Energy', ar: 'طاقة' } },
      { id: 'D', text: { en: 'Speed', ar: 'سرعة' } }
    ],
    correctOptionId: 'B',
    timeLimit: 30,
    xpReward: 10
  },
  {
    id: 'english-062',
    subject: QuizSubject.ENGLISH,
    difficulty: DifficultyLevel.EASY,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'Complete the phrase: \'Better late than _____.\'', ar: 'Complete the phrase: \'Better late than _____.\'' },
    options: [
      { id: 'A', text: { en: 'Never', ar: 'Never' } },
      { id: 'B', text: { en: 'Sorry', ar: 'Sorry' } },
      { id: 'C', text: { en: 'Early', ar: 'Early' } },
      { id: 'D', text: { en: 'Tomorrow', ar: 'Tomorrow' } }
    ],
    correctOptionId: 'A',
    timeLimit: 30,
    xpReward: 10
  },
  {
    id: 'general-063',
    subject: QuizSubject.GENERAL,
    difficulty: DifficultyLevel.EASY,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'If a red house is made of red bricks, a blue house of blue bricks, a yellow house of yellow bricks, what is a greenhouse made of?', ar: 'إذا كان البيت الأحمر من طوب أحمر، والأزرق من طوب أزرق، فمم يُصنع البيت الزجاجي (الدفيئة)؟' },
    options: [
      { id: 'A', text: { en: 'Glass', ar: 'زجاج' } },
      { id: 'B', text: { en: 'Wood', ar: 'خشب' } },
      { id: 'C', text: { en: 'Green bricks', ar: 'طوب أخضر' } },
      { id: 'D', text: { en: 'Plastic', ar: 'بلاستيك' } }
    ],
    correctOptionId: 'A',
    timeLimit: 30,
    xpReward: 10
  },
  {
    id: 'english-064',
    subject: QuizSubject.ENGLISH,
    difficulty: DifficultyLevel.EASY,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'His explanation was so _____ that nobody understood it.', ar: 'His explanation was so _____ that nobody understood it.' },
    options: [
      { id: 'A', text: { en: 'Confusing', ar: 'Confusing' } },
      { id: 'B', text: { en: 'Simple', ar: 'Simple' } },
      { id: 'C', text: { en: 'Clear', ar: 'Clear' } },
      { id: 'D', text: { en: 'Short', ar: 'Short' } }
    ],
    correctOptionId: 'A',
    timeLimit: 30,
    xpReward: 10
  },
  {
    id: 'science-065',
    subject: QuizSubject.SCIENCE,
    difficulty: DifficultyLevel.EASY,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'What is the boiling point of water in Celsius?', ar: 'ما درجة غليان الماء بالدرجة المئوية؟' },
    options: [
      { id: 'A', text: { en: '50', ar: '٥٠' } },
      { id: 'B', text: { en: '75', ar: '٧٥' } },
      { id: 'C', text: { en: '100', ar: '١٠٠' } },
      { id: 'D', text: { en: '212', ar: '٢١٢' } }
    ],
    correctOptionId: 'C',
    timeLimit: 30,
    xpReward: 10
  },
  {
    id: 'general-066',
    subject: QuizSubject.GENERAL,
    difficulty: DifficultyLevel.EASY,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'Why did the banana go to the doctor?', ar: 'لماذا ذهبت الموزة إلى الطبيب؟' },
    options: [
      { id: 'A', text: { en: 'It wasn\'t peeling well', ar: 'لم تكن تقشر جيداً' } },
      { id: 'B', text: { en: 'It slipped', ar: 'انزلقت' } },
      { id: 'C', text: { en: 'It was yellow', ar: 'كانت صفراء' } },
      { id: 'D', text: { en: 'Hungry', ar: 'جائعة' } }
    ],
    correctOptionId: 'A',
    timeLimit: 30,
    xpReward: 10
  },
  {
    id: 'science-067',
    subject: QuizSubject.SCIENCE,
    difficulty: DifficultyLevel.EASY,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'What is the largest planet in our solar system?', ar: 'ما أكبر كوكب في مجموعتنا الشمسية؟' },
    options: [
      { id: 'A', text: { en: 'Mars', ar: 'المريخ' } },
      { id: 'B', text: { en: 'Saturn', ar: 'زحل' } },
      { id: 'C', text: { en: 'Earth', ar: 'الأرض' } },
      { id: 'D', text: { en: 'Jupiter', ar: 'المشتري' } }
    ],
    correctOptionId: 'D',
    timeLimit: 30,
    xpReward: 10
  },
  {
    id: 'general-068',
    subject: QuizSubject.GENERAL,
    difficulty: DifficultyLevel.EASY,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'What is always coming but never arrives?', ar: 'ما الذي يأتي دائماً لكنه لا يصل أبداً؟' },
    options: [
      { id: 'A', text: { en: 'Rain', ar: 'المطر' } },
      { id: 'B', text: { en: 'A guest', ar: 'ضيف' } },
      { id: 'C', text: { en: 'Tomorrow', ar: 'الغد' } },
      { id: 'D', text: { en: 'A bus', ar: 'حافلة' } }
    ],
    correctOptionId: 'C',
    timeLimit: 30,
    xpReward: 10
  },
  {
    id: 'general-069',
    subject: QuizSubject.GENERAL,
    difficulty: DifficultyLevel.EASY,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'This is the longest river in the world.', ar: 'هذا هو أطول نهر في العالم.' },
    options: [
      { id: 'A', text: { en: 'Nile River', ar: 'نهر النيل' } },
      { id: 'B', text: { en: 'Yangtze River', ar: 'نهر اليانغتسي' } },
      { id: 'C', text: { en: 'Mississippi River', ar: 'نهر المسيسيبي' } },
      { id: 'D', text: { en: 'Amazon River', ar: 'نهر الأمازون' } }
    ],
    correctOptionId: 'A',
    timeLimit: 30,
    xpReward: 10
  },
  {
    id: 'arabic-070',
    subject: QuizSubject.ARABIC,
    difficulty: DifficultyLevel.EASY,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'أكمل:(العقل _____ – الذكاء جميل).', ar: 'أكمل:(العقل _____ – الذكاء جميل).' },
    options: [
      { id: 'A', text: { en: 'زينة', ar: 'زينة' } },
      { id: 'B', text: { en: 'زينة', ar: 'زينة' } },
      { id: 'C', text: { en: 'كنز', ar: 'كنز' } },
      { id: 'D', text: { en: 'هدية', ar: 'هدية' } }
    ],
    correctOptionId: 'B',
    timeLimit: 30,
    xpReward: 10
  },
  {
    id: 'general-071',
    subject: QuizSubject.GENERAL,
    difficulty: DifficultyLevel.MEDIUM,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'What is black when you buy it, red when you use it, and gray when you throw it away?', ar: 'ما الذي يكون أسود عند شرائه، وأحمر عند استخدامه، ورمادياً عند رميه؟' },
    options: [
      { id: 'A', text: { en: 'A date', ar: 'تمرة' } },
      { id: 'B', text: { en: 'Charcoal', ar: 'فحم' } },
      { id: 'C', text: { en: 'A tire', ar: 'إطار' } },
      { id: 'D', text: { en: 'A newspaper', ar: 'جريدة' } }
    ],
    correctOptionId: 'B',
    timeLimit: 30,
    xpReward: 20
  },
  {
    id: 'general-072',
    subject: QuizSubject.GENERAL,
    difficulty: DifficultyLevel.EASY,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'Why do bicycles fall over?', ar: 'لماذا تقع الدراجات الهوائية؟' },
    options: [
      { id: 'A', text: { en: 'Broken', ar: 'مكسورة' } },
      { id: 'B', text: { en: 'They\'re two-tired', ar: 'لأنها ذات عجلتين متعبتين' } },
      { id: 'C', text: { en: 'Lazy wheels', ar: 'عجلات كسولة' } },
      { id: 'D', text: { en: 'No balance', ar: 'لا توازن' } }
    ],
    correctOptionId: 'B',
    timeLimit: 30,
    xpReward: 10
  },
  {
    id: 'general-073',
    subject: QuizSubject.GENERAL,
    difficulty: DifficultyLevel.EASY,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'What can travel around the world while staying in a corner?', ar: 'ما الذي يسافر حول العالم وهو في زاوية؟' },
    options: [
      { id: 'A', text: { en: 'A falcon', ar: 'صقر' } },
      { id: 'B', text: { en: 'A plane', ar: 'طائرة' } },
      { id: 'C', text: { en: 'A shadow', ar: 'ظل' } },
      { id: 'D', text: { en: 'A stamp', ar: 'طابع بريد' } }
    ],
    correctOptionId: 'D',
    timeLimit: 30,
    xpReward: 10
  },
  {
    id: 'general-074',
    subject: QuizSubject.GENERAL,
    difficulty: DifficultyLevel.EASY,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'How many players are needed to start a basketball game (minimum on court)?', ar: 'كم عدد اللاعبين اللازمين لبدء مباراة كرة سلة (كحد أدنى في الملعب)؟' },
    options: [
      { id: 'A', text: { en: '5', ar: '٥' } },
      { id: 'B', text: { en: '10', ar: '١٠' } },
      { id: 'C', text: { en: '6', ar: '٦' } },
      { id: 'D', text: { en: '4', ar: '٤' } }
    ],
    correctOptionId: 'A',
    timeLimit: 30,
    xpReward: 10
  },
  {
    id: 'general-075',
    subject: QuizSubject.GENERAL,
    difficulty: DifficultyLevel.HARD,
    gradeRange: { min: 6, max: 8 },
    text: { en: 'Which Saudi woman was the first female pilot licensed by GACA?', ar: 'من هي أول امرأة سعودية حصلت على رخصة طيران من هيئة الطيران المدني؟' },
    options: [
      { id: 'A', text: { en: 'Haya bint Hussein', ar: 'هيا بنت حسين' } },
      { id: 'B', text: { en: 'Arwa Al-Mutairi', ar: 'أروى المطيري' } },
      { id: 'C', text: { en: 'Reema Bandar Al-Saud', ar: 'ريما بندر آل سعود' } },
      { id: 'D', text: { en: 'None', ar: 'لا أحد' } }
    ],
    correctOptionId: 'B',
    timeLimit: 30,
    xpReward: 35
  },
  {
    id: 'science-076',
    subject: QuizSubject.SCIENCE,
    difficulty: DifficultyLevel.EASY,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'What is the hardest natural substance on Earth?', ar: 'ما أصلب مادة طبيعية على الأرض؟' },
    options: [
      { id: 'A', text: { en: 'Gold', ar: 'ذهب' } },
      { id: 'B', text: { en: 'Steel', ar: 'فولاذ' } },
      { id: 'C', text: { en: 'Iron', ar: 'حديد' } },
      { id: 'D', text: { en: 'Diamond', ar: 'ألماس' } }
    ],
    correctOptionId: 'D',
    timeLimit: 30,
    xpReward: 10
  },
  {
    id: 'general-077',
    subject: QuizSubject.GENERAL,
    difficulty: DifficultyLevel.EASY,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'What do cows drink in the summer?', ar: 'ماذا تشرب الأبقار في الصيف؟' },
    options: [
      { id: 'A', text: { en: 'Water', ar: 'ماء' } },
      { id: 'B', text: { en: 'Orange Juice', ar: 'عصير برتقال' } },
      { id: 'C', text: { en: 'Coffee', ar: 'قهوة' } },
      { id: 'D', text: { en: 'Milk', ar: 'حليب' } }
    ],
    correctOptionId: 'A',
    timeLimit: 30,
    xpReward: 10
  },
  {
    id: 'general-078',
    subject: QuizSubject.GENERAL,
    difficulty: DifficultyLevel.EASY,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'Why did the student eat his homework?', ar: 'لماذا أكل الطالب واجبه المنزلي؟' },
    options: [
      { id: 'A', text: { en: 'To make it disappear', ar: 'لإخفائه' } },
      { id: 'B', text: { en: 'Teacher said it was a piece of cake', ar: 'المعلم قال إنه سهل جداً' } },
      { id: 'C', text: { en: 'It was due tomorrow', ar: 'كان مستحقاً غداً' } },
      { id: 'D', text: { en: 'He was hungry for knowledge', ar: 'كان متعطشاً للمعرفة' } }
    ],
    correctOptionId: 'B',
    timeLimit: 30,
    xpReward: 10
  },
  {
    id: 'arabic-079',
    subject: QuizSubject.ARABIC,
    difficulty: DifficultyLevel.EASY,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'أكمل:(من جدّ _____).', ar: 'أكمل:(من جدّ _____).' },
    options: [
      { id: 'A', text: { en: 'سيجد', ar: 'سيجد' } },
      { id: 'B', text: { en: 'ينجح', ar: 'ينجح' } },
      { id: 'C', text: { en: 'وجد', ar: 'وجد' } },
      { id: 'D', text: { en: 'يفوز', ar: 'يفوز' } }
    ],
    correctOptionId: 'C',
    timeLimit: 30,
    xpReward: 10
  },
  {
    id: 'english-080',
    subject: QuizSubject.ENGLISH,
    difficulty: DifficultyLevel.EASY,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'What is a synonym for \'enormous\'?', ar: 'What is a synonym for \'enormous\'?' },
    options: [
      { id: 'A', text: { en: 'Small', ar: 'Small' } },
      { id: 'B', text: { en: 'Tiny', ar: 'Tiny' } },
      { id: 'C', text: { en: 'Huge', ar: 'Huge' } },
      { id: 'D', text: { en: 'Mild', ar: 'Mild' } }
    ],
    correctOptionId: 'C',
    timeLimit: 30,
    xpReward: 10
  },
  {
    id: 'general-081',
    subject: QuizSubject.GENERAL,
    difficulty: DifficultyLevel.EASY,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'This building has the most stories.', ar: 'هذا المبنى يملك أكثر القصص.' },
    options: [
      { id: 'A', text: { en: 'A hotel', ar: 'فندق' } },
      { id: 'B', text: { en: 'A school', ar: 'مدرسة' } },
      { id: 'C', text: { en: 'A library', ar: 'مكتبة' } },
      { id: 'D', text: { en: 'A tall tower', ar: 'برج طويل' } }
    ],
    correctOptionId: 'C',
    timeLimit: 30,
    xpReward: 10
  },
  {
    id: 'science-082',
    subject: QuizSubject.SCIENCE,
    difficulty: DifficultyLevel.EASY,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'What gas do plants absorb during photosynthesis?', ar: 'ما الغاز الذي تمتصه النباتات أثناء البناء الضوئي؟' },
    options: [
      { id: 'A', text: { en: 'Carbon dioxide', ar: 'ثاني أكسيد الكربون' } },
      { id: 'B', text: { en: 'Hydrogen', ar: 'هيدروجين' } },
      { id: 'C', text: { en: 'Nitrogen', ar: 'نيتروجين' } },
      { id: 'D', text: { en: 'Oxygen', ar: 'أكسجين' } }
    ],
    correctOptionId: 'A',
    timeLimit: 30,
    xpReward: 10
  },
  {
    id: 'general-083',
    subject: QuizSubject.GENERAL,
    difficulty: DifficultyLevel.HARD,
    gradeRange: { min: 6, max: 8 },
    text: { en: 'What is the tallest lighthouse in the world, located in Jeddah?', ar: 'ما أطول منارة في العالم، وتقع في جدة؟' },
    options: [
      { id: 'A', text: { en: 'Cape Hatteras', ar: 'كيب هاتيراس' } },
      { id: 'B', text: { en: 'Lighthouse of Alexandria', ar: 'منارة الإسكندرية' } },
      { id: 'C', text: { en: 'Pharos', ar: 'فاروس' } },
      { id: 'D', text: { en: 'Jeddah Light', ar: 'منارة جدة' } }
    ],
    correctOptionId: 'D',
    timeLimit: 30,
    xpReward: 35
  },
  {
    id: 'science-084',
    subject: QuizSubject.SCIENCE,
    difficulty: DifficultyLevel.EASY,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'What do bees make?', ar: 'ماذا يصنع النحل؟' },
    options: [
      { id: 'A', text: { en: 'Honey', ar: 'عسل' } },
      { id: 'B', text: { en: 'Wax only', ar: 'شمع فقط' } },
      { id: 'C', text: { en: 'Sugar', ar: 'سكر' } },
      { id: 'D', text: { en: 'Milk', ar: 'حليب' } }
    ],
    correctOptionId: 'A',
    timeLimit: 30,
    xpReward: 10
  },
  {
    id: 'general-085',
    subject: QuizSubject.GENERAL,
    difficulty: DifficultyLevel.EASY,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'Which country is home to the Eiffel Tower?', ar: 'أي بلد يوجد فيه برج إيفل؟' },
    options: [
      { id: 'A', text: { en: 'France', ar: 'فرنسا' } },
      { id: 'B', text: { en: 'Germany', ar: 'ألمانيا' } },
      { id: 'C', text: { en: 'Spain', ar: 'إسبانيا' } },
      { id: 'D', text: { en: 'Italy', ar: 'إيطاليا' } }
    ],
    correctOptionId: 'A',
    timeLimit: 30,
    xpReward: 10
  },
  {
    id: 'general-086',
    subject: QuizSubject.GENERAL,
    difficulty: DifficultyLevel.EASY,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'How many players are on a football team on the field at one time?', ar: 'كم عدد لاعبي فريق كرة القدم في الملعب في وقت واحد؟' },
    options: [
      { id: 'A', text: { en: '12', ar: '١٢' } },
      { id: 'B', text: { en: '9', ar: '٩' } },
      { id: 'C', text: { en: '10', ar: '١٠' } },
      { id: 'D', text: { en: '11', ar: '١١' } }
    ],
    correctOptionId: 'D',
    timeLimit: 30,
    xpReward: 10
  },
  {
    id: 'english-087',
    subject: QuizSubject.ENGLISH,
    difficulty: DifficultyLevel.EASY,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'What is a synonym for \'cautious\'?', ar: 'What is a synonym for \'cautious\'?' },
    options: [
      { id: 'A', text: { en: 'Fast', ar: 'Fast' } },
      { id: 'B', text: { en: 'Careful', ar: 'Careful' } },
      { id: 'C', text: { en: 'Reckless', ar: 'Reckless' } },
      { id: 'D', text: { en: 'Brave', ar: 'Brave' } }
    ],
    correctOptionId: 'B',
    timeLimit: 30,
    xpReward: 10
  },
  {
    id: 'general-088',
    subject: QuizSubject.GENERAL,
    difficulty: DifficultyLevel.MEDIUM,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'I speak without a mouth and hear without ears. I have no body, but I come alive with the wind. What am I?', ar: 'أتكلم بلا فم وأسمع بلا أذنين. ليس لي جسد لكنني أحيا مع الريح. من أنا؟' },
    options: [
      { id: 'A', text: { en: 'An echo', ar: 'صدى' } },
      { id: 'B', text: { en: 'A shadow', ar: 'ظل' } },
      { id: 'C', text: { en: 'A ghost', ar: 'شبح' } },
      { id: 'D', text: { en: 'The desert wind', ar: 'ريح الصحراء' } }
    ],
    correctOptionId: 'A',
    timeLimit: 30,
    xpReward: 20
  },
  {
    id: 'general-089',
    subject: QuizSubject.GENERAL,
    difficulty: DifficultyLevel.EASY,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'What can you catch but not throw?', ar: 'ما الذي يمكنك أن تلتقطه لكن لا يمكنك رميه؟' },
    options: [
      { id: 'A', text: { en: 'A ball', ar: 'كرة' } },
      { id: 'B', text: { en: 'A camel ride', ar: 'ركوب جمل' } },
      { id: 'C', text: { en: 'A cold', ar: 'زكام' } },
      { id: 'D', text: { en: 'A fish', ar: 'سمكة' } }
    ],
    correctOptionId: 'C',
    timeLimit: 30,
    xpReward: 10
  },
  {
    id: 'general-090',
    subject: QuizSubject.GENERAL,
    difficulty: DifficultyLevel.EASY,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'What do you call a bear with no teeth?', ar: 'ماذا تسمي دباً بلا أسنان؟' },
    options: [
      { id: 'A', text: { en: 'Toothless', ar: 'بلا أسنان' } },
      { id: 'B', text: { en: 'Soft bear', ar: 'دب ناعم' } },
      { id: 'C', text: { en: 'Candy bear', ar: 'دب حلوى' } },
      { id: 'D', text: { en: 'A gummy bear', ar: 'دب جيلاتين' } }
    ],
    correctOptionId: 'D',
    timeLimit: 30,
    xpReward: 10
  },
  {
    id: 'english-091',
    subject: QuizSubject.ENGLISH,
    difficulty: DifficultyLevel.MEDIUM,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'Which idiom means \'to do something exactly right\'?', ar: 'Which idiom means \'to do something exactly right\'?' },
    options: [
      { id: 'A', text: { en: 'Hit the nail on the head', ar: 'Hit the nail on the head' } },
      { id: 'B', text: { en: 'Spill the tea', ar: 'Spill the tea' } },
      { id: 'C', text: { en: 'Break a leg', ar: 'Break a leg' } },
      { id: 'D', text: { en: 'Bite the bullet', ar: 'Bite the bullet' } }
    ],
    correctOptionId: 'A',
    timeLimit: 30,
    xpReward: 20
  },
  {
    id: 'general-092',
    subject: QuizSubject.GENERAL,
    difficulty: DifficultyLevel.EASY,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'I have cities, but no houses. I have mountains, but no trees. I have water, but no fish. What am I?', ar: 'لدي مدن لكن بلا بيوت. لدي جبال لكن بلا أشجار. لدي ماء لكن بلا أسماك. من أنا؟' },
    options: [
      { id: 'A', text: { en: 'A map', ar: 'خريطة' } },
      { id: 'B', text: { en: 'A desert', ar: 'صحراء' } },
      { id: 'C', text: { en: 'The sky', ar: 'سماء' } },
      { id: 'D', text: { en: 'A dream', ar: 'حلم' } }
    ],
    correctOptionId: 'A',
    timeLimit: 30,
    xpReward: 10
  },
  {
    id: 'math-093',
    subject: QuizSubject.MATH,
    difficulty: DifficultyLevel.EASY,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'Sara is 8 years old and her brother Khalid is twice her age. When Sara is 12 years old, how old will Khalid be?', ar: 'سارة عمرها ٨ سنوات وأخوها خالد ضعف عمرها. عندما تبلغ سارة ١٢ سنة، كم سيكون عمر خالد؟' },
    options: [
      { id: 'A', text: { en: '27', ar: '٢٧' } },
      { id: 'B', text: { en: '20', ar: '٢٠' } },
      { id: 'C', text: { en: '36', ar: '٣٦' } },
      { id: 'D', text: { en: '24', ar: '٢٤' } }
    ],
    correctOptionId: 'B',
    timeLimit: 30,
    xpReward: 10
  },
  {
    id: 'english-094',
    subject: QuizSubject.ENGLISH,
    difficulty: DifficultyLevel.MEDIUM,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'What does the word \'persevere\' mean?', ar: 'What does the word \'persevere\' mean?' },
    options: [
      { id: 'A', text: { en: 'Run away', ar: 'Run away' } },
      { id: 'B', text: { en: 'Forget', ar: 'Forget' } },
      { id: 'C', text: { en: 'Give up', ar: 'Give up' } },
      { id: 'D', text: { en: 'Continue despite difficulties', ar: 'Continue despite difficulties' } }
    ],
    correctOptionId: 'D',
    timeLimit: 30,
    xpReward: 20
  },
  {
    id: 'general-095',
    subject: QuizSubject.GENERAL,
    difficulty: DifficultyLevel.EASY,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'What color is the circle in the middle of the Japanese flag?', ar: 'ما لون الدائرة في وسط العلم الياباني؟' },
    options: [
      { id: 'A', text: { en: 'White', ar: 'أبيض' } },
      { id: 'B', text: { en: 'Green', ar: 'أخضر' } },
      { id: 'C', text: { en: 'Red', ar: 'أحمر' } },
      { id: 'D', text: { en: 'Blue', ar: 'أزرق' } }
    ],
    correctOptionId: 'C',
    timeLimit: 30,
    xpReward: 10
  },
  {
    id: 'general-096',
    subject: QuizSubject.GENERAL,
    difficulty: DifficultyLevel.MEDIUM,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'What is the largest sand desert in the world?', ar: 'ما أكبر صحراء رملية في العالم؟' },
    options: [
      { id: 'A', text: { en: 'Kalahari', ar: 'كالاهاري' } },
      { id: 'B', text: { en: 'Rub\' al-Khali', ar: 'الربع الخالي' } },
      { id: 'C', text: { en: 'Sahara Desert', ar: 'الصحراء الكبرى' } },
      { id: 'D', text: { en: 'Gobi Desert', ar: 'صحراء غوبي' } }
    ],
    correctOptionId: 'B',
    timeLimit: 30,
    xpReward: 20
  },
  {
    id: 'general-097',
    subject: QuizSubject.GENERAL,
    difficulty: DifficultyLevel.EASY,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'How many continents are there?', ar: 'كم عدد القارات في العالم؟' },
    options: [
      { id: 'A', text: { en: '6', ar: '٦' } },
      { id: 'B', text: { en: '8', ar: '٨' } },
      { id: 'C', text: { en: '5', ar: '٥' } },
      { id: 'D', text: { en: '7', ar: '٧' } }
    ],
    correctOptionId: 'D',
    timeLimit: 30,
    xpReward: 10
  },
  {
    id: 'general-098',
    subject: QuizSubject.GENERAL,
    difficulty: DifficultyLevel.EASY,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'What invention lets you look right through a wall?', ar: 'أي اختراع يتيح لك النظر عبر الجدار؟' },
    options: [
      { id: 'A', text: { en: 'X-ray', ar: 'أشعة سينية' } },
      { id: 'B', text: { en: 'A window', ar: 'نافذة' } },
      { id: 'C', text: { en: 'A door', ar: 'باب' } },
      { id: 'D', text: { en: 'A mirror', ar: 'مرآة' } }
    ],
    correctOptionId: 'B',
    timeLimit: 30,
    xpReward: 10
  },
  {
    id: 'science-099',
    subject: QuizSubject.SCIENCE,
    difficulty: DifficultyLevel.EASY,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'Which organ pumps blood around the body?', ar: 'أي عضو يضخ الدم في الجسم؟' },
    options: [
      { id: 'A', text: { en: 'Lungs', ar: 'الرئتان' } },
      { id: 'B', text: { en: 'Heart', ar: 'القلب' } },
      { id: 'C', text: { en: 'Brain', ar: 'الدماغ' } },
      { id: 'D', text: { en: 'Liver', ar: 'الكبد' } }
    ],
    correctOptionId: 'B',
    timeLimit: 30,
    xpReward: 10
  },
  {
    id: 'general-100',
    subject: QuizSubject.GENERAL,
    difficulty: DifficultyLevel.MEDIUM,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'Saudi Arabia has no permanent rivers on the surface.', ar: 'السعودية ليس لديها أنهار دائمة على السطح.' },
    options: [
      { id: 'A', text: { en: 'False', ar: 'خطأ' } },
      { id: 'B', text: { en: 'True', ar: 'صح' } },
      { id: 'C', text: { en: 'Only underground', ar: 'تحت الأرض فقط' } },
      { id: 'D', text: { en: 'Only in winter', ar: 'في الشتاء فقط' } }
    ],
    correctOptionId: 'B',
    timeLimit: 30,
    xpReward: 20
  },
  {
    id: 'science-101',
    subject: QuizSubject.SCIENCE,
    difficulty: DifficultyLevel.EASY,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'Which force makes it hard to slide a heavy box across the floor?', ar: 'أي قوة تجعل من الصعب دفع صندوق ثقيل على الأرض؟' },
    options: [
      { id: 'A', text: { en: 'Magnetism', ar: 'المغناطيسية' } },
      { id: 'B', text: { en: 'Tension', ar: 'التوتر' } },
      { id: 'C', text: { en: 'Gravity', ar: 'الجاذبية' } },
      { id: 'D', text: { en: 'Friction', ar: 'الاحتكاك' } }
    ],
    correctOptionId: 'D',
    timeLimit: 30,
    xpReward: 10
  },
  {
    id: 'science-102',
    subject: QuizSubject.SCIENCE,
    difficulty: DifficultyLevel.EASY,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'Which simple machine uses a wheel with a rope to lift objects?', ar: 'أي آلة بسيطة تستخدم عجلة وحبلاً لرفع الأشياء؟' },
    options: [
      { id: 'A', text: { en: 'Pulley', ar: 'بكرة' } },
      { id: 'B', text: { en: 'Lever', ar: 'رافعة' } },
      { id: 'C', text: { en: 'Screw', ar: 'برغي' } },
      { id: 'D', text: { en: 'Wedge', ar: 'إسفين' } }
    ],
    correctOptionId: 'A',
    timeLimit: 30,
    xpReward: 10
  },
  {
    id: 'english-103',
    subject: QuizSubject.ENGLISH,
    difficulty: DifficultyLevel.EASY,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'Which word means \'extremely angry\'?', ar: 'Which word means \'extremely angry\'?' },
    options: [
      { id: 'A', text: { en: 'Furious', ar: 'Furious' } },
      { id: 'B', text: { en: 'Happy', ar: 'Happy' } },
      { id: 'C', text: { en: 'Tired', ar: 'Tired' } },
      { id: 'D', text: { en: 'Calm', ar: 'Calm' } }
    ],
    correctOptionId: 'A',
    timeLimit: 30,
    xpReward: 10
  },
  {
    id: 'arabic-104',
    subject: QuizSubject.ARABIC,
    difficulty: DifficultyLevel.EASY,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'أكمل:(البيت بيت_____).', ar: 'أكمل:(البيت بيت_____).' },
    options: [
      { id: 'A', text: { en: 'نا', ar: 'نا' } },
      { id: 'B', text: { en: 'ي', ar: 'ي' } },
      { id: 'C', text: { en: 'ك', ar: 'ك' } },
      { id: 'D', text: { en: 'ه', ar: 'ه' } }
    ],
    correctOptionId: 'C',
    timeLimit: 30,
    xpReward: 10
  },
  {
    id: 'general-105',
    subject: QuizSubject.GENERAL,
    difficulty: DifficultyLevel.EASY,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'Complete: \'I\'m reading a book on anti-gravity... it\'s impossible to put... \'', ar: 'أكمل: "أقرأ كتاباً عن انعدام الجاذبية... من المستحيل أن أضعه..."' },
    options: [
      { id: 'A', text: { en: 'Away', ar: 'بعيداً' } },
      { id: 'B', text: { en: 'Up', ar: 'فوق' } },
      { id: 'C', text: { en: 'Down', ar: 'أسفل' } },
      { id: 'D', text: { en: 'Sideways', ar: 'جانباً' } }
    ],
    correctOptionId: 'C',
    timeLimit: 30,
    xpReward: 10
  },
  {
    id: 'general-106',
    subject: QuizSubject.GENERAL,
    difficulty: DifficultyLevel.EASY,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'I am not alive, but I grow; I don\'t have lungs, but I need air, but water kills me. What am I?', ar: 'لست حياً لكنني أنمو؛ ليس لي رئتان لكنني أحتاج هواءً، والماء يقتلني. من أنا؟' },
    options: [
      { id: 'A', text: { en: 'A cloud', ar: 'سحابة' } },
      { id: 'B', text: { en: 'Fire', ar: 'نار' } },
      { id: 'C', text: { en: 'A balloon', ar: 'بالون' } },
      { id: 'D', text: { en: 'A plant', ar: 'نبتة' } }
    ],
    correctOptionId: 'B',
    timeLimit: 30,
    xpReward: 10
  },
  {
    id: 'general-107',
    subject: QuizSubject.GENERAL,
    difficulty: DifficultyLevel.EASY,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'What can fill a room but takes up no space?', ar: 'ما الذي يملأ غرفة لكنه لا يشغل حيزاً؟' },
    options: [
      { id: 'A', text: { en: 'Air', ar: 'هواء' } },
      { id: 'B', text: { en: 'Smoke', ar: 'دخان' } },
      { id: 'C', text: { en: 'Darkness', ar: 'ظلام' } },
      { id: 'D', text: { en: 'Light', ar: 'ضوء' } }
    ],
    correctOptionId: 'D',
    timeLimit: 30,
    xpReward: 10
  },
  {
    id: 'general-108',
    subject: QuizSubject.GENERAL,
    difficulty: DifficultyLevel.EASY,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'What is the capital of Japan?', ar: 'ما عاصمة اليابان؟' },
    options: [
      { id: 'A', text: { en: 'Bangkok', ar: 'بانكوك' } },
      { id: 'B', text: { en: 'Tokyo', ar: 'طوكيو' } },
      { id: 'C', text: { en: 'Beijing', ar: 'بكين' } },
      { id: 'D', text: { en: 'Seoul', ar: 'سيول' } }
    ],
    correctOptionId: 'B',
    timeLimit: 30,
    xpReward: 10
  },
  {
    id: 'science-109',
    subject: QuizSubject.SCIENCE,
    difficulty: DifficultyLevel.MEDIUM,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'Sound  _______ when it travels through water', ar: 'الصوت _____ عندما ينتقل عبر الماء.' },
    options: [
      { id: 'A', text: { en: 'disappears', ar: 'يختفي' } },
      { id: 'B', text: { en: 'moves slower', ar: 'يتحرك أبطأ' } },
      { id: 'C', text: { en: 'moves faster', ar: 'يتحرك أسرع' } },
      { id: 'D', text: { en: 'stops', ar: 'يتوقف' } }
    ],
    correctOptionId: 'C',
    timeLimit: 30,
    xpReward: 20
  },
  {
    id: 'general-110',
    subject: QuizSubject.GENERAL,
    difficulty: DifficultyLevel.EASY,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'What do players kick in football?', ar: 'ماذا يركل اللاعبون في كرة القدم؟' },
    options: [
      { id: 'A', text: { en: 'Basketball', ar: 'كرة سلة' } },
      { id: 'B', text: { en: 'Ball', ar: 'كرة' } },
      { id: 'C', text: { en: 'Players', ar: 'لاعبين' } },
      { id: 'D', text: { en: 'Puck', ar: 'قرص' } }
    ],
    correctOptionId: 'B',
    timeLimit: 30,
    xpReward: 10
  },
  {
    id: 'english-111',
    subject: QuizSubject.ENGLISH,
    difficulty: DifficultyLevel.MEDIUM,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'What does \'resilient\' mean?', ar: 'What does \'resilient\' mean?' },
    options: [
      { id: 'A', text: { en: 'Lazy', ar: 'Lazy' } },
      { id: 'B', text: { en: 'Afraid', ar: 'Afraid' } },
      { id: 'C', text: { en: 'Able to recover quickly from difficulties', ar: 'Able to recover quickly from difficulties' } },
      { id: 'D', text: { en: 'Weak', ar: 'Weak' } }
    ],
    correctOptionId: 'C',
    timeLimit: 30,
    xpReward: 20
  },
  {
    id: 'general-112',
    subject: QuizSubject.GENERAL,
    difficulty: DifficultyLevel.MEDIUM,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'What traditional Saudi sweet is made from semolina, ghee, and sugar syrup?', ar: 'ما الحلوى السعودية التقليدية المصنوعة من السميد والسمن وشراب السكر؟' },
    options: [
      { id: 'A', text: { en: 'Kunafa', ar: 'كنافة' } },
      { id: 'B', text: { en: 'Ma\'amoul', ar: 'معمول' } },
      { id: 'C', text: { en: 'Baklava', ar: 'بقلاوة' } },
      { id: 'D', text: { en: 'Harisa / Harees sweet version', ar: 'هريسة حلوة' } }
    ],
    correctOptionId: 'B',
    timeLimit: 30,
    xpReward: 20
  },
  {
    id: 'general-113',
    subject: QuizSubject.GENERAL,
    difficulty: DifficultyLevel.EASY,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'How many continents are there?', ar: 'كم عدد القارات في العالم؟' },
    options: [
      { id: 'A', text: { en: '8', ar: '٨' } },
      { id: 'B', text: { en: '7', ar: '٧' } },
      { id: 'C', text: { en: '6', ar: '٦' } },
      { id: 'D', text: { en: '5', ar: '٥' } }
    ],
    correctOptionId: 'B',
    timeLimit: 30,
    xpReward: 10
  },
  {
    id: 'general-114',
    subject: QuizSubject.GENERAL,
    difficulty: DifficultyLevel.HARD,
    gradeRange: { min: 6, max: 8 },
    text: { en: 'Which ancient Saudi site is called \'the sister of Petra\'?', ar: 'أي موقع سعودي أثري يُسمى "أخت البتراء"؟' },
    options: [
      { id: 'A', text: { en: 'Jubbah', ar: 'جبة' } },
      { id: 'B', text: { en: 'Al-Ula', ar: 'العلا' } },
      { id: 'C', text: { en: 'Hegra (Mada\'in Saleh)', ar: 'الحِجر (مدائن صالح)' } },
      { id: 'D', text: { en: 'Diriyah', ar: 'الدرعية' } }
    ],
    correctOptionId: 'C',
    timeLimit: 30,
    xpReward: 35
  },
  {
    id: 'general-115',
    subject: QuizSubject.GENERAL,
    difficulty: DifficultyLevel.EASY,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'I follow you all day long, But when the night or rain comes, I am gone. What am I?', ar: 'أتبعك طوال اليوم، لكن عندما يأتي الليل أو المطر أختفي. من أنا؟' },
    options: [
      { id: 'A', text: { en: 'Your shadow', ar: 'ظلك' } },
      { id: 'B', text: { en: 'A cloud', ar: 'سحابة' } },
      { id: 'C', text: { en: 'Your friend', ar: 'صديقك' } },
      { id: 'D', text: { en: 'A memory', ar: 'ذكرى' } }
    ],
    correctOptionId: 'A',
    timeLimit: 30,
    xpReward: 10
  },
  {
    id: 'general-116',
    subject: QuizSubject.GENERAL,
    difficulty: DifficultyLevel.EASY,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'Which ocean is the largest?', ar: 'أي محيط هو الأكبر؟' },
    options: [
      { id: 'A', text: { en: 'Atlantic', ar: 'الأطلسي' } },
      { id: 'B', text: { en: 'Indian', ar: 'الهندي' } },
      { id: 'C', text: { en: 'Pacific', ar: 'الهادئ' } },
      { id: 'D', text: { en: 'Arctic', ar: 'المتجمد الشمالي' } }
    ],
    correctOptionId: 'C',
    timeLimit: 30,
    xpReward: 10
  },
  {
    id: 'general-117',
    subject: QuizSubject.GENERAL,
    difficulty: DifficultyLevel.EASY,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'What animal is called the \'ship of the desert\' and used for travel in the past?', ar: 'ما الحيوان الذي يُسمى "سفينة الصحراء"؟' },
    options: [
      { id: 'A', text: { en: 'Oryx', ar: 'المها' } },
      { id: 'B', text: { en: 'Camel', ar: 'الجمل' } },
      { id: 'C', text: { en: 'Donkey', ar: 'الحمار' } },
      { id: 'D', text: { en: 'Horse', ar: 'الحصان' } }
    ],
    correctOptionId: 'B',
    timeLimit: 30,
    xpReward: 10
  },
  {
    id: 'english-118',
    subject: QuizSubject.ENGLISH,
    difficulty: DifficultyLevel.EASY,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'Complete the phrase: \'The early bird catches the _____.\'', ar: 'Complete the phrase: \'The early bird catches the _____.\'' },
    options: [
      { id: 'A', text: { en: 'Worm', ar: 'Worm' } },
      { id: 'B', text: { en: 'Train', ar: 'Train' } },
      { id: 'C', text: { en: 'Fish', ar: 'Fish' } },
      { id: 'D', text: { en: 'Bug', ar: 'Bug' } }
    ],
    correctOptionId: 'A',
    timeLimit: 30,
    xpReward: 10
  },
  {
    id: 'general-119',
    subject: QuizSubject.GENERAL,
    difficulty: DifficultyLevel.EASY,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'What is often served with Arabic coffee in Saudi hospitality?', ar: 'ما الذي يُقدم عادةً مع القهوة العربية في الضيافة السعودية؟' },
    options: [
      { id: 'A', text: { en: 'Fruit', ar: 'فواكه' } },
      { id: 'B', text: { en: 'Cake', ar: 'كعك' } },
      { id: 'C', text: { en: 'Cookies', ar: 'بسكويت' } },
      { id: 'D', text: { en: 'Dates', ar: 'تمر' } }
    ],
    correctOptionId: 'D',
    timeLimit: 30,
    xpReward: 10
  },
  {
    id: 'science-120',
    subject: QuizSubject.SCIENCE,
    difficulty: DifficultyLevel.EASY,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'Which simple machine helps lift heavy objects using a rope?', ar: 'أي آلة بسيطة تساعد في رفع الأشياء الثقيلة باستخدام حبل؟' },
    options: [
      { id: 'A', text: { en: 'Lever', ar: 'رافعة' } },
      { id: 'B', text: { en: 'Wedge', ar: 'إسفين' } },
      { id: 'C', text: { en: 'Screw', ar: 'برغي' } },
      { id: 'D', text: { en: 'Pulley', ar: 'بكرة' } }
    ],
    correctOptionId: 'D',
    timeLimit: 30,
    xpReward: 10
  },
  {
    id: 'general-121',
    subject: QuizSubject.GENERAL,
    difficulty: DifficultyLevel.EASY,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'Which continent is the largest by land area?', ar: 'أي قارة هي الأكبر من حيث المساحة؟' },
    options: [
      { id: 'A', text: { en: 'Asia', ar: 'آسيا' } },
      { id: 'B', text: { en: 'North America', ar: 'أمريكا الشمالية' } },
      { id: 'C', text: { en: 'Africa', ar: 'أفريقيا' } },
      { id: 'D', text: { en: 'Europe', ar: 'أوروبا' } }
    ],
    correctOptionId: 'A',
    timeLimit: 30,
    xpReward: 10
  },
  {
    id: 'general-122',
    subject: QuizSubject.GENERAL,
    difficulty: DifficultyLevel.MEDIUM,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'What is the capital of Australia?', ar: 'ما عاصمة أستراليا؟' },
    options: [
      { id: 'A', text: { en: 'Canberra', ar: 'كانبرا' } },
      { id: 'B', text: { en: 'Perth', ar: 'بيرث' } },
      { id: 'C', text: { en: 'Sydney', ar: 'سيدني' } },
      { id: 'D', text: { en: 'Melbourne', ar: 'ملبورن' } }
    ],
    correctOptionId: 'A',
    timeLimit: 30,
    xpReward: 20
  },
  {
    id: 'science-123',
    subject: QuizSubject.SCIENCE,
    difficulty: DifficultyLevel.EASY,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'This element has atomic number 1 and is the lightest.', ar: 'هذا العنصر رقمه الذري ١ وهو الأخف.' },
    options: [
      { id: 'A', text: { en: 'Oxygen', ar: 'أكسجين' } },
      { id: 'B', text: { en: 'Hydrogen', ar: 'هيدروجين' } },
      { id: 'C', text: { en: 'Helium', ar: 'هيليوم' } },
      { id: 'D', text: { en: 'Carbon', ar: 'كربون' } }
    ],
    correctOptionId: 'B',
    timeLimit: 30,
    xpReward: 10
  },
  {
    id: 'english-124',
    subject: QuizSubject.ENGLISH,
    difficulty: DifficultyLevel.EASY,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'Choose the correct word: The _____ sunset made everyone stop and stare.', ar: 'Choose the correct word: The _____ sunset made everyone stop and stare.' },
    options: [
      { id: 'A', text: { en: 'Dull', ar: 'Dull' } },
      { id: 'B', text: { en: 'Boring', ar: 'Boring' } },
      { id: 'C', text: { en: 'Breathtaking', ar: 'Breathtaking' } },
      { id: 'D', text: { en: 'Ordinary', ar: 'Ordinary' } }
    ],
    correctOptionId: 'C',
    timeLimit: 30,
    xpReward: 10
  },
  {
    id: 'general-125',
    subject: QuizSubject.GENERAL,
    difficulty: DifficultyLevel.EASY,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'What has hands but can\'t clap?', ar: 'ما الذي لديه يدان لكنه لا يصفق؟' },
    options: [
      { id: 'A', text: { en: 'A glove', ar: 'قفاز' } },
      { id: 'B', text: { en: 'A clock', ar: 'ساعة' } },
      { id: 'C', text: { en: 'A person without arms', ar: 'شخص بلا ذراعين' } },
      { id: 'D', text: { en: 'A statue', ar: 'تمثال' } }
    ],
    correctOptionId: 'B',
    timeLimit: 30,
    xpReward: 10
  },
  {
    id: 'general-126',
    subject: QuizSubject.GENERAL,
    difficulty: DifficultyLevel.EASY,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'What animal needs to wear a wig?', ar: 'ما الحيوان الذي يحتاج لارتداء شعر مستعار؟' },
    options: [
      { id: 'A', text: { en: 'A sheep', ar: 'خروف' } },
      { id: 'B', text: { en: 'A lion', ar: 'أسد' } },
      { id: 'C', text: { en: 'A camel with no hair', ar: 'جمل أصلع' } },
      { id: 'D', text: { en: 'A bald eagle', ar: 'نسر أصلع' } }
    ],
    correctOptionId: 'D',
    timeLimit: 30,
    xpReward: 10
  },
  {
    id: 'general-127',
    subject: QuizSubject.GENERAL,
    difficulty: DifficultyLevel.EASY,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'I am light as a feather, but the strongest person can\'t hold me for much longer than a minute. What am I?', ar: 'أنا خفيف كالريشة، لكن أقوى شخص لا يستطيع حبسي أكثر من دقيقة. من أنا؟' },
    options: [
      { id: 'A', text: { en: 'A secret', ar: 'سر' } },
      { id: 'B', text: { en: 'A smile', ar: 'ابتسامة' } },
      { id: 'C', text: { en: 'Breath', ar: 'نَفَس' } },
      { id: 'D', text: { en: 'A promise', ar: 'وعد' } }
    ],
    correctOptionId: 'C',
    timeLimit: 30,
    xpReward: 10
  },
  {
    id: 'science-128',
    subject: QuizSubject.SCIENCE,
    difficulty: DifficultyLevel.MEDIUM,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'What is the scientific name for table sugar?', ar: 'ما الاسم العلمي لسكر المائدة؟' },
    options: [
      { id: 'A', text: { en: 'Sucrose', ar: 'سكروز' } },
      { id: 'B', text: { en: 'Lactose', ar: 'لاكتوز' } },
      { id: 'C', text: { en: 'Glucose', ar: 'غلوكوز' } },
      { id: 'D', text: { en: 'Fructose', ar: 'فركتوز' } }
    ],
    correctOptionId: 'A',
    timeLimit: 30,
    xpReward: 20
  },
  {
    id: 'math-129',
    subject: QuizSubject.MATH,
    difficulty: DifficultyLevel.EASY,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'How many zeros are in one million?', ar: 'كم عدد الأصفار في المليون؟' },
    options: [
      { id: 'A', text: { en: '7', ar: '٧' } },
      { id: 'B', text: { en: '8', ar: '٨' } },
      { id: 'C', text: { en: '5', ar: '٥' } },
      { id: 'D', text: { en: '6', ar: '٦' } }
    ],
    correctOptionId: 'D',
    timeLimit: 30,
    xpReward: 10
  },
  {
    id: 'general-130',
    subject: QuizSubject.GENERAL,
    difficulty: DifficultyLevel.EASY,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'This is the inventor of the light bulb.', ar: 'هذا هو مخترع المصباح الكهربائي.' },
    options: [
      { id: 'A', text: { en: 'Nikola Tesla', ar: 'نيكولا تسلا' } },
      { id: 'B', text: { en: 'Benjamin Franklin', ar: 'بنجامين فرانكلين' } },
      { id: 'C', text: { en: 'Alexander Graham Bell', ar: 'ألكسندر غراهام بل' } },
      { id: 'D', text: { en: 'Thomas Edison', ar: 'توماس إديسون' } }
    ],
    correctOptionId: 'D',
    timeLimit: 30,
    xpReward: 10
  },
  {
    id: 'general-131',
    subject: QuizSubject.GENERAL,
    difficulty: DifficultyLevel.EASY,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'This is the author of \'Harry Potter\'.', ar: 'هذا هو مؤلف "هاري بوتر".' },
    options: [
      { id: 'A', text: { en: 'J.K. Rowling', ar: 'ج. ك. رولينغ' } },
      { id: 'B', text: { en: 'Roald Dahl', ar: 'روالد دال' } },
      { id: 'C', text: { en: 'Suzanne Collins', ar: 'سوزان كولينز' } },
      { id: 'D', text: { en: 'Rick Riordan', ar: 'ريك ريوردان' } }
    ],
    correctOptionId: 'A',
    timeLimit: 30,
    xpReward: 10
  },
  {
    id: 'general-132',
    subject: QuizSubject.GENERAL,
    difficulty: DifficultyLevel.EASY,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'What is the main ingredient in ketchup?', ar: 'ما المكون الرئيسي في الكاتشب؟' },
    options: [
      { id: 'A', text: { en: 'Apples', ar: 'تفاح' } },
      { id: 'B', text: { en: 'Peppers', ar: 'فلفل' } },
      { id: 'C', text: { en: 'Tomatoes', ar: 'طماطم' } },
      { id: 'D', text: { en: 'Carrots', ar: 'جزر' } }
    ],
    correctOptionId: 'C',
    timeLimit: 30,
    xpReward: 10
  },
  {
    id: 'general-133',
    subject: QuizSubject.GENERAL,
    difficulty: DifficultyLevel.EASY,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'Why was the math book sad?', ar: 'لماذا كان كتاب الرياضيات حزيناً؟' },
    options: [
      { id: 'A', text: { en: 'No friends', ar: 'بلا أصدقاء' } },
      { id: 'B', text: { en: 'Bad grades', ar: 'درجات سيئة' } },
      { id: 'C', text: { en: 'Old', ar: 'قديم' } },
      { id: 'D', text: { en: 'Too many problems', ar: 'كثير المسائل' } }
    ],
    correctOptionId: 'D',
    timeLimit: 30,
    xpReward: 10
  },
  {
    id: 'general-134',
    subject: QuizSubject.GENERAL,
    difficulty: DifficultyLevel.MEDIUM,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'Which country has the most people in the world?', ar: 'أي بلد لديه أكبر عدد سكان في العالم؟' },
    options: [
      { id: 'A', text: { en: 'United States', ar: 'الولايات المتحدة' } },
      { id: 'B', text: { en: 'China', ar: 'الصين' } },
      { id: 'C', text: { en: 'Indonesia', ar: 'إندونيسيا' } },
      { id: 'D', text: { en: 'India', ar: 'الهند' } }
    ],
    correctOptionId: 'D',
    timeLimit: 30,
    xpReward: 20
  },
  {
    id: 'math-135',
    subject: QuizSubject.MATH,
    difficulty: DifficultyLevel.EASY,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'What is the square root of 64?', ar: 'ما الجذر التربيعي لـ ٦٤؟' },
    options: [
      { id: 'A', text: { en: '7', ar: '٧' } },
      { id: 'B', text: { en: '8', ar: '٨' } },
      { id: 'C', text: { en: '9', ar: '٩' } },
      { id: 'D', text: { en: '6', ar: '٦' } }
    ],
    correctOptionId: 'B',
    timeLimit: 30,
    xpReward: 10
  },
  {
    id: 'math-136',
    subject: QuizSubject.MATH,
    difficulty: DifficultyLevel.MEDIUM,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'You are in a race and pass the person in second place. What place are you now in?', ar: 'أنت في سباق وتجاوزت الشخص في المركز الثاني. في أي مركز أنت الآن؟' },
    options: [
      { id: 'A', text: { en: 'Last', ar: 'الأخير' } },
      { id: 'B', text: { en: 'First', ar: 'الأول' } },
      { id: 'C', text: { en: 'Second', ar: 'الثاني' } },
      { id: 'D', text: { en: 'Third', ar: 'الثالث' } }
    ],
    correctOptionId: 'C',
    timeLimit: 30,
    xpReward: 20
  },
  {
    id: 'general-137',
    subject: QuizSubject.GENERAL,
    difficulty: DifficultyLevel.EASY,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'This traditional Saudi sport involves hunting with trained birds.', ar: 'هذه الرياضة السعودية التقليدية تتضمن الصيد بطيور مدربة.' },
    options: [
      { id: 'A', text: { en: 'Falconry', ar: 'الصقارة' } },
      { id: 'B', text: { en: 'Horse racing', ar: 'سباق الخيل' } },
      { id: 'C', text: { en: 'Soccer', ar: 'كرة القدم' } },
      { id: 'D', text: { en: 'Camel racing', ar: 'سباق الهجن' } }
    ],
    correctOptionId: 'A',
    timeLimit: 30,
    xpReward: 10
  },
  {
    id: 'general-138',
    subject: QuizSubject.GENERAL,
    difficulty: DifficultyLevel.MEDIUM,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'What is the national animal of Saudi Arabia?', ar: 'ما الحيوان الوطني للمملكة العربية السعودية؟' },
    options: [
      { id: 'A', text: { en: 'Camel', ar: 'جمل' } },
      { id: 'B', text: { en: 'Falcon', ar: 'صقر' } },
      { id: 'C', text: { en: 'Arabian Oryx', ar: 'المها العربي' } },
      { id: 'D', text: { en: 'Gazelle', ar: 'غزال' } }
    ],
    correctOptionId: 'C',
    timeLimit: 30,
    xpReward: 20
  },
  {
    id: 'math-139',
    subject: QuizSubject.MATH,
    difficulty: DifficultyLevel.EASY,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'How many months have 28 days?', ar: 'كم شهراً فيه ٢٨ يوماً؟' },
    options: [
      { id: 'A', text: { en: '2', ar: '٢' } },
      { id: 'B', text: { en: '6', ar: '٦' } },
      { id: 'C', text: { en: '1', ar: '١' } },
      { id: 'D', text: { en: '12', ar: '١٢' } }
    ],
    correctOptionId: 'D',
    timeLimit: 30,
    xpReward: 10
  },
  {
    id: 'science-140',
    subject: QuizSubject.SCIENCE,
    difficulty: DifficultyLevel.EASY,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'Which object reflects the most light?', ar: 'أي جسم يعكس أكبر قدر من الضوء؟' },
    options: [
      { id: 'A', text: { en: 'Red cloth', ar: 'قماش أحمر' } },
      { id: 'B', text: { en: 'Wood', ar: 'خشب' } },
      { id: 'C', text: { en: 'Mirror', ar: 'مرآة' } },
      { id: 'D', text: { en: 'Black paper', ar: 'ورق أسود' } }
    ],
    correctOptionId: 'C',
    timeLimit: 30,
    xpReward: 10
  },
  {
    id: 'general-141',
    subject: QuizSubject.GENERAL,
    difficulty: DifficultyLevel.MEDIUM,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'I am taken from a mine, and shut up in a wooden case, from which I am never released, and yet I am used by almost every person. What am I?', ar: 'أُخرج من منجم وأُوضع في صندوق خشبي ولا أُخرج منه أبداً، ومع ذلك يستخدمني الجميع. من أنا؟' },
    options: [
      { id: 'A', text: { en: 'Gold', ar: 'ذهب' } },
      { id: 'B', text: { en: 'Coal', ar: 'فحم' } },
      { id: 'C', text: { en: 'Salt', ar: 'ملح' } },
      { id: 'D', text: { en: 'Pencil lead', ar: 'رصاص قلم' } }
    ],
    correctOptionId: 'D',
    timeLimit: 30,
    xpReward: 20
  },
  {
    id: 'general-142',
    subject: QuizSubject.GENERAL,
    difficulty: DifficultyLevel.EASY,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'Which club has Cristiano Ronaldo played for in Saudi Arabia?', ar: 'أي نادٍ لعب فيه كريستيانو رونالدو في السعودية؟' },
    options: [
      { id: 'A', text: { en: 'Al-Ahli', ar: 'الأهلي' } },
      { id: 'B', text: { en: 'Al-Nassr', ar: 'النصر' } },
      { id: 'C', text: { en: 'Al-Hilal', ar: 'الهلال' } },
      { id: 'D', text: { en: 'Al-Ittihad', ar: 'الاتحاد' } }
    ],
    correctOptionId: 'B',
    timeLimit: 30,
    xpReward: 10
  },
  {
    id: 'english-143',
    subject: QuizSubject.ENGLISH,
    difficulty: DifficultyLevel.EASY,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'What is the opposite of \'hot\'?', ar: 'What is the opposite of \'hot\'?' },
    options: [
      { id: 'A', text: { en: 'Boiling', ar: 'Boiling' } },
      { id: 'B', text: { en: 'Cold', ar: 'Cold' } },
      { id: 'C', text: { en: 'Cool', ar: 'Cool' } },
      { id: 'D', text: { en: 'Warm', ar: 'Warm' } }
    ],
    correctOptionId: 'B',
    timeLimit: 30,
    xpReward: 10
  },
  {
    id: 'general-144',
    subject: QuizSubject.GENERAL,
    difficulty: DifficultyLevel.EASY,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'A rooster lays an egg on the top of a barn roof. Which way does it roll?', ar: 'ديك وضع بيضة على قمة سقف حظيرة. في أي اتجاه ستتدحرج؟' },
    options: [
      { id: 'A', text: { en: 'Left', ar: 'يسار' } },
      { id: 'B', text: { en: 'Down the roof', ar: 'أسفل السقف' } },
      { id: 'C', text: { en: 'It doesn\'t roll', ar: 'لن تتدحرج' } },
      { id: 'D', text: { en: 'Right', ar: 'يمين' } }
    ],
    correctOptionId: 'C',
    timeLimit: 30,
    xpReward: 10
  },
  {
    id: 'math-145',
    subject: QuizSubject.MATH,
    difficulty: DifficultyLevel.EASY,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'If there are 5 apples and you take 3, how many Apples do you have?', ar: 'إذا كان هناك ٥ تفاحات وأخذت ٣، كم تفاحة لديك؟' },
    options: [
      { id: 'A', text: { en: '3', ar: '٣' } },
      { id: 'B', text: { en: '2', ar: '٢' } },
      { id: 'C', text: { en: '0', ar: '٠' } },
      { id: 'D', text: { en: '5', ar: '٥' } }
    ],
    correctOptionId: 'A',
    timeLimit: 30,
    xpReward: 10
  },
  {
    id: 'science-146',
    subject: QuizSubject.SCIENCE,
    difficulty: DifficultyLevel.EASY,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'What force pulls objects toward the center of the Earth?', ar: 'أي قوة تسحب الأشياء نحو مركز الأرض؟' },
    options: [
      { id: 'A', text: { en: 'Gravity', ar: 'الجاذبية' } },
      { id: 'B', text: { en: 'Magnetism', ar: 'المغناطيسية' } },
      { id: 'C', text: { en: 'Electricity', ar: 'الكهرباء' } },
      { id: 'D', text: { en: 'Friction', ar: 'الاحتكاك' } }
    ],
    correctOptionId: 'A',
    timeLimit: 30,
    xpReward: 10
  },
  {
    id: 'general-147',
    subject: QuizSubject.GENERAL,
    difficulty: DifficultyLevel.EASY,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'How many days are in a leap year?', ar: 'كم يوماً في السنة الكبيسة؟' },
    options: [
      { id: 'A', text: { en: '365', ar: '٣٦٥' } },
      { id: 'B', text: { en: '366', ar: '٣٦٦' } },
      { id: 'C', text: { en: '367', ar: '٣٦٧' } },
      { id: 'D', text: { en: '364', ar: '٣٦٤' } }
    ],
    correctOptionId: 'B',
    timeLimit: 30,
    xpReward: 10
  },
  {
    id: 'general-148',
    subject: QuizSubject.GENERAL,
    difficulty: DifficultyLevel.EASY,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'What is the largest ocean on Earth?', ar: 'ما أكبر محيط على الأرض؟' },
    options: [
      { id: 'A', text: { en: 'Arctic Ocean', ar: 'المتجمد الشمالي' } },
      { id: 'B', text: { en: 'Indian Ocean', ar: 'الهندي' } },
      { id: 'C', text: { en: 'Pacific Ocean', ar: 'الهادئ' } },
      { id: 'D', text: { en: 'Atlantic Ocean', ar: 'الأطلسي' } }
    ],
    correctOptionId: 'C',
    timeLimit: 30,
    xpReward: 10
  },
  {
    id: 'general-149',
    subject: QuizSubject.GENERAL,
    difficulty: DifficultyLevel.EASY,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'What\'s orange and sounds like a parrot?', ar: 'ما الشيء البرتقالي الذي يشبه صوته صوت الببغاء؟' },
    options: [
      { id: 'A', text: { en: 'A carrot', ar: 'جزرة' } },
      { id: 'B', text: { en: 'A funny bird', ar: 'طائر مضحك' } },
      { id: 'C', text: { en: 'A joke', ar: 'نكتة' } },
      { id: 'D', text: { en: 'An orange parrot', ar: 'ببغاء برتقالي' } }
    ],
    correctOptionId: 'A',
    timeLimit: 30,
    xpReward: 10
  },
  {
    id: 'general-150',
    subject: QuizSubject.GENERAL,
    difficulty: DifficultyLevel.MEDIUM,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'Which Saudi region is famous for rose water production and rose festivals?', ar: 'أي منطقة سعودية تشتهر بإنتاج ماء الورد ومهرجانات الورد؟' },
    options: [
      { id: 'A', text: { en: 'Jazan', ar: 'جازان' } },
      { id: 'B', text: { en: 'Asir', ar: 'عسير' } },
      { id: 'C', text: { en: 'Taif', ar: 'الطائف' } },
      { id: 'D', text: { en: 'Al-Baha', ar: 'الباحة' } }
    ],
    correctOptionId: 'C',
    timeLimit: 30,
    xpReward: 20
  },
  {
    id: 'general-151',
    subject: QuizSubject.GENERAL,
    difficulty: DifficultyLevel.EASY,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'This is the longest mountain range in the world.', ar: 'ما أطول سلسلة جبال في العالم؟' },
    options: [
      { id: 'A', text: { en: 'Andes', ar: 'الأنديز' } },
      { id: 'B', text: { en: 'Alps', ar: 'الألب' } },
      { id: 'C', text: { en: 'Himalayas', ar: 'الهيمالايا' } },
      { id: 'D', text: { en: 'Rocky Mountains', ar: 'جبال روكي' } }
    ],
    correctOptionId: 'A',
    timeLimit: 30,
    xpReward: 10
  },
  {
    id: 'general-152',
    subject: QuizSubject.GENERAL,
    difficulty: DifficultyLevel.EASY,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'This is a popular Saudi sweet made from dates and nuts.', ar: 'هذه حلوى سعودية شهيرة مصنوعة من التمر والمكسرات.' },
    options: [
      { id: 'A', text: { en: 'Kunafa', ar: 'كنافة' } },
      { id: 'B', text: { en: 'Date balls', ar: 'كرات التمر' } },
      { id: 'C', text: { en: 'Ma\'amoul', ar: 'معمول' } },
      { id: 'D', text: { en: 'Baklava', ar: 'بقلاوة' } }
    ],
    correctOptionId: 'B',
    timeLimit: 30,
    xpReward: 10
  },
  {
    id: 'arabic-153',
    subject: QuizSubject.ARABIC,
    difficulty: DifficultyLevel.EASY,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'أكمل:(الجار قبل _____).', ar: 'أكمل:(الجار قبل _____).' },
    options: [
      { id: 'A', text: { en: 'الدار', ar: 'الدار' } },
      { id: 'B', text: { en: 'الصديق', ar: 'الصديق' } },
      { id: 'C', text: { en: 'الشارع', ar: 'الشارع' } },
      { id: 'D', text: { en: 'العائلة', ar: 'العائلة' } }
    ],
    correctOptionId: 'A',
    timeLimit: 30,
    xpReward: 10
  },
  {
    id: 'general-154',
    subject: QuizSubject.GENERAL,
    difficulty: DifficultyLevel.EASY,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'The more you take, the more you leave behind. What am I?', ar: 'كلما أخذت أكثر، تركت أكثر خلفك. من أنا؟' },
    options: [
      { id: 'A', text: { en: 'Footsteps', ar: 'خطوات' } },
      { id: 'B', text: { en: 'Breath', ar: 'نَفَس' } },
      { id: 'C', text: { en: 'Money', ar: 'نقود' } },
      { id: 'D', text: { en: 'Dates from a palm', ar: 'تمر من نخلة' } }
    ],
    correctOptionId: 'A',
    timeLimit: 30,
    xpReward: 10
  },
  {
    id: 'science-155',
    subject: QuizSubject.SCIENCE,
    difficulty: DifficultyLevel.EASY,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'This is the tallest land animal.', ar: 'ما أطول حيوان بري؟' },
    options: [
      { id: 'A', text: { en: 'Elephant', ar: 'فيل' } },
      { id: 'B', text: { en: 'Giraffe', ar: 'زرافة' } },
      { id: 'C', text: { en: 'Ostrich', ar: 'نعامة' } },
      { id: 'D', text: { en: 'Kangaroo', ar: 'كنغر' } }
    ],
    correctOptionId: 'B',
    timeLimit: 30,
    xpReward: 10
  },
  {
    id: 'general-156',
    subject: QuizSubject.GENERAL,
    difficulty: DifficultyLevel.EASY,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'What do you call cheese that\'s not yours?', ar: 'ماذا تسمي الجبن الذي ليس ملكك؟' },
    options: [
      { id: 'A', text: { en: 'Nacho cheese', ar: 'جبن ناتشو (ليس جبنك)' } },
      { id: 'B', text: { en: 'Bad cheese', ar: 'جبن سيئ' } },
      { id: 'C', text: { en: 'Stolen cheese', ar: 'جبن مسروق' } },
      { id: 'D', text: { en: 'Free cheese', ar: 'جبن مجاني' } }
    ],
    correctOptionId: 'A',
    timeLimit: 30,
    xpReward: 10
  },
  {
    id: 'english-157',
    subject: QuizSubject.ENGLISH,
    difficulty: DifficultyLevel.EASY,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'What is a fun word for when you smile really big because something is super funny?', ar: 'What is a fun word for when you smile really big because something is super funny?' },
    options: [
      { id: 'A', text: { en: 'Frown', ar: 'Frown' } },
      { id: 'B', text: { en: 'Grin', ar: 'Grin' } },
      { id: 'C', text: { en: 'Cry', ar: 'Cry' } },
      { id: 'D', text: { en: 'Yawn', ar: 'Yawn' } }
    ],
    correctOptionId: 'B',
    timeLimit: 30,
    xpReward: 10
  },
  {
    id: 'english-158',
    subject: QuizSubject.ENGLISH,
    difficulty: DifficultyLevel.EASY,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'What\'s another word for a super messy room that looks like a tornado hit it?', ar: 'What\'s another word for a super messy room that looks like a tornado hit it?' },
    options: [
      { id: 'A', text: { en: 'Neat', ar: 'Neat' } },
      { id: 'B', text: { en: 'Chaotic', ar: 'Chaotic' } },
      { id: 'C', text: { en: 'Empty', ar: 'Empty' } },
      { id: 'D', text: { en: 'Bright', ar: 'Bright' } }
    ],
    correctOptionId: 'B',
    timeLimit: 30,
    xpReward: 10
  },
  {
    id: 'english-159',
    subject: QuizSubject.ENGLISH,
    difficulty: DifficultyLevel.EASY,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'What slang word means something is amazingly good, like the best pizza ever?', ar: 'What slang word means something is amazingly good, like the best pizza ever?' },
    options: [
      { id: 'A', text: { en: 'Boring', ar: 'Boring' } },
      { id: 'B', text: { en: 'Fire', ar: 'Fire' } },
      { id: 'C', text: { en: 'Cold', ar: 'Cold' } },
      { id: 'D', text: { en: 'Sad', ar: 'Sad' } }
    ],
    correctOptionId: 'B',
    timeLimit: 30,
    xpReward: 10
  },
  {
    id: 'english-160',
    subject: QuizSubject.ENGLISH,
    difficulty: DifficultyLevel.EASY,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'If someone walks like they own the hallway with extra confidence, what are they doing?', ar: 'If someone walks like they own the hallway with extra confidence, what are they doing?' },
    options: [
      { id: 'A', text: { en: 'Sneak', ar: 'Sneak' } },
      { id: 'B', text: { en: 'Swagger', ar: 'Swagger' } },
      { id: 'C', text: { en: 'Sleep', ar: 'Sleep' } },
      { id: 'D', text: { en: 'Whisper', ar: 'Whisper' } }
    ],
    correctOptionId: 'B',
    timeLimit: 30,
    xpReward: 10
  },
  {
    id: 'english-161',
    subject: QuizSubject.ENGLISH,
    difficulty: DifficultyLevel.EASY,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'What word means you are so tired you could fall asleep standing like a zombie?', ar: 'What word means you are so tired you could fall asleep standing like a zombie?' },
    options: [
      { id: 'A', text: { en: 'Energetic', ar: 'Energetic' } },
      { id: 'B', text: { en: 'Exhausted', ar: 'Exhausted' } },
      { id: 'C', text: { en: 'Hungry', ar: 'Hungry' } },
      { id: 'D', text: { en: 'Happy', ar: 'Happy' } }
    ],
    correctOptionId: 'B',
    timeLimit: 30,
    xpReward: 10
  },
  {
    id: 'english-162',
    subject: QuizSubject.ENGLISH,
    difficulty: DifficultyLevel.EASY,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'What is a dramatic word for something really really big?', ar: 'What is a dramatic word for something really really big?' },
    options: [
      { id: 'A', text: { en: 'Tiny', ar: 'Tiny' } },
      { id: 'B', text: { en: 'Gigantic', ar: 'Gigantic' } },
      { id: 'C', text: { en: 'Quiet', ar: 'Quiet' } },
      { id: 'D', text: { en: 'Soft', ar: 'Soft' } }
    ],
    correctOptionId: 'B',
    timeLimit: 30,
    xpReward: 10
  },
  {
    id: 'english-163',
    subject: QuizSubject.ENGLISH,
    difficulty: DifficultyLevel.EASY,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'What do you feel when your team wins and you scream \'YES!\' with joy?', ar: 'What do you feel when your team wins and you scream \'YES!\' with joy?' },
    options: [
      { id: 'A', text: { en: 'Bored', ar: 'Bored' } },
      { id: 'B', text: { en: 'Thrilled', ar: 'Thrilled' } },
      { id: 'C', text: { en: 'Angry', ar: 'Angry' } },
      { id: 'D', text: { en: 'Sleepy', ar: 'Sleepy' } }
    ],
    correctOptionId: 'B',
    timeLimit: 30,
    xpReward: 10
  },
  {
    id: 'english-164',
    subject: QuizSubject.ENGLISH,
    difficulty: DifficultyLevel.EASY,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'What word describes a really bad joke that makes everyone groan?', ar: 'What word describes a really bad joke that makes everyone groan?' },
    options: [
      { id: 'A', text: { en: 'Hilarious', ar: 'Hilarious' } },
      { id: 'B', text: { en: 'Cheesy', ar: 'Cheesy' } },
      { id: 'C', text: { en: 'Awesome', ar: 'Awesome' } },
      { id: 'D', text: { en: 'Cool', ar: 'Cool' } }
    ],
    correctOptionId: 'B',
    timeLimit: 30,
    xpReward: 10
  },
  {
    id: 'english-165',
    subject: QuizSubject.ENGLISH,
    difficulty: DifficultyLevel.EASY,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'What sneaky word means you quietly take the last cookie?', ar: 'What sneaky word means you quietly take the last cookie?' },
    options: [
      { id: 'A', text: { en: 'Share', ar: 'Share' } },
      { id: 'B', text: { en: 'Snatch', ar: 'Snatch' } },
      { id: 'C', text: { en: 'Give', ar: 'Give' } },
      { id: 'D', text: { en: 'Ask', ar: 'Ask' } }
    ],
    correctOptionId: 'B',
    timeLimit: 30,
    xpReward: 10
  },
  {
    id: 'english-166',
    subject: QuizSubject.ENGLISH,
    difficulty: DifficultyLevel.EASY,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'What word means daydreaming about being a superhero instead of doing homework?', ar: 'What word means daydreaming about being a superhero instead of doing homework?' },
    options: [
      { id: 'A', text: { en: 'Focus', ar: 'Focus' } },
      { id: 'B', text: { en: 'Daydream', ar: 'Daydream' } },
      { id: 'C', text: { en: 'Study', ar: 'Study' } },
      { id: 'D', text: { en: 'Run', ar: 'Run' } }
    ],
    correctOptionId: 'B',
    timeLimit: 30,
    xpReward: 10
  },
  {
    id: 'english-167',
    subject: QuizSubject.ENGLISH,
    difficulty: DifficultyLevel.EASY,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'What fancy word means food that tastes so good you want ten more pieces?', ar: 'What fancy word means food that tastes so good you want ten more pieces?' },
    options: [
      { id: 'A', text: { en: 'Yucky', ar: 'Yucky' } },
      { id: 'B', text: { en: 'Scrumptious', ar: 'Scrumptious' } },
      { id: 'C', text: { en: 'Bland', ar: 'Bland' } },
      { id: 'D', text: { en: 'Cold', ar: 'Cold' } }
    ],
    correctOptionId: 'B',
    timeLimit: 30,
    xpReward: 10
  },
  {
    id: 'english-168',
    subject: QuizSubject.ENGLISH,
    difficulty: DifficultyLevel.EASY,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'What happens when you mix blue and yellow paint?', ar: 'What happens when you mix blue and yellow paint?' },
    options: [
      { id: 'A', text: { en: 'Red', ar: 'Red' } },
      { id: 'B', text: { en: 'Blend', ar: 'Blend' } },
      { id: 'C', text: { en: 'Break', ar: 'Break' } },
      { id: 'D', text: { en: 'Hide', ar: 'Hide' } }
    ],
    correctOptionId: 'B',
    timeLimit: 30,
    xpReward: 10
  },
  {
    id: 'english-169',
    subject: QuizSubject.ENGLISH,
    difficulty: DifficultyLevel.EASY,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'What word describes a friend who always shares snacks and helps you?', ar: 'What word describes a friend who always shares snacks and helps you?' },
    options: [
      { id: 'A', text: { en: 'Selfish', ar: 'Selfish' } },
      { id: 'B', text: { en: 'Generous', ar: 'Generous' } },
      { id: 'C', text: { en: 'Mean', ar: 'Mean' } },
      { id: 'D', text: { en: 'Lazy', ar: 'Lazy' } }
    ],
    correctOptionId: 'B',
    timeLimit: 30,
    xpReward: 10
  },
  {
    id: 'english-170',
    subject: QuizSubject.ENGLISH,
    difficulty: DifficultyLevel.EASY,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'What word means your backpack is stuffed so full it might explode?', ar: 'What word means your backpack is stuffed so full it might explode?' },
    options: [
      { id: 'A', text: { en: 'Empty', ar: 'Empty' } },
      { id: 'B', text: { en: 'Bursting', ar: 'Bursting' } },
      { id: 'C', text: { en: 'Light', ar: 'Light' } },
      { id: 'D', text: { en: 'Clean', ar: 'Clean' } }
    ],
    correctOptionId: 'B',
    timeLimit: 30,
    xpReward: 10
  },
  {
    id: 'english-171',
    subject: QuizSubject.ENGLISH,
    difficulty: DifficultyLevel.EASY,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'What wild-animal way says you are really really hungry?', ar: 'What wild-animal way says you are really really hungry?' },
    options: [
      { id: 'A', text: { en: 'Full', ar: 'Full' } },
      { id: 'B', text: { en: 'Ravenous', ar: 'Ravenous' } },
      { id: 'C', text: { en: 'Thirsty', ar: 'Thirsty' } },
      { id: 'D', text: { en: 'Tired', ar: 'Tired' } }
    ],
    correctOptionId: 'B',
    timeLimit: 30,
    xpReward: 10
  },
  {
    id: 'english-172',
    subject: QuizSubject.ENGLISH,
    difficulty: DifficultyLevel.EASY,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'What do you do when you walk quietly on tiptoes so you don\'t wake your sibling?', ar: 'What do you do when you walk quietly on tiptoes so you don\'t wake your sibling?' },
    options: [
      { id: 'A', text: { en: 'Shout', ar: 'Shout' } },
      { id: 'B', text: { en: 'Sneak', ar: 'Sneak' } },
      { id: 'C', text: { en: 'Dance', ar: 'Dance' } },
      { id: 'D', text: { en: 'Sing', ar: 'Sing' } }
    ],
    correctOptionId: 'B',
    timeLimit: 30,
    xpReward: 10
  },
  {
    id: 'english-173',
    subject: QuizSubject.ENGLISH,
    difficulty: DifficultyLevel.EASY,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'What word means a story so exciting you can\'t stop reading?', ar: 'What word means a story so exciting you can\'t stop reading?' },
    options: [
      { id: 'A', text: { en: 'Boring', ar: 'Boring' } },
      { id: 'B', text: { en: 'Gripping', ar: 'Gripping' } },
      { id: 'C', text: { en: 'Short', ar: 'Short' } },
      { id: 'D', text: { en: 'Old', ar: 'Old' } }
    ],
    correctOptionId: 'B',
    timeLimit: 30,
    xpReward: 10
  },
  {
    id: 'english-174',
    subject: QuizSubject.ENGLISH,
    difficulty: DifficultyLevel.EASY,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'What word means copying someone\'s exact style or outfit?', ar: 'What word means copying someone\'s exact style or outfit?' },
    options: [
      { id: 'A', text: { en: 'Create', ar: 'Create' } },
      { id: 'B', text: { en: 'Imitate', ar: 'Imitate' } },
      { id: 'C', text: { en: 'Destroy', ar: 'Destroy' } },
      { id: 'D', text: { en: 'Forget', ar: 'Forget' } }
    ],
    correctOptionId: 'B',
    timeLimit: 30,
    xpReward: 10
  },
  {
    id: 'english-175',
    subject: QuizSubject.ENGLISH,
    difficulty: DifficultyLevel.EASY,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'What word means your joke was so good everyone laughed hard?', ar: 'What word means your joke was so good everyone laughed hard?' },
    options: [
      { id: 'A', text: { en: 'Dull', ar: 'Dull' } },
      { id: 'B', text: { en: 'Hilarious', ar: 'Hilarious' } },
      { id: 'C', text: { en: 'Quiet', ar: 'Quiet' } },
      { id: 'D', text: { en: 'Serious', ar: 'Serious' } }
    ],
    correctOptionId: 'B',
    timeLimit: 30,
    xpReward: 10
  },
  {
    id: 'english-176',
    subject: QuizSubject.ENGLISH,
    difficulty: DifficultyLevel.EASY,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'What big word means everything feels perfect and unstoppable?', ar: 'What big word means everything feels perfect and unstoppable?' },
    options: [
      { id: 'A', text: { en: 'Terrible', ar: 'Terrible' } },
      { id: 'B', text: { en: 'Fantastic', ar: 'Fantastic' } },
      { id: 'C', text: { en: 'Average', ar: 'Average' } },
      { id: 'D', text: { en: 'Okay', ar: 'Okay' } }
    ],
    correctOptionId: 'B',
    timeLimit: 30,
    xpReward: 10
  },
  {
    id: 'english-177',
    subject: QuizSubject.ENGLISH,
    difficulty: DifficultyLevel.EASY,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'What is the opposite of boring that sounds like an adventure?', ar: 'What is the opposite of boring that sounds like an adventure?' },
    options: [
      { id: 'A', text: { en: 'Dull', ar: 'Dull' } },
      { id: 'B', text: { en: 'Thrilling', ar: 'Thrilling' } },
      { id: 'C', text: { en: 'Slow', ar: 'Slow' } },
      { id: 'D', text: { en: 'Calm', ar: 'Calm' } }
    ],
    correctOptionId: 'B',
    timeLimit: 30,
    xpReward: 10
  },
  {
    id: 'english-178',
    subject: QuizSubject.ENGLISH,
    difficulty: DifficultyLevel.EASY,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'What funny word describes someone who gets food everywhere when eating?', ar: 'What funny word describes someone who gets food everywhere when eating?' },
    options: [
      { id: 'A', text: { en: 'Neat', ar: 'Neat' } },
      { id: 'B', text: { en: 'Messy', ar: 'Messy' } },
      { id: 'C', text: { en: 'Quiet', ar: 'Quiet' } },
      { id: 'D', text: { en: 'Polite', ar: 'Polite' } }
    ],
    correctOptionId: 'B',
    timeLimit: 30,
    xpReward: 10
  },
  {
    id: 'english-179',
    subject: QuizSubject.ENGLISH,
    difficulty: DifficultyLevel.EASY,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'What word means you feel super clever after solving a puzzle fast?', ar: 'What word means you feel super clever after solving a puzzle fast?' },
    options: [
      { id: 'A', text: { en: 'Confused', ar: 'Confused' } },
      { id: 'B', text: { en: 'Brilliant', ar: 'Brilliant' } },
      { id: 'C', text: { en: 'Lost', ar: 'Lost' } },
      { id: 'D', text: { en: 'Tired', ar: 'Tired' } }
    ],
    correctOptionId: 'B',
    timeLimit: 30,
    xpReward: 10
  },
  {
    id: 'english-180',
    subject: QuizSubject.ENGLISH,
    difficulty: DifficultyLevel.EASY,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'What do you do when you quietly tell a secret to your best friend?', ar: 'What do you do when you quietly tell a secret to your best friend?' },
    options: [
      { id: 'A', text: { en: 'Shout', ar: 'Shout' } },
      { id: 'B', text: { en: 'Confide', ar: 'Confide' } },
      { id: 'C', text: { en: 'Ignore', ar: 'Ignore' } },
      { id: 'D', text: { en: 'Laugh', ar: 'Laugh' } }
    ],
    correctOptionId: 'B',
    timeLimit: 30,
    xpReward: 10
  },
  {
    id: 'english-181',
    subject: QuizSubject.ENGLISH,
    difficulty: DifficultyLevel.EASY,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'What word describes ice cream on a hot day that feels magical?', ar: 'What word describes ice cream on a hot day that feels magical?' },
    options: [
      { id: 'A', text: { en: 'Disgusting', ar: 'Disgusting' } },
      { id: 'B', text: { en: 'Blissful', ar: 'Blissful' } },
      { id: 'C', text: { en: 'Boring', ar: 'Boring' } },
      { id: 'D', text: { en: 'Salty', ar: 'Salty' } }
    ],
    correctOptionId: 'B',
    timeLimit: 30,
    xpReward: 10
  },
  {
    id: 'english-182',
    subject: QuizSubject.ENGLISH,
    difficulty: DifficultyLevel.EASY,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'What happens when you mix too many colors and it gets dark?', ar: 'What happens when you mix too many colors and it gets dark?' },
    options: [
      { id: 'A', text: { en: 'Bright', ar: 'Bright' } },
      { id: 'B', text: { en: 'Muddy', ar: 'Muddy' } },
      { id: 'C', text: { en: 'Clear', ar: 'Clear' } },
      { id: 'D', text: { en: 'Shiny', ar: 'Shiny' } }
    ],
    correctOptionId: 'B',
    timeLimit: 30,
    xpReward: 10
  },
  {
    id: 'english-183',
    subject: QuizSubject.ENGLISH,
    difficulty: DifficultyLevel.EASY,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'What word means you are starting a new cool trend that everyone copies?', ar: 'What word means you are starting a new cool trend that everyone copies?' },
    options: [
      { id: 'A', text: { en: 'Follower', ar: 'Follower' } },
      { id: 'B', text: { en: 'Trendsetter', ar: 'Trendsetter' } },
      { id: 'C', text: { en: 'Loser', ar: 'Loser' } },
      { id: 'D', text: { en: 'Quiet', ar: 'Quiet' } }
    ],
    correctOptionId: 'B',
    timeLimit: 30,
    xpReward: 10
  },
  {
    id: 'english-184',
    subject: QuizSubject.ENGLISH,
    difficulty: DifficultyLevel.EASY,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'What feeling do you get when you finally understand a tricky joke?', ar: 'What feeling do you get when you finally understand a tricky joke?' },
    options: [
      { id: 'A', text: { en: 'Confused', ar: 'Confused' } },
      { id: 'B', text: { en: 'Enlightened', ar: 'Enlightened' } },
      { id: 'C', text: { en: 'Sad', ar: 'Sad' } },
      { id: 'D', text: { en: 'Angry', ar: 'Angry' } }
    ],
    correctOptionId: 'B',
    timeLimit: 30,
    xpReward: 10
  },
  {
    id: 'english-185',
    subject: QuizSubject.ENGLISH,
    difficulty: DifficultyLevel.EASY,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'What word means something is so funny it\'s completely ridiculous?', ar: 'What word means something is so funny it\'s completely ridiculous?' },
    options: [
      { id: 'A', text: { en: 'Normal', ar: 'Normal' } },
      { id: 'B', text: { en: 'Absurd', ar: 'Absurd' } },
      { id: 'C', text: { en: 'Serious', ar: 'Serious' } },
      { id: 'D', text: { en: 'Calm', ar: 'Calm' } }
    ],
    correctOptionId: 'B',
    timeLimit: 30,
    xpReward: 10
  },
  {
    id: 'english-186',
    subject: QuizSubject.ENGLISH,
    difficulty: DifficultyLevel.EASY,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'What do you do when you\'re too excited to sit still and bounce around?', ar: 'What do you do when you\'re too excited to sit still and bounce around?' },
    options: [
      { id: 'A', text: { en: 'Freeze', ar: 'Freeze' } },
      { id: 'B', text: { en: 'Fidget', ar: 'Fidget' } },
      { id: 'C', text: { en: 'Sleep', ar: 'Sleep' } },
      { id: 'D', text: { en: 'Read', ar: 'Read' } }
    ],
    correctOptionId: 'B',
    timeLimit: 30,
    xpReward: 10
  },
  {
    id: 'english-187',
    subject: QuizSubject.ENGLISH,
    difficulty: DifficultyLevel.EASY,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'What quick look do you take at a surprise gift before it\'s time?', ar: 'What quick look do you take at a surprise gift before it\'s time?' },
    options: [
      { id: 'A', text: { en: 'Stare', ar: 'Stare' } },
      { id: 'B', text: { en: 'Peek', ar: 'Peek' } },
      { id: 'C', text: { en: 'Ignore', ar: 'Ignore' } },
      { id: 'D', text: { en: 'Break', ar: 'Break' } }
    ],
    correctOptionId: 'B',
    timeLimit: 30,
    xpReward: 10
  },
  {
    id: 'english-188',
    subject: QuizSubject.ENGLISH,
    difficulty: DifficultyLevel.EASY,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'What word describes a friend who makes everyone laugh with goofy faces?', ar: 'What word describes a friend who makes everyone laugh with goofy faces?' },
    options: [
      { id: 'A', text: { en: 'Serious', ar: 'Serious' } },
      { id: 'B', text: { en: 'Comical', ar: 'Comical' } },
      { id: 'C', text: { en: 'Boring', ar: 'Boring' } },
      { id: 'D', text: { en: 'Quiet', ar: 'Quiet' } }
    ],
    correctOptionId: 'B',
    timeLimit: 30,
    xpReward: 10
  },
  {
    id: 'english-189',
    subject: QuizSubject.ENGLISH,
    difficulty: DifficultyLevel.EASY,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'What exciting feeling do you get right before opening a new video game?', ar: 'What exciting feeling do you get right before opening a new video game?' },
    options: [
      { id: 'A', text: { en: 'Boredom', ar: 'Boredom' } },
      { id: 'B', text: { en: 'Anticipation', ar: 'Anticipation' } },
      { id: 'C', text: { en: 'Tiredness', ar: 'Tiredness' } },
      { id: 'D', text: { en: 'Anger', ar: 'Anger' } }
    ],
    correctOptionId: 'B',
    timeLimit: 30,
    xpReward: 10
  },
  {
    id: 'english-190',
    subject: QuizSubject.ENGLISH,
    difficulty: DifficultyLevel.EASY,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'What sound does popcorn make in the microwave?', ar: 'What sound does popcorn make in the microwave?' },
    options: [
      { id: 'A', text: { en: 'Silent', ar: 'Silent' } },
      { id: 'B', text: { en: 'Pop', ar: 'Pop' } },
      { id: 'C', text: { en: 'Crash', ar: 'Crash' } },
      { id: 'D', text: { en: 'Whisper', ar: 'Whisper' } }
    ],
    correctOptionId: 'B',
    timeLimit: 30,
    xpReward: 10
  },
  {
    id: 'english-191',
    subject: QuizSubject.ENGLISH,
    difficulty: DifficultyLevel.EASY,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'What word means a movie scene that gives you the best chills?', ar: 'What word means a movie scene that gives you the best chills?' },
    options: [
      { id: 'A', text: { en: 'Dull', ar: 'Dull' } },
      { id: 'B', text: { en: 'Epic', ar: 'Epic' } },
      { id: 'C', text: { en: 'Normal', ar: 'Normal' } },
      { id: 'D', text: { en: 'Slow', ar: 'Slow' } }
    ],
    correctOptionId: 'B',
    timeLimit: 30,
    xpReward: 10
  },
  {
    id: 'english-192',
    subject: QuizSubject.ENGLISH,
    difficulty: DifficultyLevel.EASY,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'What word means everything feels perfect - winning, pizza, and laughing with friends?', ar: 'What word means everything feels perfect - winning, pizza, and laughing with friends?' },
    options: [
      { id: 'A', text: { en: 'Awful', ar: 'Awful' } },
      { id: 'B', text: { en: 'Bliss', ar: 'Bliss' } },
      { id: 'C', text: { en: 'Okay', ar: 'Okay' } },
      { id: 'D', text: { en: 'Average', ar: 'Average' } }
    ],
    correctOptionId: 'B',
    timeLimit: 30,
    xpReward: 10
  },
  {
    id: 'islamic-193',
    subject: QuizSubject.ISLAMIC,
    difficulty: DifficultyLevel.EASY,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'Muslims pray five times a day', ar: 'يصلي المسلمون خمس مرات في اليوم.' },
    options: [
      { id: 'A', text: { en: 'True', ar: 'صح' } },
      { id: 'B', text: { en: 'False', ar: 'خطأ' } }
    ],
    correctOptionId: 'A',
    timeLimit: 30,
    xpReward: 10
  },
  {
    id: 'islamic-194',
    subject: QuizSubject.ISLAMIC,
    difficulty: DifficultyLevel.EASY,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'In which holy month do Muslims fast from dawn to sunset?', ar: 'في أي شهر مقدس يصوم المسلمون من الفجر إلى الغروب؟' },
    options: [
      { id: 'A', text: { en: 'Shawwal', ar: 'شوال' } },
      { id: 'B', text: { en: 'Ramadan', ar: 'رمضان' } },
      { id: 'C', text: { en: 'Dhul Hijjah', ar: 'ذو الحجة' } },
      { id: 'D', text: { en: 'Muharram', ar: 'محرم' } }
    ],
    correctOptionId: 'B',
    timeLimit: 30,
    xpReward: 10
  },
  {
    id: 'islamic-195',
    subject: QuizSubject.ISLAMIC,
    difficulty: DifficultyLevel.EASY,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'The first Prophet in Islam is Prophet Adam (peace be upon him).', ar: 'أول نبي في الإسلام هو النبي آدم عليه السلام.' },
    options: [
      { id: 'A', text: { en: 'True', ar: 'صح' } },
      { id: 'B', text: { en: 'False', ar: 'خطأ' } }
    ],
    correctOptionId: 'A',
    timeLimit: 30,
    xpReward: 10
  },
  {
    id: 'islamic-196',
    subject: QuizSubject.ISLAMIC,
    difficulty: DifficultyLevel.EASY,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'What is the name of the angel who brought the Quran to Prophet Muhammad (peace be upon him)?', ar: 'ما اسم الملك الذي أنزل القرآن على النبي محمد ﷺ؟' },
    options: [
      { id: 'A', text: { en: 'Mikail', ar: 'ميكائيل' } },
      { id: 'B', text: { en: 'Jibreel', ar: 'جبريل' } },
      { id: 'C', text: { en: 'Israfil', ar: 'إسرافيل' } },
      { id: 'D', text: { en: 'Azrael', ar: 'عزرائيل' } }
    ],
    correctOptionId: 'B',
    timeLimit: 30,
    xpReward: 10
  },
  {
    id: 'islamic-197',
    subject: QuizSubject.ISLAMIC,
    difficulty: DifficultyLevel.EASY,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'In which city was Prophet Muhammad (peace be upon him) born?', ar: 'في أي مدينة وُلد النبي محمد ﷺ؟' },
    options: [
      { id: 'A', text: { en: 'Madina', ar: 'المدينة' } },
      { id: 'B', text: { en: 'Makkah', ar: 'مكة' } },
      { id: 'C', text: { en: 'Jerusalem', ar: 'القدس' } },
      { id: 'D', text: { en: 'Taif', ar: 'الطائف' } }
    ],
    correctOptionId: 'B',
    timeLimit: 30,
    xpReward: 10
  },
  {
    id: 'islamic-198',
    subject: QuizSubject.ISLAMIC,
    difficulty: DifficultyLevel.EASY,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'True or False: The Quran was revealed over a period of 23 years', ar: 'صح أم خطأ: نزل القرآن على مدى ٢٣ سنة.' },
    options: [
      { id: 'A', text: { en: 'True', ar: 'صح' } },
      { id: 'B', text: { en: 'False', ar: 'خطأ' } }
    ],
    correctOptionId: 'A',
    timeLimit: 30,
    xpReward: 10
  },
  {
    id: 'islamic-199',
    subject: QuizSubject.ISLAMIC,
    difficulty: DifficultyLevel.EASY,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'Which Prophet built a huge boat to save people and animals from the big flood?', ar: 'أي نبي بنى سفينة كبيرة لإنقاذ الناس والحيوانات من الطوفان؟' },
    options: [
      { id: 'A', text: { en: 'Ibrahim', ar: 'إبراهيم' } },
      { id: 'B', text: { en: 'Nuh', ar: 'نوح' } },
      { id: 'C', text: { en: 'Musa', ar: 'موسى' } },
      { id: 'D', text: { en: 'Isa', ar: 'عيسى' } }
    ],
    correctOptionId: 'B',
    timeLimit: 30,
    xpReward: 10
  },
  {
    id: 'islamic-200',
    subject: QuizSubject.ISLAMIC,
    difficulty: DifficultyLevel.EASY,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'Prophet Sulaiman (peace be upon him) could understand the language of animals', ar: 'النبي سليمان عليه السلام كان يفهم لغة الحيوانات.' },
    options: [
      { id: 'A', text: { en: 'True', ar: 'صح' } },
      { id: 'B', text: { en: 'False', ar: 'خطأ' } }
    ],
    correctOptionId: 'A',
    timeLimit: 30,
    xpReward: 10
  },
  {
    id: 'islamic-201',
    subject: QuizSubject.ISLAMIC,
    difficulty: DifficultyLevel.EASY,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'What do we call the direction we face when we pray - towards the Kaaba?', ar: 'ماذا نسمي الاتجاه الذي نستقبله عند الصلاة نحو الكعبة؟' },
    options: [
      { id: 'A', text: { en: 'Qibla', ar: 'القبلة' } },
      { id: 'B', text: { en: 'Mihrab', ar: 'المحراب' } },
      { id: 'C', text: { en: 'Minaret', ar: 'المئذنة' } },
      { id: 'D', text: { en: 'Masjid', ar: 'المسجد' } }
    ],
    correctOptionId: 'A',
    timeLimit: 30,
    xpReward: 10
  },
  {
    id: 'islamic-202',
    subject: QuizSubject.ISLAMIC,
    difficulty: DifficultyLevel.EASY,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'Giving charity (Zakat or Sadaqah) is one of the best ways to help others and earn big rewards!', ar: 'إعطاء الصدقة (الزكاة أو الصدقة) من أفضل الطرق لمساعدة الآخرين وكسب الأجر الكبير!' },
    options: [
      { id: 'A', text: { en: 'True', ar: 'صح' } },
      { id: 'B', text: { en: 'False', ar: 'خطأ' } }
    ],
    correctOptionId: 'A',
    timeLimit: 30,
    xpReward: 10
  },
  {
    id: 'islamic-203',
    subject: QuizSubject.ISLAMIC,
    difficulty: DifficultyLevel.EASY,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'The opening chapter of the Quran that we recite in every prayer is?', ar: 'السورة الافتتاحية من القرآن التي نقرأها في كل صلاة هي؟' },
    options: [
      { id: 'A', text: { en: 'Al-Fatihah', ar: 'الفاتحة' } },
      { id: 'B', text: { en: 'Al-Ikhlas', ar: 'الإخلاص' } },
      { id: 'C', text: { en: 'Al-Kaafirun', ar: 'الكافرون' } },
      { id: 'D', text: { en: 'Al-Kauthar', ar: 'الكوثر' } }
    ],
    correctOptionId: 'A',
    timeLimit: 30,
    xpReward: 10
  },
  {
    id: 'islamic-204',
    subject: QuizSubject.ISLAMIC,
    difficulty: DifficultyLevel.EASY,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'What is the special night in Ramadan when the Quran was first revealed?', ar: 'ما الليلة المميزة في رمضان التي نزل فيها القرآن أول مرة؟' },
    options: [
      { id: 'A', text: { en: 'Laylatul Qadr', ar: 'ليلة القدر' } },
      { id: 'B', text: { en: 'Laylatul Isra', ar: 'ليلة الإسراء' } },
      { id: 'C', text: { en: 'Laylatul Mi\'raj', ar: 'ليلة المعراج' } },
      { id: 'D', text: { en: 'Laylatul Bara\'ah', ar: 'ليلة البراءة' } }
    ],
    correctOptionId: 'A',
    timeLimit: 30,
    xpReward: 10
  },
  {
    id: 'islamic-205',
    subject: QuizSubject.ISLAMIC,
    difficulty: DifficultyLevel.EASY,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'How many chapters (Surahs) does the Quran have?', ar: 'كم عدد سور القرآن الكريم؟' },
    options: [
      { id: 'A', text: { en: '99', ar: '٩٩' } },
      { id: 'B', text: { en: '114', ar: '١١٤' } },
      { id: 'C', text: { en: '30', ar: '٣٠' } },
      { id: 'D', text: { en: '117', ar: '١١٧' } }
    ],
    correctOptionId: 'B',
    timeLimit: 30,
    xpReward: 10
  },
  {
    id: 'islamic-206',
    subject: QuizSubject.ISLAMIC,
    difficulty: DifficultyLevel.EASY,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'Umrah is the pilgrimage to Makkah that Muslims try to do at least once in their lifetime.', ar: 'العمرة هي الحج إلى مكة التي يحاول المسلمون أداءها مرة واحدة على الأقل في حياتهم.' },
    options: [
      { id: 'A', text: { en: 'True', ar: 'صح' } },
      { id: 'B', text: { en: 'False', ar: 'خطأ' } }
    ],
    correctOptionId: 'A',
    timeLimit: 30,
    xpReward: 10
  },
  {
    id: 'islamic-207',
    subject: QuizSubject.ISLAMIC,
    difficulty: DifficultyLevel.EASY,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'This Prophet split the sea with his staff to save his people from Pharaoh?', ar: 'أي نبي شق البحر بعصاه لإنقاذ قومه من فرعون؟' },
    options: [
      { id: 'A', text: { en: 'Isa', ar: 'عيسى' } },
      { id: 'B', text: { en: 'Musa', ar: 'موسى' } },
      { id: 'C', text: { en: 'Yunus', ar: 'يونس' } },
      { id: 'D', text: { en: 'Dawud', ar: 'داود' } }
    ],
    correctOptionId: 'B',
    timeLimit: 30,
    xpReward: 10
  },
  {
    id: 'islamic-208',
    subject: QuizSubject.ISLAMIC,
    difficulty: DifficultyLevel.EASY,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'What is the name of the first masjid built by Prophet Muhammad (peace be upon him) in Madinah?', ar: 'ما اسم أول مسجد بناه النبي محمد ﷺ في المدينة؟' },
    options: [
      { id: 'A', text: { en: 'Masjid Al-Haram', ar: 'المسجد الحرام' } },
      { id: 'B', text: { en: 'Masjid Quba', ar: 'مسجد قباء' } },
      { id: 'C', text: { en: 'Masjid Qiblatain', ar: 'مسجد القبلتين' } },
      { id: 'D', text: { en: 'Masjid Aqsa', ar: 'المسجد الأقصى' } }
    ],
    correctOptionId: 'B',
    timeLimit: 30,
    xpReward: 10
  },
  {
    id: 'islamic-209',
    subject: QuizSubject.ISLAMIC,
    difficulty: DifficultyLevel.EASY,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'The five pillars of Islam are Shahadah, Salah, Zakat, Sawm, and Hajj.', ar: 'أركان الإسلام الخمسة هي الشهادة والصلاة والزكاة والصوم والحج.' },
    options: [
      { id: 'A', text: { en: 'True', ar: 'صح' } },
      { id: 'B', text: { en: 'False', ar: 'خطأ' } }
    ],
    correctOptionId: 'A',
    timeLimit: 30,
    xpReward: 10
  },
  {
    id: 'islamic-210',
    subject: QuizSubject.ISLAMIC,
    difficulty: DifficultyLevel.EASY,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'Which Surah is called \'The Heart of the Quran\' and is very short but powerful?', ar: 'أي سورة تُسمى "قلب القرآن" وهي قصيرة لكنها قوية؟' },
    options: [
      { id: 'A', text: { en: 'Al-Ikhlas', ar: 'الإخلاص' } },
      { id: 'B', text: { en: 'Al-Falaq', ar: 'الفلق' } },
      { id: 'C', text: { en: 'An-Nas', ar: 'الناس' } },
      { id: 'D', text: { en: 'Al-Kawthar', ar: 'الكوثر' } }
    ],
    correctOptionId: 'A',
    timeLimit: 30,
    xpReward: 10
  },
  {
    id: 'islamic-211',
    subject: QuizSubject.ISLAMIC,
    difficulty: DifficultyLevel.EASY,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'Who was the young companion known for memorizing the entire Quran and becoming a great scholar?', ar: 'من الصحابي الشاب الذي اشتهر بحفظ القرآن كاملاً وأصبح عالماً كبيراً؟' },
    options: [
      { id: 'A', text: { en: 'Bilal', ar: 'بلال' } },
      { id: 'B', text: { en: 'Ibn Abbas', ar: 'ابن عباس' } },
      { id: 'C', text: { en: 'Abu Bakr', ar: 'أبو بكر' } },
      { id: 'D', text: { en: 'Umar', ar: 'عمر' } }
    ],
    correctOptionId: 'B',
    timeLimit: 30,
    xpReward: 10
  },
  {
    id: 'islamic-212',
    subject: QuizSubject.ISLAMIC,
    difficulty: DifficultyLevel.EASY,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'Zamzam water is the blessed water that appeared for baby Ismail and his mother Hajar.', ar: 'ماء زمزم هو الماء المبارك الذي ظهر للطفل إسماعيل وأمه هاجر.' },
    options: [
      { id: 'A', text: { en: 'True', ar: 'صح' } },
      { id: 'B', text: { en: 'False', ar: 'خطأ' } }
    ],
    correctOptionId: 'A',
    timeLimit: 30,
    xpReward: 10
  },
  {
    id: 'islamic-213',
    subject: QuizSubject.ISLAMIC,
    difficulty: DifficultyLevel.EASY,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'What does the word \'Islam\' mean in Arabic?', ar: 'ما معنى كلمة "إسلام" بالعربية؟' },
    options: [
      { id: 'A', text: { en: 'Peace', ar: 'سلام' } },
      { id: 'B', text: { en: 'Submission to Allah', ar: 'الاستسلام لله' } },
      { id: 'C', text: { en: 'Prayer', ar: 'صلاة' } },
      { id: 'D', text: { en: 'Charity', ar: 'صدقة' } }
    ],
    correctOptionId: 'B',
    timeLimit: 30,
    xpReward: 10
  },
  {
    id: 'islamic-214',
    subject: QuizSubject.ISLAMIC,
    difficulty: DifficultyLevel.EASY,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'Eid al-Fitr is the big celebration before the month of Dhu Al-qa\'dah', ar: 'عيد الفطر هو الاحتفال الكبير قبل شهر ذي القعدة.' },
    options: [
      { id: 'A', text: { en: 'True', ar: 'صح' } },
      { id: 'B', text: { en: 'False', ar: 'خطأ' } }
    ],
    correctOptionId: 'A',
    timeLimit: 30,
    xpReward: 10
  },
  {
    id: 'islamic-215',
    subject: QuizSubject.ISLAMIC,
    difficulty: DifficultyLevel.EASY,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'Which Prophet is mentioned the most times in the Quran?', ar: 'أي نبي ذُكر أكثر في القرآن؟' },
    options: [
      { id: 'A', text: { en: 'Prophet Nuh', ar: 'النبي نوح' } },
      { id: 'B', text: { en: 'Prophet Musa', ar: 'النبي موسى' } },
      { id: 'C', text: { en: 'Prophet Isa', ar: 'النبي عيسى' } },
      { id: 'D', text: { en: 'Prophet Ibrahim', ar: 'النبي إبراهيم' } }
    ],
    correctOptionId: 'B',
    timeLimit: 30,
    xpReward: 10
  },
  {
    id: 'islamic-216',
    subject: QuizSubject.ISLAMIC,
    difficulty: DifficultyLevel.EASY,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'Saying \'Assalamu alaikum\' means \'Peace be upon you\'.', ar: 'قول "السلام عليكم" يعني "السلام عليكم".' },
    options: [
      { id: 'A', text: { en: 'True', ar: 'صح' } },
      { id: 'B', text: { en: 'False', ar: 'خطأ' } }
    ],
    correctOptionId: 'A',
    timeLimit: 30,
    xpReward: 10
  },
  {
    id: 'islamic-217',
    subject: QuizSubject.ISLAMIC,
    difficulty: DifficultyLevel.EASY,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'The call to prayer that echoes from mosques five times a day is called?', ar: 'النداء للصلاة الذي يصدح من المساجد خمس مرات في اليوم يُسمى؟' },
    options: [
      { id: 'A', text: { en: 'Iqamah', ar: 'الإقامة' } },
      { id: 'B', text: { en: 'Adhan', ar: 'الأذان' } },
      { id: 'C', text: { en: 'Takbir', ar: 'التكبير' } },
      { id: 'D', text: { en: 'Tasbeeh', ar: 'التسبيح' } }
    ],
    correctOptionId: 'B',
    timeLimit: 30,
    xpReward: 10
  },
  {
    id: 'islamic-218',
    subject: QuizSubject.ISLAMIC,
    difficulty: DifficultyLevel.EASY,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'Prophet Yunus (peace be upon him) was swallowed by a big fish and then saved after making dua.', ar: 'النبي يونس عليه السلام ابتلعه حوت كبير ثم نجا بعد الدعاء.' },
    options: [
      { id: 'A', text: { en: 'True', ar: 'صح' } },
      { id: 'B', text: { en: 'False', ar: 'خطأ' } }
    ],
    correctOptionId: 'A',
    timeLimit: 30,
    xpReward: 10
  },
  {
    id: 'islamic-219',
    subject: QuizSubject.ISLAMIC,
    difficulty: DifficultyLevel.EASY,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'Which pillar of Islam involves giving a portion of your wealth to help the poor every year?', ar: 'أي ركن من أركان الإسلام يتضمن إعطاء جزء من مالك لمساعدة الفقراء كل عام؟' },
    options: [
      { id: 'A', text: { en: 'Salah', ar: 'الصلاة' } },
      { id: 'B', text: { en: 'Zakat', ar: 'الزكاة' } },
      { id: 'C', text: { en: 'Sawm', ar: 'الصوم' } },
      { id: 'D', text: { en: 'Sadaqah', ar: 'الصدقة' } }
    ],
    correctOptionId: 'B',
    timeLimit: 30,
    xpReward: 10
  },
  {
    id: 'islamic-220',
    subject: QuizSubject.ISLAMIC,
    difficulty: DifficultyLevel.EASY,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'What do we call the companions of Prophet Muhammad (peace be upon him) who were closest to him?', ar: 'ماذا نسمي أصحاب النبي محمد ﷺ الذين كانوا أقرب إليه؟' },
    options: [
      { id: 'A', text: { en: 'Sahabah', ar: 'الصحابة' } },
      { id: 'B', text: { en: 'Tabi\'een', ar: 'التابعون' } },
      { id: 'C', text: { en: 'Imams', ar: 'الأئمة' } },
      { id: 'D', text: { en: 'Caliphs', ar: 'الخلفاء' } }
    ],
    correctOptionId: 'A',
    timeLimit: 30,
    xpReward: 10
  },
  {
    id: 'islamic-221',
    subject: QuizSubject.ISLAMIC,
    difficulty: DifficultyLevel.EASY,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'Which short Surah teaches us about the tiny ant and how even small things matter to Allah?', ar: 'أي سورة قصيرة تعلمنا عن النملة الصغيرة وكيف أن حتى الأشياء الصغيرة مهمة عند الله؟' },
    options: [
      { id: 'A', text: { en: 'Al-Fil', ar: 'الفيل' } },
      { id: 'B', text: { en: 'Al-Asr', ar: 'العصر' } },
      { id: 'C', text: { en: 'An-Naml', ar: 'النمل' } },
      { id: 'D', text: { en: 'Al-Kahf', ar: 'الكهف' } }
    ],
    correctOptionId: 'C',
    timeLimit: 30,
    xpReward: 10
  },
  {
    id: 'islamic-222',
    subject: QuizSubject.ISLAMIC,
    difficulty: DifficultyLevel.EASY,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'The mandatory special washing we do before prayer is called', ar: 'الوضوء الواجب قبل الصلاة يُسمى؟' },
    options: [
      { id: 'A', text: { en: 'Shower', ar: 'استحمام' } },
      { id: 'B', text: { en: 'Ghusl', ar: 'غسل' } },
      { id: 'C', text: { en: 'Wudhu', ar: 'وضوء' } },
      { id: 'D', text: { en: 'Masah', ar: 'مسح' } }
    ],
    correctOptionId: 'C',
    timeLimit: 30,
    xpReward: 10
  },
  {
    id: 'islamic-223',
    subject: QuizSubject.ISLAMIC,
    difficulty: DifficultyLevel.EASY,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'Who was the loyal friend and first adult male to accept Islam?', ar: 'من كان الصديق الوفي وأول رجل بالغ يدخل الإسلام؟' },
    options: [
      { id: 'A', text: { en: 'Umar', ar: 'عمر' } },
      { id: 'B', text: { en: 'Abu Bakr', ar: 'أبو بكر' } },
      { id: 'C', text: { en: 'Ali', ar: 'علي' } },
      { id: 'D', text: { en: 'Uthman', ar: 'عثمان' } }
    ],
    correctOptionId: 'B',
    timeLimit: 30,
    xpReward: 10
  },
  {
    id: 'islamic-224',
    subject: QuizSubject.ISLAMIC,
    difficulty: DifficultyLevel.EASY,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'Eid al-Adha celebrates Prophet Ibrahim\'s willingness to sacrifice for Allah.', ar: 'عيد الأضحى يحتفل باستعداد النبي إبراهيم للتضحية في سبيل الله.' },
    options: [
      { id: 'A', text: { en: 'True', ar: 'صح' } },
      { id: 'B', text: { en: 'False', ar: 'خطأ' } }
    ],
    correctOptionId: 'A',
    timeLimit: 30,
    xpReward: 10
  },
  {
    id: 'islamic-225',
    subject: QuizSubject.ISLAMIC,
    difficulty: DifficultyLevel.EASY,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'What is the name of the black stone in the Kaaba that Prophet Ibrahim and Ismail placed?', ar: 'ما اسم الحجر الأسود في الكعبة الذي وضعه النبي إبراهيم وإسماعيل؟' },
    options: [
      { id: 'A', text: { en: 'Hajar Aswad', ar: 'الحجر الأسود' } },
      { id: 'B', text: { en: 'Maqam Ibrahim', ar: 'مقام إبراهيم' } },
      { id: 'C', text: { en: 'Zamzam', ar: 'زمزم' } },
      { id: 'D', text: { en: 'Safa', ar: 'الصفا' } }
    ],
    correctOptionId: 'A',
    timeLimit: 30,
    xpReward: 10
  },
  {
    id: 'islamic-226',
    subject: QuizSubject.ISLAMIC,
    difficulty: DifficultyLevel.EASY,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'Which pillar of Islam is the declaration of faith\'?', ar: 'أي ركن من أركان الإسلام هو شهادة الإيمان؟' },
    options: [
      { id: 'A', text: { en: 'Salah', ar: 'الصلاة' } },
      { id: 'B', text: { en: 'Shahadah', ar: 'الشهادة' } },
      { id: 'C', text: { en: 'Zakat', ar: 'الزكاة' } },
      { id: 'D', text: { en: 'Sawm', ar: 'الصوم' } }
    ],
    correctOptionId: 'B',
    timeLimit: 30,
    xpReward: 10
  },
  {
    id: 'islamic-227',
    subject: QuizSubject.ISLAMIC,
    difficulty: DifficultyLevel.EASY,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'Helping your parents, being kind to neighbors, and smiling are all ways to earn huge rewards in Islam!', ar: 'مساعدة الوالدين واللطف مع الجيران والابتسام كلها طرق لكسب أجر عظيم في الإسلام!' },
    options: [
      { id: 'A', text: { en: 'True', ar: 'صح' } },
      { id: 'B', text: { en: 'False', ar: 'خطأ' } }
    ],
    correctOptionId: 'A',
    timeLimit: 30,
    xpReward: 10
  },
  {
    id: 'math-228',
    subject: QuizSubject.MATH,
    difficulty: DifficultyLevel.EASY,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'You\'re battling zombies in a video game and defeat 7 groups of 8 zombies each. How many zombies did you smash?', ar: 'أنت تقاتل زومبي في لعبة فيديو وهزمت ٧ مجموعات من ٨ زومبي لكل منها. كم زومبي سحقت؟' },
    options: [
      { id: 'A', text: { en: '48', ar: '٤٨' } },
      { id: 'B', text: { en: '56', ar: '٥٦' } },
      { id: 'C', text: { en: '64', ar: '٦٤' } },
      { id: 'D', text: { en: '72', ar: '٧٢' } }
    ],
    correctOptionId: 'B',
    timeLimit: 30,
    xpReward: 10
  },
  {
    id: 'math-229',
    subject: QuizSubject.MATH,
    difficulty: DifficultyLevel.EASY,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'True or False: If you eat 3.9999 out of 4 pizzas, you basically have zero pizzas left and should probably order more.', ar: 'صح أم خطأ: إذا أكلت ٣.٩٩٩٩ من ٤ بيتزات، فلم يتبقَّ لديك شيء تقريباً ويجب أن تطلب المزيد.' },
    options: [
      { id: 'A', text: { en: 'True', ar: 'صح' } },
      { id: 'B', text: { en: 'False', ar: 'خطأ' } }
    ],
    correctOptionId: 'A',
    timeLimit: 30,
    xpReward: 10
  },
  {
    id: 'math-230',
    subject: QuizSubject.MATH,
    difficulty: DifficultyLevel.EASY,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'A farmer has 17 sheep. All but 9 run away to chase TikTok trends. How many sheep are still chilling with the farmer?', ar: 'مزارع لديه ١٧ خروفاً. هربت جميعها ما عدا ٩. كم خروفاً بقي مع المزارع؟' },
    options: [
      { id: 'A', text: { en: '8', ar: '٨' } },
      { id: 'B', text: { en: '9', ar: '٩' } },
      { id: 'C', text: { en: '17', ar: '١٧' } },
      { id: 'D', text: { en: '0', ar: '٠' } }
    ],
    correctOptionId: 'B',
    timeLimit: 30,
    xpReward: 10
  },
  {
    id: 'math-231',
    subject: QuizSubject.MATH,
    difficulty: DifficultyLevel.EASY,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'True or False: A square is basically a fancy rectangle that went to the gym and got equal sides.', ar: 'صح أم خطأ: المربع هو في الأساس مستطيل أنيق ذهب إلى النادي وحصل على أضلاع متساوية.' },
    options: [
      { id: 'A', text: { en: 'True', ar: 'صح' } },
      { id: 'B', text: { en: 'False', ar: 'خطأ' } }
    ],
    correctOptionId: 'A',
    timeLimit: 30,
    xpReward: 10
  },
  {
    id: 'math-232',
    subject: QuizSubject.MATH,
    difficulty: DifficultyLevel.EASY,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'You and your squad share 14 slices of pizza equally. How many slices does each person get if there are 2 of you?', ar: 'أنت وصديقك تتشاركان ١٤ شريحة بيتزا بالتساوي. كم شريحة لكل واحد إذا كنتما اثنين؟' },
    options: [
      { id: 'A', text: { en: '5', ar: '٥' } },
      { id: 'B', text: { en: '7', ar: '٧' } },
      { id: 'C', text: { en: '8', ar: '٨' } },
      { id: 'D', text: { en: '10', ar: '١٠' } }
    ],
    correctOptionId: 'B',
    timeLimit: 30,
    xpReward: 10
  },
  {
    id: 'math-233',
    subject: QuizSubject.MATH,
    difficulty: DifficultyLevel.EASY,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'True or False: Pi is that never-ending number you can never write perfectly as a simple fraction - it\'s too wild!', ar: 'صح أم خطأ: باي (π) هو ذلك الرقم اللانهائي الذي لا يمكنك كتابته ككسر بسيط!' },
    options: [
      { id: 'A', text: { en: 'True', ar: 'صح' } },
      { id: 'B', text: { en: 'False', ar: 'خطأ' } }
    ],
    correctOptionId: 'A',
    timeLimit: 30,
    xpReward: 10
  },
  {
    id: 'math-234',
    subject: QuizSubject.MATH,
    difficulty: DifficultyLevel.EASY,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'True or False: Zero is totally even - it hangs out with all the other even numbers at the party.', ar: 'صح أم خطأ: الصفر هو رقم زوجي تماماً.' },
    options: [
      { id: 'A', text: { en: 'True', ar: 'صح' } },
      { id: 'B', text: { en: 'False', ar: 'خطأ' } }
    ],
    correctOptionId: 'A',
    timeLimit: 30,
    xpReward: 10
  },
  {
    id: 'math-235',
    subject: QuizSubject.MATH,
    difficulty: DifficultyLevel.EASY,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'How many sides does a cool pentagon shape have?', ar: 'كم عدد أضلاع الشكل الخماسي؟' },
    options: [
      { id: 'A', text: { en: '4', ar: '٤' } },
      { id: 'B', text: { en: '5', ar: '٥' } },
      { id: 'C', text: { en: '6', ar: '٦' } },
      { id: 'D', text: { en: '8', ar: '٨' } }
    ],
    correctOptionId: 'B',
    timeLimit: 30,
    xpReward: 10
  },
  {
    id: 'math-236',
    subject: QuizSubject.MATH,
    difficulty: DifficultyLevel.EASY,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'True or False: The inside angles of any triangle always add up to exactly 180 degrees - no exceptions!', ar: 'صح أم خطأ: زوايا أي مثلث مجموعها دائماً ١٨٠ درجة بالضبط!' },
    options: [
      { id: 'A', text: { en: 'True', ar: 'صح' } },
      { id: 'B', text: { en: 'False', ar: 'خطأ' } }
    ],
    correctOptionId: 'A',
    timeLimit: 30,
    xpReward: 10
  },
  {
    id: 'math-237',
    subject: QuizSubject.MATH,
    difficulty: DifficultyLevel.EASY,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'True or False: 1,000 pounds of bricks weigh the same as 1,000 pounds of fluffy feathers', ar: 'صح أم خطأ: ١٠٠٠ رطل من الطوب تزن نفس وزن ١٠٠٠ رطل من الريش.' },
    options: [
      { id: 'A', text: { en: 'True', ar: 'صح' } },
      { id: 'B', text: { en: 'False', ar: 'خطأ' } }
    ],
    correctOptionId: 'A',
    timeLimit: 30,
    xpReward: 10
  },
  {
    id: 'math-238',
    subject: QuizSubject.MATH,
    difficulty: DifficultyLevel.EASY,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'How many zeros are in a googol?', ar: 'كم عدد الأصفار في الغوغول (googol)؟' },
    options: [
      { id: 'A', text: { en: '10', ar: '١٠' } },
      { id: 'B', text: { en: '100', ar: '١٠٠' } },
      { id: 'C', text: { en: '1000', ar: '١٠٠٠' } },
      { id: 'D', text: { en: '1', ar: '١' } }
    ],
    correctOptionId: 'B',
    timeLimit: 30,
    xpReward: 10
  },
  {
    id: 'math-239',
    subject: QuizSubject.MATH,
    difficulty: DifficultyLevel.EASY,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'True or False: Adding two odd numbers always gives you an even number - like magic!', ar: 'صح أم خطأ: جمع رقمين فرديين يعطيك دائماً رقماً زوجياً!' },
    options: [
      { id: 'A', text: { en: 'True', ar: 'صح' } },
      { id: 'B', text: { en: 'False', ar: 'خطأ' } }
    ],
    correctOptionId: 'A',
    timeLimit: 30,
    xpReward: 10
  },
  {
    id: 'math-240',
    subject: QuizSubject.MATH,
    difficulty: DifficultyLevel.EASY,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'True or False: -40 degrees Celsius is exactly the same as -40 degrees Fahrenheit', ar: 'صح أم خطأ: -٤٠ درجة مئوية تساوي تماماً -٤٠ درجة فهرنهايت.' },
    options: [
      { id: 'A', text: { en: 'True', ar: 'صح' } },
      { id: 'B', text: { en: 'False', ar: 'خطأ' } }
    ],
    correctOptionId: 'A',
    timeLimit: 30,
    xpReward: 10
  },
  {
    id: 'math-241',
    subject: QuizSubject.MATH,
    difficulty: DifficultyLevel.EASY,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'If you roll three dice, what\'s the highest score you can get in one go?', ar: 'إذا رميت ثلاث نرد، ما أعلى نتيجة يمكنك الحصول عليها دفعة واحدة؟' },
    options: [
      { id: 'A', text: { en: '15', ar: '١٥' } },
      { id: 'B', text: { en: '18', ar: '١٨' } },
      { id: 'C', text: { en: '21', ar: '٢١' } },
      { id: 'D', text: { en: '20', ar: '٢٠' } }
    ],
    correctOptionId: 'B',
    timeLimit: 30,
    xpReward: 10
  },
  {
    id: 'math-242',
    subject: QuizSubject.MATH,
    difficulty: DifficultyLevel.EASY,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'How many sides does a hexagon have? (Think honeycomb or stop signs!)', ar: 'كم عدد أضلاع الشكل السداسي؟ (فكر في خلية النحل!)' },
    options: [
      { id: 'A', text: { en: '5', ar: '٥' } },
      { id: 'B', text: { en: '6', ar: '٦' } },
      { id: 'C', text: { en: '7', ar: '٧' } },
      { id: 'D', text: { en: '8', ar: '٨' } }
    ],
    correctOptionId: 'B',
    timeLimit: 30,
    xpReward: 10
  },
  {
    id: 'math-243',
    subject: QuizSubject.MATH,
    difficulty: DifficultyLevel.EASY,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'True or False: A billion has exactly 9 zeros', ar: 'صح أم خطأ: المليار فيه ٩ أصفار بالضبط.' },
    options: [
      { id: 'A', text: { en: 'True', ar: 'صح' } },
      { id: 'B', text: { en: 'False', ar: 'خطأ' } }
    ],
    correctOptionId: 'A',
    timeLimit: 30,
    xpReward: 10
  },
  {
    id: 'math-244',
    subject: QuizSubject.MATH,
    difficulty: DifficultyLevel.EASY,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'True or False: There are exactly 60 minutes in an hour - perfect for timing your Fortnite sessions.', ar: 'صح أم خطأ: في الساعة ٦٠ دقيقة بالضبط.' },
    options: [
      { id: 'A', text: { en: 'True', ar: 'صح' } },
      { id: 'B', text: { en: 'False', ar: 'خطأ' } }
    ],
    correctOptionId: 'A',
    timeLimit: 30,
    xpReward: 10
  },
  {
    id: 'math-245',
    subject: QuizSubject.MATH,
    difficulty: DifficultyLevel.EASY,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'If it\'s 9 a.m. and you add 5 hours of gaming time, what time is it?', ar: 'إذا كانت الساعة ٩ صباحاً وأضفت ٥ ساعات لعب، كم تكون الساعة؟' },
    options: [
      { id: 'A', text: { en: '1 p.m.', ar: '١ ظهراً' } },
      { id: 'B', text: { en: '2 p.m.', ar: '٢ ظهراً' } },
      { id: 'C', text: { en: '3 p.m.', ar: '٣ عصراً' } },
      { id: 'D', text: { en: '4 p.m.', ar: '٤ عصراً' } }
    ],
    correctOptionId: 'B',
    timeLimit: 30,
    xpReward: 10
  },
  {
    id: 'math-246',
    subject: QuizSubject.MATH,
    difficulty: DifficultyLevel.EASY,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'True or False: An angle bigger than 90 degrees is called obtuse', ar: 'صح أم خطأ: الزاوية الأكبر من ٩٠ درجة تُسمى منفرجة.' },
    options: [
      { id: 'A', text: { en: 'True', ar: 'صح' } },
      { id: 'B', text: { en: 'False', ar: 'خطأ' } }
    ],
    correctOptionId: 'A',
    timeLimit: 30,
    xpReward: 10
  },
  {
    id: 'math-247',
    subject: QuizSubject.MATH,
    difficulty: DifficultyLevel.EASY,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'True or False: A googol is way bigger than a quadrillion.', ar: 'صح أم خطأ: الغوغول أكبر بكثير من الكوادريليون.' },
    options: [
      { id: 'A', text: { en: 'True', ar: 'صح' } },
      { id: 'B', text: { en: 'False', ar: 'خطأ' } }
    ],
    correctOptionId: 'A',
    timeLimit: 30,
    xpReward: 10
  },
  {
    id: 'math-248',
    subject: QuizSubject.MATH,
    difficulty: DifficultyLevel.EASY,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'How many sides does a pizza slice have?', ar: 'كم عدد أضلاع شريحة البيتزا؟' },
    options: [
      { id: 'A', text: { en: '2', ar: '٢' } },
      { id: 'B', text: { en: '3', ar: '٣' } },
      { id: 'C', text: { en: '4', ar: '٤' } },
      { id: 'D', text: { en: '5', ar: '٥' } }
    ],
    correctOptionId: 'B',
    timeLimit: 30,
    xpReward: 10
  },
  {
    id: 'math-249',
    subject: QuizSubject.MATH,
    difficulty: DifficultyLevel.EASY,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'True or False: All rectangles are squares, but not all squares are rectangles?', ar: 'صح أم خطأ: كل المستطيلات مربعات، لكن ليس كل المربعات مستطيلات؟' },
    options: [
      { id: 'A', text: { en: 'True', ar: 'صح' } },
      { id: 'B', text: { en: 'False', ar: 'خطأ' } }
    ],
    correctOptionId: 'B',
    timeLimit: 30,
    xpReward: 10
  },
  {
    id: 'math-250',
    subject: QuizSubject.MATH,
    difficulty: DifficultyLevel.EASY,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'True or False: The fear of the number 13 is called triskaidekaphobia', ar: 'صح أم خطأ: الخوف من الرقم ١٣ يُسمى تريسكايديكافوبيا.' },
    options: [
      { id: 'A', text: { en: 'True', ar: 'صح' } },
      { id: 'B', text: { en: 'False', ar: 'خطأ' } }
    ],
    correctOptionId: 'A',
    timeLimit: 30,
    xpReward: 10
  },
  {
    id: 'math-251',
    subject: QuizSubject.MATH,
    difficulty: DifficultyLevel.EASY,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'What is 2 + 2 × 3?', ar: 'ما ناتج ٢ + ٢ × ٣؟' },
    options: [
      { id: 'A', text: { en: '8', ar: '٨' } },
      { id: 'B', text: { en: '12', ar: '١٢' } },
      { id: 'C', text: { en: '10', ar: '١٠' } },
      { id: 'D', text: { en: '6', ar: '٦' } }
    ],
    correctOptionId: 'A',
    timeLimit: 30,
    xpReward: 10
  },
  {
    id: 'math-252',
    subject: QuizSubject.MATH,
    difficulty: DifficultyLevel.EASY,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'How many legs do 5 cats have?', ar: 'كم عدد أرجل ٥ قطط؟' },
    options: [
      { id: 'A', text: { en: '16', ar: '١٦' } },
      { id: 'B', text: { en: '20', ar: '٢٠' } },
      { id: 'C', text: { en: '18', ar: '١٨' } },
      { id: 'D', text: { en: '15', ar: '١٥' } }
    ],
    correctOptionId: 'B',
    timeLimit: 30,
    xpReward: 10
  },
  {
    id: 'math-253',
    subject: QuizSubject.MATH,
    difficulty: DifficultyLevel.EASY,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'True or False: The sum of the first five prime numbers (2+3+5+7+11) is 29.', ar: 'صح أم خطأ: مجموع أول خمسة أعداد أولية (٢+٣+٥+٧+١١) هو ٢٩.' },
    options: [
      { id: 'A', text: { en: 'True', ar: 'صح' } },
      { id: 'B', text: { en: 'False', ar: 'خطأ' } }
    ],
    correctOptionId: 'B',
    timeLimit: 30,
    xpReward: 10
  },
  {
    id: 'arabic-254',
    subject: QuizSubject.ARABIC,
    difficulty: DifficultyLevel.EASY,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'ما جمع كلمة "كتاب"؟', ar: 'ما جمع كلمة "كتاب"؟' },
    options: [
      { id: 'A', text: { en: 'كتابات', ar: 'كتابات' } },
      { id: 'B', text: { en: 'كُتُب', ar: 'كُتُب' } },
      { id: 'C', text: { en: 'كاتبون', ar: 'كاتبون' } },
      { id: 'D', text: { en: 'مكاتب', ar: 'مكاتب' } }
    ],
    correctOptionId: 'B',
    timeLimit: 30,
    xpReward: 10
  },
  {
    id: 'arabic-255',
    subject: QuizSubject.ARABIC,
    difficulty: DifficultyLevel.EASY,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'ما مرادف كلمة "شجاع"؟', ar: 'ما مرادف كلمة "شجاع"؟' },
    options: [
      { id: 'A', text: { en: 'جبان', ar: 'جبان' } },
      { id: 'B', text: { en: 'مِقدام', ar: 'مِقدام' } },
      { id: 'C', text: { en: 'كسول', ar: 'كسول' } },
      { id: 'D', text: { en: 'ضعيف', ar: 'ضعيف' } }
    ],
    correctOptionId: 'B',
    timeLimit: 30,
    xpReward: 10
  },
  {
    id: 'arabic-256',
    subject: QuizSubject.ARABIC,
    difficulty: DifficultyLevel.EASY,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'ما ضد كلمة "الكرم"؟', ar: 'ما ضد كلمة "الكرم"؟' },
    options: [
      { id: 'A', text: { en: 'الشجاعة', ar: 'الشجاعة' } },
      { id: 'B', text: { en: 'البُخل', ar: 'البُخل' } },
      { id: 'C', text: { en: 'الصدق', ar: 'الصدق' } },
      { id: 'D', text: { en: 'الجمال', ar: 'الجمال' } }
    ],
    correctOptionId: 'B',
    timeLimit: 30,
    xpReward: 10
  },
  {
    id: 'arabic-257',
    subject: QuizSubject.ARABIC,
    difficulty: DifficultyLevel.EASY,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'أي من هذه الكلمات تبدأ بهمزة وصل؟', ar: 'أي من هذه الكلمات تبدأ بهمزة وصل؟' },
    options: [
      { id: 'A', text: { en: 'أحمد', ar: 'أحمد' } },
      { id: 'B', text: { en: 'استخرج', ar: 'استخرج' } },
      { id: 'C', text: { en: 'إبراهيم', ar: 'إبراهيم' } },
      { id: 'D', text: { en: 'أكل', ar: 'أكل' } }
    ],
    correctOptionId: 'B',
    timeLimit: 30,
    xpReward: 10
  },
  {
    id: 'arabic-258',
    subject: QuizSubject.ARABIC,
    difficulty: DifficultyLevel.EASY,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'ما نوع الهمزة في كلمة "إسلام"؟', ar: 'ما نوع الهمزة في كلمة "إسلام"؟' },
    options: [
      { id: 'A', text: { en: 'همزة وصل', ar: 'همزة وصل' } },
      { id: 'B', text: { en: 'همزة قطع', ar: 'همزة قطع' } },
      { id: 'C', text: { en: 'همزة متوسطة', ar: 'همزة متوسطة' } },
      { id: 'D', text: { en: 'همزة متطرفة', ar: 'همزة متطرفة' } }
    ],
    correctOptionId: 'B',
    timeLimit: 30,
    xpReward: 10
  },
  {
    id: 'arabic-259',
    subject: QuizSubject.ARABIC,
    difficulty: DifficultyLevel.EASY,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'ما إعراب كلمة "التلميذُ" في جملة: "جاء التلميذُ"؟', ar: 'ما إعراب كلمة "التلميذُ" في جملة: "جاء التلميذُ"؟' },
    options: [
      { id: 'A', text: { en: 'مفعول به', ar: 'مفعول به' } },
      { id: 'B', text: { en: 'فاعل', ar: 'فاعل' } },
      { id: 'C', text: { en: 'مبتدأ', ar: 'مبتدأ' } },
      { id: 'D', text: { en: 'خبر', ar: 'خبر' } }
    ],
    correctOptionId: 'B',
    timeLimit: 30,
    xpReward: 10
  },
  {
    id: 'arabic-260',
    subject: QuizSubject.ARABIC,
    difficulty: DifficultyLevel.EASY,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'كم عدد حروف اللغة العربية؟', ar: 'كم عدد حروف اللغة العربية؟' },
    options: [
      { id: 'A', text: { en: '26', ar: '26' } },
      { id: 'B', text: { en: '28', ar: '28' } },
      { id: 'C', text: { en: '30', ar: '30' } },
      { id: 'D', text: { en: '24', ar: '24' } }
    ],
    correctOptionId: 'B',
    timeLimit: 30,
    xpReward: 10
  },
  {
    id: 'arabic-261',
    subject: QuizSubject.ARABIC,
    difficulty: DifficultyLevel.EASY,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'ما جمع كلمة "معلم"؟', ar: 'ما جمع كلمة "معلم"؟' },
    options: [
      { id: 'A', text: { en: 'معالم', ar: 'معالم' } },
      { id: 'B', text: { en: 'معلمون', ar: 'معلمون' } },
      { id: 'C', text: { en: 'علوم', ar: 'علوم' } },
      { id: 'D', text: { en: 'تعليم', ar: 'تعليم' } }
    ],
    correctOptionId: 'B',
    timeLimit: 30,
    xpReward: 10
  },
  {
    id: 'arabic-262',
    subject: QuizSubject.ARABIC,
    difficulty: DifficultyLevel.EASY,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'أيّ كلمة فيها حرف مشدّد؟', ar: 'أيّ كلمة فيها حرف مشدّد؟' },
    options: [
      { id: 'A', text: { en: 'كتب', ar: 'كتب' } },
      { id: 'B', text: { en: 'شدَّ', ar: 'شدَّ' } },
      { id: 'C', text: { en: 'درس', ar: 'درس' } },
      { id: 'D', text: { en: 'فهم', ar: 'فهم' } }
    ],
    correctOptionId: 'B',
    timeLimit: 30,
    xpReward: 10
  },
  {
    id: 'arabic-263',
    subject: QuizSubject.ARABIC,
    difficulty: DifficultyLevel.EASY,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'ما مثنى كلمة "طالب"؟', ar: 'ما مثنى كلمة "طالب"؟' },
    options: [
      { id: 'A', text: { en: 'طلاب', ar: 'طلاب' } },
      { id: 'B', text: { en: 'طالبان', ar: 'طالبان' } },
      { id: 'C', text: { en: 'طالبون', ar: 'طالبون' } },
      { id: 'D', text: { en: 'طالبين', ar: 'طالبين' } }
    ],
    correctOptionId: 'B',
    timeLimit: 30,
    xpReward: 10
  },
  {
    id: 'arabic-264',
    subject: QuizSubject.ARABIC,
    difficulty: DifficultyLevel.EASY,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'أيّ جملة فعلية؟', ar: 'أيّ جملة فعلية؟' },
    options: [
      { id: 'A', text: { en: 'الشمسُ مشرقةٌ', ar: 'الشمسُ مشرقةٌ' } },
      { id: 'B', text: { en: 'لعبَ الولدُ', ar: 'لعبَ الولدُ' } },
      { id: 'C', text: { en: 'البيتُ كبيرٌ', ar: 'البيتُ كبيرٌ' } },
      { id: 'D', text: { en: 'الحديقةُ جميلةٌ', ar: 'الحديقةُ جميلةٌ' } }
    ],
    correctOptionId: 'B',
    timeLimit: 30,
    xpReward: 10
  },
  {
    id: 'arabic-265',
    subject: QuizSubject.ARABIC,
    difficulty: DifficultyLevel.EASY,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'ما الحرف الذي يُنطق من الحلق؟', ar: 'ما الحرف الذي يُنطق من الحلق؟' },
    options: [
      { id: 'A', text: { en: 'باء', ar: 'باء' } },
      { id: 'B', text: { en: 'عين', ar: 'عين' } },
      { id: 'C', text: { en: 'لام', ar: 'لام' } },
      { id: 'D', text: { en: 'نون', ar: 'نون' } }
    ],
    correctOptionId: 'B',
    timeLimit: 30,
    xpReward: 10
  },
  {
    id: 'arabic-266',
    subject: QuizSubject.ARABIC,
    difficulty: DifficultyLevel.EASY,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'ما ضد كلمة "النجاح"؟', ar: 'ما ضد كلمة "النجاح"؟' },
    options: [
      { id: 'A', text: { en: 'التفوق', ar: 'التفوق' } },
      { id: 'B', text: { en: 'الفشل', ar: 'الفشل' } },
      { id: 'C', text: { en: 'الجد', ar: 'الجد' } },
      { id: 'D', text: { en: 'الاجتهاد', ar: 'الاجتهاد' } }
    ],
    correctOptionId: 'B',
    timeLimit: 30,
    xpReward: 10
  },
  {
    id: 'arabic-267',
    subject: QuizSubject.ARABIC,
    difficulty: DifficultyLevel.EASY,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'أيّ كلمة تحتوي على تاء مربوطة؟', ar: 'أيّ كلمة تحتوي على تاء مربوطة؟' },
    options: [
      { id: 'A', text: { en: 'بيت', ar: 'بيت' } },
      { id: 'B', text: { en: 'مدرسة', ar: 'مدرسة' } },
      { id: 'C', text: { en: 'كتبت', ar: 'كتبت' } },
      { id: 'D', text: { en: 'زيت', ar: 'زيت' } }
    ],
    correctOptionId: 'B',
    timeLimit: 30,
    xpReward: 10
  },
  {
    id: 'arabic-268',
    subject: QuizSubject.ARABIC,
    difficulty: DifficultyLevel.EASY,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'ما الفرق بين التاء المربوطة والهاء في آخر الكلمة؟', ar: 'ما الفرق بين التاء المربوطة والهاء في آخر الكلمة؟' },
    options: [
      { id: 'A', text: { en: 'لا فرق بينهما', ar: 'لا فرق بينهما' } },
      { id: 'B', text: { en: 'التاء المربوطة تُنطق تاءً عند الوصل', ar: 'التاء المربوطة تُنطق تاءً عند الوصل' } },
      { id: 'C', text: { en: 'الهاء تنطق تاءً دائماً', ar: 'الهاء تنطق تاءً دائماً' } },
      { id: 'D', text: { en: 'كلاهما يُنطقان هاءً', ar: 'كلاهما يُنطقان هاءً' } }
    ],
    correctOptionId: 'B',
    timeLimit: 30,
    xpReward: 10
  },
  {
    id: 'arabic-269',
    subject: QuizSubject.ARABIC,
    difficulty: DifficultyLevel.EASY,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'ما علامة رفع الفعل المضارع؟', ar: 'ما علامة رفع الفعل المضارع؟' },
    options: [
      { id: 'A', text: { en: 'الفتحة', ar: 'الفتحة' } },
      { id: 'B', text: { en: 'الضمة', ar: 'الضمة' } },
      { id: 'C', text: { en: 'الكسرة', ar: 'الكسرة' } },
      { id: 'D', text: { en: 'السكون', ar: 'السكون' } }
    ],
    correctOptionId: 'B',
    timeLimit: 30,
    xpReward: 10
  },
  {
    id: 'arabic-270',
    subject: QuizSubject.ARABIC,
    difficulty: DifficultyLevel.EASY,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'أيّ من هذه أداة استفهام؟', ar: 'أيّ من هذه أداة استفهام؟' },
    options: [
      { id: 'A', text: { en: 'ثم', ar: 'ثم' } },
      { id: 'B', text: { en: 'كيف', ar: 'كيف' } },
      { id: 'C', text: { en: 'لكن', ar: 'لكن' } },
      { id: 'D', text: { en: 'أو', ar: 'أو' } }
    ],
    correctOptionId: 'B',
    timeLimit: 30,
    xpReward: 10
  },
  {
    id: 'arabic-271',
    subject: QuizSubject.ARABIC,
    difficulty: DifficultyLevel.EASY,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'ما معنى كلمة "الفصيح" في اللغة العربية؟', ar: 'ما معنى كلمة "الفصيح" في اللغة العربية؟' },
    options: [
      { id: 'A', text: { en: 'الصامت', ar: 'الصامت' } },
      { id: 'B', text: { en: 'البليغ الواضح', ar: 'البليغ الواضح' } },
      { id: 'C', text: { en: 'الغامض', ar: 'الغامض' } },
      { id: 'D', text: { en: 'السريع', ar: 'السريع' } }
    ],
    correctOptionId: 'B',
    timeLimit: 30,
    xpReward: 10
  },
  {
    id: 'arabic-272',
    subject: QuizSubject.ARABIC,
    difficulty: DifficultyLevel.EASY,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'صح أم خطأ: الفاعل يأتي دائماً بعد الفعل في الجملة الفعلية.', ar: 'صح أم خطأ: الفاعل يأتي دائماً بعد الفعل في الجملة الفعلية.' },
    options: [
      { id: 'A', text: { en: 'صح', ar: 'صح' } },
      { id: 'B', text: { en: 'خطأ', ar: 'خطأ' } }
    ],
    correctOptionId: 'A',
    timeLimit: 30,
    xpReward: 10
  },
  {
    id: 'arabic-273',
    subject: QuizSubject.ARABIC,
    difficulty: DifficultyLevel.EASY,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'ما جمع كلمة "قلم"؟', ar: 'ما جمع كلمة "قلم"؟' },
    options: [
      { id: 'A', text: { en: 'قلمان', ar: 'قلمان' } },
      { id: 'B', text: { en: 'أقلام', ar: 'أقلام' } },
      { id: 'C', text: { en: 'قالم', ar: 'قالم' } },
      { id: 'D', text: { en: 'مقلمة', ar: 'مقلمة' } }
    ],
    correctOptionId: 'B',
    timeLimit: 30,
    xpReward: 10
  },
  {
    id: 'arabic-274',
    subject: QuizSubject.ARABIC,
    difficulty: DifficultyLevel.EASY,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'أيّ كلمة كُتبت بشكل صحيح؟', ar: 'أيّ كلمة كُتبت بشكل صحيح؟' },
    options: [
      { id: 'A', text: { en: 'مسئول', ar: 'مسئول' } },
      { id: 'B', text: { en: 'مسؤول', ar: 'مسؤول' } },
      { id: 'C', text: { en: 'مسأول', ar: 'مسأول' } },
      { id: 'D', text: { en: 'مسوؤل', ar: 'مسوؤل' } }
    ],
    correctOptionId: 'B',
    timeLimit: 30,
    xpReward: 10
  },
  {
    id: 'arabic-275',
    subject: QuizSubject.ARABIC,
    difficulty: DifficultyLevel.EASY,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'ما نوع كلمة "جميل" في اللغة العربية؟', ar: 'ما نوع كلمة "جميل" في اللغة العربية؟' },
    options: [
      { id: 'A', text: { en: 'فعل', ar: 'فعل' } },
      { id: 'B', text: { en: 'صفة', ar: 'صفة' } },
      { id: 'C', text: { en: 'اسم', ar: 'اسم' } },
      { id: 'D', text: { en: 'حرف', ar: 'حرف' } }
    ],
    correctOptionId: 'B',
    timeLimit: 30,
    xpReward: 10
  },
  {
    id: 'arabic-276',
    subject: QuizSubject.ARABIC,
    difficulty: DifficultyLevel.EASY,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'صح أم خطأ: "أل" الشمسية تُنطق ولا تُدغم.', ar: 'صح أم خطأ: "أل" الشمسية تُنطق ولا تُدغم.' },
    options: [
      { id: 'A', text: { en: 'صح', ar: 'صح' } },
      { id: 'B', text: { en: 'خطأ', ar: 'خطأ' } }
    ],
    correctOptionId: 'B',
    timeLimit: 30,
    xpReward: 10
  },
  {
    id: 'arabic-277',
    subject: QuizSubject.ARABIC,
    difficulty: DifficultyLevel.EASY,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'أيّ حرف من الحروف الشمسية؟', ar: 'أيّ حرف من الحروف الشمسية؟' },
    options: [
      { id: 'A', text: { en: 'ب', ar: 'ب' } },
      { id: 'B', text: { en: 'ت', ar: 'ت' } },
      { id: 'C', text: { en: 'ك', ar: 'ك' } },
      { id: 'D', text: { en: 'م', ar: 'م' } }
    ],
    correctOptionId: 'B',
    timeLimit: 30,
    xpReward: 10
  },
  {
    id: 'arabic-278',
    subject: QuizSubject.ARABIC,
    difficulty: DifficultyLevel.EASY,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'ما مرادف كلمة "الغضب"؟', ar: 'ما مرادف كلمة "الغضب"؟' },
    options: [
      { id: 'A', text: { en: 'الفرح', ar: 'الفرح' } },
      { id: 'B', text: { en: 'السخط', ar: 'السخط' } },
      { id: 'C', text: { en: 'الحزن', ar: 'الحزن' } },
      { id: 'D', text: { en: 'الخوف', ar: 'الخوف' } }
    ],
    correctOptionId: 'B',
    timeLimit: 30,
    xpReward: 10
  },
  {
    id: 'arabic-279',
    subject: QuizSubject.ARABIC,
    difficulty: DifficultyLevel.EASY,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'ما المفرد من كلمة "علماء"؟', ar: 'ما المفرد من كلمة "علماء"؟' },
    options: [
      { id: 'A', text: { en: 'علوم', ar: 'علوم' } },
      { id: 'B', text: { en: 'عالِم', ar: 'عالِم' } },
      { id: 'C', text: { en: 'معلم', ar: 'معلم' } },
      { id: 'D', text: { en: 'تعلّم', ar: 'تعلّم' } }
    ],
    correctOptionId: 'B',
    timeLimit: 30,
    xpReward: 10
  },
  {
    id: 'arabic-280',
    subject: QuizSubject.ARABIC,
    difficulty: DifficultyLevel.EASY,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'في جملة "الطالبُ مجتهدٌ"، ما إعراب "مجتهدٌ"؟', ar: 'في جملة "الطالبُ مجتهدٌ"، ما إعراب "مجتهدٌ"؟' },
    options: [
      { id: 'A', text: { en: 'مبتدأ', ar: 'مبتدأ' } },
      { id: 'B', text: { en: 'خبر', ar: 'خبر' } },
      { id: 'C', text: { en: 'فاعل', ar: 'فاعل' } },
      { id: 'D', text: { en: 'مفعول به', ar: 'مفعول به' } }
    ],
    correctOptionId: 'B',
    timeLimit: 30,
    xpReward: 10
  },
  {
    id: 'arabic-281',
    subject: QuizSubject.ARABIC,
    difficulty: DifficultyLevel.EASY,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'ما الاسم الموصول المناسب: "جاء الولد _____ فاز بالمسابقة"؟', ar: 'ما الاسم الموصول المناسب: "جاء الولد _____ فاز بالمسابقة"؟' },
    options: [
      { id: 'A', text: { en: 'التي', ar: 'التي' } },
      { id: 'B', text: { en: 'الذي', ar: 'الذي' } },
      { id: 'C', text: { en: 'اللذان', ar: 'اللذان' } },
      { id: 'D', text: { en: 'اللاتي', ar: 'اللاتي' } }
    ],
    correctOptionId: 'B',
    timeLimit: 30,
    xpReward: 10
  },
  {
    id: 'arabic-282',
    subject: QuizSubject.ARABIC,
    difficulty: DifficultyLevel.EASY,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'صح أم خطأ: الحروف في العربية ليس لها معنى بذاتها بدون جملة.', ar: 'صح أم خطأ: الحروف في العربية ليس لها معنى بذاتها بدون جملة.' },
    options: [
      { id: 'A', text: { en: 'صح', ar: 'صح' } },
      { id: 'B', text: { en: 'خطأ', ar: 'خطأ' } }
    ],
    correctOptionId: 'A',
    timeLimit: 30,
    xpReward: 10
  },
  {
    id: 'arabic-283',
    subject: QuizSubject.ARABIC,
    difficulty: DifficultyLevel.EASY,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'أيّ كلمة فيها "ال" القمرية؟', ar: 'أيّ كلمة فيها "ال" القمرية؟' },
    options: [
      { id: 'A', text: { en: 'الشمس', ar: 'الشمس' } },
      { id: 'B', text: { en: 'القمر', ar: 'القمر' } },
      { id: 'C', text: { en: 'النور', ar: 'النور' } },
      { id: 'D', text: { en: 'التراب', ar: 'التراب' } }
    ],
    correctOptionId: 'B',
    timeLimit: 30,
    xpReward: 10
  },
  {
    id: 'arabic-284',
    subject: QuizSubject.ARABIC,
    difficulty: DifficultyLevel.EASY,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'ما ضد كلمة "الصعب"؟', ar: 'ما ضد كلمة "الصعب"؟' },
    options: [
      { id: 'A', text: { en: 'المستحيل', ar: 'المستحيل' } },
      { id: 'B', text: { en: 'السهل', ar: 'السهل' } },
      { id: 'C', text: { en: 'الطويل', ar: 'الطويل' } },
      { id: 'D', text: { en: 'القصير', ar: 'القصير' } }
    ],
    correctOptionId: 'B',
    timeLimit: 30,
    xpReward: 10
  },
  {
    id: 'arabic-285',
    subject: QuizSubject.ARABIC,
    difficulty: DifficultyLevel.EASY,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'ما نوع الجملة: "العلمُ نورٌ"؟', ar: 'ما نوع الجملة: "العلمُ نورٌ"؟' },
    options: [
      { id: 'A', text: { en: 'جملة فعلية', ar: 'جملة فعلية' } },
      { id: 'B', text: { en: 'جملة اسمية', ar: 'جملة اسمية' } },
      { id: 'C', text: { en: 'جملة شرطية', ar: 'جملة شرطية' } },
      { id: 'D', text: { en: 'جملة أمر', ar: 'جملة أمر' } }
    ],
    correctOptionId: 'B',
    timeLimit: 30,
    xpReward: 10
  },
  {
    id: 'arabic-286',
    subject: QuizSubject.ARABIC,
    difficulty: DifficultyLevel.EASY,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'أيّ كلمة مكتوبة بالهمزة بشكل صحيح؟', ar: 'أيّ كلمة مكتوبة بالهمزة بشكل صحيح؟' },
    options: [
      { id: 'A', text: { en: 'سأل', ar: 'سأل' } },
      { id: 'B', text: { en: 'سئل', ar: 'سئل' } },
      { id: 'C', text: { en: 'سؤل', ar: 'سؤل' } },
      { id: 'D', text: { en: 'سءل', ar: 'سءل' } }
    ],
    correctOptionId: 'A',
    timeLimit: 30,
    xpReward: 10
  },
  {
    id: 'arabic-287',
    subject: QuizSubject.ARABIC,
    difficulty: DifficultyLevel.EASY,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'ما معنى المثل: "من جدّ وجد"؟', ar: 'ما معنى المثل: "من جدّ وجد"؟' },
    options: [
      { id: 'A', text: { en: 'من نام ارتاح', ar: 'من نام ارتاح' } },
      { id: 'B', text: { en: 'من اجتهد حقّق هدفه', ar: 'من اجتهد حقّق هدفه' } },
      { id: 'C', text: { en: 'من لعب خسر', ar: 'من لعب خسر' } },
      { id: 'D', text: { en: 'من سافر تعب', ar: 'من سافر تعب' } }
    ],
    correctOptionId: 'B',
    timeLimit: 30,
    xpReward: 10
  },
  {
    id: 'arabic-288',
    subject: QuizSubject.ARABIC,
    difficulty: DifficultyLevel.EASY,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'ما الحركة التي تدل على الكسر؟', ar: 'ما الحركة التي تدل على الكسر؟' },
    options: [
      { id: 'A', text: { en: 'ـَ', ar: 'ـَ' } },
      { id: 'B', text: { en: 'ـِ', ar: 'ـِ' } },
      { id: 'C', text: { en: 'ـُ', ar: 'ـُ' } },
      { id: 'D', text: { en: 'ـْ', ar: 'ـْ' } }
    ],
    correctOptionId: 'B',
    timeLimit: 30,
    xpReward: 10
  },
  {
    id: 'arabic-289',
    subject: QuizSubject.ARABIC,
    difficulty: DifficultyLevel.EASY,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'صح أم خطأ: كل اسم يبدأ بـ "ال" يكون معرفة.', ar: 'صح أم خطأ: كل اسم يبدأ بـ "ال" يكون معرفة.' },
    options: [
      { id: 'A', text: { en: 'صح', ar: 'صح' } },
      { id: 'B', text: { en: 'خطأ', ar: 'خطأ' } }
    ],
    correctOptionId: 'A',
    timeLimit: 30,
    xpReward: 10
  },
  {
    id: 'arabic-290',
    subject: QuizSubject.ARABIC,
    difficulty: DifficultyLevel.EASY,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'ما جمع كلمة "بحر"؟', ar: 'ما جمع كلمة "بحر"؟' },
    options: [
      { id: 'A', text: { en: 'بحران', ar: 'بحران' } },
      { id: 'B', text: { en: 'بحار', ar: 'بحار' } },
      { id: 'C', text: { en: 'بحيرة', ar: 'بحيرة' } },
      { id: 'D', text: { en: 'أبحر', ar: 'أبحر' } }
    ],
    correctOptionId: 'B',
    timeLimit: 30,
    xpReward: 10
  },
  {
    id: 'arabic-291',
    subject: QuizSubject.ARABIC,
    difficulty: DifficultyLevel.EASY,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'أيّ من التالي فعل ماضٍ؟', ar: 'أيّ من التالي فعل ماضٍ؟' },
    options: [
      { id: 'A', text: { en: 'يلعب', ar: 'يلعب' } },
      { id: 'B', text: { en: 'ذهبَ', ar: 'ذهبَ' } },
      { id: 'C', text: { en: 'اكتبْ', ar: 'اكتبْ' } },
      { id: 'D', text: { en: 'يدرس', ar: 'يدرس' } }
    ],
    correctOptionId: 'B',
    timeLimit: 30,
    xpReward: 10
  },
  {
    id: 'arabic-292',
    subject: QuizSubject.ARABIC,
    difficulty: DifficultyLevel.EASY,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'ما معنى كلمة "الوطن"؟', ar: 'ما معنى كلمة "الوطن"؟' },
    options: [
      { id: 'A', text: { en: 'المدرسة', ar: 'المدرسة' } },
      { id: 'B', text: { en: 'البلد الذي ينتمي إليه الإنسان', ar: 'البلد الذي ينتمي إليه الإنسان' } },
      { id: 'C', text: { en: 'الشارع', ar: 'الشارع' } },
      { id: 'D', text: { en: 'المكتبة', ar: 'المكتبة' } }
    ],
    correctOptionId: 'B',
    timeLimit: 30,
    xpReward: 10
  },
  {
    id: 'arabic-293',
    subject: QuizSubject.ARABIC,
    difficulty: DifficultyLevel.EASY,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'أيّ من هذه الكلمات اسم مكان؟', ar: 'أيّ من هذه الكلمات اسم مكان؟' },
    options: [
      { id: 'A', text: { en: 'كاتب', ar: 'كاتب' } },
      { id: 'B', text: { en: 'مكتبة', ar: 'مكتبة' } },
      { id: 'C', text: { en: 'كتابة', ar: 'كتابة' } },
      { id: 'D', text: { en: 'يكتب', ar: 'يكتب' } }
    ],
    correctOptionId: 'B',
    timeLimit: 30,
    xpReward: 10
  },
  {
    id: 'arabic-294',
    subject: QuizSubject.ARABIC,
    difficulty: DifficultyLevel.EASY,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'صح أم خطأ: الفعل الأمر يدل على طلب فعل شيء في المستقبل.', ar: 'صح أم خطأ: الفعل الأمر يدل على طلب فعل شيء في المستقبل.' },
    options: [
      { id: 'A', text: { en: 'صح', ar: 'صح' } },
      { id: 'B', text: { en: 'خطأ', ar: 'خطأ' } }
    ],
    correctOptionId: 'A',
    timeLimit: 30,
    xpReward: 10
  },
  {
    id: 'arabic-295',
    subject: QuizSubject.ARABIC,
    difficulty: DifficultyLevel.EASY,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'ما مرادف كلمة "السرور"؟', ar: 'ما مرادف كلمة "السرور"؟' },
    options: [
      { id: 'A', text: { en: 'الحزن', ar: 'الحزن' } },
      { id: 'B', text: { en: 'الفرح', ar: 'الفرح' } },
      { id: 'C', text: { en: 'الغضب', ar: 'الغضب' } },
      { id: 'D', text: { en: 'الخوف', ar: 'الخوف' } }
    ],
    correctOptionId: 'B',
    timeLimit: 30,
    xpReward: 10
  },
  {
    id: 'arabic-296',
    subject: QuizSubject.ARABIC,
    difficulty: DifficultyLevel.EASY,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'أيّ من هذه الجمل تحتوي على أسلوب نداء؟', ar: 'أيّ من هذه الجمل تحتوي على أسلوب نداء؟' },
    options: [
      { id: 'A', text: { en: 'الجو جميل', ar: 'الجو جميل' } },
      { id: 'B', text: { en: 'يا أحمد، تعالَ', ar: 'يا أحمد، تعالَ' } },
      { id: 'C', text: { en: 'ذهب علي', ar: 'ذهب علي' } },
      { id: 'D', text: { en: 'الكتاب مفيد', ar: 'الكتاب مفيد' } }
    ],
    correctOptionId: 'B',
    timeLimit: 30,
    xpReward: 10
  },
  {
    id: 'arabic-297',
    subject: QuizSubject.ARABIC,
    difficulty: DifficultyLevel.EASY,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'ما ضد كلمة "الظلام"؟', ar: 'ما ضد كلمة "الظلام"؟' },
    options: [
      { id: 'A', text: { en: 'الليل', ar: 'الليل' } },
      { id: 'B', text: { en: 'النور', ar: 'النور' } },
      { id: 'C', text: { en: 'السماء', ar: 'السماء' } },
      { id: 'D', text: { en: 'القمر', ar: 'القمر' } }
    ],
    correctOptionId: 'B',
    timeLimit: 30,
    xpReward: 10
  },
  {
    id: 'arabic-298',
    subject: QuizSubject.ARABIC,
    difficulty: DifficultyLevel.EASY,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'ما جمع كلمة "نجمة"؟', ar: 'ما جمع كلمة "نجمة"؟' },
    options: [
      { id: 'A', text: { en: 'نجمتان', ar: 'نجمتان' } },
      { id: 'B', text: { en: 'نجوم', ar: 'نجوم' } },
      { id: 'C', text: { en: 'نجمات فقط', ar: 'نجمات فقط' } },
      { id: 'D', text: { en: 'أنجم', ar: 'أنجم' } }
    ],
    correctOptionId: 'B',
    timeLimit: 30,
    xpReward: 10
  },
  {
    id: 'arabic-299',
    subject: QuizSubject.ARABIC,
    difficulty: DifficultyLevel.EASY,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'صح أم خطأ: "لن" تنصب الفعل المضارع.', ar: 'صح أم خطأ: "لن" تنصب الفعل المضارع.' },
    options: [
      { id: 'A', text: { en: 'صح', ar: 'صح' } },
      { id: 'B', text: { en: 'خطأ', ar: 'خطأ' } }
    ],
    correctOptionId: 'A',
    timeLimit: 30,
    xpReward: 10
  },
  {
    id: 'arabic-300',
    subject: QuizSubject.ARABIC,
    difficulty: DifficultyLevel.EASY,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'ما نوع كلمة "في" في اللغة العربية؟', ar: 'ما نوع كلمة "في" في اللغة العربية؟' },
    options: [
      { id: 'A', text: { en: 'اسم', ar: 'اسم' } },
      { id: 'B', text: { en: 'حرف جر', ar: 'حرف جر' } },
      { id: 'C', text: { en: 'فعل', ar: 'فعل' } },
      { id: 'D', text: { en: 'صفة', ar: 'صفة' } }
    ],
    correctOptionId: 'B',
    timeLimit: 30,
    xpReward: 10
  },
  {
    id: 'arabic-301',
    subject: QuizSubject.ARABIC,
    difficulty: DifficultyLevel.EASY,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'أيّ كلمة تحتوي على مدّ بالألف؟', ar: 'أيّ كلمة تحتوي على مدّ بالألف؟' },
    options: [
      { id: 'A', text: { en: 'كُتُب', ar: 'كُتُب' } },
      { id: 'B', text: { en: 'كِتَاب', ar: 'كِتَاب' } },
      { id: 'C', text: { en: 'كَتَبَ', ar: 'كَتَبَ' } },
      { id: 'D', text: { en: 'مَكتَب', ar: 'مَكتَب' } }
    ],
    correctOptionId: 'B',
    timeLimit: 30,
    xpReward: 10
  },
  {
    id: 'arabic-302',
    subject: QuizSubject.ARABIC,
    difficulty: DifficultyLevel.EASY,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'ما معنى المثل: "العلم في الصغر كالنقش في الحجر"؟', ar: 'ما معنى المثل: "العلم في الصغر كالنقش في الحجر"؟' },
    options: [
      { id: 'A', text: { en: 'العلم صعب', ar: 'العلم صعب' } },
      { id: 'B', text: { en: 'ما تتعلمه صغيراً لا تنساه', ar: 'ما تتعلمه صغيراً لا تنساه' } },
      { id: 'C', text: { en: 'الحجر قوي', ar: 'الحجر قوي' } },
      { id: 'D', text: { en: 'النقش جميل', ar: 'النقش جميل' } }
    ],
    correctOptionId: 'B',
    timeLimit: 30,
    xpReward: 10
  },
  {
    id: 'arabic-303',
    subject: QuizSubject.ARABIC,
    difficulty: DifficultyLevel.EASY,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'ما علامة نصب المفعول به المفرد؟', ar: 'ما علامة نصب المفعول به المفرد؟' },
    options: [
      { id: 'A', text: { en: 'الضمة', ar: 'الضمة' } },
      { id: 'B', text: { en: 'الفتحة', ar: 'الفتحة' } },
      { id: 'C', text: { en: 'الكسرة', ar: 'الكسرة' } },
      { id: 'D', text: { en: 'السكون', ar: 'السكون' } }
    ],
    correctOptionId: 'B',
    timeLimit: 30,
    xpReward: 10
  },
  {
    id: 'general-304',
    subject: QuizSubject.GENERAL,
    difficulty: DifficultyLevel.EASY,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'Sapporo is a major city in what country?', ar: 'سابورو مدينة كبرى في أي بلد؟' },
    options: [
      { id: 'A', text: { en: 'Japan', ar: 'اليابان' } },
      { id: 'B', text: { en: 'China', ar: 'الصين' } },
      { id: 'C', text: { en: 'The Phillippines', ar: 'الفلبين' } },
      { id: 'D', text: { en: 'Thailand', ar: 'تايلاند' } }
    ],
    correctOptionId: 'A',
    timeLimit: 30,
    xpReward: 10
  },
  {
    id: 'english-305',
    subject: QuizSubject.ENGLISH,
    difficulty: DifficultyLevel.EASY,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'If someone wearing a T-shirt with the word "WOW" on it stood on his head, what word would people read?', ar: 'If someone wearing a T-shirt with the word "WOW" on it stood on his head, what word would people read?' },
    options: [
      { id: 'A', text: { en: 'Moo', ar: 'Moo' } },
      { id: 'B', text: { en: 'Who', ar: 'Who' } },
      { id: 'C', text: { en: 'Mom', ar: 'Mom' } },
      { id: 'D', text: { en: 'I\'m with Stupid', ar: 'I\'m with Stupid' } }
    ],
    correctOptionId: 'C',
    timeLimit: 30,
    xpReward: 10
  },
  {
    id: 'science-306',
    subject: QuizSubject.SCIENCE,
    difficulty: DifficultyLevel.EASY,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'What part of a plant draws water from the soil?', ar: 'أي جزء من النبات يسحب الماء من التربة؟' },
    options: [
      { id: 'A', text: { en: 'Branches', ar: 'الأغصان' } },
      { id: 'B', text: { en: 'Leaves', ar: 'الأوراق' } },
      { id: 'C', text: { en: 'Seeds', ar: 'البذور' } },
      { id: 'D', text: { en: 'Roots', ar: 'الجذور' } }
    ],
    correctOptionId: 'D',
    timeLimit: 30,
    xpReward: 10
  },
  {
    id: 'general-307',
    subject: QuizSubject.GENERAL,
    difficulty: DifficultyLevel.EASY,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'Which of the following tools is most useful for clearing snow from a driveway?', ar: 'أي من الأدوات التالية هي الأكثر فائدة لإزالة الثلج من الممر؟' },
    options: [
      { id: 'A', text: { en: 'Rake', ar: 'مذراة' } },
      { id: 'B', text: { en: 'Shovel', ar: 'مجرفة' } },
      { id: 'C', text: { en: 'Pitchfork', ar: 'شوكة كبيرة' } },
      { id: 'D', text: { en: 'Toothpick', ar: 'عود أسنان' } }
    ],
    correctOptionId: 'B',
    timeLimit: 30,
    xpReward: 10
  },
  {
    id: 'english-308',
    subject: QuizSubject.ENGLISH,
    difficulty: DifficultyLevel.EASY,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'A race that finishes in a tie for first place is commonly called what?', ar: 'A race that finishes in a tie for first place is commonly called what?' },
    options: [
      { id: 'A', text: { en: 'Dry heat', ar: 'Dry heat' } },
      { id: 'B', text: { en: 'Dead giveaway', ar: 'Dead giveaway' } },
      { id: 'C', text: { en: 'Dead heat', ar: 'Dead heat' } },
      { id: 'D', text: { en: 'Presidency', ar: 'Presidency' } }
    ],
    correctOptionId: 'C',
    timeLimit: 30,
    xpReward: 10
  },
  {
    id: 'general-309',
    subject: QuizSubject.GENERAL,
    difficulty: DifficultyLevel.EASY,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'People in what profession are nicknamed "frogmen"?', ar: 'ما هي المهنة التي يطلق على ممارسيها لقب "رجال الضفادع"؟' },
    options: [
      { id: 'A', text: { en: 'Puppeteers', ar: 'محرّكو الدمى' } },
      { id: 'B', text: { en: 'High jumpers', ar: 'قافزو الارتفاع' } },
      { id: 'C', text: { en: 'Exterminators', ar: 'مبيدو الحشرات' } },
      { id: 'D', text: { en: 'Underwater divers', ar: 'الغواصون' } }
    ],
    correctOptionId: 'D',
    timeLimit: 30,
    xpReward: 10
  },
  {
    id: 'english-310',
    subject: QuizSubject.ENGLISH,
    difficulty: DifficultyLevel.EASY,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'According to a well-known expression, "the best things in life are" what?', ar: 'According to a well-known expression, "the best things in life are" what?' },
    options: [
      { id: 'A', text: { en: 'Costly', ar: 'Costly' } },
      { id: 'B', text: { en: 'Free', ar: 'Free' } },
      { id: 'C', text: { en: 'Groovy', ar: 'Groovy' } },
      { id: 'D', text: { en: 'Mortgaged', ar: 'Mortgaged' } }
    ],
    correctOptionId: 'B',
    timeLimit: 30,
    xpReward: 10
  },
  {
    id: 'science-311',
    subject: QuizSubject.SCIENCE,
    difficulty: DifficultyLevel.EASY,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'Which of the following scientists specializes in the study of plants and flowers?', ar: 'أي من العلماء التاليين متخصص في دراسة النباتات والأزهار؟' },
    options: [
      { id: 'A', text: { en: 'Zoologist', ar: 'عالم الحيوان' } },
      { id: 'B', text: { en: 'Botanist', ar: 'عالم النبات' } },
      { id: 'C', text: { en: 'Taxidermist', ar: 'محنط الحيوانات' } },
      { id: 'D', text: { en: 'Nutritionist', ar: 'أخصائي تغذية' } }
    ],
    correctOptionId: 'B',
    timeLimit: 30,
    xpReward: 10
  },
  {
    id: 'science-312',
    subject: QuizSubject.SCIENCE,
    difficulty: DifficultyLevel.EASY,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'Which of these extinct prehistoric animals is classified as a mammal?', ar: 'أي من هذه الحيوانات المنقرضة قبل التاريخ تصنف من الثدييات؟' },
    options: [
      { id: 'A', text: { en: 'Pterodactyl', ar: 'البتيروداكتيل' } },
      { id: 'B', text: { en: 'Tyrannosaurus Rex', ar: 'التيرانوصور ركس' } },
      { id: 'C', text: { en: 'Trilobite', ar: 'الترايلوبيت' } },
      { id: 'D', text: { en: 'Woolly mammoth', ar: 'الماموث الصوفي' } }
    ],
    correctOptionId: 'D',
    timeLimit: 30,
    xpReward: 10
  },
  {
    id: 'english-313',
    subject: QuizSubject.ENGLISH,
    difficulty: DifficultyLevel.EASY,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'Which of these words is commonly used when a person wants silence?', ar: 'Which of these words is commonly used when a person wants silence?' },
    options: [
      { id: 'A', text: { en: 'Egads!', ar: 'Egads!' } },
      { id: 'B', text: { en: 'Eek!', ar: 'Eek!' } },
      { id: 'C', text: { en: 'Yikes!', ar: 'Yikes!' } },
      { id: 'D', text: { en: 'Shush!', ar: 'Shush!' } }
    ],
    correctOptionId: 'D',
    timeLimit: 30,
    xpReward: 10
  },
  {
    id: 'general-314',
    subject: QuizSubject.GENERAL,
    difficulty: DifficultyLevel.MEDIUM,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'Which of these flower varieties has a common nickname consisting of the last three letters of its names?', ar: 'أيٌّ من هذه الأزهار له اسم شائع مختصر يتكون من آخر ثلاثة أحرف من اسمها؟' },
    options: [
      { id: 'A', text: { en: 'Crysanthemum', ar: 'الأقحوان (Crysanthemum)' } },
      { id: 'B', text: { en: 'Gardenia', ar: 'الجاردينيا' } },
      { id: 'C', text: { en: 'Violet', ar: 'البنفسج' } },
      { id: 'D', text: { en: 'Carnation', ar: 'القرنفل' } }
    ],
    correctOptionId: 'A',
    timeLimit: 30,
    xpReward: 20
  },
  {
    id: 'general-315',
    subject: QuizSubject.GENERAL,
    difficulty: DifficultyLevel.EASY,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'Which sign of the zodiac is traditionally represented by a pair of fish?', ar: 'أيُّ برج فلكي يُمثَّل تقليدياً بزوج من السمك؟' },
    options: [
      { id: 'A', text: { en: 'Gemini', ar: 'الجوزاء' } },
      { id: 'B', text: { en: 'Scorpio', ar: 'العقرب' } },
      { id: 'C', text: { en: 'Libra', ar: 'الميزان' } },
      { id: 'D', text: { en: 'Pisces', ar: 'الحوت' } }
    ],
    correctOptionId: 'D',
    timeLimit: 30,
    xpReward: 10
  },
  {
    id: 'general-316',
    subject: QuizSubject.GENERAL,
    difficulty: DifficultyLevel.MEDIUM,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'Due to its deep & powerful sound, what brass instrument is traditionally the only one of its kind in an orchestra?', ar: 'بسبب صوتها العميق والقوي، ما الآلة النحاسية التي تُعدّ تقليدياً الوحيدة من نوعها في الأوركسترا؟' },
    options: [
      { id: 'A', text: { en: 'Tuba', ar: 'التوبا' } },
      { id: 'B', text: { en: 'Trombone', ar: 'الترومبون' } },
      { id: 'C', text: { en: 'French horn', ar: 'البوق الفرنسي' } },
      { id: 'D', text: { en: 'Trumpet', ar: 'البوق' } }
    ],
    correctOptionId: 'A',
    timeLimit: 30,
    xpReward: 20
  },
  {
    id: 'general-317',
    subject: QuizSubject.GENERAL,
    difficulty: DifficultyLevel.MEDIUM,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'Indonesia is part of a group of nations known as what?', ar: 'تنتمي إندونيسيا إلى مجموعة من الدول تُعرف بـ ماذا؟' },
    options: [
      { id: 'A', text: { en: 'Maldives', ar: 'جزر المالديف' } },
      { id: 'B', text: { en: 'Micronesia', ar: 'ميكرونيزيا' } },
      { id: 'C', text: { en: 'East Indies', ar: 'جزر الهند الشرقية' } },
      { id: 'D', text: { en: 'French Polynesia', ar: 'بولينيزيا الفرنسية' } }
    ],
    correctOptionId: 'C',
    timeLimit: 30,
    xpReward: 20
  },
  {
    id: 'english-318',
    subject: QuizSubject.ENGLISH,
    difficulty: DifficultyLevel.EASY,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'Which of these terms appears in the dictionary as an adjective meaning "very dry"?', ar: 'Which of these terms appears in the dictionary as an adjective meaning "very dry"?' },
    options: [
      { id: 'A', text: { en: 'Bone-dry', ar: 'Bone-dry' } },
      { id: 'B', text: { en: 'Hair-dry', ar: 'Hair-dry' } },
      { id: 'C', text: { en: 'Skin-dry', ar: 'Skin-dry' } },
      { id: 'D', text: { en: 'Tooth-dry', ar: 'Tooth-dry' } }
    ],
    correctOptionId: 'A',
    timeLimit: 30,
    xpReward: 10
  },
  {
    id: 'general-319',
    subject: QuizSubject.GENERAL,
    difficulty: DifficultyLevel.MEDIUM,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'The British often take a coffee or tea break aptly known as "elevenses" at what time of day?', ar: 'غالباً ما يأخذ البريطانيون استراحة قهوة أو شاي تُعرف بـ"إيلِفِنسز"، في أي وقت من اليوم؟' },
    options: [
      { id: 'A', text: { en: 'Early evening', ar: 'أوّل المساء' } },
      { id: 'B', text: { en: 'Sunrise', ar: 'الشروق' } },
      { id: 'C', text: { en: 'Midafternoon', ar: 'منتصف بعد الظهر' } },
      { id: 'D', text: { en: 'Late morning', ar: 'أواخر الصباح' } }
    ],
    correctOptionId: 'D',
    timeLimit: 30,
    xpReward: 20
  },
  {
    id: 'general-320',
    subject: QuizSubject.GENERAL,
    difficulty: DifficultyLevel.MEDIUM,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'Featuring legs that are yellow instead of pink, the Andean flamingo is native to which of these countries?', ar: 'يتميّز فلامينغو الأنديز بسيقان صفراء بدلاً من الوردية، فهو موطنه أيٌّ من هذه الدول؟' },
    options: [
      { id: 'A', text: { en: 'Australia', ar: 'أستراليا' } },
      { id: 'B', text: { en: 'Switzerland', ar: 'سويسرا' } },
      { id: 'C', text: { en: 'Peru', ar: 'بيرو' } },
      { id: 'D', text: { en: 'Nepal', ar: 'النيبال' } }
    ],
    correctOptionId: 'C',
    timeLimit: 30,
    xpReward: 20
  },
  {
    id: 'science-321',
    subject: QuizSubject.SCIENCE,
    difficulty: DifficultyLevel.EASY,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'Lions prefer to live where?', ar: 'تفضّل الأسود العيش في أي بيئة؟' },
    options: [
      { id: 'A', text: { en: 'Snowy mountains', ar: 'الجبال الثلجية' } },
      { id: 'B', text: { en: 'Grassy plains', ar: 'السهول العشبية' } },
      { id: 'C', text: { en: 'Muddy swamps', ar: 'المستنقعات الطينية' } },
      { id: 'D', text: { en: 'Gated communities', ar: 'المجمعات المسوّرة' } }
    ],
    correctOptionId: 'B',
    timeLimit: 30,
    xpReward: 10
  },
  {
    id: 'english-322',
    subject: QuizSubject.ENGLISH,
    difficulty: DifficultyLevel.EASY,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'A person whose work is truly outstanding is said to be what "above the rest"?', ar: 'A person whose work is truly outstanding is said to be what "above the rest"?' },
    options: [
      { id: 'A', text: { en: 'Ankles and toes', ar: 'Ankles and toes' } },
      { id: 'B', text: { en: 'Hands and elbows', ar: 'Hands and elbows' } },
      { id: 'C', text: { en: 'Head and shoulders', ar: 'Head and shoulders' } },
      { id: 'D', text: { en: 'Good at copying', ar: 'Good at copying' } }
    ],
    correctOptionId: 'C',
    timeLimit: 30,
    xpReward: 10
  },
  {
    id: 'science-323',
    subject: QuizSubject.SCIENCE,
    difficulty: DifficultyLevel.EASY,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'What color is the "meat" inside a coconut?', ar: 'ما لون "اللحم" داخل جوز الهند؟' },
    options: [
      { id: 'A', text: { en: 'White', ar: 'أبيض' } },
      { id: 'B', text: { en: 'Yellow', ar: 'أصفر' } },
      { id: 'C', text: { en: 'Green', ar: 'أخضر' } },
      { id: 'D', text: { en: 'Orange', ar: 'برتقالي' } }
    ],
    correctOptionId: 'A',
    timeLimit: 30,
    xpReward: 10
  },
  {
    id: 'general-324',
    subject: QuizSubject.GENERAL,
    difficulty: DifficultyLevel.EASY,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'What is the term for the U-shaped ramp used in skateboarding competitions?', ar: 'ما المصطلح الذي يُطلق على المنحدر على شكل حرف U المستخدم في مسابقات التزلج بالألواح؟' },
    options: [
      { id: 'A', text: { en: 'Highchair', ar: 'كرسي عالٍ' } },
      { id: 'B', text: { en: 'Topper', ar: 'توبر' } },
      { id: 'C', text: { en: 'Lowrider', ar: 'لوريدر' } },
      { id: 'D', text: { en: 'Half-pipe', ar: 'هاف-بايب' } }
    ],
    correctOptionId: 'D',
    timeLimit: 30,
    xpReward: 10
  },
  {
    id: 'general-325',
    subject: QuizSubject.GENERAL,
    difficulty: DifficultyLevel.MEDIUM,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'Which of these types of pasta is NOT typically stuffed with cheese?', ar: 'أيٌّ من أنواع المعكرونة التالية لا يُحشى عادةً بالجبن؟' },
    options: [
      { id: 'A', text: { en: 'Tortellini', ar: 'تورتيليني' } },
      { id: 'B', text: { en: 'Tagliatelle', ar: 'تالياتيلي' } },
      { id: 'C', text: { en: 'Manicotti', ar: 'مانيكوتي' } },
      { id: 'D', text: { en: 'Cannelloni', ar: 'كانيلوني' } }
    ],
    correctOptionId: 'B',
    timeLimit: 30,
    xpReward: 20
  },
  {
    id: 'english-326',
    subject: QuizSubject.ENGLISH,
    difficulty: DifficultyLevel.EASY,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'If your eyes are bloodshot, what color are they?', ar: 'If your eyes are bloodshot, what color are they?' },
    options: [
      { id: 'A', text: { en: 'Red', ar: 'Red' } },
      { id: 'B', text: { en: 'Blue', ar: 'Blue' } },
      { id: 'C', text: { en: 'Black', ar: 'Black' } },
      { id: 'D', text: { en: 'Plaid', ar: 'Plaid' } }
    ],
    correctOptionId: 'A',
    timeLimit: 30,
    xpReward: 10
  },
  {
    id: 'general-327',
    subject: QuizSubject.GENERAL,
    difficulty: DifficultyLevel.EASY,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'A flood that rises and falls rapidly with little or no warning is commonly called what?', ar: 'ما الاسم الشائع للفيضان الذي يرتفع وينحسر بسرعة دون إنذار يُذكر؟' },
    options: [
      { id: 'A', text: { en: 'Fisherman\'s flood', ar: 'فيضان الصياد' } },
      { id: 'B', text: { en: 'Whitewash flood', ar: 'فيضان طلاء أبيض' } },
      { id: 'C', text: { en: 'Flash flood', ar: 'الفيضان الخاطف' } },
      { id: 'D', text: { en: 'Flood pants', ar: 'بنطال الفيضان' } }
    ],
    correctOptionId: 'C',
    timeLimit: 30,
    xpReward: 10
  },
  {
    id: 'general-328',
    subject: QuizSubject.GENERAL,
    difficulty: DifficultyLevel.EASY,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'A swinging bed made of netting or canvas that is hung up at each end is called what?', ar: 'ما اسم السرير المتأرجح المصنوع من الشباك أو القماش والمعلّق من كلا الطرفين؟' },
    options: [
      { id: 'A', text: { en: 'Bunk bed', ar: 'سرير بطابقين' } },
      { id: 'B', text: { en: 'Fourposter', ar: 'سرير بأربعة أعمدة' } },
      { id: 'C', text: { en: 'Trundle', ar: 'سرير منزلق' } },
      { id: 'D', text: { en: 'Hammock', ar: 'أرجوحة شبكية' } }
    ],
    correctOptionId: 'D',
    timeLimit: 30,
    xpReward: 10
  },
  {
    id: 'science-329',
    subject: QuizSubject.SCIENCE,
    difficulty: DifficultyLevel.MEDIUM,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'About four times as strong as standard glass, what glass used for car windows is made by heating it to over 600 degrees Celsius, and then quickly cooling it?', ar: 'يبلغ متانته نحو أربعة أضعاف الزجاج العادي، ما الزجاج المستخدم في نوافذ السيارات والذي يُصنع بتسخينه إلى أكثر من ٦٠٠ درجة مئوية ثم تبريده سريعاً؟' },
    options: [
      { id: 'A', text: { en: 'Beveled glass', ar: 'زجاج مشطوف' } },
      { id: 'B', text: { en: 'Frosted glass', ar: 'زجاج مصنفر' } },
      { id: 'C', text: { en: 'Plate glass', ar: 'زجاج لوحي' } },
      { id: 'D', text: { en: 'Tempered glass', ar: 'زجاج مقسّى' } }
    ],
    correctOptionId: 'D',
    timeLimit: 30,
    xpReward: 20
  },
  {
    id: 'science-330',
    subject: QuizSubject.SCIENCE,
    difficulty: DifficultyLevel.MEDIUM,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'A primary food source for baleen whales, krill are a variety of what?', ar: 'تُعدّ الكريل غذاءً رئيسياً لحيتان البالين، فهي نوع من ماذا؟' },
    options: [
      { id: 'A', text: { en: 'Jellyfish', ar: 'قنديل البحر' } },
      { id: 'B', text: { en: 'Seaweed', ar: 'الأعشاب البحرية' } },
      { id: 'C', text: { en: 'Squid', ar: 'الحبار' } },
      { id: 'D', text: { en: 'Crustacean', ar: 'القشريات' } }
    ],
    correctOptionId: 'D',
    timeLimit: 30,
    xpReward: 20
  },
  {
    id: 'science-331',
    subject: QuizSubject.SCIENCE,
    difficulty: DifficultyLevel.MEDIUM,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'Because of its shape, what plant used to soothe wounds in Thailand is known as the crocodile\'s tail?', ar: 'بسبب شكلها، ما النبتة المستخدمة لتسكين الجروح في تايلاند والتي تُعرف بذيل التمساح؟' },
    options: [
      { id: 'A', text: { en: 'Ginger', ar: 'الزنجبيل' } },
      { id: 'B', text: { en: 'Aloe vera', ar: 'الصبار (الألوة فيرا)' } },
      { id: 'C', text: { en: 'Eucalyptus', ar: 'الكينا' } },
      { id: 'D', text: { en: 'St. John\'s wort', ar: 'نبتة سانت جون' } }
    ],
    correctOptionId: 'B',
    timeLimit: 30,
    xpReward: 20
  },
  {
    id: 'general-332',
    subject: QuizSubject.GENERAL,
    difficulty: DifficultyLevel.MEDIUM,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'What Latin American city is home to a museum known to locals as El Museo del Canal?', ar: 'أي مدينة في أمريكا اللاتينية يقع فيها متحف يعرفه السكان المحليون باسم El Museo del Canal؟' },
    options: [
      { id: 'A', text: { en: 'Mexico City', ar: 'مكسيكو سيتي' } },
      { id: 'B', text: { en: 'Havana', ar: 'هافانا' } },
      { id: 'C', text: { en: 'Buenos Aires', ar: 'بوينس آيرس' } },
      { id: 'D', text: { en: 'Panama City', ar: 'بنما سيتي' } }
    ],
    correctOptionId: 'D',
    timeLimit: 30,
    xpReward: 20
  },
  {
    id: 'general-333',
    subject: QuizSubject.GENERAL,
    difficulty: DifficultyLevel.EASY,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'Claustrophobia is the fear of what?', ar: 'ما هو الخوف الذي يُعرف بـ"الكلوستروفوبيا"؟' },
    options: [
      { id: 'A', text: { en: 'Heights', ar: 'المرتفعات' } },
      { id: 'B', text: { en: 'Enclosed spaces', ar: 'الأماكن المغلقة' } },
      { id: 'C', text: { en: 'Strangers', ar: 'الغرباء' } },
      { id: 'D', text: { en: 'Dogs', ar: 'الكلاب' } }
    ],
    correctOptionId: 'B',
    timeLimit: 30,
    xpReward: 10
  },
  {
    id: 'science-334',
    subject: QuizSubject.SCIENCE,
    difficulty: DifficultyLevel.MEDIUM,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'Like other stars, the Sun generates energy by converting hydrogen fuel into what element?', ar: 'مثل النجوم الأخرى، تولّد الشمس الطاقة بتحويل وقود الهيدروجين إلى أيّ عنصر؟' },
    options: [
      { id: 'A', text: { en: 'Helium', ar: 'الهيليوم' } },
      { id: 'B', text: { en: 'Carbon', ar: 'الكربون' } },
      { id: 'C', text: { en: 'Oxygen', ar: 'الأكسجين' } },
      { id: 'D', text: { en: 'Nitrogen', ar: 'النيتروجين' } }
    ],
    correctOptionId: 'A',
    timeLimit: 30,
    xpReward: 20
  },
  {
    id: 'english-335',
    subject: QuizSubject.ENGLISH,
    difficulty: DifficultyLevel.EASY,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'Someone who has declared his candidacy for elected office is said to be "throwing his hat" where?', ar: 'Someone who has declared his candidacy for elected office is said to be "throwing his hat" where?' },
    options: [
      { id: 'A', text: { en: 'In the air', ar: 'In the air' } },
      { id: 'B', text: { en: 'Out the window', ar: 'Out the window' } },
      { id: 'C', text: { en: 'On the ground', ar: 'On the ground' } },
      { id: 'D', text: { en: 'Into the ring', ar: 'Into the ring' } }
    ],
    correctOptionId: 'D',
    timeLimit: 30,
    xpReward: 10
  },
  {
    id: 'general-336',
    subject: QuizSubject.GENERAL,
    difficulty: DifficultyLevel.MEDIUM,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'Which of the following all share their names with constellations?', ar: 'أيٌّ ممّا يلي تتطابق أسماؤه مع أسماء الأبراج النجمية؟' },
    options: [
      { id: 'A', text: { en: 'Days of the week', ar: 'أيام الأسبوع' } },
      { id: 'B', text: { en: 'Signs of the zodiac', ar: 'الأبراج الفلكية' } },
      { id: 'C', text: { en: 'Months in the calendar year', ar: 'أشهر السنة' } },
      { id: 'D', text: { en: 'Planets in the solar system', ar: 'كواكب المجموعة الشمسية' } }
    ],
    correctOptionId: 'B',
    timeLimit: 30,
    xpReward: 20
  },
  {
    id: 'general-337',
    subject: QuizSubject.GENERAL,
    difficulty: DifficultyLevel.EASY,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'In which of the following sporting events does the checkered flag proclaim the winner?', ar: 'في أيٍّ من هذه الفعاليات الرياضية يُعلن العلم المربعات عن الفائز؟' },
    options: [
      { id: 'A', text: { en: 'Auto race', ar: 'سباق السيارات' } },
      { id: 'B', text: { en: 'Soccer game', ar: 'مباراة كرة قدم' } },
      { id: 'C', text: { en: 'Hockey game', ar: 'مباراة هوكي' } },
      { id: 'D', text: { en: 'Gymnastics competition', ar: 'مسابقة جمباز' } }
    ],
    correctOptionId: 'A',
    timeLimit: 30,
    xpReward: 10
  },
  {
    id: 'science-338',
    subject: QuizSubject.SCIENCE,
    difficulty: DifficultyLevel.EASY,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'What kind of animal is a sidewinder?', ar: 'ما نوع الحيوان المعروف بالـ"سايدويندر"؟' },
    options: [
      { id: 'A', text: { en: 'Crab', ar: 'سرطان' } },
      { id: 'B', text: { en: 'Snake', ar: 'ثعبان' } },
      { id: 'C', text: { en: 'Jellyfish', ar: 'قنديل البحر' } },
      { id: 'D', text: { en: 'Spider', ar: 'عنكبوت' } }
    ],
    correctOptionId: 'B',
    timeLimit: 30,
    xpReward: 10
  },
  {
    id: 'general-339',
    subject: QuizSubject.GENERAL,
    difficulty: DifficultyLevel.MEDIUM,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'What is the thin, coarse mortar used to fill cavities in masonry or between tiles in tilework?', ar: 'ما هو الملاط الرقيق الخشن المستخدم لملء الفراغات في البناء أو بين البلاط؟' },
    options: [
      { id: 'A', text: { en: 'Spackle', ar: 'معجون التشقق' } },
      { id: 'B', text: { en: 'Epoxy', ar: 'الإيبوكسي' } },
      { id: 'C', text: { en: 'Grout', ar: 'الجاروت (ملاط البلاط)' } },
      { id: 'D', text: { en: 'Sludge', ar: 'الحمأة' } }
    ],
    correctOptionId: 'C',
    timeLimit: 30,
    xpReward: 20
  },
  {
    id: 'english-340',
    subject: QuizSubject.ENGLISH,
    difficulty: DifficultyLevel.MEDIUM,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'The words "congratulate" and "gratify" are derived from the Latin word "gratus," which is also the root word for "thank you" in what European language?', ar: 'The words "congratulate" and "gratify" are derived from the Latin word "gratus," which is also the root word for "thank you" in what European language?' },
    options: [
      { id: 'A', text: { en: 'Spanish', ar: 'Spanish' } },
      { id: 'B', text: { en: 'Mandarin', ar: 'Mandarin' } },
      { id: 'C', text: { en: 'Punjabi', ar: 'Punjabi' } },
      { id: 'D', text: { en: 'French', ar: 'French' } }
    ],
    correctOptionId: 'A',
    timeLimit: 30,
    xpReward: 20
  },
  {
    id: 'english-341',
    subject: QuizSubject.ENGLISH,
    difficulty: DifficultyLevel.EASY,
    gradeRange: { min: 5, max: 8 },
    text: { en: '"Finger-lickin\'" is an adjective that is often used to describe food that is what?', ar: '"Finger-lickin\'" is an adjective that is often used to describe food that is what?' },
    options: [
      { id: 'A', text: { en: 'Rotten', ar: 'Rotten' } },
      { id: 'B', text: { en: 'Delicious', ar: 'Delicious' } },
      { id: 'C', text: { en: 'Frozen', ar: 'Frozen' } },
      { id: 'D', text: { en: 'Barbecuelicious', ar: 'Barbecuelicious' } }
    ],
    correctOptionId: 'B',
    timeLimit: 30,
    xpReward: 10
  },
  {
    id: 'general-342',
    subject: QuizSubject.GENERAL,
    difficulty: DifficultyLevel.EASY,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'While underwater, a diver will cross his arms and rub his upper arms with his hands to signal what to his companions?', ar: 'تحت الماء، يضمّ الغواص ذراعيه ويفركهما بيديه ليُشير بأي رسالة لرفاقه؟' },
    options: [
      { id: 'A', text: { en: 'I\'m cold', ar: 'أشعر بالبرد' } },
      { id: 'B', text: { en: 'I\'m hungry', ar: 'أشعر بالجوع' } },
      { id: 'C', text: { en: 'I\'m sleepy', ar: 'أشعر بالنعاس' } },
      { id: 'D', text: { en: 'I can\'t breathe', ar: 'لا أستطيع التنفس' } }
    ],
    correctOptionId: 'A',
    timeLimit: 30,
    xpReward: 10
  },
  {
    id: 'science-343',
    subject: QuizSubject.SCIENCE,
    difficulty: DifficultyLevel.MEDIUM,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'Wildly outnumbering humans and boasting about 1 million species, an estimated 4 out of 5 of all living animals on earth are nematodes, a type of what?', ar: 'تفوق البشر بمراحل، ولها نحو مليون نوع، ويُقدّر أن ٤ من كل ٥ حيوانات على الأرض هي ديدان نيماتودا، وهي نوع من ماذا؟' },
    options: [
      { id: 'A', text: { en: 'Fish', ar: 'السمك' } },
      { id: 'B', text: { en: 'Mosquito', ar: 'البعوض' } },
      { id: 'C', text: { en: 'Worm', ar: 'الديدان' } },
      { id: 'D', text: { en: 'Ant', ar: 'النمل' } }
    ],
    correctOptionId: 'C',
    timeLimit: 30,
    xpReward: 20
  },
  {
    id: 'science-344',
    subject: QuizSubject.SCIENCE,
    difficulty: DifficultyLevel.MEDIUM,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'A "hidden talent" that the creatures only seem to demonstrate in high humidity, which of these are you most likely to see a cockroach do during a heat wave?', ar: '"موهبة خفية" لا تظهرها هذه المخلوقات إلا في الرطوبة العالية، ما الفعل الذي قد تراه يفعله الصرصور خلال موجة حر؟' },
    options: [
      { id: 'A', text: { en: 'Play water polo', ar: 'يلعب كرة الماء' } },
      { id: 'B', text: { en: 'Kayak', ar: 'يقود قارب الكاياك' } },
      { id: 'C', text: { en: 'Do cannonballs', ar: 'يقفز قفزة كرة المدفع' } },
      { id: 'D', text: { en: 'Fly', ar: 'يطير' } }
    ],
    correctOptionId: 'D',
    timeLimit: 30,
    xpReward: 20
  },
  {
    id: 'general-345',
    subject: QuizSubject.GENERAL,
    difficulty: DifficultyLevel.MEDIUM,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'Said to predict future success, what psychological experiment gives 4-year-olds a choice of getting one desirable item immediately or two 15 minutes later?', ar: 'يُقال إنها تتنبأ بالنجاح المستقبلي، ما اسم التجربة النفسية التي تخيّر الأطفال البالغين ٤ سنوات بين الحصول على غرض مرغوب الآن أو غرضين بعد ١٥ دقيقة؟' },
    options: [
      { id: 'A', text: { en: 'Marshmallow test', ar: 'اختبار المارشميلو' } },
      { id: 'B', text: { en: 'Broccoli test', ar: 'اختبار البروكلي' } },
      { id: 'C', text: { en: 'Rotten apple test', ar: 'اختبار التفاحة الفاسدة' } },
      { id: 'D', text: { en: 'Boiled cabbage test', ar: 'اختبار الملفوف المسلوق' } }
    ],
    correctOptionId: 'A',
    timeLimit: 30,
    xpReward: 20
  },
  {
    id: 'science-346',
    subject: QuizSubject.SCIENCE,
    difficulty: DifficultyLevel.EASY,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'When you open a yogurt, you might notice a pool of liquid floating on the top. What does it mostly consist of?', ar: 'عند فتح الزبادي، قد ترى بركة سائل تطفو في الأعلى، ممّ يتكوّن هذا السائل في معظمه؟' },
    options: [
      { id: 'A', text: { en: 'Pectin', ar: 'البكتين' } },
      { id: 'B', text: { en: 'Fat', ar: 'الدهون' } },
      { id: 'C', text: { en: 'Whey', ar: 'مصل اللبن' } },
      { id: 'D', text: { en: 'Corn syrup', ar: 'شراب الذرة' } }
    ],
    correctOptionId: 'C',
    timeLimit: 30,
    xpReward: 10
  },
  {
    id: 'english-347',
    subject: QuizSubject.ENGLISH,
    difficulty: DifficultyLevel.EASY,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'By definition, if you are shadowing someone, what are you doing?', ar: 'By definition, if you are shadowing someone, what are you doing?' },
    options: [
      { id: 'A', text: { en: 'Following him', ar: 'Following him' } },
      { id: 'B', text: { en: 'Interviewing him', ar: 'Interviewing him' } },
      { id: 'C', text: { en: 'Insulting him', ar: 'Insulting him' } },
      { id: 'D', text: { en: 'Running from him', ar: 'Running from him' } }
    ],
    correctOptionId: 'A',
    timeLimit: 30,
    xpReward: 10
  },
  {
    id: 'math-348',
    subject: QuizSubject.MATH,
    difficulty: DifficultyLevel.EASY,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'In geometry, which of these shapes is, by definition, not a parallelogram?', ar: 'في الهندسة، أيٌّ من هذه الأشكال لا يُعدّ متوازي أضلاع بالتعريف؟' },
    options: [
      { id: 'A', text: { en: 'Square', ar: 'مربع' } },
      { id: 'B', text: { en: 'Rhombus', ar: 'معيّن' } },
      { id: 'C', text: { en: 'Rectangle', ar: 'مستطيل' } },
      { id: 'D', text: { en: 'Trapezoid', ar: 'شبه منحرف' } }
    ],
    correctOptionId: 'D',
    timeLimit: 30,
    xpReward: 10
  },
  {
    id: 'general-349',
    subject: QuizSubject.GENERAL,
    difficulty: DifficultyLevel.MEDIUM,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'Built by order of the Roman emperor Hadrian, parts of Hadrian\'s Wall still stand in what country?', ar: 'بُني بأمر من الإمبراطور الروماني هادريان، ولا تزال بعض أجزاء جدار هادريان قائمة في أي بلد؟' },
    options: [
      { id: 'A', text: { en: 'England', ar: 'إنجلترا' } },
      { id: 'B', text: { en: 'France', ar: 'فرنسا' } },
      { id: 'C', text: { en: 'Turkey', ar: 'تركيا' } },
      { id: 'D', text: { en: 'Spain', ar: 'إسبانيا' } }
    ],
    correctOptionId: 'A',
    timeLimit: 30,
    xpReward: 20
  },
  {
    id: 'general-350',
    subject: QuizSubject.GENERAL,
    difficulty: DifficultyLevel.EASY,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'On the Internet, a Web site that no longer exists will often prompt the phrase "Not Found" and what code number?', ar: 'على الإنترنت، يظهر عند الموقع الذي لم يعد موجوداً عبارة "غير موجود" مع أي رقم رمز؟' },
    options: [
      { id: 'A', text: { en: '363', ar: '٣٦٣' } },
      { id: 'B', text: { en: '404', ar: '٤٠٤' } },
      { id: 'C', text: { en: '525', ar: '٥٢٥' } },
      { id: 'D', text: { en: '616', ar: '٦١٦' } }
    ],
    correctOptionId: 'B',
    timeLimit: 30,
    xpReward: 10
  },
  {
    id: 'science-351',
    subject: QuizSubject.SCIENCE,
    difficulty: DifficultyLevel.MEDIUM,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'While hot lava is one obvious danger of an active volcano, eruptions can also cause all but which of these catastrophes?', ar: 'مع أن الحمم الساخنة خطر واضح للبركان النشط، تستطيع الانفجارات أن تسبب جميع الكوارث التالية باستثناء أي واحدة؟' },
    options: [
      { id: 'A', text: { en: 'Tsunamis', ar: 'تسونامي' } },
      { id: 'B', text: { en: 'Mudflows', ar: 'تدفقات الطين' } },
      { id: 'C', text: { en: 'Earthquakes', ar: 'الزلازل' } },
      { id: 'D', text: { en: 'Hurricanes', ar: 'الأعاصير المدارية' } }
    ],
    correctOptionId: 'D',
    timeLimit: 30,
    xpReward: 20
  },
  {
    id: 'science-352',
    subject: QuizSubject.SCIENCE,
    difficulty: DifficultyLevel.EASY,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'Which of these marine animals is classified as a crustacean?', ar: 'أيٌّ من هذه الحيوانات البحرية يُصنف من القشريات؟' },
    options: [
      { id: 'A', text: { en: 'Oyster', ar: 'محار' } },
      { id: 'B', text: { en: 'Clam', ar: 'بطلينوس' } },
      { id: 'C', text: { en: 'Lobster', ar: 'الكركند' } },
      { id: 'D', text: { en: 'Sea horse', ar: 'حصان البحر' } }
    ],
    correctOptionId: 'C',
    timeLimit: 30,
    xpReward: 10
  },
  {
    id: 'math-353',
    subject: QuizSubject.MATH,
    difficulty: DifficultyLevel.EASY,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'A standard sheet of typing paper is what shape?', ar: 'ما شكل ورقة الطباعة القياسية؟' },
    options: [
      { id: 'A', text: { en: 'Square', ar: 'مربع' } },
      { id: 'B', text: { en: 'Rectangle', ar: 'مستطيل' } },
      { id: 'C', text: { en: 'Triangle', ar: 'مثلث' } },
      { id: 'D', text: { en: 'Airplane', ar: 'طائرة' } }
    ],
    correctOptionId: 'B',
    timeLimit: 30,
    xpReward: 10
  },
  {
    id: 'general-354',
    subject: QuizSubject.GENERAL,
    difficulty: DifficultyLevel.EASY,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'Which of the following would a person most likely do on a treadmill?', ar: 'أيٌّ ممّا يلي قد يفعله الشخص على جهاز الجري؟' },
    options: [
      { id: 'A', text: { en: 'Jog', ar: 'يهرول' } },
      { id: 'B', text: { en: 'Row', ar: 'يجدّف' } },
      { id: 'C', text: { en: 'Jump rope', ar: 'يقفز بالحبل' } },
      { id: 'D', text: { en: 'Interpretive dance', ar: 'يرقص رقصاً تعبيرياً' } }
    ],
    correctOptionId: 'A',
    timeLimit: 30,
    xpReward: 10
  },
  {
    id: 'science-355',
    subject: QuizSubject.SCIENCE,
    difficulty: DifficultyLevel.EASY,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'From what direction does the sun appear to rise?', ar: 'من أي اتجاه تبدو الشمس وكأنها تشرق؟' },
    options: [
      { id: 'A', text: { en: 'North', ar: 'الشمال' } },
      { id: 'B', text: { en: 'West', ar: 'الغرب' } },
      { id: 'C', text: { en: 'East', ar: 'الشرق' } },
      { id: 'D', text: { en: 'South', ar: 'الجنوب' } }
    ],
    correctOptionId: 'C',
    timeLimit: 30,
    xpReward: 10
  },
  {
    id: 'general-356',
    subject: QuizSubject.GENERAL,
    difficulty: DifficultyLevel.EASY,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'Most of Siberia lies in what country?', ar: 'تقع معظم سيبيريا في أي بلد؟' },
    options: [
      { id: 'A', text: { en: 'China', ar: 'الصين' } },
      { id: 'B', text: { en: 'Iceland', ar: 'أيسلندا' } },
      { id: 'C', text: { en: 'Norway', ar: 'النرويج' } },
      { id: 'D', text: { en: 'Russia', ar: 'روسيا' } }
    ],
    correctOptionId: 'D',
    timeLimit: 30,
    xpReward: 10
  },
  {
    id: 'science-357',
    subject: QuizSubject.SCIENCE,
    difficulty: DifficultyLevel.MEDIUM,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'What element is added to steel to make it "stainless"?', ar: 'ما العنصر الذي يُضاف إلى الفولاذ ليجعله "غير قابل للصدأ"؟' },
    options: [
      { id: 'A', text: { en: 'Iron', ar: 'الحديد' } },
      { id: 'B', text: { en: 'Chromium', ar: 'الكروم' } },
      { id: 'C', text: { en: 'Magnesium', ar: 'المغنيسيوم' } },
      { id: 'D', text: { en: 'Zinc', ar: 'الزنك' } }
    ],
    correctOptionId: 'B',
    timeLimit: 30,
    xpReward: 20
  },
  {
    id: 'general-358',
    subject: QuizSubject.GENERAL,
    difficulty: DifficultyLevel.EASY,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'In a refrigerator, the crisper is a compartment for storing which of these food items?', ar: 'في الثلاجة، درج الخضار "كريسبر" مخصّص لتخزين أيٍّ من الأطعمة التالية؟' },
    options: [
      { id: 'A', text: { en: 'Gallon of milk', ar: 'علبة حليب' } },
      { id: 'B', text: { en: 'Head of lettuce', ar: 'رأس خس' } },
      { id: 'C', text: { en: 'Loaf of bread', ar: 'رغيف خبز' } },
      { id: 'D', text: { en: 'Cut of meat', ar: 'قطعة لحم' } }
    ],
    correctOptionId: 'B',
    timeLimit: 30,
    xpReward: 10
  },
  {
    id: 'general-359',
    subject: QuizSubject.GENERAL,
    difficulty: DifficultyLevel.EASY,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'Which of these medical professionals would you see to take care of your bridgework?', ar: 'أيٌّ من المختصين الطبيين تراجعه للعناية بـ"الجسر السني" (طقم الأسنان)؟' },
    options: [
      { id: 'A', text: { en: 'Podiatrist', ar: 'طبيب الأقدام' } },
      { id: 'B', text: { en: 'Dermatologist', ar: 'طبيب جلدية' } },
      { id: 'C', text: { en: 'Ophthalmologist', ar: 'طبيب عيون' } },
      { id: 'D', text: { en: 'Dentist', ar: 'طبيب أسنان' } }
    ],
    correctOptionId: 'D',
    timeLimit: 30,
    xpReward: 10
  },
  {
    id: 'general-360',
    subject: QuizSubject.GENERAL,
    difficulty: DifficultyLevel.EASY,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'Which of these cooking utensils is commonly used to drain spaghetti?', ar: 'أيٌّ من أدوات الطبخ تُستخدم عادةً لتصفية السباغيتي؟' },
    options: [
      { id: 'A', text: { en: 'Grater', ar: 'مبشرة' } },
      { id: 'B', text: { en: 'Spatula', ar: 'ملعقة مسطحة' } },
      { id: 'C', text: { en: 'Colander', ar: 'مصفاة' } },
      { id: 'D', text: { en: 'Ladle', ar: 'مغرفة' } }
    ],
    correctOptionId: 'C',
    timeLimit: 30,
    xpReward: 10
  },
  {
    id: 'general-361',
    subject: QuizSubject.GENERAL,
    difficulty: DifficultyLevel.EASY,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'Which of the following body parts do you need to give someone a "high-five"?', ar: 'أيٌّ من أجزاء الجسم تحتاج إليه لتعطي شخصاً تحية الـ"هاي فايف"؟' },
    options: [
      { id: 'A', text: { en: 'Hand', ar: 'اليد' } },
      { id: 'B', text: { en: 'Knee', ar: 'الركبة' } },
      { id: 'C', text: { en: 'Nose', ar: 'الأنف' } },
      { id: 'D', text: { en: 'Elbows', ar: 'المرفقان' } }
    ],
    correctOptionId: 'A',
    timeLimit: 30,
    xpReward: 10
  },
  {
    id: 'english-362',
    subject: QuizSubject.ENGLISH,
    difficulty: DifficultyLevel.EASY,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'Which of the following refers to a painting done on the surface of a wall?', ar: 'Which of the following refers to a painting done on the surface of a wall?' },
    options: [
      { id: 'A', text: { en: 'Batik', ar: 'Batik' } },
      { id: 'B', text: { en: 'Mobile', ar: 'Mobile' } },
      { id: 'C', text: { en: 'Silkscreen', ar: 'Silkscreen' } },
      { id: 'D', text: { en: 'Mural', ar: 'Mural' } }
    ],
    correctOptionId: 'D',
    timeLimit: 30,
    xpReward: 10
  },
  {
    id: 'general-363',
    subject: QuizSubject.GENERAL,
    difficulty: DifficultyLevel.EASY,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'Which of the following is not a variety of lettuce?', ar: 'أيٌّ ممّا يلي ليس نوعاً من الخس؟' },
    options: [
      { id: 'A', text: { en: 'Romaine', ar: 'رومين' } },
      { id: 'B', text: { en: 'Iceberg', ar: 'آيسبرغ' } },
      { id: 'C', text: { en: 'Bibb', ar: 'بيب' } },
      { id: 'D', text: { en: 'Celtic', ar: 'سلتيك' } }
    ],
    correctOptionId: 'D',
    timeLimit: 30,
    xpReward: 10
  },
  {
    id: 'science-364',
    subject: QuizSubject.SCIENCE,
    difficulty: DifficultyLevel.MEDIUM,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'Which of the following elements did Marie Curie and her husband Pierre discover?', ar: 'أي العناصر التالية اكتشفته ماري كوري وزوجها بيير؟' },
    options: [
      { id: 'A', text: { en: 'Uranium', ar: 'اليورانيوم' } },
      { id: 'B', text: { en: 'Radium', ar: 'الراديوم' } },
      { id: 'C', text: { en: 'Curium', ar: 'الكوريوم' } },
      { id: 'D', text: { en: 'Mercury', ar: 'الزئبق' } }
    ],
    correctOptionId: 'B',
    timeLimit: 30,
    xpReward: 20
  },
  {
    id: 'general-365',
    subject: QuizSubject.GENERAL,
    difficulty: DifficultyLevel.MEDIUM,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'Which of the following countries does not border Russia?', ar: 'أيٌّ من البلدان التالية لا تشترك في حدود مع روسيا؟' },
    options: [
      { id: 'A', text: { en: 'China', ar: 'الصين' } },
      { id: 'B', text: { en: 'Finland', ar: 'فنلندا' } },
      { id: 'C', text: { en: 'Sweden', ar: 'السويد' } },
      { id: 'D', text: { en: 'Mongolia', ar: 'منغوليا' } }
    ],
    correctOptionId: 'C',
    timeLimit: 30,
    xpReward: 20
  },
  {
    id: 'english-366',
    subject: QuizSubject.ENGLISH,
    difficulty: DifficultyLevel.EASY,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'Which of these jackets is designed to restrict a person\'s arm movements?', ar: 'Which of these jackets is designed to restrict a person\'s arm movements?' },
    options: [
      { id: 'A', text: { en: 'Book jacket', ar: 'Book jacket' } },
      { id: 'B', text: { en: 'Life jacket', ar: 'Life jacket' } },
      { id: 'C', text: { en: 'Strait jacket', ar: 'Strait jacket' } },
      { id: 'D', text: { en: 'Bomber jacket', ar: 'Bomber jacket' } }
    ],
    correctOptionId: 'C',
    timeLimit: 30,
    xpReward: 10
  },
  {
    id: 'general-367',
    subject: QuizSubject.GENERAL,
    difficulty: DifficultyLevel.MEDIUM,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'In terms of square mileage, which of these Middle Eastern countries is the largest?', ar: 'من حيث المساحة بالأميال المربعة، أيٌّ من دول الشرق الأوسط هي الأكبر؟' },
    options: [
      { id: 'A', text: { en: 'Iran', ar: 'إيران' } },
      { id: 'B', text: { en: 'Saudi Arabia', ar: 'المملكة العربية السعودية' } },
      { id: 'C', text: { en: 'Turkey', ar: 'تركيا' } },
      { id: 'D', text: { en: 'Afghanistan', ar: 'أفغانستان' } }
    ],
    correctOptionId: 'B',
    timeLimit: 30,
    xpReward: 20
  },
  {
    id: 'science-368',
    subject: QuizSubject.SCIENCE,
    difficulty: DifficultyLevel.MEDIUM,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'In his famous experiment, scientist Ivan Pavlov conditioned dogs to do what at the sound of a bell?', ar: 'في تجربته الشهيرة، شرَط العالم إيفان بافلوف الكلاب لتفعل ماذا عند سماع الجرس؟' },
    options: [
      { id: 'A', text: { en: 'Salivate', ar: 'يسيل لعابها' } },
      { id: 'B', text: { en: 'Bark', ar: 'تنبح' } },
      { id: 'C', text: { en: 'Roll over', ar: 'تتقلب' } },
      { id: 'D', text: { en: 'Fall asleep', ar: 'تنام' } }
    ],
    correctOptionId: 'A',
    timeLimit: 30,
    xpReward: 20
  },
  {
    id: 'general-369',
    subject: QuizSubject.GENERAL,
    difficulty: DifficultyLevel.EASY,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'Macaroon cookies are traditionally made with which of the following ingredients?', ar: 'تُصنع بسكويت الماكارون تقليدياً من أيٍّ من المكونات التالية؟' },
    options: [
      { id: 'A', text: { en: 'Coconut', ar: 'جوز الهند' } },
      { id: 'B', text: { en: 'Walnut', ar: 'الجوز' } },
      { id: 'C', text: { en: 'Pistachio', ar: 'الفستق' } },
      { id: 'D', text: { en: 'Peanut', ar: 'الفول السوداني' } }
    ],
    correctOptionId: 'A',
    timeLimit: 30,
    xpReward: 10
  },
  {
    id: 'science-370',
    subject: QuizSubject.SCIENCE,
    difficulty: DifficultyLevel.MEDIUM,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'A technique used to help a group locate food, the waggle dance is employed by which of these creatures?', ar: 'تقنية تُستخدم لمساعدة المجموعة على إيجاد الطعام، ما المخلوقات التي تستخدم رقصة الـ"واغل"؟' },
    options: [
      { id: 'A', text: { en: 'Otters', ar: 'القضاعات' } },
      { id: 'B', text: { en: 'Sparrows', ar: 'العصافير' } },
      { id: 'C', text: { en: 'Horseshoe crabs', ar: 'سرطانات حدوة الحصان' } },
      { id: 'D', text: { en: 'Honeybees', ar: 'نحل العسل' } }
    ],
    correctOptionId: 'D',
    timeLimit: 30,
    xpReward: 20
  },
  {
    id: 'english-371',
    subject: QuizSubject.ENGLISH,
    difficulty: DifficultyLevel.EASY,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'Someone who is said to be getting some "shut-eye" is doing what?', ar: 'Someone who is said to be getting some "shut-eye" is doing what?' },
    options: [
      { id: 'A', text: { en: 'Sleeping', ar: 'Sleeping' } },
      { id: 'B', text: { en: 'Crying', ar: 'Crying' } },
      { id: 'C', text: { en: 'Praying', ar: 'Praying' } },
      { id: 'D', text: { en: 'Watching pro golf', ar: 'Watching pro golf' } }
    ],
    correctOptionId: 'A',
    timeLimit: 30,
    xpReward: 10
  },
  {
    id: 'science-372',
    subject: QuizSubject.SCIENCE,
    difficulty: DifficultyLevel.EASY,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'As suggested by their name, snowball plants are prized for their round clusters of flowers with what color petals?', ar: 'كما يوحي اسمها، تُقدَّر نباتات كرة الثلج بسبب عناقيدها المستديرة من الأزهار بأي لون من البتلات؟' },
    options: [
      { id: 'A', text: { en: 'Blue', ar: 'أزرق' } },
      { id: 'B', text: { en: 'Red', ar: 'أحمر' } },
      { id: 'C', text: { en: 'White', ar: 'أبيض' } },
      { id: 'D', text: { en: 'Orange', ar: 'برتقالي' } }
    ],
    correctOptionId: 'C',
    timeLimit: 30,
    xpReward: 10
  },
  {
    id: 'general-373',
    subject: QuizSubject.GENERAL,
    difficulty: DifficultyLevel.MEDIUM,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'Which of these sports usually has separate divisions for left-handed and right-handed people?', ar: 'أيٌّ من هذه الرياضات تعتمد عادةً تقسيمات منفصلة لليُمنى ولليُسرى؟' },
    options: [
      { id: 'A', text: { en: 'Kickboxing', ar: 'الكيك بوكسينغ' } },
      { id: 'B', text: { en: 'Gymnastics', ar: 'الجمباز' } },
      { id: 'C', text: { en: 'Archery', ar: 'الرماية بالقوس' } },
      { id: 'D', text: { en: 'Arm wrestling', ar: 'مصارعة الذراعين' } }
    ],
    correctOptionId: 'D',
    timeLimit: 30,
    xpReward: 20
  },
  {
    id: 'general-374',
    subject: QuizSubject.GENERAL,
    difficulty: DifficultyLevel.EASY,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'What continent\'s sub-Saharan region is home to the majority of its countries?', ar: 'قارة منطقتها الواقعة جنوب الصحراء الكبرى تضم غالبية بلدانها، فما هي؟' },
    options: [
      { id: 'A', text: { en: 'Europe', ar: 'أوروبا' } },
      { id: 'B', text: { en: 'Asia', ar: 'آسيا' } },
      { id: 'C', text: { en: 'Africa', ar: 'أفريقيا' } },
      { id: 'D', text: { en: 'South America', ar: 'أمريكا الجنوبية' } }
    ],
    correctOptionId: 'C',
    timeLimit: 30,
    xpReward: 10
  },
  {
    id: 'science-375',
    subject: QuizSubject.SCIENCE,
    difficulty: DifficultyLevel.MEDIUM,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'What type of protein, used to provide structure to connective tissue, is the most abundant protein in the human body?', ar: 'ما نوع البروتين المستخدم لإعطاء البنية للأنسجة الضامة، وهو أكثر بروتين وفرة في الجسم البشري؟' },
    options: [
      { id: 'A', text: { en: 'Hemoglobin', ar: 'الهيموغلوبين' } },
      { id: 'B', text: { en: 'Keratin', ar: 'الكيراتين' } },
      { id: 'C', text: { en: 'Insulin', ar: 'الإنسولين' } },
      { id: 'D', text: { en: 'Collagen', ar: 'الكولاجين' } }
    ],
    correctOptionId: 'D',
    timeLimit: 30,
    xpReward: 20
  },
  {
    id: 'general-376',
    subject: QuizSubject.GENERAL,
    difficulty: DifficultyLevel.EASY,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'Which of the following divides a regulation tennis court in half?', ar: 'أيٌّ ممّا يلي يقسم ملعب التنس النظامي إلى نصفين؟' },
    options: [
      { id: 'A', text: { en: 'Hedge', ar: 'سياج نباتي' } },
      { id: 'B', text: { en: 'Net', ar: 'الشبكة' } },
      { id: 'C', text: { en: 'Moat', ar: 'خندق' } },
      { id: 'D', text: { en: 'Bad sportsmanship', ar: 'روح رياضية سيئة' } }
    ],
    correctOptionId: 'B',
    timeLimit: 30,
    xpReward: 10
  },
  {
    id: 'general-377',
    subject: QuizSubject.GENERAL,
    difficulty: DifficultyLevel.EASY,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'In which of these kitchen appliances would you warm up leftover food?', ar: 'في أيٍّ من أجهزة المطبخ ستسخّن بقايا الطعام؟' },
    options: [
      { id: 'A', text: { en: 'Refrigerator', ar: 'الثلاجة' } },
      { id: 'B', text: { en: 'Microwave oven', ar: 'فرن الميكروويف' } },
      { id: 'C', text: { en: 'Garbage disposal', ar: 'طاحونة النفايات' } },
      { id: 'D', text: { en: 'Blender', ar: 'الخلاط' } }
    ],
    correctOptionId: 'B',
    timeLimit: 30,
    xpReward: 10
  },
  {
    id: 'science-378',
    subject: QuizSubject.SCIENCE,
    difficulty: DifficultyLevel.EASY,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'Which of the following animals is considered an amphibian?', ar: 'أيٌّ من الحيوانات التالية يُعدّ من البرمائيات؟' },
    options: [
      { id: 'A', text: { en: 'Frog', ar: 'الضفدع' } },
      { id: 'B', text: { en: 'Iguana', ar: 'الإغوانا' } },
      { id: 'C', text: { en: 'Turtle', ar: 'السلحفاة' } },
      { id: 'D', text: { en: 'Crawfish', ar: 'جراد البحر' } }
    ],
    correctOptionId: 'A',
    timeLimit: 30,
    xpReward: 10
  },
  {
    id: 'general-379',
    subject: QuizSubject.GENERAL,
    difficulty: DifficultyLevel.MEDIUM,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'Italian dishes served "al pomodoro" are made with what kind of sauce?', ar: 'الأطباق الإيطالية المقدمة بـ"البومودورو" تُصنع بأي نوع من الصلصة؟' },
    options: [
      { id: 'A', text: { en: 'Mushroom', ar: 'الفطر' } },
      { id: 'B', text: { en: 'Tomato', ar: 'الطماطم' } },
      { id: 'C', text: { en: 'Clam', ar: 'المحار' } },
      { id: 'D', text: { en: 'Meat', ar: 'اللحم' } }
    ],
    correctOptionId: 'B',
    timeLimit: 30,
    xpReward: 20
  },
  {
    id: 'general-380',
    subject: QuizSubject.GENERAL,
    difficulty: DifficultyLevel.MEDIUM,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'Which of these games features the categories "Action," "Object," and "Person/Place/Animal"?', ar: 'أيٌّ من هذه الألعاب يتضمّن الفئات "حركة" و"جسم" و"شخص/مكان/حيوان"؟' },
    options: [
      { id: 'A', text: { en: 'Taboo', ar: 'تابو' } },
      { id: 'B', text: { en: 'Pictionary', ar: 'بكتيوناري' } },
      { id: 'C', text: { en: 'Trivial Pursuit', ar: 'تريفيال بيرسوت' } },
      { id: 'D', text: { en: 'Scruples', ar: 'سكروبلز' } }
    ],
    correctOptionId: 'B',
    timeLimit: 30,
    xpReward: 20
  },
  {
    id: 'english-381',
    subject: QuizSubject.ENGLISH,
    difficulty: DifficultyLevel.MEDIUM,
    gradeRange: { min: 5, max: 8 },
    text: { en: '"The night Max wore his wolf suit and made mischief..." is the opening to what classic children\'s book?', ar: '"The night Max wore his wolf suit and made mischief..." is the opening to what classic children\'s book?' },
    options: [
      { id: 'A', text: { en: 'Where the Wild Things Are', ar: 'Where the Wild Things Are' } },
      { id: 'B', text: { en: 'Jumanji', ar: 'Jumanji' } },
      { id: 'C', text: { en: 'The Polar Express', ar: 'The Polar Express' } },
      { id: 'D', text: { en: 'The Giving Tree', ar: 'The Giving Tree' } }
    ],
    correctOptionId: 'A',
    timeLimit: 30,
    xpReward: 20
  },
  {
    id: 'general-382',
    subject: QuizSubject.GENERAL,
    difficulty: DifficultyLevel.MEDIUM,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'What is the only capital city in Central America that borders an ocean?', ar: 'ما العاصمة الوحيدة في أمريكا الوسطى التي تقع على ساحل محيط؟' },
    options: [
      { id: 'A', text: { en: 'Managua, Nicaragua', ar: 'ماناغوا - نيكاراغوا' } },
      { id: 'B', text: { en: 'Belmopan, Belize', ar: 'بلموبان - بليز' } },
      { id: 'C', text: { en: 'Panama City, Panama', ar: 'مدينة بنما - بنما' } },
      { id: 'D', text: { en: 'San Jose, Costa Rica', ar: 'سان خوسيه - كوستاريكا' } }
    ],
    correctOptionId: 'C',
    timeLimit: 30,
    xpReward: 20
  },
  {
    id: 'general-383',
    subject: QuizSubject.GENERAL,
    difficulty: DifficultyLevel.EASY,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'What method of cooking eggs usually involves first beating the eggs?', ar: 'ما طريقة طهي البيض التي تتطلب عادةً خفقه أولاً؟' },
    options: [
      { id: 'A', text: { en: 'Frying', ar: 'القلي' } },
      { id: 'B', text: { en: 'Hard-boiling', ar: 'السلق الكامل' } },
      { id: 'C', text: { en: 'Poaching', ar: 'السلق بدون قشر' } },
      { id: 'D', text: { en: 'Scrambling', ar: 'الخفق (بيض مخفوق)' } }
    ],
    correctOptionId: 'D',
    timeLimit: 30,
    xpReward: 10
  },
  {
    id: 'english-384',
    subject: QuizSubject.ENGLISH,
    difficulty: DifficultyLevel.EASY,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'What is the second letter of the Greek alphabet?', ar: 'What is the second letter of the Greek alphabet?' },
    options: [
      { id: 'A', text: { en: 'Beta', ar: 'Beta' } },
      { id: 'B', text: { en: 'Gamma', ar: 'Gamma' } },
      { id: 'C', text: { en: 'Delta', ar: 'Delta' } },
      { id: 'D', text: { en: 'Phi', ar: 'Phi' } }
    ],
    correctOptionId: 'A',
    timeLimit: 30,
    xpReward: 10
  },
  {
    id: 'general-385',
    subject: QuizSubject.GENERAL,
    difficulty: DifficultyLevel.EASY,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'What piece of medical equipment closely resembles a Popsicle stick?', ar: 'ما قطعة المعدات الطبية التي تشبه عصا المصاصة المثلجة كثيراً؟' },
    options: [
      { id: 'A', text: { en: 'Tongue depressor', ar: 'خافض اللسان' } },
      { id: 'B', text: { en: 'Stethoscope', ar: 'السماعة الطبية' } },
      { id: 'C', text: { en: 'Stretcher', ar: 'نقالة المرضى' } },
      { id: 'D', text: { en: 'Artificial heart', ar: 'القلب الصناعي' } }
    ],
    correctOptionId: 'A',
    timeLimit: 30,
    xpReward: 10
  },
  {
    id: 'general-386',
    subject: QuizSubject.GENERAL,
    difficulty: DifficultyLevel.EASY,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'On a farm, horses are usually kept where?', ar: 'في المزرعة، أين تُحفظ الخيول عادةً؟' },
    options: [
      { id: 'A', text: { en: 'Silo', ar: 'صومعة' } },
      { id: 'B', text: { en: 'Stable', ar: 'إسطبل' } },
      { id: 'C', text: { en: 'Sty', ar: 'حظيرة الخنازير' } },
      { id: 'D', text: { en: 'High-rise condo', ar: 'شقة برج عالية' } }
    ],
    correctOptionId: 'B',
    timeLimit: 30,
    xpReward: 10
  },
  {
    id: 'science-387',
    subject: QuizSubject.SCIENCE,
    difficulty: DifficultyLevel.EASY,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'What can chameleons change?', ar: 'ما الذي تستطيع الحرابي تغييره؟' },
    options: [
      { id: 'A', text: { en: 'Hairstyle', ar: 'تسريحة الشعر' } },
      { id: 'B', text: { en: 'Color', ar: 'اللون' } },
      { id: 'C', text: { en: 'Gloves', ar: 'القفازات' } },
      { id: 'D', text: { en: 'Country', ar: 'الدولة' } }
    ],
    correctOptionId: 'B',
    timeLimit: 30,
    xpReward: 10
  },
  {
    id: 'general-388',
    subject: QuizSubject.GENERAL,
    difficulty: DifficultyLevel.MEDIUM,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'What is the Italian dish polenta?', ar: 'ما هو الطبق الإيطالي البولينتا؟' },
    options: [
      { id: 'A', text: { en: 'Oats', ar: 'الشوفان' } },
      { id: 'B', text: { en: 'Wheatgrass', ar: 'أعشاب القمح' } },
      { id: 'C', text: { en: 'Rice', ar: 'الأرز' } },
      { id: 'D', text: { en: 'Cornmeal', ar: 'دقيق الذرة' } }
    ],
    correctOptionId: 'D',
    timeLimit: 30,
    xpReward: 20
  },
  {
    id: 'general-389',
    subject: QuizSubject.GENERAL,
    difficulty: DifficultyLevel.EASY,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'Which of the following is most likely to be a baby\'s first word?', ar: 'أيٌّ ممّا يلي يُرجَّح أن يكون أول كلمة للرضيع؟' },
    options: [
      { id: 'A', text: { en: 'Anesthesiologist', ar: 'طبيب التخدير' } },
      { id: 'B', text: { en: 'Disproportionality', ar: 'عدم التناسب' } },
      { id: 'C', text: { en: 'Dada', ar: 'بابا/دادا' } },
      { id: 'D', text: { en: 'Antidisestablishmentarianism', ar: 'معاداة إلغاء الكنيسة' } }
    ],
    correctOptionId: 'C',
    timeLimit: 30,
    xpReward: 10
  },
  {
    id: 'general-390',
    subject: QuizSubject.GENERAL,
    difficulty: DifficultyLevel.EASY,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'Tiny plastic submarines and aircraft carriers are among the pieces included with what classic board game?', ar: 'تُعدّ الغواصات وحاملات الطائرات البلاستيكية الصغيرة من قطع أي من ألعاب الطاولة الكلاسيكية؟' },
    options: [
      { id: 'A', text: { en: 'Clue', ar: 'كلو' } },
      { id: 'B', text: { en: 'Battleship', ar: 'باتلشيب (السفن الحربية)' } },
      { id: 'C', text: { en: 'Chutes and Ladders', ar: 'السلالم والأفاعي' } },
      { id: 'D', text: { en: 'Sorry!', ar: 'سوري!' } }
    ],
    correctOptionId: 'B',
    timeLimit: 30,
    xpReward: 10
  },
  {
    id: 'general-391',
    subject: QuizSubject.GENERAL,
    difficulty: DifficultyLevel.MEDIUM,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'A play on Sputnik, "muttnik" was the nickname of a famous dog who was sent where?', ar: 'تورية على اسم سبوتنك، "موتنك" هو لقب كلب مشهور أُرسل إلى أين؟' },
    options: [
      { id: 'A', text: { en: 'Antarctica', ar: 'القطب الجنوبي' } },
      { id: 'B', text: { en: 'To the bottom of the ocean', ar: 'قاع المحيط' } },
      { id: 'C', text: { en: 'Into space', ar: 'الفضاء' } },
      { id: 'D', text: { en: 'To the top of Mount Everest', ar: 'قمة إيفرست' } }
    ],
    correctOptionId: 'C',
    timeLimit: 30,
    xpReward: 20
  },
  {
    id: 'general-392',
    subject: QuizSubject.GENERAL,
    difficulty: DifficultyLevel.HARD,
    gradeRange: { min: 6, max: 8 },
    text: { en: 'On a map of Europe, there is one country that begins with, and another one that ends with, which of these 3-letter words?', ar: 'على خريطة أوروبا، ثمّة بلد يبدأ وآخر ينتهي بأيٍّ من هذه الكلمات الثلاثية الأحرف؟' },
    options: [
      { id: 'A', text: { en: 'Nor', ar: 'Nor' } },
      { id: 'B', text: { en: 'Den', ar: 'Den' } },
      { id: 'C', text: { en: 'Fin', ar: 'Fin' } },
      { id: 'D', text: { en: 'Ice', ar: 'Ice' } }
    ],
    correctOptionId: 'B',
    timeLimit: 30,
    xpReward: 35
  },
  {
    id: 'general-393',
    subject: QuizSubject.GENERAL,
    difficulty: DifficultyLevel.MEDIUM,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'In tennis, which of these apt nicknames refers to a set ending in a score of 6-0?', ar: 'في التنس، أيٌّ من هذه الألقاب يصف شوطاً ينتهي بنتيجة ٦-٠؟' },
    options: [
      { id: 'A', text: { en: 'French fry', ar: 'بطاطا فرنسية' } },
      { id: 'B', text: { en: 'Waffle', ar: 'وافل' } },
      { id: 'C', text: { en: 'Eggplant', ar: 'باذنجان' } },
      { id: 'D', text: { en: 'Bagel', ar: 'البيغل' } }
    ],
    correctOptionId: 'D',
    timeLimit: 30,
    xpReward: 20
  },
  {
    id: 'english-394',
    subject: QuizSubject.ENGLISH,
    difficulty: DifficultyLevel.EASY,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'Which of these common phrases is another way of saying "hurry up"?', ar: 'Which of these common phrases is another way of saying "hurry up"?' },
    options: [
      { id: 'A', text: { en: 'Have a heart', ar: 'Have a heart' } },
      { id: 'B', text: { en: 'Shake a leg', ar: 'Shake a leg' } },
      { id: 'C', text: { en: 'Bite your tongue', ar: 'Bite your tongue' } },
      { id: 'D', text: { en: 'Look out for that cheetah!', ar: 'Look out for that cheetah!' } }
    ],
    correctOptionId: 'B',
    timeLimit: 30,
    xpReward: 10
  },
  {
    id: 'english-395',
    subject: QuizSubject.ENGLISH,
    difficulty: DifficultyLevel.EASY,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'Which of these everyday abbreviations includes a letter that stands for a day of the week?', ar: 'Which of these everyday abbreviations includes a letter that stands for a day of the week?' },
    options: [
      { id: 'A', text: { en: 'FYI', ar: 'FYI' } },
      { id: 'B', text: { en: 'ASAP', ar: 'ASAP' } },
      { id: 'C', text: { en: 'TGIF', ar: 'TGIF' } },
      { id: 'D', text: { en: 'IOU', ar: 'IOU' } }
    ],
    correctOptionId: 'C',
    timeLimit: 30,
    xpReward: 10
  },
  {
    id: 'science-396',
    subject: QuizSubject.SCIENCE,
    difficulty: DifficultyLevel.EASY,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'Meteorologists commonly use the word "muggy" to describe which of these weather conditions?', ar: 'يستخدم خبراء الأرصاد كلمة "muggy" لوصف أيٍّ من حالات الطقس التالية؟' },
    options: [
      { id: 'A', text: { en: 'Scattered clouds', ar: 'غيوم متفرقة' } },
      { id: 'B', text: { en: 'High humidity', ar: 'رطوبة عالية' } },
      { id: 'C', text: { en: 'Light winds', ar: 'رياح خفيفة' } },
      { id: 'D', text: { en: 'Freezing temperatures', ar: 'درجات حرارة متجمدة' } }
    ],
    correctOptionId: 'B',
    timeLimit: 30,
    xpReward: 10
  },
  {
    id: 'english-397',
    subject: QuizSubject.ENGLISH,
    difficulty: DifficultyLevel.MEDIUM,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'The popular children\'s rhyme that begins "Fuzzy Wuzzy was a bear" usually ends with what two words?', ar: 'The popular children\'s rhyme that begins "Fuzzy Wuzzy was a bear" usually ends with what two words?' },
    options: [
      { id: 'A', text: { en: 'Did he?', ar: 'Did he?' } },
      { id: 'B', text: { en: 'Was he?', ar: 'Was he?' } },
      { id: 'C', text: { en: 'Should he?', ar: 'Should he?' } },
      { id: 'D', text: { en: 'Will he?', ar: 'Will he?' } }
    ],
    correctOptionId: 'B',
    timeLimit: 30,
    xpReward: 20
  },
  {
    id: 'english-398',
    subject: QuizSubject.ENGLISH,
    difficulty: DifficultyLevel.MEDIUM,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'Which of these prefixes literally means "occurring together"?', ar: 'Which of these prefixes literally means "occurring together"?' },
    options: [
      { id: 'A', text: { en: 'Megalo-', ar: 'Megalo-' } },
      { id: 'B', text: { en: 'Pseudo-', ar: 'Pseudo-' } },
      { id: 'C', text: { en: 'Thermo-', ar: 'Thermo-' } },
      { id: 'D', text: { en: 'Synchro-', ar: 'Synchro-' } }
    ],
    correctOptionId: 'D',
    timeLimit: 30,
    xpReward: 20
  },
  {
    id: 'math-399',
    subject: QuizSubject.MATH,
    difficulty: DifficultyLevel.EASY,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'Weighing close to three tons, one million pennies is equal to how many dollars?', ar: 'ويبلغ وزنها قرابة ثلاثة أطنان، يعادل مليون سنت كم دولاراً؟' },
    options: [
      { id: 'A', text: { en: '100', ar: '١٠٠' } },
      { id: 'B', text: { en: '1,000', ar: '١٬٠٠٠' } },
      { id: 'C', text: { en: '10,000', ar: '١٠٬٠٠٠' } },
      { id: 'D', text: { en: '100,000', ar: '١٠٠٬٠٠٠' } }
    ],
    correctOptionId: 'C',
    timeLimit: 30,
    xpReward: 10
  },
  {
    id: 'general-400',
    subject: QuizSubject.GENERAL,
    difficulty: DifficultyLevel.MEDIUM,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'Popular in France, a croque-monsieur is a heated sandwich traditionally filled with what?', ar: 'شائعة في فرنسا، شطيرة "كروك مسيو" الساخنة تُحشى تقليدياً بماذا؟' },
    options: [
      { id: 'A', text: { en: 'Tuna fish', ar: 'التونة' } },
      { id: 'B', text: { en: 'Chocolate', ar: 'الشوكولاتة' } },
      { id: 'C', text: { en: 'Liver and onions', ar: 'الكبدة والبصل' } },
      { id: 'D', text: { en: 'Meat and cheese', ar: 'اللحم والجبن' } }
    ],
    correctOptionId: 'D',
    timeLimit: 30,
    xpReward: 20
  },
  {
    id: 'general-401',
    subject: QuizSubject.GENERAL,
    difficulty: DifficultyLevel.EASY,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'The feared conqueror Genghis Khan was the leader of what ancient people?', ar: 'الفاتح المرعب جنكيز خان قاد أيّ من الشعوب القديمة؟' },
    options: [
      { id: 'A', text: { en: 'Goths', ar: 'القوط' } },
      { id: 'B', text: { en: 'Vikings', ar: 'الفايكنغ' } },
      { id: 'C', text: { en: 'Mongols', ar: 'المغول' } },
      { id: 'D', text: { en: 'Saxons', ar: 'الساكسون' } }
    ],
    correctOptionId: 'C',
    timeLimit: 30,
    xpReward: 10
  },
  {
    id: 'english-402',
    subject: QuizSubject.ENGLISH,
    difficulty: DifficultyLevel.EASY,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'Which of these adjectives best describes a person who claims to be "on cloud nine"?', ar: 'Which of these adjectives best describes a person who claims to be "on cloud nine"?' },
    options: [
      { id: 'A', text: { en: 'Curious', ar: 'Curious' } },
      { id: 'B', text: { en: 'Sad', ar: 'Sad' } },
      { id: 'C', text: { en: 'Happy', ar: 'Happy' } },
      { id: 'D', text: { en: 'Angry', ar: 'Angry' } }
    ],
    correctOptionId: 'C',
    timeLimit: 30,
    xpReward: 10
  },
  {
    id: 'math-403',
    subject: QuizSubject.MATH,
    difficulty: DifficultyLevel.EASY,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'What shape are the sides of Egypt\'s famous pyramids at Giza?', ar: 'ما شكل جوانب الأهرامات المصرية الشهيرة في الجيزة؟' },
    options: [
      { id: 'A', text: { en: 'Square', ar: 'مربعة' } },
      { id: 'B', text: { en: 'Triangular', ar: 'مثلثية' } },
      { id: 'C', text: { en: 'Circular', ar: 'دائرية' } },
      { id: 'D', text: { en: 'Rectangular', ar: 'مستطيلة' } }
    ],
    correctOptionId: 'B',
    timeLimit: 30,
    xpReward: 10
  },
  {
    id: 'english-404',
    subject: QuizSubject.ENGLISH,
    difficulty: DifficultyLevel.EASY,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'By definition an effervescent drink has what in it?', ar: 'By definition an effervescent drink has what in it?' },
    options: [
      { id: 'A', text: { en: 'Ice', ar: 'Ice' } },
      { id: 'B', text: { en: 'Bubbles', ar: 'Bubbles' } },
      { id: 'C', text: { en: 'Caffeine', ar: 'Caffeine' } },
      { id: 'D', text: { en: 'Sugar', ar: 'Sugar' } }
    ],
    correctOptionId: 'B',
    timeLimit: 30,
    xpReward: 10
  },
  {
    id: 'general-405',
    subject: QuizSubject.GENERAL,
    difficulty: DifficultyLevel.EASY,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'Unfriendly spectators are commonly heard chanting "air ball" in what sport?', ar: 'يُسمع المشجعون غير الوديين عادةً ينادون "إير بول" في أي رياضة؟' },
    options: [
      { id: 'A', text: { en: 'Baseball', ar: 'البيسبول' } },
      { id: 'B', text: { en: 'Football', ar: 'كرة القدم الأمريكية' } },
      { id: 'C', text: { en: 'Soccer', ar: 'كرة القدم' } },
      { id: 'D', text: { en: 'Basketball', ar: 'كرة السلة' } }
    ],
    correctOptionId: 'D',
    timeLimit: 30,
    xpReward: 10
  },
  {
    id: 'general-406',
    subject: QuizSubject.GENERAL,
    difficulty: DifficultyLevel.EASY,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'Which of these countries is home to the ruins of the ancient Mayan Civilization?', ar: 'أيٌّ من هذه الدول تضم أطلال حضارة المايا القديمة؟' },
    options: [
      { id: 'A', text: { en: 'Turkey', ar: 'تركيا' } },
      { id: 'B', text: { en: 'Egypt', ar: 'مصر' } },
      { id: 'C', text: { en: 'Mexico', ar: 'المكسيك' } },
      { id: 'D', text: { en: 'Iraq', ar: 'العراق' } }
    ],
    correctOptionId: 'C',
    timeLimit: 30,
    xpReward: 10
  },
  {
    id: 'english-407',
    subject: QuizSubject.ENGLISH,
    difficulty: DifficultyLevel.EASY,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'What ancient Greek word translates to mean "I have found it"?', ar: 'What ancient Greek word translates to mean "I have found it"?' },
    options: [
      { id: 'A', text: { en: 'A-ha', ar: 'A-ha' } },
      { id: 'B', text: { en: 'Yikes', ar: 'Yikes' } },
      { id: 'C', text: { en: 'Eureka', ar: 'Eureka' } },
      { id: 'D', text: { en: 'Wow', ar: 'Wow' } }
    ],
    correctOptionId: 'C',
    timeLimit: 30,
    xpReward: 10
  },
  {
    id: 'science-408',
    subject: QuizSubject.SCIENCE,
    difficulty: DifficultyLevel.EASY,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'How long does it take the Earth to make one full orbit around the Sun?', ar: 'كم تستغرق الأرض لتُكمل دورة كاملة حول الشمس؟' },
    options: [
      { id: 'A', text: { en: 'One century', ar: 'قرن' } },
      { id: 'B', text: { en: 'One month', ar: 'شهر' } },
      { id: 'C', text: { en: 'One week', ar: 'أسبوع' } },
      { id: 'D', text: { en: 'One year', ar: 'سنة' } }
    ],
    correctOptionId: 'D',
    timeLimit: 30,
    xpReward: 10
  },
  {
    id: 'general-409',
    subject: QuizSubject.GENERAL,
    difficulty: DifficultyLevel.EASY,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'What is the capital of Australia?', ar: 'ما عاصمة أستراليا؟' },
    options: [
      { id: 'A', text: { en: 'Canberra', ar: 'كانبرا' } },
      { id: 'B', text: { en: 'Sydney', ar: 'سيدني' } },
      { id: 'C', text: { en: 'Melbourne', ar: 'ملبورن' } },
      { id: 'D', text: { en: 'Perth', ar: 'بيرث' } }
    ],
    correctOptionId: 'A',
    timeLimit: 30,
    xpReward: 10
  },
  {
    id: 'general-410',
    subject: QuizSubject.GENERAL,
    difficulty: DifficultyLevel.EASY,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'A common saying on the best way to pick up heavy objects is "lift with your legs, not with your" what?', ar: 'مقولة شائعة عن أفضل طريقة لرفع الأشياء الثقيلة: "ارفع بساقيك لا بـ..." ماذا؟' },
    options: [
      { id: 'A', text: { en: 'Neck', ar: 'الرقبة' } },
      { id: 'B', text: { en: 'Head', ar: 'الرأس' } },
      { id: 'C', text: { en: 'Hands', ar: 'اليدين' } },
      { id: 'D', text: { en: 'Back', ar: 'الظهر' } }
    ],
    correctOptionId: 'D',
    timeLimit: 30,
    xpReward: 10
  },
  {
    id: 'general-411',
    subject: QuizSubject.GENERAL,
    difficulty: DifficultyLevel.MEDIUM,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'A news article about the Burj Khalifa stated the world\'s tallest building is so tall you can grab an elevator and experience what twice in one day?', ar: 'ذكر مقال إخباري عن برج خليفة أن أطول بناء في العالم مرتفع لدرجة أنه يمكنك استخدام المصعد ومشاهدة ماذا مرتين في اليوم؟' },
    options: [
      { id: 'A', text: { en: 'High temperature', ar: 'درجة حرارة عالية' } },
      { id: 'B', text: { en: 'Shooting star', ar: 'شهاب' } },
      { id: 'C', text: { en: 'Rainbow', ar: 'قوس قزح' } },
      { id: 'D', text: { en: 'Sunset', ar: 'غروب الشمس' } }
    ],
    correctOptionId: 'D',
    timeLimit: 30,
    xpReward: 20
  },
  {
    id: 'science-412',
    subject: QuizSubject.SCIENCE,
    difficulty: DifficultyLevel.MEDIUM,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'After killing its prey, what animal is known to take up to half an hour catching its breath before it dines?', ar: 'بعد قتل فريسته، أي حيوان معروف بأنه قد يستغرق نصف ساعة لاستعادة أنفاسه قبل أن يأكل؟' },
    options: [
      { id: 'A', text: { en: 'Crocodile', ar: 'التمساح' } },
      { id: 'B', text: { en: 'Hawk', ar: 'الصقر' } },
      { id: 'C', text: { en: 'Cheetah', ar: 'الفهد' } },
      { id: 'D', text: { en: 'Cobra', ar: 'الكوبرا' } }
    ],
    correctOptionId: 'C',
    timeLimit: 30,
    xpReward: 20
  },
  {
    id: 'english-413',
    subject: QuizSubject.ENGLISH,
    difficulty: DifficultyLevel.EASY,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'Which of the following words comes after "stop" and "drop" in a popular fire safety slogan?', ar: 'Which of the following words comes after "stop" and "drop" in a popular fire safety slogan?' },
    options: [
      { id: 'A', text: { en: 'Hop', ar: 'Hop' } },
      { id: 'B', text: { en: 'Roll', ar: 'Roll' } },
      { id: 'C', text: { en: 'Go', ar: 'Go' } },
      { id: 'D', text: { en: 'Moonwalk', ar: 'Moonwalk' } }
    ],
    correctOptionId: 'B',
    timeLimit: 30,
    xpReward: 10
  },
  {
    id: 'general-414',
    subject: QuizSubject.GENERAL,
    difficulty: DifficultyLevel.EASY,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'In Chinese philosophy, what is the opposite of "yin"?', ar: 'في الفلسفة الصينية، ما عكس "ين"؟' },
    options: [
      { id: 'A', text: { en: 'Yon', ar: 'Yon' } },
      { id: 'B', text: { en: 'Yang', ar: 'يانغ' } },
      { id: 'C', text: { en: 'Yen', ar: 'Yen' } },
      { id: 'D', text: { en: 'Yo', ar: 'Yo' } }
    ],
    correctOptionId: 'B',
    timeLimit: 30,
    xpReward: 10
  },
  {
    id: 'english-415',
    subject: QuizSubject.ENGLISH,
    difficulty: DifficultyLevel.MEDIUM,
    gradeRange: { min: 5, max: 8 },
    text: { en: '"There once was a man from Nantucket" is the first line of what type of poem?', ar: '"There once was a man from Nantucket" is the first line of what type of poem?' },
    options: [
      { id: 'A', text: { en: 'Sonnet', ar: 'Sonnet' } },
      { id: 'B', text: { en: 'Tanka', ar: 'Tanka' } },
      { id: 'C', text: { en: 'Haiku', ar: 'Haiku' } },
      { id: 'D', text: { en: 'Limerick', ar: 'Limerick' } }
    ],
    correctOptionId: 'D',
    timeLimit: 30,
    xpReward: 20
  },
  {
    id: 'math-416',
    subject: QuizSubject.MATH,
    difficulty: DifficultyLevel.MEDIUM,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'If you face north and then turn 90 degrees to the left three times in a row, which way are you facing?', ar: 'إذا واجهت الشمال ثم استدرت ٩٠ درجة إلى اليسار ثلاث مرات متتالية، إلى أي اتجاه تواجه؟' },
    options: [
      { id: 'A', text: { en: 'North', ar: 'الشمال' } },
      { id: 'B', text: { en: 'South', ar: 'الجنوب' } },
      { id: 'C', text: { en: 'East', ar: 'الشرق' } },
      { id: 'D', text: { en: 'West', ar: 'الغرب' } }
    ],
    correctOptionId: 'C',
    timeLimit: 30,
    xpReward: 20
  },
  {
    id: 'general-417',
    subject: QuizSubject.GENERAL,
    difficulty: DifficultyLevel.HARD,
    gradeRange: { min: 6, max: 8 },
    text: { en: 'What Washington State Park advertises fun family activities like hiking and treasure hunts, despite its depressing name?', ar: 'أيُّ متنزه ولاية في واشنطن يُعلن عن نشاطات عائلية ممتعة كالمشي والبحث عن الكنوز رغم اسمه الكئيب؟' },
    options: [
      { id: 'A', text: { en: 'Fort Sadness', ar: 'قلعة الحزن' } },
      { id: 'B', text: { en: 'Disenchantment Reserve', ar: 'محمية الإحباط' } },
      { id: 'C', text: { en: 'Ingratitude Coast Trail', ar: 'مسار ساحل الجحود' } },
      { id: 'D', text: { en: 'Cape Disappointment', ar: 'رأس خيبة الأمل' } }
    ],
    correctOptionId: 'D',
    timeLimit: 30,
    xpReward: 35
  },
  {
    id: 'science-418',
    subject: QuizSubject.SCIENCE,
    difficulty: DifficultyLevel.EASY,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'An adult Dalmatian dog is best known for what type of markings?', ar: 'يُعرف الكلب الدلماسي البالغ بأنواع علامات على جسده، فما نوعها؟' },
    options: [
      { id: 'A', text: { en: 'Spots', ar: 'النقاط' } },
      { id: 'B', text: { en: 'Triangles', ar: 'المثلثات' } },
      { id: 'C', text: { en: 'Stripes', ar: 'الخطوط' } },
      { id: 'D', text: { en: 'Stars', ar: 'النجوم' } }
    ],
    correctOptionId: 'A',
    timeLimit: 30,
    xpReward: 10
  },
  {
    id: 'english-419',
    subject: QuizSubject.ENGLISH,
    difficulty: DifficultyLevel.EASY,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'According to a well-known phrase, where shouldn\'t you put all your eggs?', ar: 'According to a well-known phrase, where shouldn\'t you put all your eggs?' },
    options: [
      { id: 'A', text: { en: 'In one pocketbook', ar: 'In one pocketbook' } },
      { id: 'B', text: { en: 'In one knapsack', ar: 'In one knapsack' } },
      { id: 'C', text: { en: 'In one basket', ar: 'In one basket' } },
      { id: 'D', text: { en: 'In one omelette', ar: 'In one omelette' } }
    ],
    correctOptionId: 'C',
    timeLimit: 30,
    xpReward: 10
  },
  {
    id: 'science-420',
    subject: QuizSubject.SCIENCE,
    difficulty: DifficultyLevel.EASY,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'Which of the following is the name of the process the human body uses to cool itself?', ar: 'أيٌّ ممّا يلي اسم العملية التي يستخدمها جسم الإنسان لتبريد نفسه؟' },
    options: [
      { id: 'A', text: { en: 'Vindication', ar: 'التبرير' } },
      { id: 'B', text: { en: 'Condemnation', ar: 'الإدانة' } },
      { id: 'C', text: { en: 'Aggravation', ar: 'التفاقم' } },
      { id: 'D', text: { en: 'Perspiration', ar: 'التعرق' } }
    ],
    correctOptionId: 'D',
    timeLimit: 30,
    xpReward: 10
  },
  {
    id: 'general-421',
    subject: QuizSubject.GENERAL,
    difficulty: DifficultyLevel.EASY,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'What ingredient gives guacamole its green color?', ar: 'ما المكوّن الذي يعطي الغواكامولي لونه الأخضر؟' },
    options: [
      { id: 'A', text: { en: 'Tomato', ar: 'الطماطم' } },
      { id: 'B', text: { en: 'Avocado', ar: 'الأفوكادو' } },
      { id: 'C', text: { en: 'Zucchini', ar: 'الكوسا' } },
      { id: 'D', text: { en: 'Onion', ar: 'البصل' } }
    ],
    correctOptionId: 'B',
    timeLimit: 30,
    xpReward: 10
  },
  {
    id: 'general-422',
    subject: QuizSubject.GENERAL,
    difficulty: DifficultyLevel.MEDIUM,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'Traditionally a "fob" is a chain attached to what kind of item?', ar: 'تقليدياً، الـ"فوب" هي سلسلة تُربط بأي نوع من الأشياء؟' },
    options: [
      { id: 'A', text: { en: 'Scarf', ar: 'وشاح' } },
      { id: 'B', text: { en: 'Pocket watch', ar: 'ساعة جيب' } },
      { id: 'C', text: { en: 'Wallet', ar: 'محفظة' } },
      { id: 'D', text: { en: 'Eyeglasses', ar: 'نظارات' } }
    ],
    correctOptionId: 'B',
    timeLimit: 30,
    xpReward: 20
  },
  {
    id: 'english-423',
    subject: QuizSubject.ENGLISH,
    difficulty: DifficultyLevel.EASY,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'Kids often learn how to tie their shoelaces using a technique commonly known as what?', ar: 'Kids often learn how to tie their shoelaces using a technique commonly known as what?' },
    options: [
      { id: 'A', text: { en: 'Bunny ears', ar: 'Bunny ears' } },
      { id: 'B', text: { en: 'Lamb ears', ar: 'Lamb ears' } },
      { id: 'C', text: { en: 'Kitty ears', ar: 'Kitty ears' } },
      { id: 'D', text: { en: 'Piglet ears', ar: 'Piglet ears' } }
    ],
    correctOptionId: 'A',
    timeLimit: 30,
    xpReward: 10
  },
  {
    id: 'science-424',
    subject: QuizSubject.SCIENCE,
    difficulty: DifficultyLevel.MEDIUM,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'Water intoxication occurs in marathon runners when too much water is consumed without replacing what?', ar: 'يحدث "تسمّم الماء" لدى عدائي الماراثون عند شرب كميات كبيرة من الماء دون تعويض ماذا؟' },
    options: [
      { id: 'A', text: { en: 'Salt', ar: 'الملح' } },
      { id: 'B', text: { en: 'Vitamin D', ar: 'فيتامين د' } },
      { id: 'C', text: { en: 'Iron', ar: 'الحديد' } },
      { id: 'D', text: { en: 'Sugar', ar: 'السكر' } }
    ],
    correctOptionId: 'A',
    timeLimit: 30,
    xpReward: 20
  },
  {
    id: 'english-425',
    subject: QuizSubject.ENGLISH,
    difficulty: DifficultyLevel.EASY,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'If you reduce something to its basic elements, it is said you are "getting down to the" what?', ar: 'If you reduce something to its basic elements, it is said you are "getting down to the" what?' },
    options: [
      { id: 'A', text: { en: 'Sitting pretty', ar: 'Sitting pretty' } },
      { id: 'B', text: { en: 'Nitty-gritty', ar: 'Nitty-gritty' } },
      { id: 'C', text: { en: 'Emerald City', ar: 'Emerald City' } },
      { id: 'D', text: { en: 'Hello Kitty', ar: 'Hello Kitty' } }
    ],
    correctOptionId: 'B',
    timeLimit: 30,
    xpReward: 10
  },
  {
    id: 'general-426',
    subject: QuizSubject.GENERAL,
    difficulty: DifficultyLevel.EASY,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'Which of these pieces of office equipment is the most likely to break down due to a paper jam?', ar: 'أيٌّ من معدات المكتب التالية هي الأكثر عرضة للتعطل بسبب انحشار الورق؟' },
    options: [
      { id: 'A', text: { en: 'Photocopier', ar: 'آلة النسخ' } },
      { id: 'B', text: { en: 'Pencil sharpener', ar: 'بريّة الأقلام' } },
      { id: 'C', text: { en: 'Desk lamp', ar: 'مصباح الطاولة' } },
      { id: 'D', text: { en: 'In-box', ar: 'صندوق الوارد' } }
    ],
    correctOptionId: 'A',
    timeLimit: 30,
    xpReward: 10
  },
  {
    id: 'english-427',
    subject: QuizSubject.ENGLISH,
    difficulty: DifficultyLevel.EASY,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'A person who muzzles a dog prevents it from doing which of the following?', ar: 'A person who muzzles a dog prevents it from doing which of the following?' },
    options: [
      { id: 'A', text: { en: 'Biting', ar: 'Biting' } },
      { id: 'B', text: { en: 'Running in traffic', ar: 'Running in traffic' } },
      { id: 'C', text: { en: 'Chasing its tail', ar: 'Chasing its tail' } },
      { id: 'D', text: { en: 'Gossiping', ar: 'Gossiping' } }
    ],
    correctOptionId: 'A',
    timeLimit: 30,
    xpReward: 10
  },
  {
    id: 'general-428',
    subject: QuizSubject.GENERAL,
    difficulty: DifficultyLevel.EASY,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'Roman gladiator contests took place at which of the following sites?', ar: 'كانت مباريات المصارعين الرومان تُقام في أيٍّ من المواقع التالية؟' },
    options: [
      { id: 'A', text: { en: 'Pyramids', ar: 'الأهرامات' } },
      { id: 'B', text: { en: 'Acropolis', ar: 'الأكروبوليس' } },
      { id: 'C', text: { en: 'Basilica', ar: 'البازيليكا' } },
      { id: 'D', text: { en: 'Colosseum', ar: 'الكولوسيوم' } }
    ],
    correctOptionId: 'D',
    timeLimit: 30,
    xpReward: 10
  },
  {
    id: 'general-429',
    subject: QuizSubject.GENERAL,
    difficulty: DifficultyLevel.MEDIUM,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'Which of these countries is not completely surrounded by water?', ar: 'أيٌّ من هذه الدول ليست محاطة بالماء بالكامل؟' },
    options: [
      { id: 'A', text: { en: 'Japan', ar: 'اليابان' } },
      { id: 'B', text: { en: 'Australia', ar: 'أستراليا' } },
      { id: 'C', text: { en: 'Italy', ar: 'إيطاليا' } },
      { id: 'D', text: { en: 'New Zealand', ar: 'نيوزيلندا' } }
    ],
    correctOptionId: 'C',
    timeLimit: 30,
    xpReward: 20
  },
  {
    id: 'science-430',
    subject: QuizSubject.SCIENCE,
    difficulty: DifficultyLevel.MEDIUM,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'Which of the following organisms does not get nourishment through photosynthesis?', ar: 'أيٌّ من الكائنات التالية لا يحصل على غذائه عن طريق التمثيل الضوئي؟' },
    options: [
      { id: 'A', text: { en: 'Mushroom', ar: 'الفطر' } },
      { id: 'B', text: { en: 'Fern', ar: 'السرخس' } },
      { id: 'C', text: { en: 'Cactus', ar: 'الصبار' } },
      { id: 'D', text: { en: 'Moss', ar: 'الطحالب' } }
    ],
    correctOptionId: 'A',
    timeLimit: 30,
    xpReward: 20
  },
  {
    id: 'science-431',
    subject: QuizSubject.SCIENCE,
    difficulty: DifficultyLevel.MEDIUM,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'The ferret, otter and wolverine are all members of what animal family?', ar: 'ابن مقرض والقضاعة والولفرين كلها أعضاء في أي فصيلة حيوانية؟' },
    options: [
      { id: 'A', text: { en: 'Rodent', ar: 'القوارض' } },
      { id: 'B', text: { en: 'Primate', ar: 'الرئيسيات' } },
      { id: 'C', text: { en: 'Marsupial', ar: 'الجرابيات' } },
      { id: 'D', text: { en: 'Weasel', ar: 'ابن عرس' } }
    ],
    correctOptionId: 'D',
    timeLimit: 30,
    xpReward: 20
  },
  {
    id: 'general-432',
    subject: QuizSubject.GENERAL,
    difficulty: DifficultyLevel.EASY,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'Which of these collars fits tightest around the neck?', ar: 'أيٌّ من هذه الياقات يلتصق أكثر حول الرقبة؟' },
    options: [
      { id: 'A', text: { en: 'Turtleneck', ar: 'ياقة عالية' } },
      { id: 'B', text: { en: 'V-neck', ar: 'ياقة V' } },
      { id: 'C', text: { en: 'Sweetheart neck', ar: 'ياقة قلبية' } },
      { id: 'D', text: { en: 'Draped neck', ar: 'ياقة منسدلة' } }
    ],
    correctOptionId: 'A',
    timeLimit: 30,
    xpReward: 10
  },
  {
    id: 'science-433',
    subject: QuizSubject.SCIENCE,
    difficulty: DifficultyLevel.MEDIUM,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'Typically, a baby\'s first teeth will appear at six months of age, and be of what type?', ar: 'عادةً تظهر أول أسنان الرضيع في عمر ستة أشهر، فمن أي نوع تكون؟' },
    options: [
      { id: 'A', text: { en: 'Incisors', ar: 'القواطع' } },
      { id: 'B', text: { en: 'Molars', ar: 'الأضراس' } },
      { id: 'C', text: { en: 'Canines', ar: 'الأنياب' } },
      { id: 'D', text: { en: 'Bicuspids', ar: 'الضواحك' } }
    ],
    correctOptionId: 'A',
    timeLimit: 30,
    xpReward: 20
  },
  {
    id: 'science-434',
    subject: QuizSubject.SCIENCE,
    difficulty: DifficultyLevel.HARD,
    gradeRange: { min: 6, max: 8 },
    text: { en: 'Ossicones are hair-covered horns found atop the head of which of these mammals?', ar: 'الـ"أوسيكونات" هي قرون مغطاة بالشعر تظهر على رأس أيٍّ من هذه الثدييات؟' },
    options: [
      { id: 'A', text: { en: 'Gorilla', ar: 'الغوريلا' } },
      { id: 'B', text: { en: 'Kangaroo', ar: 'الكنغر' } },
      { id: 'C', text: { en: 'Giraffe', ar: 'الزرافة' } },
      { id: 'D', text: { en: 'Zebra', ar: 'الحمار الوحشي' } }
    ],
    correctOptionId: 'C',
    timeLimit: 30,
    xpReward: 35
  },
  {
    id: 'science-435',
    subject: QuizSubject.SCIENCE,
    difficulty: DifficultyLevel.MEDIUM,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'What metal is the best conductor of heat and electricity?', ar: 'ما المعدن الأفضل في توصيل الحرارة والكهرباء؟' },
    options: [
      { id: 'A', text: { en: 'Titanium', ar: 'التيتانيوم' } },
      { id: 'B', text: { en: 'Silver', ar: 'الفضة' } },
      { id: 'C', text: { en: 'Gold', ar: 'الذهب' } },
      { id: 'D', text: { en: 'Platinum', ar: 'البلاتين' } }
    ],
    correctOptionId: 'B',
    timeLimit: 30,
    xpReward: 20
  },
  {
    id: 'general-436',
    subject: QuizSubject.GENERAL,
    difficulty: DifficultyLevel.MEDIUM,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'As any atlas can tell you, the Atlas mountain range is located where?', ar: 'كما يخبرك أي أطلس، أين تقع سلسلة جبال الأطلس؟' },
    options: [
      { id: 'A', text: { en: 'Southern Asia', ar: 'جنوب آسيا' } },
      { id: 'B', text: { en: 'Central America', ar: 'أمريكا الوسطى' } },
      { id: 'C', text: { en: 'Northern Africa', ar: 'شمال أفريقيا' } },
      { id: 'D', text: { en: 'Eastern Europe', ar: 'شرق أوروبا' } }
    ],
    correctOptionId: 'C',
    timeLimit: 30,
    xpReward: 20
  },
  {
    id: 'general-437',
    subject: QuizSubject.GENERAL,
    difficulty: DifficultyLevel.EASY,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'For which of the following activities do fitness trainers normally recommend a "spotter"?', ar: 'في أيٍّ من النشاطات التالية ينصح مدربو اللياقة عادةً بوجود "مراقب"؟' },
    options: [
      { id: 'A', text: { en: 'Cycling', ar: 'ركوب الدراجة' } },
      { id: 'B', text: { en: 'Bench-pressing', ar: 'رفع البار من الاستلقاء' } },
      { id: 'C', text: { en: 'Race walking', ar: 'المشي السريع' } },
      { id: 'D', text: { en: 'Light dusting', ar: 'إزالة الغبار' } }
    ],
    correctOptionId: 'B',
    timeLimit: 30,
    xpReward: 10
  },
  {
    id: 'english-438',
    subject: QuizSubject.ENGLISH,
    difficulty: DifficultyLevel.EASY,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'How is a standard English dictionary organized?', ar: 'How is a standard English dictionary organized?' },
    options: [
      { id: 'A', text: { en: 'Alphabetically', ar: 'Alphabetically' } },
      { id: 'B', text: { en: 'By age', ar: 'By age' } },
      { id: 'C', text: { en: 'Word length', ar: 'Word length' } },
      { id: 'D', text: { en: 'Poorly', ar: 'Poorly' } }
    ],
    correctOptionId: 'A',
    timeLimit: 30,
    xpReward: 10
  },
  {
    id: 'science-439',
    subject: QuizSubject.SCIENCE,
    difficulty: DifficultyLevel.EASY,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'By definition, altitude sickness is caused by lack of what?', ar: 'بحسب التعريف، يحدث "داء الارتفاعات" بسبب نقص ماذا؟' },
    options: [
      { id: 'A', text: { en: 'Water', ar: 'الماء' } },
      { id: 'B', text: { en: 'Food', ar: 'الطعام' } },
      { id: 'C', text: { en: 'Sleep', ar: 'النوم' } },
      { id: 'D', text: { en: 'Oxygen', ar: 'الأكسجين' } }
    ],
    correctOptionId: 'D',
    timeLimit: 30,
    xpReward: 10
  },
  {
    id: 'general-440',
    subject: QuizSubject.GENERAL,
    difficulty: DifficultyLevel.EASY,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'What type of food is capellini?', ar: 'ما نوع الطعام المعروف بـ"كابيليني"؟' },
    options: [
      { id: 'A', text: { en: 'Pesto', ar: 'بستو' } },
      { id: 'B', text: { en: 'Pastry', ar: 'معجنات' } },
      { id: 'C', text: { en: 'Poultry', ar: 'دواجن' } },
      { id: 'D', text: { en: 'Pasta', ar: 'معكرونة' } }
    ],
    correctOptionId: 'D',
    timeLimit: 30,
    xpReward: 10
  },
  {
    id: 'science-441',
    subject: QuizSubject.SCIENCE,
    difficulty: DifficultyLevel.MEDIUM,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'Which of the following was co-invented by Jacques Cousteau while he was an officer in the French navy?', ar: 'أيٌّ ممّا يلي شارك جاك كوستو في اختراعه أثناء خدمته كضابط في البحرية الفرنسية؟' },
    options: [
      { id: 'A', text: { en: 'Aqua Lung', ar: 'الرئة المائية (أكوا لانغ)' } },
      { id: 'B', text: { en: 'Gyroscope', ar: 'الجيروسكوب' } },
      { id: 'C', text: { en: 'Sonar', ar: 'السونار' } },
      { id: 'D', text: { en: 'Shark repellent', ar: 'طارد القروش' } }
    ],
    correctOptionId: 'A',
    timeLimit: 30,
    xpReward: 20
  },
  {
    id: 'english-442',
    subject: QuizSubject.ENGLISH,
    difficulty: DifficultyLevel.MEDIUM,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'Google\'s search engine jokingly asks "Did you mean: nag a ram?" if users type in a search for which of these linguistic terms?', ar: 'Google\'s search engine jokingly asks "Did you mean: nag a ram?" if users type in a search for which of these linguistic terms?' },
    options: [
      { id: 'A', text: { en: 'Palindrome', ar: 'Palindrome' } },
      { id: 'B', text: { en: 'Oxymoron', ar: 'Oxymoron' } },
      { id: 'C', text: { en: 'Spoonerism', ar: 'Spoonerism' } },
      { id: 'D', text: { en: 'Anagram', ar: 'Anagram' } }
    ],
    correctOptionId: 'D',
    timeLimit: 30,
    xpReward: 20
  },
  {
    id: 'general-443',
    subject: QuizSubject.GENERAL,
    difficulty: DifficultyLevel.MEDIUM,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'In China, what does a person do with renminbi?', ar: 'في الصين، ماذا يفعل الشخص بالـ"رنمينبي"؟' },
    options: [
      { id: 'A', text: { en: 'Eat it', ar: 'يأكله' } },
      { id: 'B', text: { en: 'Spend it', ar: 'ينفقه' } },
      { id: 'C', text: { en: 'Wear it', ar: 'يرتديه' } },
      { id: 'D', text: { en: 'Listen to it', ar: 'يستمع إليه' } }
    ],
    correctOptionId: 'B',
    timeLimit: 30,
    xpReward: 20
  },
  {
    id: 'science-444',
    subject: QuizSubject.SCIENCE,
    difficulty: DifficultyLevel.EASY,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'To make sure they don\'t work overtime, in Queensland, Australia, what native animals can only be cuddled by zoo visitors for 30 minutes a day?', ar: 'لضمان عدم إرهاقها، في كوينزلاند بأستراليا، أيٌّ من الحيوانات المحلية لا يُسمح لزوار حدائق الحيوان باحتضانها أكثر من ٣٠ دقيقة يومياً؟' },
    options: [
      { id: 'A', text: { en: 'Pandas', ar: 'الباندا' } },
      { id: 'B', text: { en: 'Koalas', ar: 'الكوالا' } },
      { id: 'C', text: { en: 'Tiger cubs', ar: 'أشبال النمور' } },
      { id: 'D', text: { en: 'Lemurs', ar: 'الليمور' } }
    ],
    correctOptionId: 'B',
    timeLimit: 30,
    xpReward: 10
  },
  {
    id: 'general-445',
    subject: QuizSubject.GENERAL,
    difficulty: DifficultyLevel.EASY,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'Also called "a bicycle built for two," a tandem bicycle typically has its riders sitting in which position?', ar: 'تُعرف أيضاً بـ"دراجة لشخصين"، تُجلس الدراجة الترادفية راكبَيها عادة في أي وضع؟' },
    options: [
      { id: 'A', text: { en: 'Back-to-back', ar: 'ظهراً لظهر' } },
      { id: 'B', text: { en: 'Face-to-face', ar: 'وجهاً لوجه' } },
      { id: 'C', text: { en: 'One behind the other', ar: 'واحد خلف الآخر' } },
      { id: 'D', text: { en: 'On each other\'s laps', ar: 'أحدهما في حضن الآخر' } }
    ],
    correctOptionId: 'C',
    timeLimit: 30,
    xpReward: 10
  },
  {
    id: 'english-446',
    subject: QuizSubject.ENGLISH,
    difficulty: DifficultyLevel.EASY,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'Which common English word means "I hear" in Latin?', ar: 'Which common English word means "I hear" in Latin?' },
    options: [
      { id: 'A', text: { en: 'Audio', ar: 'Audio' } },
      { id: 'B', text: { en: 'Video', ar: 'Video' } },
      { id: 'C', text: { en: 'Cardio', ar: 'Cardio' } },
      { id: 'D', text: { en: 'Fabio', ar: 'Fabio' } }
    ],
    correctOptionId: 'A',
    timeLimit: 30,
    xpReward: 10
  },
  {
    id: 'general-447',
    subject: QuizSubject.GENERAL,
    difficulty: DifficultyLevel.EASY,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'In an attempt to attract younger viewers, organizers of the 2024 Paris Olympics have considered adding eSports, also known as competitive what?', ar: 'في محاولة لاستقطاب جمهور أصغر سناً، فكر منظمو أولمبياد باريس ٢٠٢٤ بإضافة الرياضات الإلكترونية، المعروفة أيضاً بـ"التنافس في..." ماذا؟' },
    options: [
      { id: 'A', text: { en: 'Online shopping', ar: 'التسوق عبر الإنترنت' } },
      { id: 'B', text: { en: 'Video gaming', ar: 'ألعاب الفيديو' } },
      { id: 'C', text: { en: 'Internet trolling', ar: 'إغاظة الإنترنت' } },
      { id: 'D', text: { en: 'Day trading', ar: 'التداول اليومي' } }
    ],
    correctOptionId: 'B',
    timeLimit: 30,
    xpReward: 10
  },
  {
    id: 'general-448',
    subject: QuizSubject.GENERAL,
    difficulty: DifficultyLevel.MEDIUM,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'The difference between which of the following foods doesn\'t have to do with the plants\' species, but simply their ripeness at the time they were harvested?', ar: 'الفرق بين أيٍّ من الأطعمة التالية لا يعود إلى نوع النبات، بل إلى مرحلة نضجه عند الحصاد؟' },
    options: [
      { id: 'A', text: { en: 'Green and black olives', ar: 'الزيتون الأخضر والأسود' } },
      { id: 'B', text: { en: 'Zucchini and yellow squash', ar: 'الكوسا والقرع الأصفر' } },
      { id: 'C', text: { en: 'Black and pinto beans', ar: 'الفاصولياء السوداء والبينتو' } },
      { id: 'D', text: { en: 'Cauliflower and broccoli', ar: 'القرنبيط والبروكلي' } }
    ],
    correctOptionId: 'A',
    timeLimit: 30,
    xpReward: 20
  },
  {
    id: 'math-449',
    subject: QuizSubject.MATH,
    difficulty: DifficultyLevel.MEDIUM,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'If you have all of your adult teeth including your wisdom teeth, what percentage of them are molars?', ar: 'إذا كانت لديك كل أسنانك البالغة بما فيها أضراس العقل، فما النسبة المئوية للأضراس منها؟' },
    options: [
      { id: 'A', text: { en: '12.5 percent', ar: '١٢٫٥٪' } },
      { id: 'B', text: { en: '25 percent', ar: '٢٥٪' } },
      { id: 'C', text: { en: '37.5 percent', ar: '٣٧٫٥٪' } },
      { id: 'D', text: { en: '50 percent', ar: '٥٠٪' } }
    ],
    correctOptionId: 'C',
    timeLimit: 30,
    xpReward: 20
  },
  {
    id: 'science-450',
    subject: QuizSubject.SCIENCE,
    difficulty: DifficultyLevel.MEDIUM,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'Which of these prehistoric animals is classified as a member of the Elephantidae family?', ar: 'أيٌّ من هذه الحيوانات قبل التاريخ يصنّف من عائلة الفيلة (Elephantidae)؟' },
    options: [
      { id: 'A', text: { en: 'Woolly mammoth', ar: 'الماموث الصوفي' } },
      { id: 'B', text: { en: 'Saber-toothed tiger', ar: 'النمر سيف الأنياب' } },
      { id: 'C', text: { en: 'Cave lion', ar: 'أسد الكهوف' } },
      { id: 'D', text: { en: 'Woolly rhino', ar: 'وحيد القرن الصوفي' } }
    ],
    correctOptionId: 'A',
    timeLimit: 30,
    xpReward: 20
  },
  {
    id: 'general-451',
    subject: QuizSubject.GENERAL,
    difficulty: DifficultyLevel.EASY,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'Arabic is not the official language in which of these countries?', ar: 'العربية ليست اللغة الرسمية في أيٍّ من هذه الدول؟' },
    options: [
      { id: 'A', text: { en: 'Jordan', ar: 'الأردن' } },
      { id: 'B', text: { en: 'Syria', ar: 'سوريا' } },
      { id: 'C', text: { en: 'Afghanistan', ar: 'أفغانستان' } },
      { id: 'D', text: { en: 'Kuwait', ar: 'الكويت' } }
    ],
    correctOptionId: 'C',
    timeLimit: 30,
    xpReward: 10
  },
  {
    id: 'math-452',
    subject: QuizSubject.MATH,
    difficulty: DifficultyLevel.EASY,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'How many days are in a normal weekend?', ar: 'كم عدد أيام نهاية الأسبوع المعتادة؟' },
    options: [
      { id: 'A', text: { en: 'One', ar: 'واحد' } },
      { id: 'B', text: { en: 'Two', ar: 'اثنان' } },
      { id: 'C', text: { en: 'Five', ar: 'خمسة' } },
      { id: 'D', text: { en: 'Not enough', ar: 'ليست كافية' } }
    ],
    correctOptionId: 'B',
    timeLimit: 30,
    xpReward: 10
  },
  {
    id: 'general-453',
    subject: QuizSubject.GENERAL,
    difficulty: DifficultyLevel.MEDIUM,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'Which of the following sports requires participants to lie on their backs?', ar: 'أيٌّ من الرياضات التالية تتطلب من المشاركين الاستلقاء على ظهورهم؟' },
    options: [
      { id: 'A', text: { en: 'Skiing', ar: 'التزلج' } },
      { id: 'B', text: { en: 'Luge', ar: 'اللوج' } },
      { id: 'C', text: { en: 'Rowing', ar: 'التجديف' } },
      { id: 'D', text: { en: 'Hang gliding', ar: 'الطيران الشراعي' } }
    ],
    correctOptionId: 'B',
    timeLimit: 30,
    xpReward: 20
  },
  {
    id: 'science-454',
    subject: QuizSubject.SCIENCE,
    difficulty: DifficultyLevel.EASY,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'As its name suggests, which of these diseases primarily affects cattle?', ar: 'كما يدل اسمه، أيٌّ من الأمراض التالية يصيب الماشية بشكل أساسي؟' },
    options: [
      { id: 'A', text: { en: 'Whooping cough', ar: 'السعال الديكي' } },
      { id: 'B', text: { en: 'Cowpox', ar: 'جدري البقر' } },
      { id: 'C', text: { en: 'Scarlet fever', ar: 'الحمى القرمزية' } },
      { id: 'D', text: { en: 'Moolaria', ar: 'موولاريا' } }
    ],
    correctOptionId: 'B',
    timeLimit: 30,
    xpReward: 10
  },
  {
    id: 'general-455',
    subject: QuizSubject.GENERAL,
    difficulty: DifficultyLevel.EASY,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'Windburn is an ailment commonly suffered by enthusiasts of which of these sports?', ar: 'حروق الرياح من المتاعب التي يعاني منها هواة أيٍّ من هذه الرياضات؟' },
    options: [
      { id: 'A', text: { en: 'Bowling', ar: 'البولينغ' } },
      { id: 'B', text: { en: 'Wrestling', ar: 'المصارعة' } },
      { id: 'C', text: { en: 'Skiing', ar: 'التزلج' } },
      { id: 'D', text: { en: 'Boxing', ar: 'الملاكمة' } }
    ],
    correctOptionId: 'C',
    timeLimit: 30,
    xpReward: 10
  },
  {
    id: 'general-456',
    subject: QuizSubject.GENERAL,
    difficulty: DifficultyLevel.EASY,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'Meaning "one who has gone before" the Japanese word "sensei" is often used to mean what?', ar: 'تعني "من سبق آخرين"، فالكلمة اليابانية "سينسي" تُستخدم غالباً للإشارة إلى ماذا؟' },
    options: [
      { id: 'A', text: { en: 'Teacher', ar: 'المعلم' } },
      { id: 'B', text: { en: 'Uncle', ar: 'العم' } },
      { id: 'C', text: { en: 'Soldier', ar: 'الجندي' } },
      { id: 'D', text: { en: 'Baby', ar: 'الرضيع' } }
    ],
    correctOptionId: 'A',
    timeLimit: 30,
    xpReward: 10
  },
  {
    id: 'general-457',
    subject: QuizSubject.GENERAL,
    difficulty: DifficultyLevel.EASY,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'When tying your gym shoes, which of these must you run your shoelaces through?', ar: 'عند ربط حذائك الرياضي، عبر أيٍّ من هذه يجب أن تُمرّر رباط الحذاء؟' },
    options: [
      { id: 'A', text: { en: 'Eyelet', ar: 'ثقب الرباط' } },
      { id: 'B', text: { en: 'Insole', ar: 'النعل الداخلي' } },
      { id: 'C', text: { en: 'Welt', ar: 'حافة الحذاء' } },
      { id: 'D', text: { en: 'Immunity challenge', ar: 'تحدي الحصانة' } }
    ],
    correctOptionId: 'A',
    timeLimit: 30,
    xpReward: 10
  },
  {
    id: 'english-458',
    subject: QuizSubject.ENGLISH,
    difficulty: DifficultyLevel.EASY,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'A person who specializes in breaking open safes is called what?', ar: 'A person who specializes in breaking open safes is called what?' },
    options: [
      { id: 'A', text: { en: 'Safehouser', ar: 'Safehouser' } },
      { id: 'B', text: { en: 'Safelighter', ar: 'Safelighter' } },
      { id: 'C', text: { en: 'Safecracker', ar: 'Safecracker' } },
      { id: 'D', text: { en: 'Club treasurer', ar: 'Club treasurer' } }
    ],
    correctOptionId: 'C',
    timeLimit: 30,
    xpReward: 10
  },
  {
    id: 'science-459',
    subject: QuizSubject.SCIENCE,
    difficulty: DifficultyLevel.EASY,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'Which of the following creatures is most likely to be caught in a spider\'s web?', ar: 'أيٌّ من المخلوقات التالية أكثر احتمالاً أن تعلق في شبكة العنكبوت؟' },
    options: [
      { id: 'A', text: { en: 'Lobster', ar: 'الكركند' } },
      { id: 'B', text: { en: 'Fly', ar: 'الذبابة' } },
      { id: 'C', text: { en: 'House cat', ar: 'القط المنزلي' } },
      { id: 'D', text: { en: 'Wildebeest', ar: 'الحيوان البري' } }
    ],
    correctOptionId: 'B',
    timeLimit: 30,
    xpReward: 10
  },
  {
    id: 'math-460',
    subject: QuizSubject.MATH,
    difficulty: DifficultyLevel.EASY,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'How many sides of an isosceles triangle are of equal length?', ar: 'كم ضلعاً من المثلث متساوي الساقين تكون متساوية الطول؟' },
    options: [
      { id: 'A', text: { en: 'One', ar: 'ضلع واحد' } },
      { id: 'B', text: { en: 'Two', ar: 'ضلعان' } },
      { id: 'C', text: { en: 'Three', ar: 'ثلاثة أضلاع' } },
      { id: 'D', text: { en: 'None', ar: 'لا شيء' } }
    ],
    correctOptionId: 'B',
    timeLimit: 30,
    xpReward: 10
  },
  {
    id: 'general-461',
    subject: QuizSubject.GENERAL,
    difficulty: DifficultyLevel.MEDIUM,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'Who was known for adorning their leaders with a "war bonnet" before battle?', ar: 'من اشتُهر بتزيين قادته بـ"غطاء الرأس الحربي" قبل المعركة؟' },
    options: [
      { id: 'A', text: { en: 'Plains Indians', ar: 'هنود السهول' } },
      { id: 'B', text: { en: 'Conquistadors', ar: 'الفاتحون الإسبان' } },
      { id: 'C', text: { en: 'Mongols', ar: 'المغول' } },
      { id: 'D', text: { en: 'Redcoats', ar: 'الأقمصة الحمراء' } }
    ],
    correctOptionId: 'A',
    timeLimit: 30,
    xpReward: 20
  },
  {
    id: 'science-462',
    subject: QuizSubject.SCIENCE,
    difficulty: DifficultyLevel.MEDIUM,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'In a living cell, what generates energy through aerobic respiration?', ar: 'في الخلية الحية، ما الذي يولّد الطاقة عبر التنفس الهوائي؟' },
    options: [
      { id: 'A', text: { en: 'Mitochondria', ar: 'الميتوكوندريا' } },
      { id: 'B', text: { en: 'Lysosomes', ar: 'الليسوسومات' } },
      { id: 'C', text: { en: 'Centrioles', ar: 'السنتريولات' } },
      { id: 'D', text: { en: 'Golgi bodies', ar: 'أجسام جولجي' } }
    ],
    correctOptionId: 'A',
    timeLimit: 30,
    xpReward: 20
  },
  {
    id: 'general-463',
    subject: QuizSubject.GENERAL,
    difficulty: DifficultyLevel.MEDIUM,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'Slightly easier to throw than lasagna, the annual "Battle of the Oranges" is a massive food fight honoring a historic uprising in what country?', ar: 'أسهل قليلاً في الرمي من اللازانيا، "معركة البرتقال" السنوية هي معركة طعام ضخمة تخلّد ثورة تاريخية في أي بلد؟' },
    options: [
      { id: 'A', text: { en: 'Russia', ar: 'روسيا' } },
      { id: 'B', text: { en: 'Italy', ar: 'إيطاليا' } },
      { id: 'C', text: { en: 'Mexico', ar: 'المكسيك' } },
      { id: 'D', text: { en: 'Japan', ar: 'اليابان' } }
    ],
    correctOptionId: 'B',
    timeLimit: 30,
    xpReward: 20
  },
  {
    id: 'english-464',
    subject: QuizSubject.ENGLISH,
    difficulty: DifficultyLevel.EASY,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'Which of the following phrases means "completely ruined"?', ar: 'Which of the following phrases means "completely ruined"?' },
    options: [
      { id: 'A', text: { en: 'All washed up', ar: 'All washed up' } },
      { id: 'B', text: { en: 'Flying high', ar: 'Flying high' } },
      { id: 'C', text: { en: 'Skip to my Lou', ar: 'Skip to my Lou' } },
      { id: 'D', text: { en: 'Regional theater', ar: 'Regional theater' } }
    ],
    correctOptionId: 'A',
    timeLimit: 30,
    xpReward: 10
  },
  {
    id: 'general-465',
    subject: QuizSubject.GENERAL,
    difficulty: DifficultyLevel.EASY,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'On a handsaw, what are the individual notches that make up the jagged edge called?', ar: 'في المنشار اليدوي، ما اسم النتوءات الفردية التي تشكّل الحافة المسننة؟' },
    options: [
      { id: 'A', text: { en: 'Brads', ar: 'مسامير دقيقة' } },
      { id: 'B', text: { en: 'Teeth', ar: 'الأسنان' } },
      { id: 'C', text: { en: 'Nails', ar: 'المسامير' } },
      { id: 'D', text: { en: 'Shards', ar: 'الشظايا' } }
    ],
    correctOptionId: 'B',
    timeLimit: 30,
    xpReward: 10
  },
  {
    id: 'science-466',
    subject: QuizSubject.SCIENCE,
    difficulty: DifficultyLevel.MEDIUM,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'The mongoose is known for its ability to kill which of these animals?', ar: 'يُعرف ابن عرس النمس بقدرته على قتل أيٍّ من هذه الحيوانات؟' },
    options: [
      { id: 'A', text: { en: 'Spiders', ar: 'العناكب' } },
      { id: 'B', text: { en: 'Bats', ar: 'الخفافيش' } },
      { id: 'C', text: { en: 'Scorpions', ar: 'العقارب' } },
      { id: 'D', text: { en: 'Snakes', ar: 'الأفاعي' } }
    ],
    correctOptionId: 'D',
    timeLimit: 30,
    xpReward: 20
  },
  {
    id: 'general-467',
    subject: QuizSubject.GENERAL,
    difficulty: DifficultyLevel.MEDIUM,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'Which of these famous European residences was home to King Louis XIV?', ar: 'أيٌّ من هذه الإقامات الملكية الأوروبية المشهورة كانت مقراً للملك لويس الرابع عشر؟' },
    options: [
      { id: 'A', text: { en: 'Versailles', ar: 'قصر فرساي' } },
      { id: 'B', text: { en: 'The Doge\'s Palace', ar: 'قصر الدوق' } },
      { id: 'C', text: { en: 'Windsor Castle', ar: 'قلعة وندسور' } },
      { id: 'D', text: { en: 'Winter Palace', ar: 'القصر الشتوي' } }
    ],
    correctOptionId: 'A',
    timeLimit: 30,
    xpReward: 20
  },
  {
    id: 'general-468',
    subject: QuizSubject.GENERAL,
    difficulty: DifficultyLevel.MEDIUM,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'Which of these bodies of water borders three continents?', ar: 'أيٌّ من هذه المسطحات المائية تحدّها ثلاث قارات؟' },
    options: [
      { id: 'A', text: { en: 'Mediterranean Sea', ar: 'البحر الأبيض المتوسط' } },
      { id: 'B', text: { en: 'North Sea', ar: 'بحر الشمال' } },
      { id: 'C', text: { en: 'Red Sea', ar: 'البحر الأحمر' } },
      { id: 'D', text: { en: 'Caspian Sea', ar: 'بحر قزوين' } }
    ],
    correctOptionId: 'A',
    timeLimit: 30,
    xpReward: 20
  },
  {
    id: 'english-469',
    subject: QuizSubject.ENGLISH,
    difficulty: DifficultyLevel.EASY,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'Humane societies are most commonly concerned with the treatment and protection of what group?', ar: 'Humane societies are most commonly concerned with the treatment and protection of what group?' },
    options: [
      { id: 'A', text: { en: 'Immigrant workers', ar: 'Immigrant workers' } },
      { id: 'B', text: { en: 'Senior citizens', ar: 'Senior citizens' } },
      { id: 'C', text: { en: 'Animals', ar: 'Animals' } },
      { id: 'D', text: { en: 'Romanian gymnasts', ar: 'Romanian gymnasts' } }
    ],
    correctOptionId: 'C',
    timeLimit: 30,
    xpReward: 10
  },
  {
    id: 'english-470',
    subject: QuizSubject.ENGLISH,
    difficulty: DifficultyLevel.MEDIUM,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'A misleading and distracting clue is commonly called a "red" what?', ar: 'A misleading and distracting clue is commonly called a "red" what?' },
    options: [
      { id: 'A', text: { en: 'Herring', ar: 'Herring' } },
      { id: 'B', text: { en: 'Rover', ar: 'Rover' } },
      { id: 'C', text: { en: 'Carpet', ar: 'Carpet' } },
      { id: 'D', text: { en: 'Baron', ar: 'Baron' } }
    ],
    correctOptionId: 'A',
    timeLimit: 30,
    xpReward: 20
  },
  {
    id: 'english-471',
    subject: QuizSubject.ENGLISH,
    difficulty: DifficultyLevel.EASY,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'According to a familiar sentence that uses all 26 letters, "The quick brown fox jumps over the" what?', ar: 'According to a familiar sentence that uses all 26 letters, "The quick brown fox jumps over the" what?' },
    options: [
      { id: 'A', text: { en: 'Golden goose', ar: 'Golden goose' } },
      { id: 'B', text: { en: 'Lazy dog', ar: 'Lazy dog' } },
      { id: 'C', text: { en: 'Silly toad', ar: 'Silly toad' } },
      { id: 'D', text: { en: 'Zany rabbit', ar: 'Zany rabbit' } }
    ],
    correctOptionId: 'B',
    timeLimit: 30,
    xpReward: 10
  },
  {
    id: 'english-472',
    subject: QuizSubject.ENGLISH,
    difficulty: DifficultyLevel.MEDIUM,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'Which of the following is not a foreign word meaning "thank you"?', ar: 'Which of the following is not a foreign word meaning "thank you"?' },
    options: [
      { id: 'A', text: { en: 'Gracias', ar: 'Gracias' } },
      { id: 'B', text: { en: 'Arrivederci', ar: 'Arrivederci' } },
      { id: 'C', text: { en: 'Danke', ar: 'Danke' } },
      { id: 'D', text: { en: 'Merci', ar: 'Merci' } }
    ],
    correctOptionId: 'B',
    timeLimit: 30,
    xpReward: 20
  },
  {
    id: 'science-473',
    subject: QuizSubject.SCIENCE,
    difficulty: DifficultyLevel.MEDIUM,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'Meningitis is a disease characterized by the swelling of tissue surrounding the spinal cord and what organ?', ar: 'التهاب السحايا مرض يتميز بتورم الأنسجة المحيطة بالحبل الشوكي وأيِّ عضو آخر؟' },
    options: [
      { id: 'A', text: { en: 'Brain', ar: 'الدماغ' } },
      { id: 'B', text: { en: 'Liver', ar: 'الكبد' } },
      { id: 'C', text: { en: 'Heart', ar: 'القلب' } },
      { id: 'D', text: { en: 'Stomach', ar: 'المعدة' } }
    ],
    correctOptionId: 'A',
    timeLimit: 30,
    xpReward: 20
  },
  {
    id: 'math-474',
    subject: QuizSubject.MATH,
    difficulty: DifficultyLevel.MEDIUM,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'A cubic foot consists of how many cubic inches?', ar: 'كم بوصة مكعبة تحتويها القدم المكعبة؟' },
    options: [
      { id: 'A', text: { en: '24', ar: '٢٤' } },
      { id: 'B', text: { en: '36', ar: '٣٦' } },
      { id: 'C', text: { en: '144', ar: '١٤٤' } },
      { id: 'D', text: { en: '1728', ar: '١٧٢٨' } }
    ],
    correctOptionId: 'D',
    timeLimit: 30,
    xpReward: 20
  },
  {
    id: 'general-475',
    subject: QuizSubject.GENERAL,
    difficulty: DifficultyLevel.HARD,
    gradeRange: { min: 6, max: 8 },
    text: { en: 'Which of these famous statues is missing its head and both of its arms?', ar: 'أيٌّ من هذه التماثيل الشهيرة يفتقد رأسه وذراعيه معاً؟' },
    options: [
      { id: 'A', text: { en: 'Winged Victory', ar: 'النصر المجنّح' } },
      { id: 'B', text: { en: 'Rebellious Slave', ar: 'العبد المتمرد' } },
      { id: 'C', text: { en: 'Venus de Milo', ar: 'فينوس دي ميلو' } },
      { id: 'D', text: { en: 'Discus Thrower', ar: 'رامي القرص' } }
    ],
    correctOptionId: 'A',
    timeLimit: 30,
    xpReward: 35
  },
  {
    id: 'english-476',
    subject: QuizSubject.ENGLISH,
    difficulty: DifficultyLevel.EASY,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'What is customarily shouted to alert others that someone has fallen off a ship and into the water?', ar: 'What is customarily shouted to alert others that someone has fallen off a ship and into the water?' },
    options: [
      { id: 'A', text: { en: 'Heads up!', ar: 'Heads up!' } },
      { id: 'B', text: { en: 'Heave ho!', ar: 'Heave ho!' } },
      { id: 'C', text: { en: 'Man overboard!', ar: 'Man overboard!' } },
      { id: 'D', text: { en: 'Keep on trucking!', ar: 'Keep on trucking!' } }
    ],
    correctOptionId: 'C',
    timeLimit: 30,
    xpReward: 10
  },
  {
    id: 'general-477',
    subject: QuizSubject.GENERAL,
    difficulty: DifficultyLevel.EASY,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'What type of pen is a "Magic Marker"?', ar: 'ما نوع القلم المعروف بـ"ماجيك ماركر"؟' },
    options: [
      { id: 'A', text: { en: 'Felt tip', ar: 'قلم لباد' } },
      { id: 'B', text: { en: 'Ballpoint', ar: 'قلم حبر جاف' } },
      { id: 'C', text: { en: 'Erasable', ar: 'قابل للمسح' } },
      { id: 'D', text: { en: 'Fountain', ar: 'قلم حبر سائل' } }
    ],
    correctOptionId: 'A',
    timeLimit: 30,
    xpReward: 10
  },
  {
    id: 'general-478',
    subject: QuizSubject.GENERAL,
    difficulty: DifficultyLevel.EASY,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'Which of these hats normally has a brim?', ar: 'أيٌّ من هذه القبعات لها حافة عادةً؟' },
    options: [
      { id: 'A', text: { en: 'Fez', ar: 'الطربوش' } },
      { id: 'B', text: { en: 'Beret', ar: 'البيريه' } },
      { id: 'C', text: { en: 'Stocking cap', ar: 'القبعة الجوارب' } },
      { id: 'D', text: { en: 'Sombrero', ar: 'السومبريرو' } }
    ],
    correctOptionId: 'D',
    timeLimit: 30,
    xpReward: 10
  },
  {
    id: 'general-479',
    subject: QuizSubject.GENERAL,
    difficulty: DifficultyLevel.MEDIUM,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'From the Spanish for table, what is the term for a flat-topped elevation common to the Southwest?', ar: 'مشتقة من الكلمة الإسبانية "طاولة"، ما المصطلح للمرتفع المسطح الذي ينتشر في الجنوب الغربي؟' },
    options: [
      { id: 'A', text: { en: 'Mesa', ar: 'ميسا' } },
      { id: 'B', text: { en: 'Plateau', ar: 'هضبة' } },
      { id: 'C', text: { en: 'Hillock', ar: 'أَكَمَة' } },
      { id: 'D', text: { en: 'Savannah', ar: 'سافانا' } }
    ],
    correctOptionId: 'A',
    timeLimit: 30,
    xpReward: 20
  },
  {
    id: 'english-480',
    subject: QuizSubject.ENGLISH,
    difficulty: DifficultyLevel.EASY,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'According to a common saying, you should "let sleeping dogs" do what?', ar: 'According to a common saying, you should "let sleeping dogs" do what?' },
    options: [
      { id: 'A', text: { en: 'Lie', ar: 'Lie' } },
      { id: 'B', text: { en: 'Snore', ar: 'Snore' } },
      { id: 'C', text: { en: 'Eat', ar: 'Eat' } },
      { id: 'D', text: { en: 'Dream about hydrants', ar: 'Dream about hydrants' } }
    ],
    correctOptionId: 'A',
    timeLimit: 30,
    xpReward: 10
  },
  {
    id: 'english-481',
    subject: QuizSubject.ENGLISH,
    difficulty: DifficultyLevel.MEDIUM,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'In the classic children\'s books, the well-intentioned Amelia Bedelia works as a what?', ar: 'In the classic children\'s books, the well-intentioned Amelia Bedelia works as a what?' },
    options: [
      { id: 'A', text: { en: 'Zookeeper', ar: 'Zookeeper' } },
      { id: 'B', text: { en: 'Nurse', ar: 'Nurse' } },
      { id: 'C', text: { en: 'Housekeeper', ar: 'Housekeeper' } },
      { id: 'D', text: { en: 'Librarian', ar: 'Librarian' } }
    ],
    correctOptionId: 'C',
    timeLimit: 30,
    xpReward: 20
  },
  {
    id: 'english-482',
    subject: QuizSubject.ENGLISH,
    difficulty: DifficultyLevel.EASY,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'Someone who has received a high grade on an exam is said to have done what?', ar: 'Someone who has received a high grade on an exam is said to have done what?' },
    options: [
      { id: 'A', text: { en: 'Deuced it', ar: 'Deuced it' } },
      { id: 'B', text: { en: 'Kinged it', ar: 'Kinged it' } },
      { id: 'C', text: { en: 'Aced it', ar: 'Aced it' } },
      { id: 'D', text: { en: 'Knighted it', ar: 'Knighted it' } }
    ],
    correctOptionId: 'C',
    timeLimit: 30,
    xpReward: 10
  },
  {
    id: 'general-483',
    subject: QuizSubject.GENERAL,
    difficulty: DifficultyLevel.EASY,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'A lime is normally what color?', ar: 'ما لون الليمون الأخضر (الليم) عادةً؟' },
    options: [
      { id: 'A', text: { en: 'Red', ar: 'أحمر' } },
      { id: 'B', text: { en: 'Green', ar: 'أخضر' } },
      { id: 'C', text: { en: 'White', ar: 'أبيض' } },
      { id: 'D', text: { en: 'Fluffy', ar: 'منفوش' } }
    ],
    correctOptionId: 'B',
    timeLimit: 30,
    xpReward: 10
  },
  {
    id: 'english-484',
    subject: QuizSubject.ENGLISH,
    difficulty: DifficultyLevel.EASY,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'If you are "jimmying" a suitcase, what are you doing to it?', ar: 'If you are "jimmying" a suitcase, what are you doing to it?' },
    options: [
      { id: 'A', text: { en: 'Carrying it', ar: 'Carrying it' } },
      { id: 'B', text: { en: 'Filling it with clothes', ar: 'Filling it with clothes' } },
      { id: 'C', text: { en: 'Prying it open', ar: 'Prying it open' } },
      { id: 'D', text: { en: 'Putting Jimmy in it', ar: 'Putting Jimmy in it' } }
    ],
    correctOptionId: 'C',
    timeLimit: 30,
    xpReward: 10
  },
  {
    id: 'english-485',
    subject: QuizSubject.ENGLISH,
    difficulty: DifficultyLevel.EASY,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'Which of these symbols resembles a tilted tic-tac-toe board?', ar: 'Which of these symbols resembles a tilted tic-tac-toe board?' },
    options: [
      { id: 'A', text: { en: 'Caret', ar: 'Caret' } },
      { id: 'B', text: { en: 'Pound sign', ar: 'Pound sign' } },
      { id: 'C', text: { en: 'Ampersand', ar: 'Ampersand' } },
      { id: 'D', text: { en: 'Bracket', ar: 'Bracket' } }
    ],
    correctOptionId: 'B',
    timeLimit: 30,
    xpReward: 10
  },
  {
    id: 'science-486',
    subject: QuizSubject.SCIENCE,
    difficulty: DifficultyLevel.EASY,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'What natural formation shoots columns of hot water and steam into the air?', ar: 'ما التشكل الطبيعي الذي يدفع أعمدة من الماء الساخن والبخار إلى الهواء؟' },
    options: [
      { id: 'A', text: { en: 'Basin', ar: 'حوض' } },
      { id: 'B', text: { en: 'Caldera', ar: 'فوهة بركان' } },
      { id: 'C', text: { en: 'Vortex', ar: 'دوامة' } },
      { id: 'D', text: { en: 'Geyser', ar: 'نافورة حارّة (غيزر)' } }
    ],
    correctOptionId: 'D',
    timeLimit: 30,
    xpReward: 10
  },
  {
    id: 'english-487',
    subject: QuizSubject.ENGLISH,
    difficulty: DifficultyLevel.EASY,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'What term is often used to describe an overused book that has folded or creased pages?', ar: 'What term is often used to describe an overused book that has folded or creased pages?' },
    options: [
      { id: 'A', text: { en: 'Pony-tailed', ar: 'Pony-tailed' } },
      { id: 'B', text: { en: 'Dog-eared', ar: 'Dog-eared' } },
      { id: 'C', text: { en: 'Cat-pawed', ar: 'Cat-pawed' } },
      { id: 'D', text: { en: 'Pig-headed', ar: 'Pig-headed' } }
    ],
    correctOptionId: 'B',
    timeLimit: 30,
    xpReward: 10
  },
  {
    id: 'english-488',
    subject: QuizSubject.ENGLISH,
    difficulty: DifficultyLevel.EASY,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'By definition, a person who is bilingual can do which of the following?', ar: 'By definition, a person who is bilingual can do which of the following?' },
    options: [
      { id: 'A', text: { en: 'Speak two languages', ar: 'Speak two languages' } },
      { id: 'B', text: { en: 'Write with either hand', ar: 'Write with either hand' } },
      { id: 'C', text: { en: 'Pilot a plane', ar: 'Pilot a plane' } },
      { id: 'D', text: { en: 'Rule the world', ar: 'Rule the world' } }
    ],
    correctOptionId: 'A',
    timeLimit: 30,
    xpReward: 10
  },
  {
    id: 'science-489',
    subject: QuizSubject.SCIENCE,
    difficulty: DifficultyLevel.EASY,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'What is the main food source of the giant panda?', ar: 'ما المصدر الغذائي الرئيسي لباندا العملاقة؟' },
    options: [
      { id: 'A', text: { en: 'Bamboo', ar: 'الخيزران' } },
      { id: 'B', text: { en: 'Eucalyptus', ar: 'الكينا' } },
      { id: 'C', text: { en: 'Sap', ar: 'العصارة' } },
      { id: 'D', text: { en: 'Fish', ar: 'السمك' } }
    ],
    correctOptionId: 'A',
    timeLimit: 30,
    xpReward: 10
  },
  {
    id: 'english-490',
    subject: QuizSubject.ENGLISH,
    difficulty: DifficultyLevel.EASY,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'According to the popular saying, what "flies while you\'re having fun"?', ar: 'According to the popular saying, what "flies while you\'re having fun"?' },
    options: [
      { id: 'A', text: { en: 'Power', ar: 'Power' } },
      { id: 'B', text: { en: 'Time', ar: 'Time' } },
      { id: 'C', text: { en: 'Games', ar: 'Games' } },
      { id: 'D', text: { en: 'Food', ar: 'Food' } }
    ],
    correctOptionId: 'B',
    timeLimit: 30,
    xpReward: 10
  },
  {
    id: 'general-491',
    subject: QuizSubject.GENERAL,
    difficulty: DifficultyLevel.EASY,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'Which of the following devices is commonly used to control the action of a computer or arcade game?', ar: 'أيٌّ من الأجهزة التالية يُستخدم عادةً للتحكم بحركة لعبة كمبيوتر أو لعبة أركيد؟' },
    options: [
      { id: 'A', text: { en: 'Joystick', ar: 'عصا التحكم' } },
      { id: 'B', text: { en: 'Kid glove', ar: 'قفاز ناعم' } },
      { id: 'C', text: { en: 'Handlebar', ar: 'مقود الدراجة' } },
      { id: 'D', text: { en: 'Parents', ar: 'الوالدان' } }
    ],
    correctOptionId: 'A',
    timeLimit: 30,
    xpReward: 10
  },
  {
    id: 'general-492',
    subject: QuizSubject.GENERAL,
    difficulty: DifficultyLevel.MEDIUM,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'Which of the following is commonly used to thin paint?', ar: 'أيٌّ ممّا يلي يُستخدم عادةً لتخفيف الطلاء؟' },
    options: [
      { id: 'A', text: { en: 'Olive oil', ar: 'زيت الزيتون' } },
      { id: 'B', text: { en: 'Turpentine', ar: 'التربنتين' } },
      { id: 'C', text: { en: 'Detergent', ar: 'منظف' } },
      { id: 'D', text: { en: 'Ammonia', ar: 'الأمونيا' } }
    ],
    correctOptionId: 'B',
    timeLimit: 30,
    xpReward: 20
  },
  {
    id: 'english-493',
    subject: QuizSubject.ENGLISH,
    difficulty: DifficultyLevel.EASY,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'What term is generally used to describe a young bear?', ar: 'What term is generally used to describe a young bear?' },
    options: [
      { id: 'A', text: { en: 'Chick', ar: 'Chick' } },
      { id: 'B', text: { en: 'Cub', ar: 'Cub' } },
      { id: 'C', text: { en: 'Bunny', ar: 'Bunny' } },
      { id: 'D', text: { en: 'Ditka', ar: 'Ditka' } }
    ],
    correctOptionId: 'B',
    timeLimit: 30,
    xpReward: 10
  },
  {
    id: 'english-494',
    subject: QuizSubject.ENGLISH,
    difficulty: DifficultyLevel.EASY,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'When referring to intelligence, what does the letter "Q" stand for in the abbreviation "IQ"?', ar: 'When referring to intelligence, what does the letter "Q" stand for in the abbreviation "IQ"?' },
    options: [
      { id: 'A', text: { en: 'Quack', ar: 'Quack' } },
      { id: 'B', text: { en: 'Quirky', ar: 'Quirky' } },
      { id: 'C', text: { en: 'Quotient', ar: 'Quotient' } },
      { id: 'D', text: { en: 'Queasy', ar: 'Queasy' } }
    ],
    correctOptionId: 'C',
    timeLimit: 30,
    xpReward: 10
  },
  {
    id: 'science-495',
    subject: QuizSubject.SCIENCE,
    difficulty: DifficultyLevel.EASY,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'Ophthalmology deals with disorders of what part of the body?', ar: 'يتعامل طب العيون (Ophthalmology) مع اضطرابات أي جزء من الجسم؟' },
    options: [
      { id: 'A', text: { en: 'Feet', ar: 'القدمين' } },
      { id: 'B', text: { en: 'Nose', ar: 'الأنف' } },
      { id: 'C', text: { en: 'Eyes', ar: 'العينين' } },
      { id: 'D', text: { en: 'Throat', ar: 'الحلق' } }
    ],
    correctOptionId: 'C',
    timeLimit: 30,
    xpReward: 10
  },
  {
    id: 'english-496',
    subject: QuizSubject.ENGLISH,
    difficulty: DifficultyLevel.EASY,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'What term is used to describe a group of whales?', ar: 'What term is used to describe a group of whales?' },
    options: [
      { id: 'A', text: { en: 'Pod', ar: 'Pod' } },
      { id: 'B', text: { en: 'Troop', ar: 'Troop' } },
      { id: 'C', text: { en: 'Reef', ar: 'Reef' } },
      { id: 'D', text: { en: 'Pack', ar: 'Pack' } }
    ],
    correctOptionId: 'A',
    timeLimit: 30,
    xpReward: 10
  },
  {
    id: 'general-497',
    subject: QuizSubject.GENERAL,
    difficulty: DifficultyLevel.MEDIUM,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'What was the name of the first manned vehicle to touch down on the moon?', ar: 'ما اسم أول مركبة مأهولة هبطت على سطح القمر؟' },
    options: [
      { id: 'A', text: { en: 'Falcon', ar: 'فالكون' } },
      { id: 'B', text: { en: 'Voyager', ar: 'فوياجر' } },
      { id: 'C', text: { en: 'Eagle', ar: 'إيغل (النسر)' } },
      { id: 'D', text: { en: 'Columbia', ar: 'كولومبيا' } }
    ],
    correctOptionId: 'C',
    timeLimit: 30,
    xpReward: 20
  },
  {
    id: 'general-498',
    subject: QuizSubject.GENERAL,
    difficulty: DifficultyLevel.EASY,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'What precious gem does the manmade compound called cubic zirconia resemble?', ar: 'ما الحجر الكريم الذي يشبهه المركب الاصطناعي المسمى زركونيا مكعبة؟' },
    options: [
      { id: 'A', text: { en: 'Diamond', ar: 'الماس' } },
      { id: 'B', text: { en: 'Opal', ar: 'الأوبال' } },
      { id: 'C', text: { en: 'Turquoise', ar: 'الفيروز' } },
      { id: 'D', text: { en: 'Topaz', ar: 'التوباز' } }
    ],
    correctOptionId: 'A',
    timeLimit: 30,
    xpReward: 10
  },
  {
    id: 'math-499',
    subject: QuizSubject.MATH,
    difficulty: DifficultyLevel.EASY,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'How many colored sides are on an original Rubik\'s Cube?', ar: 'كم وجهاً ملوناً في مكعب روبيك الأصلي؟' },
    options: [
      { id: 'A', text: { en: '4', ar: '٤' } },
      { id: 'B', text: { en: '6', ar: '٦' } },
      { id: 'C', text: { en: '8', ar: '٨' } },
      { id: 'D', text: { en: '10', ar: '١٠' } }
    ],
    correctOptionId: 'B',
    timeLimit: 30,
    xpReward: 10
  },
  {
    id: 'general-500',
    subject: QuizSubject.GENERAL,
    difficulty: DifficultyLevel.EASY,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'A person is most likely to wear a life preserver while riding on which of the following?', ar: 'في أيٍّ ممّا يلي يرتدي الشخص سترة النجاة على الأرجح؟' },
    options: [
      { id: 'A', text: { en: 'Tractor', ar: 'جرّار' } },
      { id: 'B', text: { en: 'Speedboat', ar: 'قارب سريع' } },
      { id: 'C', text: { en: 'Subway', ar: 'قطار الأنفاق' } },
      { id: 'D', text: { en: 'Natural high', ar: 'نشوة طبيعية' } }
    ],
    correctOptionId: 'B',
    timeLimit: 30,
    xpReward: 10
  },
  {
    id: 'general-501',
    subject: QuizSubject.GENERAL,
    difficulty: DifficultyLevel.EASY,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'What is the Russian word for "no"?', ar: 'ما الكلمة الروسية لـ"لا"؟' },
    options: [
      { id: 'A', text: { en: 'Non', ar: 'Non' } },
      { id: 'B', text: { en: 'Nik', ar: 'Nik' } },
      { id: 'C', text: { en: 'Nyet', ar: 'Nyet (نيت)' } },
      { id: 'D', text: { en: 'Nosireebob', ar: 'Nosireebob' } }
    ],
    correctOptionId: 'C',
    timeLimit: 30,
    xpReward: 10
  },
  {
    id: 'general-502',
    subject: QuizSubject.GENERAL,
    difficulty: DifficultyLevel.EASY,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'Which of the following would most likely be sold in a hardware store?', ar: 'أيٌّ ممّا يلي قد يُباع في متجر أدوات منزلية؟' },
    options: [
      { id: 'A', text: { en: 'Hammer', ar: 'مطرقة' } },
      { id: 'B', text: { en: 'Perfume', ar: 'عطر' } },
      { id: 'C', text: { en: 'Corduroy pants', ar: 'بنطال كوردي' } },
      { id: 'D', text: { en: 'Giant cupcakes', ar: 'كب كيك عملاق' } }
    ],
    correctOptionId: 'A',
    timeLimit: 30,
    xpReward: 10
  },
  {
    id: 'general-503',
    subject: QuizSubject.GENERAL,
    difficulty: DifficultyLevel.MEDIUM,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'What is the main ingredient in a traditional frittata?', ar: 'ما المكوّن الرئيسي في طبق الفريتاتا التقليدي؟' },
    options: [
      { id: 'A', text: { en: 'Bread', ar: 'الخبز' } },
      { id: 'B', text: { en: 'Flour', ar: 'الطحين' } },
      { id: 'C', text: { en: 'Orange juice', ar: 'عصير برتقال' } },
      { id: 'D', text: { en: 'Eggs', ar: 'البيض' } }
    ],
    correctOptionId: 'D',
    timeLimit: 30,
    xpReward: 20
  },
  {
    id: 'english-504',
    subject: QuizSubject.ENGLISH,
    difficulty: DifficultyLevel.EASY,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'Which of the following terms means "a person who is overly concerned about unimportant matters"?', ar: 'Which of the following terms means "a person who is overly concerned about unimportant matters"?' },
    options: [
      { id: 'A', text: { en: 'Toadstool', ar: 'Toadstool' } },
      { id: 'B', text: { en: 'Worrywart', ar: 'Worrywart' } },
      { id: 'C', text: { en: 'Rock head', ar: 'Rock head' } },
      { id: 'D', text: { en: 'Tax auditor', ar: 'Tax auditor' } }
    ],
    correctOptionId: 'B',
    timeLimit: 30,
    xpReward: 10
  },
  {
    id: 'english-505',
    subject: QuizSubject.ENGLISH,
    difficulty: DifficultyLevel.EASY,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'A bus that has two levels is called what?', ar: 'A bus that has two levels is called what?' },
    options: [
      { id: 'A', text: { en: 'Double-decker', ar: 'Double-decker' } },
      { id: 'B', text: { en: 'Second-story', ar: 'Second-story' } },
      { id: 'C', text: { en: 'Twin-tower', ar: 'Twin-tower' } },
      { id: 'D', text: { en: 'Roomy', ar: 'Roomy' } }
    ],
    correctOptionId: 'A',
    timeLimit: 30,
    xpReward: 10
  },
  {
    id: 'science-506',
    subject: QuizSubject.SCIENCE,
    difficulty: DifficultyLevel.EASY,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'In what direction do most North American birds fly for the winter?', ar: 'في أي اتجاه تطير معظم الطيور في أمريكا الشمالية في فصل الشتاء؟' },
    options: [
      { id: 'A', text: { en: 'North', ar: 'الشمال' } },
      { id: 'B', text: { en: 'East', ar: 'الشرق' } },
      { id: 'C', text: { en: 'South', ar: 'الجنوب' } },
      { id: 'D', text: { en: 'Counterclockwise', ar: 'بعكس عقارب الساعة' } }
    ],
    correctOptionId: 'C',
    timeLimit: 30,
    xpReward: 10
  },
  {
    id: 'general-507',
    subject: QuizSubject.GENERAL,
    difficulty: DifficultyLevel.EASY,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'What fruit\'s name best describes the color of a ripe carrot?', ar: 'اسم أي فاكهة يصف لون الجزر الناضج بشكل أفضل؟' },
    options: [
      { id: 'A', text: { en: 'Orange', ar: 'البرتقال' } },
      { id: 'B', text: { en: 'Peach', ar: 'الخوخ' } },
      { id: 'C', text: { en: 'Grape', ar: 'العنب' } },
      { id: 'D', text: { en: 'Kumquat', ar: 'الكمكوات' } }
    ],
    correctOptionId: 'A',
    timeLimit: 30,
    xpReward: 10
  },
  {
    id: 'math-508',
    subject: QuizSubject.MATH,
    difficulty: DifficultyLevel.EASY,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'What shape is an A-frame house?', ar: 'ما شكل البيت من نوع "A-frame"؟' },
    options: [
      { id: 'A', text: { en: 'Square', ar: 'مربع' } },
      { id: 'B', text: { en: 'Rectangular', ar: 'مستطيل' } },
      { id: 'C', text: { en: 'Triangular', ar: 'مثلث' } },
      { id: 'D', text: { en: 'Round', ar: 'مستدير' } }
    ],
    correctOptionId: 'C',
    timeLimit: 30,
    xpReward: 10
  },
  {
    id: 'science-509',
    subject: QuizSubject.SCIENCE,
    difficulty: DifficultyLevel.MEDIUM,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'Having no known function, the appendix is a tubelike organ that is attached to what part of the human body?', ar: 'لا توجد له وظيفة معروفة، الزائدة الدودية عضو أنبوبي متصل بأي جزء من جسم الإنسان؟' },
    options: [
      { id: 'A', text: { en: 'Gall bladder', ar: 'المرارة' } },
      { id: 'B', text: { en: 'Stomach', ar: 'المعدة' } },
      { id: 'C', text: { en: 'Large intestine', ar: 'الأمعاء الغليظة' } },
      { id: 'D', text: { en: 'Pancreas', ar: 'البنكرياس' } }
    ],
    correctOptionId: 'C',
    timeLimit: 30,
    xpReward: 20
  },
  {
    id: 'english-510',
    subject: QuizSubject.ENGLISH,
    difficulty: DifficultyLevel.MEDIUM,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'In the famous Grimm\'s fairy tale, the Pied Piper of Hamelin is described as "pied" because he does what?', ar: 'In the famous Grimm\'s fairy tale, the Pied Piper of Hamelin is described as "pied" because he does what?' },
    options: [
      { id: 'A', text: { en: 'Talks to animals', ar: 'Talks to animals' } },
      { id: 'B', text: { en: 'Wears colorful clothing', ar: 'Wears colorful clothing' } },
      { id: 'C', text: { en: 'Uses magic', ar: 'Uses magic' } },
      { id: 'D', text: { en: 'Seeks revenge', ar: 'Seeks revenge' } }
    ],
    correctOptionId: 'B',
    timeLimit: 30,
    xpReward: 20
  },
  {
    id: 'general-511',
    subject: QuizSubject.GENERAL,
    difficulty: DifficultyLevel.EASY,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'What type of vehicle is often stored in a rail yard?', ar: 'ما نوع المركبة التي تُحفظ غالباً في ساحة السكك الحديدية؟' },
    options: [
      { id: 'A', text: { en: 'Sailboat', ar: 'قارب شراعي' } },
      { id: 'B', text: { en: 'Bicycle', ar: 'دراجة' } },
      { id: 'C', text: { en: 'Train', ar: 'قطار' } },
      { id: 'D', text: { en: 'Airplane', ar: 'طائرة' } }
    ],
    correctOptionId: 'C',
    timeLimit: 30,
    xpReward: 10
  },
  {
    id: 'general-512',
    subject: QuizSubject.GENERAL,
    difficulty: DifficultyLevel.MEDIUM,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'What European country\'s mainland comes closest to Africa without actually touching it?', ar: 'أيُّ بلد أوروبي تقترب أراضيه القارّية من أفريقيا أكثر من غيره دون أن تلامسها؟' },
    options: [
      { id: 'A', text: { en: 'Greece', ar: 'اليونان' } },
      { id: 'B', text: { en: 'Spain', ar: 'إسبانيا' } },
      { id: 'C', text: { en: 'Italy', ar: 'إيطاليا' } },
      { id: 'D', text: { en: 'Portugal', ar: 'البرتغال' } }
    ],
    correctOptionId: 'B',
    timeLimit: 30,
    xpReward: 20
  },
  {
    id: 'science-513',
    subject: QuizSubject.SCIENCE,
    difficulty: DifficultyLevel.EASY,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'What part of the body suffers from fallen arches?', ar: 'أي جزء من الجسم يعاني من سقوط القوس (الأقواس الساقطة)؟' },
    options: [
      { id: 'A', text: { en: 'Eyebrow', ar: 'الحاجب' } },
      { id: 'B', text: { en: 'Feet', ar: 'القدمين' } },
      { id: 'C', text: { en: 'Heart', ar: 'القلب' } },
      { id: 'D', text: { en: 'The McNuggets', ar: 'الماك ناغتس' } }
    ],
    correctOptionId: 'B',
    timeLimit: 30,
    xpReward: 10
  },
  {
    id: 'general-514',
    subject: QuizSubject.GENERAL,
    difficulty: DifficultyLevel.MEDIUM,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'The historic European city of Toledo is located in what country?', ar: 'تقع مدينة طليطلة الأوروبية التاريخية في أي بلد؟' },
    options: [
      { id: 'A', text: { en: 'Italy', ar: 'إيطاليا' } },
      { id: 'B', text: { en: 'Portugal', ar: 'البرتغال' } },
      { id: 'C', text: { en: 'Spain', ar: 'إسبانيا' } },
      { id: 'D', text: { en: 'Sweden', ar: 'السويد' } }
    ],
    correctOptionId: 'C',
    timeLimit: 30,
    xpReward: 20
  },
  {
    id: 'science-515',
    subject: QuizSubject.SCIENCE,
    difficulty: DifficultyLevel.EASY,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'What is the proper term for the center of an atom?', ar: 'ما المصطلح الصحيح لمركز الذرة؟' },
    options: [
      { id: 'A', text: { en: 'Nucleus', ar: 'النواة' } },
      { id: 'B', text: { en: 'Electron', ar: 'الإلكترون' } },
      { id: 'C', text: { en: 'Molecule', ar: 'الجزيء' } },
      { id: 'D', text: { en: 'Lepton', ar: 'الليبتون' } }
    ],
    correctOptionId: 'A',
    timeLimit: 30,
    xpReward: 10
  },
  {
    id: 'general-516',
    subject: QuizSubject.GENERAL,
    difficulty: DifficultyLevel.MEDIUM,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'Used to describe how pasta should be cooked, "al dente" is an Italian phrase meaning "to the" what?', ar: 'تُستخدم لوصف كيفية طهي المعكرونة، "أل دينتي" عبارة إيطالية تعني "إلى..." ماذا؟' },
    options: [
      { id: 'A', text: { en: 'Tongue', ar: 'اللسان' } },
      { id: 'B', text: { en: 'Tooth', ar: 'السن' } },
      { id: 'C', text: { en: 'Lips', ar: 'الشفتين' } },
      { id: 'D', text: { en: 'Nose', ar: 'الأنف' } }
    ],
    correctOptionId: 'B',
    timeLimit: 30,
    xpReward: 20
  },
  {
    id: 'general-517',
    subject: QuizSubject.GENERAL,
    difficulty: DifficultyLevel.EASY,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'Which of these does not belong in a zoo?', ar: 'أيٌّ ممّا يلي لا ينتمي إلى حديقة الحيوان؟' },
    options: [
      { id: 'A', text: { en: 'Gibbon', ar: 'الجيبون' } },
      { id: 'B', text: { en: 'Koala', ar: 'الكوالا' } },
      { id: 'C', text: { en: 'Baboon', ar: 'البابون' } },
      { id: 'D', text: { en: 'Human being', ar: 'الإنسان' } }
    ],
    correctOptionId: 'D',
    timeLimit: 30,
    xpReward: 10
  },
  {
    id: 'general-518',
    subject: QuizSubject.GENERAL,
    difficulty: DifficultyLevel.HARD,
    gradeRange: { min: 6, max: 8 },
    text: { en: 'When Europeans saw Native Americans using it to ease kidney pain, what gem was given a Spanish name meaning "stone of the loins"?', ar: 'عندما رأى الأوروبيون الأمريكيين الأصليين يستخدمونه لتسكين ألم الكلى، أي حجر كريم أُعطي اسماً إسبانياً يعني "حجر الخواصر"؟' },
    options: [
      { id: 'A', text: { en: 'Ruby', ar: 'الياقوت' } },
      { id: 'B', text: { en: 'Pearl', ar: 'اللؤلؤ' } },
      { id: 'C', text: { en: 'Jade', ar: 'اليشم' } },
      { id: 'D', text: { en: 'Topaz', ar: 'التوباز' } }
    ],
    correctOptionId: 'C',
    timeLimit: 30,
    xpReward: 35
  },
  {
    id: 'general-519',
    subject: QuizSubject.GENERAL,
    difficulty: DifficultyLevel.EASY,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'Which of these is NOT the name of one of history\'s most powerful ruling empires?', ar: 'أيٌّ ممّا يلي ليس اسماً لإحدى أقوى الإمبراطوريات الحاكمة في التاريخ؟' },
    options: [
      { id: 'A', text: { en: 'Persian Empire', ar: 'الإمبراطورية الفارسية' } },
      { id: 'B', text: { en: 'Holy Roman Empire', ar: 'الإمبراطورية الرومانية المقدسة' } },
      { id: 'C', text: { en: 'Ottoman Empire', ar: 'الإمبراطورية العثمانية' } },
      { id: 'D', text: { en: 'Galactic Empire', ar: 'الإمبراطورية المجرية' } }
    ],
    correctOptionId: 'D',
    timeLimit: 30,
    xpReward: 10
  },
  {
    id: 'general-520',
    subject: QuizSubject.GENERAL,
    difficulty: DifficultyLevel.MEDIUM,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'Due to the nature of the footwork involved, what sport\'s shoes commonly feature spikes in the heel?', ar: 'بسبب طبيعة العمل بالقدمين، أحذية أي رياضة تحتوي عادةً على مسامير في الكعب؟' },
    options: [
      { id: 'A', text: { en: 'Bowling', ar: 'البولينغ' } },
      { id: 'B', text: { en: 'High jump', ar: 'الوثب العالي' } },
      { id: 'C', text: { en: 'Beach volleyball', ar: 'الكرة الطائرة الشاطئية' } },
      { id: 'D', text: { en: 'Wrestling', ar: 'المصارعة' } }
    ],
    correctOptionId: 'B',
    timeLimit: 30,
    xpReward: 20
  },
  {
    id: 'general-521',
    subject: QuizSubject.GENERAL,
    difficulty: DifficultyLevel.EASY,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'A spot of light on a radar screen that shows the position of a plane is called what?', ar: 'ما اسم نقطة الضوء على شاشة الرادار التي تظهر موقع الطائرة؟' },
    options: [
      { id: 'A', text: { en: 'Blip', ar: 'بليب' } },
      { id: 'B', text: { en: 'Blob', ar: 'نقطة' } },
      { id: 'C', text: { en: 'Block', ar: 'كتلة' } },
      { id: 'D', text: { en: 'Time for Windex', ar: 'وقت الويندكس' } }
    ],
    correctOptionId: 'A',
    timeLimit: 30,
    xpReward: 10
  },
  {
    id: 'english-522',
    subject: QuizSubject.ENGLISH,
    difficulty: DifficultyLevel.EASY,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'The name of what part of the pizza is also slang for "money"?', ar: 'The name of what part of the pizza is also slang for "money"?' },
    options: [
      { id: 'A', text: { en: 'Dough', ar: 'Dough' } },
      { id: 'B', text: { en: 'Tomato sauce', ar: 'Tomato sauce' } },
      { id: 'C', text: { en: 'Cheese', ar: 'Cheese' } },
      { id: 'D', text: { en: 'Heartburn', ar: 'Heartburn' } }
    ],
    correctOptionId: 'A',
    timeLimit: 30,
    xpReward: 10
  },
  {
    id: 'science-523',
    subject: QuizSubject.SCIENCE,
    difficulty: DifficultyLevel.EASY,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'Which of these is the proper name for a female rabbit?', ar: 'أيٌّ ممّا يلي اسم الإناث من الأرانب؟' },
    options: [
      { id: 'A', text: { en: 'Bess', ar: 'بيس' } },
      { id: 'B', text: { en: 'Doe', ar: 'دو (الأنثى)' } },
      { id: 'C', text: { en: 'Chick', ar: 'كتكوت' } },
      { id: 'D', text: { en: 'Jen', ar: 'جين' } }
    ],
    correctOptionId: 'B',
    timeLimit: 30,
    xpReward: 10
  },
  {
    id: 'general-524',
    subject: QuizSubject.GENERAL,
    difficulty: DifficultyLevel.EASY,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'When its lid is being sealed, Tupperware is famously said to make what humanlike sound?', ar: 'عند إغلاق غطائها، تُشتهر علب توبروير بإصدار أي صوت يشبه الإنسان؟' },
    options: [
      { id: 'A', text: { en: 'Cough', ar: 'السعال' } },
      { id: 'B', text: { en: 'Hiccup', ar: 'الفُواق' } },
      { id: 'C', text: { en: 'Burp', ar: 'التجشؤ' } },
      { id: 'D', text: { en: 'Sneeze', ar: 'العطس' } }
    ],
    correctOptionId: 'C',
    timeLimit: 30,
    xpReward: 10
  },
  {
    id: 'english-525',
    subject: QuizSubject.ENGLISH,
    difficulty: DifficultyLevel.EASY,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'A person who is temporarily in charge is commonly asked to "hold the" what?', ar: 'A person who is temporarily in charge is commonly asked to "hold the" what?' },
    options: [
      { id: 'A', text: { en: 'Castle', ar: 'Castle' } },
      { id: 'B', text: { en: 'Barn', ar: 'Barn' } },
      { id: 'C', text: { en: 'Fort', ar: 'Fort' } },
      { id: 'D', text: { en: 'Mayo', ar: 'Mayo' } }
    ],
    correctOptionId: 'C',
    timeLimit: 30,
    xpReward: 10
  },
  {
    id: 'english-526',
    subject: QuizSubject.ENGLISH,
    difficulty: DifficultyLevel.MEDIUM,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'How often does a biannual event occur?', ar: 'How often does a biannual event occur?' },
    options: [
      { id: 'A', text: { en: 'Once a year', ar: 'Once a year' } },
      { id: 'B', text: { en: 'Once every 3 years', ar: 'Once every 3 years' } },
      { id: 'C', text: { en: 'Twice a year', ar: 'Twice a year' } },
      { id: 'D', text: { en: 'Check local listings', ar: 'Check local listings' } }
    ],
    correctOptionId: 'C',
    timeLimit: 30,
    xpReward: 20
  },
  {
    id: 'general-527',
    subject: QuizSubject.GENERAL,
    difficulty: DifficultyLevel.EASY,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'In a swimming relay, a swimmer finishes his leg of the race by doing what?', ar: 'في سباق التتابع للسباحة، ينهي السباح مرحلته من السباق بفعل ماذا؟' },
    options: [
      { id: 'A', text: { en: 'Touching pool wall', ar: 'لمس جدار المسبح' } },
      { id: 'B', text: { en: 'Lighting torch', ar: 'إشعال الشعلة' } },
      { id: 'C', text: { en: 'Passing baton', ar: 'تسليم العصا' } },
      { id: 'D', text: { en: 'Belly-flopping', ar: 'السقوط على البطن' } }
    ],
    correctOptionId: 'A',
    timeLimit: 30,
    xpReward: 10
  },
  {
    id: 'english-528',
    subject: QuizSubject.ENGLISH,
    difficulty: DifficultyLevel.EASY,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'In cooking, what is another word for "broth"?', ar: 'In cooking, what is another word for "broth"?' },
    options: [
      { id: 'A', text: { en: 'Bond', ar: 'Bond' } },
      { id: 'B', text: { en: 'Roast', ar: 'Roast' } },
      { id: 'C', text: { en: 'Stock', ar: 'Stock' } },
      { id: 'D', text: { en: 'Lard', ar: 'Lard' } }
    ],
    correctOptionId: 'C',
    timeLimit: 30,
    xpReward: 10
  },
  {
    id: 'general-529',
    subject: QuizSubject.GENERAL,
    difficulty: DifficultyLevel.EASY,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'Which of these cat breeds has long hair?', ar: 'أيٌّ من سلالات القطط التالية شعرها طويل؟' },
    options: [
      { id: 'A', text: { en: 'Persian', ar: 'الفارسي' } },
      { id: 'B', text: { en: 'Siamese', ar: 'السيامي' } },
      { id: 'C', text: { en: 'Burmese', ar: 'البورمي' } },
      { id: 'D', text: { en: 'Russian Blue', ar: 'الأزرق الروسي' } }
    ],
    correctOptionId: 'A',
    timeLimit: 30,
    xpReward: 10
  },
  {
    id: 'general-530',
    subject: QuizSubject.GENERAL,
    difficulty: DifficultyLevel.EASY,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'A fireplace opening is located at the base of what?', ar: 'تقع فتحة المدفأة عند قاعدة ماذا؟' },
    options: [
      { id: 'A', text: { en: 'Refrigerator', ar: 'الثلاجة' } },
      { id: 'B', text: { en: 'Window', ar: 'النافذة' } },
      { id: 'C', text: { en: 'Chimney', ar: 'المدخنة' } },
      { id: 'D', text: { en: 'Mount Everest', ar: 'جبل إيفرست' } }
    ],
    correctOptionId: 'C',
    timeLimit: 30,
    xpReward: 10
  },
  {
    id: 'general-531',
    subject: QuizSubject.GENERAL,
    difficulty: DifficultyLevel.MEDIUM,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'People commonly ride in gondolas while participating in which of these leisure activities?', ar: 'غالباً ما يركب الناس في عربات التلفريك (gondolas) أثناء مشاركتهم في أيٍّ من هذه الأنشطة الترفيهية؟' },
    options: [
      { id: 'A', text: { en: 'Golf', ar: 'الغولف' } },
      { id: 'B', text: { en: 'Polo', ar: 'البولو' } },
      { id: 'C', text: { en: 'Skiing', ar: 'التزلج' } },
      { id: 'D', text: { en: 'Biking', ar: 'ركوب الدراجات' } }
    ],
    correctOptionId: 'C',
    timeLimit: 30,
    xpReward: 20
  },
  {
    id: 'english-532',
    subject: QuizSubject.ENGLISH,
    difficulty: DifficultyLevel.MEDIUM,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'What is the translation of the Latin question "Et tu, Brute?"', ar: 'What is the translation of the Latin question "Et tu, Brute?"' },
    options: [
      { id: 'A', text: { en: 'Are you Brutus?', ar: 'Are you Brutus?' } },
      { id: 'B', text: { en: 'Me too, Brutus?', ar: 'Me too, Brutus?' } },
      { id: 'C', text: { en: 'What now, Beast?', ar: 'What now, Beast?' } },
      { id: 'D', text: { en: 'And you, Brutus?', ar: 'And you, Brutus?' } }
    ],
    correctOptionId: 'D',
    timeLimit: 30,
    xpReward: 20
  },
  {
    id: 'general-533',
    subject: QuizSubject.GENERAL,
    difficulty: DifficultyLevel.EASY,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'Which of these household appliances often features an ice maker?', ar: 'أيٌّ من أجهزة المنزل التالية يحتوي غالباً على صانعة ثلج؟' },
    options: [
      { id: 'A', text: { en: 'Microwave oven', ar: 'فرن الميكروويف' } },
      { id: 'B', text: { en: 'Garbage disposal', ar: 'طاحونة النفايات' } },
      { id: 'C', text: { en: 'Freezer', ar: 'المجمدة' } },
      { id: 'D', text: { en: 'Dishwasher', ar: 'غسالة الصحون' } }
    ],
    correctOptionId: 'C',
    timeLimit: 30,
    xpReward: 10
  },
  {
    id: 'science-534',
    subject: QuizSubject.SCIENCE,
    difficulty: DifficultyLevel.MEDIUM,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'Well-known to sailors in the tropics, winds that blow steadily from east to west and toward the equator are called what?', ar: 'معروفة لدى البحّارة في المناطق المدارية، ما اسم الرياح التي تهب بثبات من الشرق إلى الغرب نحو خط الاستواء؟' },
    options: [
      { id: 'A', text: { en: 'Pilot winds', ar: 'رياح الطيار' } },
      { id: 'B', text: { en: 'Lead winds', ar: 'رياح القائد' } },
      { id: 'C', text: { en: 'Diver winds', ar: 'رياح الغواص' } },
      { id: 'D', text: { en: 'Trade winds', ar: 'الرياح التجارية' } }
    ],
    correctOptionId: 'D',
    timeLimit: 30,
    xpReward: 20
  },
  {
    id: 'english-535',
    subject: QuizSubject.ENGLISH,
    difficulty: DifficultyLevel.MEDIUM,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'Which of the following letters has more than one syllable?', ar: 'Which of the following letters has more than one syllable?' },
    options: [
      { id: 'A', text: { en: 'A', ar: 'A' } },
      { id: 'B', text: { en: 'T', ar: 'T' } },
      { id: 'C', text: { en: 'W', ar: 'W' } },
      { id: 'D', text: { en: 'Live', ar: 'Live' } }
    ],
    correctOptionId: 'C',
    timeLimit: 30,
    xpReward: 20
  },
  {
    id: 'general-536',
    subject: QuizSubject.GENERAL,
    difficulty: DifficultyLevel.EASY,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'What is the name for a tract of low land between two mountains?', ar: 'ما اسم الأرض المنخفضة بين جبلين؟' },
    options: [
      { id: 'A', text: { en: 'Valley', ar: 'وادي' } },
      { id: 'B', text: { en: 'Gulf', ar: 'خليج' } },
      { id: 'C', text: { en: 'Cliff', ar: 'هاوية' } },
      { id: 'D', text: { en: 'Sinkhole', ar: 'بالوعة' } }
    ],
    correctOptionId: 'A',
    timeLimit: 30,
    xpReward: 10
  },
  {
    id: 'science-537',
    subject: QuizSubject.SCIENCE,
    difficulty: DifficultyLevel.EASY,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'What branch of science includes the study of dominant and recessive traits?', ar: 'ما فرع العلم الذي يشمل دراسة الصفات السائدة والمتنحية؟' },
    options: [
      { id: 'A', text: { en: 'Geology', ar: 'علم الأرض' } },
      { id: 'B', text: { en: 'Cosmology', ar: 'علم الكون' } },
      { id: 'C', text: { en: 'Ecology', ar: 'علم البيئة' } },
      { id: 'D', text: { en: 'Genetics', ar: 'علم الوراثة' } }
    ],
    correctOptionId: 'D',
    timeLimit: 30,
    xpReward: 10
  },
  {
    id: 'science-538',
    subject: QuizSubject.SCIENCE,
    difficulty: DifficultyLevel.MEDIUM,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'Which of the following spices comes from the small dried flower buds of a tropical tree?', ar: 'أيٌّ من البهارات التالية يأتي من براعم زهور صغيرة مجففة لشجرة استوائية؟' },
    options: [
      { id: 'A', text: { en: 'Nutmeg', ar: 'جوزة الطيب' } },
      { id: 'B', text: { en: 'Clove', ar: 'القرنفل' } },
      { id: 'C', text: { en: 'Turmeric', ar: 'الكركم' } },
      { id: 'D', text: { en: 'Paprika', ar: 'الفلفل الحلو' } }
    ],
    correctOptionId: 'B',
    timeLimit: 30,
    xpReward: 20
  },
  {
    id: 'general-539',
    subject: QuizSubject.GENERAL,
    difficulty: DifficultyLevel.EASY,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'A helipad is a common feature on the roof of which of these places?', ar: 'مهبط الطائرات المروحية ميزة شائعة على سطح أيٍّ من هذه الأماكن؟' },
    options: [
      { id: 'A', text: { en: 'Barbershop', ar: 'محل حلاقة' } },
      { id: 'B', text: { en: 'Library', ar: 'مكتبة' } },
      { id: 'C', text: { en: 'Hospital', ar: 'مستشفى' } },
      { id: 'D', text: { en: 'Playground', ar: 'ملعب' } }
    ],
    correctOptionId: 'C',
    timeLimit: 30,
    xpReward: 10
  },
  {
    id: 'english-540',
    subject: QuizSubject.ENGLISH,
    difficulty: DifficultyLevel.EASY,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'Three books by the same author that deal with a related theme are known as what?', ar: 'Three books by the same author that deal with a related theme are known as what?' },
    options: [
      { id: 'A', text: { en: 'Tribune', ar: 'Tribune' } },
      { id: 'B', text: { en: 'Trilogy', ar: 'Trilogy' } },
      { id: 'C', text: { en: 'Triple play', ar: 'Triple play' } },
      { id: 'D', text: { en: 'Snoozefest', ar: 'Snoozefest' } }
    ],
    correctOptionId: 'B',
    timeLimit: 30,
    xpReward: 10
  },
  {
    id: 'science-541',
    subject: QuizSubject.SCIENCE,
    difficulty: DifficultyLevel.MEDIUM,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'What kind of animal is an ibex?', ar: 'ما نوع الحيوان المعروف بـ"الوعل"؟' },
    options: [
      { id: 'A', text: { en: 'Goat', ar: 'ماعز' } },
      { id: 'B', text: { en: 'Bird', ar: 'طائر' } },
      { id: 'C', text: { en: 'Cat', ar: 'قط' } },
      { id: 'D', text: { en: 'Deer', ar: 'غزال' } }
    ],
    correctOptionId: 'A',
    timeLimit: 30,
    xpReward: 20
  },
  {
    id: 'general-542',
    subject: QuizSubject.GENERAL,
    difficulty: DifficultyLevel.EASY,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'Which of these girls\' names is also the name for a type of gemstone?', ar: 'أيٌّ من أسماء البنات التالية هو أيضاً اسم لنوع من الأحجار الكريمة؟' },
    options: [
      { id: 'A', text: { en: 'Alice', ar: 'أليس' } },
      { id: 'B', text: { en: 'Ruby', ar: 'روبي (الياقوت)' } },
      { id: 'C', text: { en: 'Patricia', ar: 'باتريشيا' } },
      { id: 'D', text: { en: 'Blingface', ar: 'بلينغفيس' } }
    ],
    correctOptionId: 'B',
    timeLimit: 30,
    xpReward: 10
  },
  {
    id: 'english-543',
    subject: QuizSubject.ENGLISH,
    difficulty: DifficultyLevel.EASY,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'A person who is annoying another person is often said to be "ruffling" what?', ar: 'A person who is annoying another person is often said to be "ruffling" what?' },
    options: [
      { id: 'A', text: { en: 'Fins', ar: 'Fins' } },
      { id: 'B', text: { en: 'Scales', ar: 'Scales' } },
      { id: 'C', text: { en: 'Feathers', ar: 'Feathers' } },
      { id: 'D', text: { en: 'Antlers', ar: 'Antlers' } }
    ],
    correctOptionId: 'C',
    timeLimit: 30,
    xpReward: 10
  },
  {
    id: 'general-544',
    subject: QuizSubject.GENERAL,
    difficulty: DifficultyLevel.EASY,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'Which of the following is not classified as a wind instrument?', ar: 'أيٌّ ممّا يلي لا يُصنف من الآلات الهوائية؟' },
    options: [
      { id: 'A', text: { en: 'Flute', ar: 'الناي' } },
      { id: 'B', text: { en: 'French horn', ar: 'البوق الفرنسي' } },
      { id: 'C', text: { en: 'Bassoon', ar: 'الباصون' } },
      { id: 'D', text: { en: 'Xylophone', ar: 'الإكسيليفون' } }
    ],
    correctOptionId: 'D',
    timeLimit: 30,
    xpReward: 10
  },
  {
    id: 'general-545',
    subject: QuizSubject.GENERAL,
    difficulty: DifficultyLevel.EASY,
    gradeRange: { min: 5, max: 8 },
    text: { en: '"Bareknuckle" is a word often used to describe an equipment-free version of what sport?', ar: '"بير ناكِل" كلمة تُستخدم لوصف نسخة بدون معدات من أي رياضة؟' },
    options: [
      { id: 'A', text: { en: 'Tennis', ar: 'التنس' } },
      { id: 'B', text: { en: 'Baseball', ar: 'البيسبول' } },
      { id: 'C', text: { en: 'Boxing', ar: 'الملاكمة' } },
      { id: 'D', text: { en: 'Golf', ar: 'الغولف' } }
    ],
    correctOptionId: 'C',
    timeLimit: 30,
    xpReward: 10
  },
  {
    id: 'general-546',
    subject: QuizSubject.GENERAL,
    difficulty: DifficultyLevel.EASY,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'Which of these paint varieties has the shiniest finish?', ar: 'أيٌّ من أنواع الطلاء التالية لها أكثر تشطيب لامع؟' },
    options: [
      { id: 'A', text: { en: 'Gloss', ar: 'لامع' } },
      { id: 'B', text: { en: 'Eggshell', ar: 'قشر البيض' } },
      { id: 'C', text: { en: 'Satin', ar: 'ساتان' } },
      { id: 'D', text: { en: 'Flat', ar: 'مطفي' } }
    ],
    correctOptionId: 'A',
    timeLimit: 30,
    xpReward: 10
  },
  {
    id: 'general-547',
    subject: QuizSubject.GENERAL,
    difficulty: DifficultyLevel.EASY,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'What does a "boom box" do?', ar: 'ما الذي يفعله جهاز "بوم بوكس"؟' },
    options: [
      { id: 'A', text: { en: 'Play music', ar: 'يشغّل الموسيقى' } },
      { id: 'B', text: { en: 'Demolish buildings', ar: 'يهدم المباني' } },
      { id: 'C', text: { en: 'Throw punches', ar: 'يلكم' } },
      { id: 'D', text: { en: 'Break dance', ar: 'يرقص بريك دانس' } }
    ],
    correctOptionId: 'A',
    timeLimit: 30,
    xpReward: 10
  },
  {
    id: 'general-548',
    subject: QuizSubject.GENERAL,
    difficulty: DifficultyLevel.MEDIUM,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'Which of the following types of pasta is shaped like a corkscrew?', ar: 'أيٌّ من أنواع المعكرونة التالية يأخذ شكل بريمة فتاحة الزجاجات؟' },
    options: [
      { id: 'A', text: { en: 'Fettucini', ar: 'فيتوتشيني' } },
      { id: 'B', text: { en: 'Tortellini', ar: 'تورتيليني' } },
      { id: 'C', text: { en: 'Spaghetti', ar: 'سباغيتي' } },
      { id: 'D', text: { en: 'Fusilli', ar: 'فوزيلي' } }
    ],
    correctOptionId: 'D',
    timeLimit: 30,
    xpReward: 20
  },
  {
    id: 'science-549',
    subject: QuizSubject.SCIENCE,
    difficulty: DifficultyLevel.EASY,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'Which of the following tree leaves are a koala bear\'s primary source of food?', ar: 'أيٌّ من أوراق الأشجار التالية تُعدّ المصدر الغذائي الأساسي للكوالا؟' },
    options: [
      { id: 'A', text: { en: 'Gingko', ar: 'الجنكة' } },
      { id: 'B', text: { en: 'Sumac', ar: 'السماق' } },
      { id: 'C', text: { en: 'Eucalyptus', ar: 'الكينا' } },
      { id: 'D', text: { en: 'Dogwood', ar: 'القرانيا' } }
    ],
    correctOptionId: 'C',
    timeLimit: 30,
    xpReward: 10
  },
  {
    id: 'general-550',
    subject: QuizSubject.GENERAL,
    difficulty: DifficultyLevel.EASY,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'Which of the following characters is not considered a "Pokémon"?', ar: 'أيٌّ من الشخصيات التالية لا تُعدّ من شخصيات بوكيمون؟' },
    options: [
      { id: 'A', text: { en: 'Jigglypuff', ar: 'جيغليبف' } },
      { id: 'B', text: { en: 'Frodo', ar: 'فرودو' } },
      { id: 'C', text: { en: 'Squirtle', ar: 'سكويرتل' } },
      { id: 'D', text: { en: 'Pikachu', ar: 'بيكاتشو' } }
    ],
    correctOptionId: 'B',
    timeLimit: 30,
    xpReward: 10
  },
  {
    id: 'general-551',
    subject: QuizSubject.GENERAL,
    difficulty: DifficultyLevel.EASY,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'What food is said to be shaped to resemble arms folded in prayer?', ar: 'أيٌّ من الأطعمة يُقال إنه يأخذ شكل ذراعين مطويتين في صلاة؟' },
    options: [
      { id: 'A', text: { en: 'Bagel', ar: 'البيغل' } },
      { id: 'B', text: { en: 'Pretzel', ar: 'البريتزل' } },
      { id: 'C', text: { en: 'Funnel cake', ar: 'كعكة القُمع' } },
      { id: 'D', text: { en: 'Hot cross bun', ar: 'الكعك الصليبي الساخن' } }
    ],
    correctOptionId: 'B',
    timeLimit: 30,
    xpReward: 10
  },
  {
    id: 'science-552',
    subject: QuizSubject.SCIENCE,
    difficulty: DifficultyLevel.EASY,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'In what position does the winged mammal known as a bat normally rest?', ar: 'في أي وضع يستريح الخفاش (الثدييات المجنحة) عادةً؟' },
    options: [
      { id: 'A', text: { en: 'On its side', ar: 'على جنبه' } },
      { id: 'B', text: { en: 'On its back', ar: 'على ظهره' } },
      { id: 'C', text: { en: 'On its stomach', ar: 'على بطنه' } },
      { id: 'D', text: { en: 'Upside-down', ar: 'معكوساً' } }
    ],
    correctOptionId: 'D',
    timeLimit: 30,
    xpReward: 10
  },
  {
    id: 'english-553',
    subject: QuizSubject.ENGLISH,
    difficulty: DifficultyLevel.EASY,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'By profession, what does a cobbler make?', ar: 'By profession, what does a cobbler make?' },
    options: [
      { id: 'A', text: { en: 'Hats', ar: 'Hats' } },
      { id: 'B', text: { en: 'Watches', ar: 'Watches' } },
      { id: 'C', text: { en: 'Shoes', ar: 'Shoes' } },
      { id: 'D', text: { en: 'Jewelry', ar: 'Jewelry' } }
    ],
    correctOptionId: 'C',
    timeLimit: 30,
    xpReward: 10
  },
  {
    id: 'general-554',
    subject: QuizSubject.GENERAL,
    difficulty: DifficultyLevel.EASY,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'Gorgonzola is a type of what?', ar: 'الغورغونزولا نوع من ماذا؟' },
    options: [
      { id: 'A', text: { en: 'Meat', ar: 'اللحم' } },
      { id: 'B', text: { en: 'Cheese', ar: 'الجبن' } },
      { id: 'C', text: { en: 'Fruit', ar: 'الفاكهة' } },
      { id: 'D', text: { en: 'Car', ar: 'السيارة' } }
    ],
    correctOptionId: 'B',
    timeLimit: 30,
    xpReward: 10
  },
  {
    id: 'general-555',
    subject: QuizSubject.GENERAL,
    difficulty: DifficultyLevel.MEDIUM,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'What does the \'B\' stand for in the acronym \'SCUBA\'?', ar: 'ماذا يرمز حرف B في الاختصار SCUBA؟' },
    options: [
      { id: 'A', text: { en: 'Blowing', ar: 'النفخ' } },
      { id: 'B', text: { en: 'Basic', ar: 'أساسي' } },
      { id: 'C', text: { en: 'Breathing', ar: 'التنفس' } },
      { id: 'D', text: { en: 'Binary', ar: 'الثنائي' } }
    ],
    correctOptionId: 'C',
    timeLimit: 30,
    xpReward: 20
  },
  {
    id: 'math-556',
    subject: QuizSubject.MATH,
    difficulty: DifficultyLevel.EASY,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'How many spaces are there on a typical tic-tac-toe board?', ar: 'كم عدد المربعات في لوحة لعبة الـX-O النموذجية؟' },
    options: [
      { id: 'A', text: { en: '6', ar: '٦' } },
      { id: 'B', text: { en: '7', ar: '٧' } },
      { id: 'C', text: { en: '8', ar: '٨' } },
      { id: 'D', text: { en: '9', ar: '٩' } }
    ],
    correctOptionId: 'D',
    timeLimit: 30,
    xpReward: 10
  },
  {
    id: 'english-557',
    subject: QuizSubject.ENGLISH,
    difficulty: DifficultyLevel.EASY,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'An item that suits something perfectly is said to "fit like a" what?', ar: 'An item that suits something perfectly is said to "fit like a" what?' },
    options: [
      { id: 'A', text: { en: 'Cape', ar: 'Cape' } },
      { id: 'B', text: { en: 'Glove', ar: 'Glove' } },
      { id: 'C', text: { en: 'Poncho', ar: 'Poncho' } },
      { id: 'D', text: { en: 'Wrestler\'s unitard', ar: 'Wrestler\'s unitard' } }
    ],
    correctOptionId: 'B',
    timeLimit: 30,
    xpReward: 10
  },
  {
    id: 'general-558',
    subject: QuizSubject.GENERAL,
    difficulty: DifficultyLevel.EASY,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'What household item is usually placed on top of a box spring?', ar: 'ما الغرض المنزلي الذي يُوضع عادةً فوق صندوق الزنبركات (بوكس سبرينغ)؟' },
    options: [
      { id: 'A', text: { en: 'Mattress', ar: 'المرتبة' } },
      { id: 'B', text: { en: 'Grill', ar: 'الشواية' } },
      { id: 'C', text: { en: 'Light bulb', ar: 'المصباح' } },
      { id: 'D', text: { en: 'Ejector seat', ar: 'مقعد القذف' } }
    ],
    correctOptionId: 'A',
    timeLimit: 30,
    xpReward: 10
  },
  {
    id: 'english-559',
    subject: QuizSubject.ENGLISH,
    difficulty: DifficultyLevel.EASY,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'An agreement that is canceled is said to be "null and" what?', ar: 'An agreement that is canceled is said to be "null and" what?' },
    options: [
      { id: 'A', text: { en: 'Nonsense', ar: 'Nonsense' } },
      { id: 'B', text: { en: 'Void', ar: 'Void' } },
      { id: 'C', text: { en: 'Slim', ar: 'Slim' } },
      { id: 'D', text: { en: 'Under litigation', ar: 'Under litigation' } }
    ],
    correctOptionId: 'B',
    timeLimit: 30,
    xpReward: 10
  },
  {
    id: 'general-560',
    subject: QuizSubject.GENERAL,
    difficulty: DifficultyLevel.EASY,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'Which of these colors is considered to be an earth tone?', ar: 'أيٌّ من الألوان التالية يُعدّ من الألوان الترابية؟' },
    options: [
      { id: 'A', text: { en: 'Blue', ar: 'أزرق' } },
      { id: 'B', text: { en: 'Pink', ar: 'وردي' } },
      { id: 'C', text: { en: 'Brown', ar: 'بني' } },
      { id: 'D', text: { en: 'White', ar: 'أبيض' } }
    ],
    correctOptionId: 'C',
    timeLimit: 30,
    xpReward: 10
  },
  {
    id: 'science-561',
    subject: QuizSubject.SCIENCE,
    difficulty: DifficultyLevel.MEDIUM,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'The lowest two pairs of ribs in the human body are commonly known as what?', ar: 'ما الاسم الشائع لأدنى زوجين من الأضلاع في جسم الإنسان؟' },
    options: [
      { id: 'A', text: { en: 'Cervical ribs', ar: 'الأضلاع العنقية' } },
      { id: 'B', text: { en: 'True ribs', ar: 'الأضلاع الحقيقية' } },
      { id: 'C', text: { en: 'Sternal ribs', ar: 'الأضلاع القصية' } },
      { id: 'D', text: { en: 'Floating ribs', ar: 'الأضلاع العائمة' } }
    ],
    correctOptionId: 'D',
    timeLimit: 30,
    xpReward: 20
  },
  {
    id: 'english-562',
    subject: QuizSubject.ENGLISH,
    difficulty: DifficultyLevel.EASY,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'A person with a complaint is said to have a "bone to" what?', ar: 'A person with a complaint is said to have a "bone to" what?' },
    options: [
      { id: 'A', text: { en: 'Pick', ar: 'Pick' } },
      { id: 'B', text: { en: 'Break', ar: 'Break' } },
      { id: 'C', text: { en: 'Throw', ar: 'Throw' } },
      { id: 'D', text: { en: 'Chew', ar: 'Chew' } }
    ],
    correctOptionId: 'A',
    timeLimit: 30,
    xpReward: 10
  },
  {
    id: 'general-563',
    subject: QuizSubject.GENERAL,
    difficulty: DifficultyLevel.EASY,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'In art, the three primary colors are red, yellow and what?', ar: 'في الفن، الألوان الأساسية الثلاثة هي الأحمر والأصفر و...؟' },
    options: [
      { id: 'A', text: { en: 'White', ar: 'الأبيض' } },
      { id: 'B', text: { en: 'Blue', ar: 'الأزرق' } },
      { id: 'C', text: { en: 'Green', ar: 'الأخضر' } },
      { id: 'D', text: { en: 'Orange', ar: 'البرتقالي' } }
    ],
    correctOptionId: 'B',
    timeLimit: 30,
    xpReward: 10
  },
  {
    id: 'general-564',
    subject: QuizSubject.GENERAL,
    difficulty: DifficultyLevel.MEDIUM,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'King William I of England, crowned in 1066, is better known as "William the" what?', ar: 'الملك ويليام الأول ملك إنجلترا، الذي توّج عام ١٠٦٦، معروف باسم "ويليام..." ماذا؟' },
    options: [
      { id: 'A', text: { en: 'Destroyer', ar: 'المدمّر' } },
      { id: 'B', text: { en: 'Terrible', ar: 'الرهيب' } },
      { id: 'C', text: { en: 'Conqueror', ar: 'الفاتح' } },
      { id: 'D', text: { en: 'Avenger', ar: 'المنتقم' } }
    ],
    correctOptionId: 'C',
    timeLimit: 30,
    xpReward: 20
  },
  {
    id: 'general-565',
    subject: QuizSubject.GENERAL,
    difficulty: DifficultyLevel.EASY,
    gradeRange: { min: 5, max: 8 },
    text: { en: '15th-century inventor Johann Gutenberg is famous for his contributions to what important invention?', ar: 'المخترع يوهان غوتنبرغ من القرن الخامس عشر اشتُهر بإسهاماته في أي اختراع مهم؟' },
    options: [
      { id: 'A', text: { en: 'Sewing machine', ar: 'ماكينة الخياطة' } },
      { id: 'B', text: { en: 'Plow', ar: 'المحراث' } },
      { id: 'C', text: { en: 'Wood-burning stove', ar: 'موقد الحطب' } },
      { id: 'D', text: { en: 'Printing press', ar: 'المطبعة' } }
    ],
    correctOptionId: 'D',
    timeLimit: 30,
    xpReward: 10
  },
  {
    id: 'general-566',
    subject: QuizSubject.GENERAL,
    difficulty: DifficultyLevel.HARD,
    gradeRange: { min: 6, max: 8 },
    text: { en: 'Measuring over 33 miles in length, the world\'s longest railroad tunnel is located in what country?', ar: 'بطول يزيد على ٣٣ ميلاً، يقع أطول نفق سكة حديد في العالم في أي بلد؟' },
    options: [
      { id: 'A', text: { en: 'France', ar: 'فرنسا' } },
      { id: 'B', text: { en: 'Switzerland', ar: 'سويسرا' } },
      { id: 'C', text: { en: 'Russia', ar: 'روسيا' } },
      { id: 'D', text: { en: 'Japan', ar: 'اليابان' } }
    ],
    correctOptionId: 'D',
    timeLimit: 30,
    xpReward: 35
  },
  {
    id: 'science-567',
    subject: QuizSubject.SCIENCE,
    difficulty: DifficultyLevel.MEDIUM,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'Light is created in a fluorescent lamp when an electric current reacts with an inert gas and what?', ar: 'يتولد الضوء في المصباح الفلوري عندما يتفاعل تيار كهربائي مع غاز خامل و...؟' },
    options: [
      { id: 'A', text: { en: 'Mercury', ar: 'الزئبق' } },
      { id: 'B', text: { en: 'Silicon', ar: 'السيليكون' } },
      { id: 'C', text: { en: 'Carbon', ar: 'الكربون' } },
      { id: 'D', text: { en: 'Uranium', ar: 'اليورانيوم' } }
    ],
    correctOptionId: 'A',
    timeLimit: 30,
    xpReward: 20
  },
  {
    id: 'general-568',
    subject: QuizSubject.GENERAL,
    difficulty: DifficultyLevel.EASY,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'Often derived from plants, tenderizer is a substance commonly added to what food before it is cooked?', ar: 'غالباً ما يُستخرج من النباتات، طريّ الطعام (التِندِرَايزَر) مادة تُضاف عادةً إلى أي طعام قبل طهيه؟' },
    options: [
      { id: 'A', text: { en: 'Pasta', ar: 'المعكرونة' } },
      { id: 'B', text: { en: 'Bread dough', ar: 'عجينة الخبز' } },
      { id: 'C', text: { en: 'Potatoes', ar: 'البطاطا' } },
      { id: 'D', text: { en: 'Meat', ar: 'اللحم' } }
    ],
    correctOptionId: 'D',
    timeLimit: 30,
    xpReward: 10
  },
  {
    id: 'science-569',
    subject: QuizSubject.SCIENCE,
    difficulty: DifficultyLevel.MEDIUM,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'Which of the following planets can be spelled differently to mean an essential human organ?', ar: 'أيٌّ من الكواكب التالية يمكن إعادة ترتيب حروفه ليعني عضواً أساسياً في جسم الإنسان؟' },
    options: [
      { id: 'A', text: { en: 'Earth', ar: 'الأرض (Earth)' } },
      { id: 'B', text: { en: 'Jupiter', ar: 'المشتري' } },
      { id: 'C', text: { en: 'Saturn', ar: 'زحل' } },
      { id: 'D', text: { en: 'Venus', ar: 'الزهرة' } }
    ],
    correctOptionId: 'A',
    timeLimit: 30,
    xpReward: 20
  },
  {
    id: 'general-570',
    subject: QuizSubject.GENERAL,
    difficulty: DifficultyLevel.MEDIUM,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'As one of the lowest-lying nations on Earth, what country held an underwater meeting to draw attention to global warming?', ar: 'بصفتها من أكثر الدول انخفاضاً عن سطح البحر، عقدت أي دولة اجتماعاً تحت الماء لاسترعاء الانتباه إلى الاحتباس الحراري؟' },
    options: [
      { id: 'A', text: { en: 'Maldives', ar: 'جزر المالديف' } },
      { id: 'B', text: { en: 'Mauritania', ar: 'موريتانيا' } },
      { id: 'C', text: { en: 'Malta', ar: 'مالطا' } },
      { id: 'D', text: { en: 'Myanmar', ar: 'ميانمار' } }
    ],
    correctOptionId: 'A',
    timeLimit: 30,
    xpReward: 20
  },
  {
    id: 'general-571',
    subject: QuizSubject.GENERAL,
    difficulty: DifficultyLevel.EASY,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'A wig would most likely be used to change which of the following traits?', ar: 'على الأرجح يُستخدم الباروكة لتغيير أيٍّ من السمات التالية؟' },
    options: [
      { id: 'A', text: { en: 'Eye color', ar: 'لون العين' } },
      { id: 'B', text: { en: 'Hair style', ar: 'تسريحة الشعر' } },
      { id: 'C', text: { en: 'Shoe size', ar: 'مقاس الحذاء' } },
      { id: 'D', text: { en: 'Marital status', ar: 'الحالة الاجتماعية' } }
    ],
    correctOptionId: 'B',
    timeLimit: 30,
    xpReward: 10
  },
  {
    id: 'general-572',
    subject: QuizSubject.GENERAL,
    difficulty: DifficultyLevel.EASY,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'What should you do if someone asks you for a "hard copy" of an E-mail?', ar: 'ماذا يجب أن تفعل إذا طلب منك أحدهم نسخة "ورقية" من البريد الإلكتروني؟' },
    options: [
      { id: 'A', text: { en: 'Print it on paper', ar: 'اطبعها على ورق' } },
      { id: 'B', text: { en: 'Copy it onto a disk', ar: 'انسخها على قرص' } },
      { id: 'C', text: { en: 'Memorize it', ar: 'احفظها' } },
      { id: 'D', text: { en: 'Delete it', ar: 'احذفها' } }
    ],
    correctOptionId: 'A',
    timeLimit: 30,
    xpReward: 10
  },
  {
    id: 'english-573',
    subject: QuizSubject.ENGLISH,
    difficulty: DifficultyLevel.EASY,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'A steed is what kind of animal?', ar: 'A steed is what kind of animal?' },
    options: [
      { id: 'A', text: { en: 'Dog', ar: 'Dog' } },
      { id: 'B', text: { en: 'Bear', ar: 'Bear' } },
      { id: 'C', text: { en: 'Bird', ar: 'Bird' } },
      { id: 'D', text: { en: 'Horse', ar: 'Horse' } }
    ],
    correctOptionId: 'D',
    timeLimit: 30,
    xpReward: 10
  },
  {
    id: 'english-574',
    subject: QuizSubject.ENGLISH,
    difficulty: DifficultyLevel.EASY,
    gradeRange: { min: 5, max: 8 },
    text: { en: 'By definition, someone who has "gone ballistic" has expressed what emotion?', ar: 'By definition, someone who has "gone ballistic" has expressed what emotion?' },
    options: [
      { id: 'A', text: { en: 'Anger', ar: 'Anger' } },
      { id: 'B', text: { en: 'Fear', ar: 'Fear' } },
      { id: 'C', text: { en: 'Excitement', ar: 'Excitement' } },
      { id: 'D', text: { en: 'Disco fever', ar: 'Disco fever' } }
    ],
    correctOptionId: 'A',
    timeLimit: 30,
    xpReward: 10
  }
];
